webpackJsonp([1],{

/***/ "+/bs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"my-3",attrs:{"slot":"activator","disabled":!_vm.redistribute,"block":"","large":"","color":"primary"},on:{"click":_vm.downloadCsv},slot:"activator"},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-table")]),_vm._v("\n        Download Data\n    ")],1),_vm._v(" "),(_vm.redistribute)?_c('span',[_vm._v("Download CSV file")]):_vm._e(),_vm._v(" "),(!_vm.redistribute)?_c('span',[_vm._v("This station's data is not authorized for redistribution")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+5Z1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pluralize__ = __webpack_require__("DbJJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pluralize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pluralize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_checkQueryData__ = __webpack_require__("ieMF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_streamflowData__ = __webpack_require__("Nt91");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_getStationMetadata__ = __webpack_require__("s6bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SidebarSparkline__ = __webpack_require__("XFj9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DownloadCsvButton__ = __webpack_require__("l2MX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// components



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'station-details-streamflow',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_checkQueryData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_streamflowData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_getStationMetadata__["a" /* default */]],
    components: {
        SparkLine: __WEBPACK_IMPORTED_MODULE_5__components_SidebarSparkline__["a" /* default */],
        DownloadCsvButton: __WEBPACK_IMPORTED_MODULE_6__components_DownloadCsvButton__["a" /* default */]
    },
    computed: {
        stationId: function stationId() {
            return this.station.id;
        }
    },
    methods: {
        pluralize: function pluralize(term, num) {
            return __WEBPACK_IMPORTED_MODULE_0_pluralize___default()(term, num);
        },
        showChartModal: function showChartModal(tabName) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__constants_actions__["i" /* SET_CHART_MODAL_TAB */], tabName);
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__constants_actions__["y" /* SHOW_CHART_MODAL */], true);
        }
    }
});

/***/ }),

/***/ "+CHo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FDDatePicker_vue__ = __webpack_require__("Vq0p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df65d4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FDDatePicker_vue__ = __webpack_require__("BnFB");
function injectStyle (ssrContext) {
  __webpack_require__("mydN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FDDatePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df65d4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FDDatePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+GTB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapLegend_vue__ = __webpack_require__("/3V8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0719c281_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapLegend_vue__ = __webpack_require__("549J");
function injectStyle (ssrContext) {
  __webpack_require__("GI3Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapLegend_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0719c281_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapLegend_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+TRb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);
/**
 * number formatting helper functions
 * can be used in vue filters
 */


/**
 * apply a numeral.js formatting string to an input value
 * @param  {Number} val            input value to be changed
 * @param  {String} [format='0,0'] numeral.js format string
 * @return {String}                formatted output string
 */
/* harmony default export */ __webpack_exports__["a"] = (function (val) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0,0';
  return __WEBPACK_IMPORTED_MODULE_0_numeral___default()(val).format(format);
});

/***/ }),

/***/ "+jVx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+rz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_stationsPage__ = __webpack_require__("geYf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_mapLegend__ = __webpack_require__("6Tn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ChartModalClimate__ = __webpack_require__("UVyt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MapSaveButton__ = __webpack_require__("e5y2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// mixins






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Climate',
    components: {
        ChartModal: __WEBPACK_IMPORTED_MODULE_2__components_ChartModalClimate__["a" /* default */],
        MapSaveButton: __WEBPACK_IMPORTED_MODULE_3__components_MapSaveButton__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_stationsPage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_mapLegend__["a" /* default */]],
    data: function data() {
        return {
            name: 'climate',
            mapSourceUrl: this.$cfg.API_URL + '/stations/climate',
            stationType: 'CLIMATE',
            filters: ['network', 'analyses', 'status', 'yearMin', 'yearMax'],
            showMapSave: false
        };
    }
});

/***/ }),

/***/ "/3V8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        items: {
            type: Array,
            required: true
        },
        value: Boolean
    },
    computed: {
        topStyle: function topStyle() {
            if (this.$router.currentRoute.path === '/watershed') {
                return '200px';
            }
            return '160px';
        }
    },
    methods: {
        /**
         * build style object for legend items
         * @param  {Object} item item configuration
         * @return {Object}      vue style object
         */
        getCircleStyle: function getCircleStyle(item) {
            var defaultStyle = {
                color: '#ccc',
                borderColor: '#fff'
            };
            var mergedStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultStyle, item);
            return {
                'background-color': mergedStyle.color,
                'border-color': mergedStyle.borderColor
            };
        },

        /**
         * change visible state of the map legend
         * hides by default
         * @param  {Boolean} [on=false] true for visible
         */
        show: function show() {
            var on = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.$emit('input', on);
        }
    }
});

/***/ }),

/***/ "/5hf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarToggle_vue__ = __webpack_require__("yHZv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e327448_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarToggle_vue__ = __webpack_require__("mw/h");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarToggle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e327448_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarToggle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/63i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartModalSwQuality_vue__ = __webpack_require__("Nuxx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec64bc78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartModalSwQuality_vue__ = __webpack_require__("JKMa");
function injectStyle (ssrContext) {
  __webpack_require__("5U9U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ec64bc78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartModalSwQuality_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec64bc78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartModalSwQuality_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/AML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_yearlyChart__ = __webpack_require__("tMAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_formatHistoricalDailyData__ = __webpack_require__("/SS+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_formatHistoricalDailyDateData__ = __webpack_require__("r0h7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_exportChart__ = __webpack_require__("h326");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_resetChart__ = __webpack_require__("AstN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_climateData__ = __webpack_require__("epYP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_ie11ChartResize__ = __webpack_require__("4+uC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chartData_climateManualSnowSurveyChart__ = __webpack_require__("aD+S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_yearlyChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_formatHistoricalDailyData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_formatHistoricalDailyDateData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_exportChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_resetChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_climateData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_ie11ChartResize__["a" /* default */]],
    data: function data() {
        return {
            chart: null,
            chartId: 'canvas-manual-snow-survey',
            dataType: 'manual_snow_survey'
        };
    },

    computed: {
        chartData: function chartData() {
            return this.queryData.manual_snow_survey;
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.chart.destroy();
    },
    mounted: function mounted() {
        if (this.chartData) {
            this.updateChart();
        }
    },

    methods: {
        /**
         * create datasets and chart context object
         * @return {Object} chart.js context object
         */
        formatDatasets: function formatDatasets() {
            var _chartData$datasets;

            var historicalData = this.formatHistoricalData(this.chartData.historical, function (date, e) {
                var formatted = {
                    d: date,
                    p50: e.p50,
                    p10: e.p10,
                    p25: e.p25,
                    p75: e.p75,
                    p90: e.p90
                };
                return formatted;
            });
            var currentData = this.formatCurrentData(this.chartData.current);
            var chartDates = historicalData.map(function (d) {
                return d.d;
            });

            var chartData = Object(__WEBPACK_IMPORTED_MODULE_8__chartData_climateManualSnowSurveyChart__["b" /* data */])(chartDates, currentData, historicalData);
            // that "true" on the end of this function call tells the formatter to split datasets
            var yearlyOverlayDatasets = this.formatYearlyData(this.formatHistoricalDateData, true);
            (_chartData$datasets = chartData.datasets).unshift.apply(_chartData$datasets, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(yearlyOverlayDatasets));
            return chartData;
        },

        /**
         * set up the chart and do the initial render
         */
        renderChart: function renderChart() {
            var chartData = this.formatDatasets();

            this.chart = new __WEBPACK_IMPORTED_MODULE_9_chart_js___default.a(this.chartId, Object(__WEBPACK_IMPORTED_MODULE_8__chartData_climateManualSnowSurveyChart__["a" /* container */])(chartData));
        },

        /**
         * update the datasets and re-render the chart
         */
        updateChart: function updateChart() {
            // do the initial render if the chart isn't defined yet
            if (this.chart === null) {
                this.renderChart();
                return;
            }
            this.chart.data = this.formatDatasets();
            this.chart.update({
                duration: 0
            });
        },

        /**
         * format current snow water equivalent data with date objects
         * @param  {Array} currentData SWE data with string dates
         * @return {Array}             SWE data with moment.js dates
         */
        formatCurrentData: function formatCurrentData(currentData) {
            var dataWithDates = currentData.map(function (d) {
                var date = __WEBPACK_IMPORTED_MODULE_10_moment___default()(d.d);
                return {
                    d: date,
                    v: d.v
                };
            });

            return dataWithDates;
        }
    },
    watch: {
        /**
         * update the chart when the data changes
         */
        chartData: function chartData(val) {
            this.yearlyData = {};
            this.yearlyDataDisplay = [];
            if (val) {
                this.updateChart();
            }
        },
        updateData: function updateData(val) {
            if (val) {
                this.updateChart();
                this.updateData = false;
            }
        }
    }
});

/***/ }),

/***/ "/KFX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__("AHJT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65ad3460_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__("vm4e");
function injectStyle (ssrContext) {
  __webpack_require__("Qgob")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65ad3460_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/QY9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"station-details climate"},[(!_vm.queryDone)?_c('div',{staticClass:"loading"},[_c('p',[_vm._v("Loading station data...")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),_vm._v(" "),(_vm.station && _vm.queryDone)?_c('div',{staticClass:"station"},[_c('h3',{staticClass:"headline station-name primary--text",domProps:{"textContent":_vm._s(_vm.queryData.name)}}),_vm._v(" "),_c('p',{staticClass:"body-2 mb-1 network-info"},[_vm._v("\n            "+_vm._s(_vm.networkId)),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":_vm.networkUrl}},[_vm._v(_vm._s(_vm.network))])]),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_vm._l((_vm.properties),function(ref){
var title = ref.title;
var value = ref.value;
return (value)?_c('div',{staticClass:"properties-item mb-3"},[_c('h4',{staticClass:"subheading field-title grey--text",domProps:{"textContent":_vm._s(title)}}),_vm._v(" "),_c('div',{staticClass:"body-1 field-value",domProps:{"textContent":_vm._s(value)}})]):_vm._e()}),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_c('download-csv-button',{attrs:{"redistribute":_vm.dataRedistirbute,"station-id":_vm.stationId}}),_vm._v(" "),_c('h3',{staticClass:"mt-3 mb-1 subheading"},[_vm._v("Temperature")]),_vm._v(" "),(_vm.checkChartData(this.queryData, 'temperature', this.checkClimateDataFields.temperature))?_c('spark-line',{attrs:{"id":"tempSparkline","height":"76","width":"300","datasets":_vm.temperatureDatasets},on:{"click":function($event){_vm.showChartModal('temperature')}}}):_vm._e(),_vm._v(" "),(!_vm.checkChartData(this.queryData, 'temperature', this.checkClimateDataFields.temperature))?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_c('h3',{staticClass:"mt-3 mb-1 subheading"},[_vm._v("Precipitation")]),_vm._v(" "),(_vm.checkChartData(this.queryData, 'precipitation', this.checkClimateDataFields.precipitation))?_c('spark-line',{attrs:{"id":"precipSparkline","height":"76","width":"300","datasets":_vm.precipitationDatasets},on:{"click":function($event){_vm.showChartModal('precipitation')}}}):_vm._e(),_vm._v(" "),(!_vm.checkChartData(this.queryData, 'precipitation', this.checkClimateDataFields.precipitation))?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_c('h3',{staticClass:"mt-3 mb-1 subheading"},[_vm._v("Snow on Ground")]),_vm._v(" "),(_vm.checkChartData(this.queryData, 'snow_on_ground_depth', this.checkClimateDataFields.snow_on_ground_depth))?_c('spark-line',{attrs:{"id":"snowSparkline","height":"76","width":"300","datasets":_vm.snowDatasets},on:{"click":function($event){_vm.showChartModal('snow')}}}):_vm._e(),_vm._v(" "),(!_vm.checkChartData(this.queryData, 'snow_on_ground_depth', this.checkClimateDataFields.snow_on_ground_depth))?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_c('h3',{staticClass:"mt-3 mb-1 subheading"},[_vm._v("Snow Water Equivalent")]),_vm._v(" "),(_vm.checkChartData(this.queryData, 'snow_water_equivalent', this.checkClimateDataFields.snow_water_equivalent))?_c('spark-line',{attrs:{"id":"sweSparkline","height":"76","width":"300","datasets":_vm.SWEDatasets},on:{"click":function($event){_vm.showChartModal('snow-water-equivalent')}}}):_vm._e(),_vm._v(" "),(!_vm.checkChartData(this.queryData, 'snow_water_equivalent', this.checkClimateDataFields.snow_water_equivalent))?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_c('h3',{staticClass:"mt-3 mb-1 subheading"},[_vm._v("Manual Snow Survey")]),_vm._v(" "),(_vm.checkChartData(this.queryData, 'manual_snow_survey', this.checkClimateDataFields.manual_snow_survey))?_c('spark-line',{attrs:{"id":"sweSparkline","height":"76","width":"300","datasets":_vm.MSSDatasets},on:{"click":function($event){_vm.showChartModal('manual-snow-survey')}}}):_vm._e(),_vm._v(" "),(!_vm.checkChartData(this.queryData, 'manual_snow_survey', this.checkClimateDataFields.manual_snow_survey))?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"my-3"})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/SS+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        /**
         * format 365-day historical data into 18 months of daily data
         * @param  {Array} data365days 365-day data
         * @param  {Function} formatter   formatter callback
         * @return {Array}             formatted 18-month data
         */
        formatHistoricalData: function formatHistoricalData(data365days, formatter) {
            // build 18 months of historical values from 12 months of data
            // use the last 13 months, plus the next 5 months

            // clone the year of data to form last year, this year, next year
            var today = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
            var yearStart = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1, 'years').startOf('year');
            var data3Years = data365days.concat(data365days, data365days);
            data3Years = data3Years.map(function (e, i) {
                var date = yearStart.clone().add(i, 'days');

                return formatter(date, e);
            });

            // the first of this month, last year
            var currentMonth = today.format('MM');
            var periodStart = __WEBPACK_IMPORTED_MODULE_0_moment___default()(yearStart.format('Y') + '-' + currentMonth + '-01');
            // period start + 19 months, - 1 day (end of 18 months later)
            var periodEnd = periodStart.clone().add(19, 'months').subtract(1, 'days');

            // trim the array to just this 18-month period
            periodStart = data3Years.findIndex(function (e) {
                return e.d.isSame(periodStart);
            });
            periodEnd = data3Years.findIndex(function (e) {
                return e.d.isSame(periodEnd);
            });
            var data18Months = data3Years.slice(periodStart, periodEnd);
            return data18Months;
        }
    }
});

/***/ }),

/***/ "/gII":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"id":"create"}},[_c('v-speed-dial',{attrs:{"bottom":"","right":"","direction":"right","transition":"slide-y-reverse-transition"},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-badge',{attrs:{"slot":"activator","overlap":"","color":"orange"},slot:"activator"},[_c('v-tooltip',{attrs:{"right":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","fab":"","hover":""},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("cloud_download")]),_vm._v(" "),_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Download Reports")])],1),_vm._v(" "),_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.downloadingNum)+"/"+_vm._s(_vm.downloadedNum))])],1),_vm._v(" "),_c('v-card',{staticClass:"report-inter",attrs:{"height":"250"}},[_c('v-card-title',{on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"headline primary--text"},[_vm._v("My Reports\n                    "),_c('v-btn',{staticClass:"closereportlist",attrs:{"flat":"","icon":"","small":""},on:{"click":function($event){_vm.fab=false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('h3',[_vm._v("Downloads")]),_vm._v(" "),_vm._l((_vm.newReports),function(report){return _c('div',{key:report.wfi,staticClass:"d-flex align-center justify-space-between",staticStyle:{"margin":"0.2rem 0"}},[_c('p',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(report.name)),_c('br'),_vm._v("WFI: "+_vm._s(report.wfi)+" - "+_vm._s(report.timestamp))]),_vm._v(" "),_c('div',{staticStyle:{"flex":"none !important"}},[_c('v-btn',{attrs:{"flat":"","icon":"","disabled":report.downloading || report.loading,"loading":report.downloading || report.loading},on:{"click":function($event){_vm.downloadReport(report.wfi)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("cloud_download")])],1)],1)])})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0uOx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-wrap flow-metrics-table"},[_vm._m(0),_vm._v(" "),_c('scrolling-table',{staticClass:"scroll-table",attrs:{"data":_vm.scrollingTableData}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"margin":"6px"}},[_vm._v("The BC Streamflow Inventory (BCSI) has been updated using more recent hydrologic data to represent the normal period of 1981-2010. The standard discharge data used is published by the Water Survey of Canada (WSC). Results of these analyses are provided below. For more information, the full reports are available on Ecocat "),_c('a',{attrs:{"href":"https://a100.gov.bc.ca/pub/acat/public/search.do"}},[_vm._v("https://a100.gov.bc.ca/pub/acat/public/search.do")]),_vm._v(" using the search parameter \"Inventory of Streamflow\".")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1T91":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return data; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chartjs_plugin_zoom__ = __webpack_require__("oPhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chartjs_plugin_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_chartjs_plugin_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_appColors__ = __webpack_require__("QW0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions_chartTooltipDate__ = __webpack_require__("rgFZ");







var container = function container(data) {
    return {
        type: 'line',
        data: data,
        plugins: [__WEBPACK_IMPORTED_MODULE_3_chartjs_plugin_zoom___default.a],
        options: {
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
                mode: 'index',
                axis: 'x',
                intersect: false,
                position: 'nearest',
                callbacks: {
                    label: function label(tooltipItem, d) {
                        var label = d.datasets[tooltipItem.datasetIndex].label || '';
                        var value = __WEBPACK_IMPORTED_MODULE_1_numeral___default()(tooltipItem.yLabel).format('0,0');
                        return label + ': ' + value + ' mm';
                    },

                    title: __WEBPACK_IMPORTED_MODULE_5__functions_chartTooltipDate__["a" /* default */]
                }
            },
            annotation: {
                events: [],
                annotations: [{
                    drawTime: 'afterDatasetsDraw',
                    id: 'vline',
                    type: 'line',
                    mode: 'vertical',
                    scaleID: 'x-axis-0',
                    value: __WEBPACK_IMPORTED_MODULE_2_moment___default()(),
                    borderColor: 'black',
                    borderWidth: 3,
                    label: {
                        backgroundColor: __WEBPACK_IMPORTED_MODULE_4__functions_appColors__["A" /* todayMarker */],
                        content: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('LL'),
                        enabled: true
                    }
                }]
            },
            pan: {
                enabled: true,
                mode: 'y',
                speed: 10,
                threshold: 10
            },
            zoom: {
                enabled: true,
                mode: 'y',
                limits: {
                    max: 100,
                    min: 1
                }
            },
            scales: {
                xAxes: [{
                    type: 'time',
                    distribution: 'linear',
                    time: {
                        tooltipFormat: 'MMM DD, YYYY',
                        unit: 'month'
                    }
                }],
                yAxes: [{
                    ticks: {
                        min: 0,
                        max: Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.datasets[0].data.map(function (i) {
                            return i.y;
                        }))) > 1500 ? 1500 : undefined
                    },
                    scaleLabel: {
                        display: true,
                        labelString: 'Precipitation (mm)'
                    }
                }],
                // disable animations
                animation: false
            }
        }
    };
};

var data = function data(labels, currentData, historicalData) {
    return {
        labels: labels,
        datasets: [{
            type: 'line',
            label: 'Current MTD',
            borderColor: __WEBPACK_IMPORTED_MODULE_4__functions_appColors__["C" /* waterBorder */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_4__functions_appColors__["B" /* waterBg */],
            borderWidth: 2,
            fill: true,
            pointRadius: 0,
            pointHitRadius: 1,
            // steppedLine: 'before',
            data: currentData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.mtd
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical median',
            borderColor: __WEBPACK_IMPORTED_MODULE_4__functions_appColors__["h" /* historicalMedian */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_4__functions_appColors__["h" /* historicalMedian */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 24,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p50
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 75th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_4__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_4__functions_appColors__["e" /* historical1 */],
            borderWidth: 2,
            fill: '+1',
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 24,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p75
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 25th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_4__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_4__functions_appColors__["e" /* historical1 */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 24,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p25
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 90th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_4__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_4__functions_appColors__["f" /* historical2 */],
            borderWidth: 2,
            fill: '+1',
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 24,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p90
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 10th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_4__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_4__functions_appColors__["f" /* historical2 */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 24,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p10
                };
                return valObj;
            })
        }]
    };
};

/***/ }),

/***/ "1j2J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1sRJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "25jo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_yearlyChart__ = __webpack_require__("tMAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_formatHistoricalDailyData__ = __webpack_require__("/SS+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_formatHistoricalDailyDateData__ = __webpack_require__("r0h7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_exportChart__ = __webpack_require__("h326");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_resetChart__ = __webpack_require__("AstN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_climateData__ = __webpack_require__("epYP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_ie11ChartResize__ = __webpack_require__("4+uC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chartData_climateSnowChart__ = __webpack_require__("YihI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_yearlyChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_formatHistoricalDailyData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_formatHistoricalDailyDateData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_exportChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_resetChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_climateData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_ie11ChartResize__["a" /* default */]],
    data: function data() {
        return {
            chart: null,
            chartId: 'canvas-snow-depth',
            dataType: 'snow_on_ground_depth'
        };
    },

    computed: {
        chartData: function chartData() {
            return this.queryData.snow_on_ground_depth;
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.chart.destroy();
    },
    mounted: function mounted() {
        if (this.chartData) {
            this.updateChart();
        }
    },

    methods: {
        /**
         * create datasets and chart context object
         * @return {Object} chart.js context object
         */
        formatDatasets: function formatDatasets() {
            var _chartData$datasets;

            var historicalData = this.formatHistoricalData(this.chartData.historical, function (date, e) {
                var formatted = {
                    d: date,
                    a: e.a,
                    p10: e.p10,
                    p25: e.p25,
                    p75: e.p75,
                    p90: e.p90
                };
                return formatted;
            });
            var currentData = this.formatCurrentData(this.chartData.current);
            var chartDates = historicalData.map(function (d) {
                return d.d;
            });

            var chartData = Object(__WEBPACK_IMPORTED_MODULE_8__chartData_climateSnowChart__["b" /* data */])(chartDates, currentData, historicalData);

            var yearlyOverlayDatasets = this.formatYearlyData(this.formatHistoricalDateData);
            (_chartData$datasets = chartData.datasets).unshift.apply(_chartData$datasets, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(yearlyOverlayDatasets));
            return chartData;
        },

        /**
         * set up the chart and do the initial render
         */
        renderChart: function renderChart() {
            var chartData = this.formatDatasets();

            this.chart = new __WEBPACK_IMPORTED_MODULE_9_chart_js___default.a(this.chartId, Object(__WEBPACK_IMPORTED_MODULE_8__chartData_climateSnowChart__["a" /* container */])(chartData));
        },

        /**
         * update the datasets and re-render the chart
         */
        updateChart: function updateChart() {
            // do the initial render if the chart isn't defined yet
            if (this.chart === null) {
                this.renderChart();
                return;
            }
            this.chart.data = this.formatDatasets();
            this.chart.update({
                duration: 0
            });
        },

        /**
         * format current snow depth data with date objects
         * @param  {Array} currentData snow depth data with string dates
         * @return {Array}             snow depth data with moment.js dates
         */
        formatCurrentData: function formatCurrentData(currentData) {
            var dataWithDates = currentData.map(function (d) {
                var date = __WEBPACK_IMPORTED_MODULE_10_moment___default()(d.d);
                return {
                    d: date,
                    v: d.v
                };
            });

            return dataWithDates;
        }
    },
    watch: {
        /**
         * update the chart when the data changes
         */
        chartData: function chartData(val) {
            this.yearlyData = {};
            this.yearlyDataDisplay = [];
            if (val) {
                this.updateChart();
            }
        },
        updateData: function updateData(val) {
            if (val) {
                this.updateChart();
                this.updateData = false;
            }
        }
    }
});

/***/ }),

/***/ "26vA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClimateTemperature_vue__ = __webpack_require__("emTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8ff937e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClimateTemperature_vue__ = __webpack_require__("7HhR");
function injectStyle (ssrContext) {
  __webpack_require__("89KZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClimateTemperature_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8ff937e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClimateTemperature_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2863":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2FRe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        agree: function agree() {
            // dismiss the modal
            this.$emit('input', false);
        },
        disagree: function disagree() {
            // redirect to a website
            window.location.href = 'https://gov.bc.ca/';
        }
    }
});

/***/ }),

/***/ "2VR6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.show,"persistent":"","scrollable":"","fullscreen":"","transition":"scale-transition"}},[_c('v-card',{staticClass:"chart-modal"},[_c('v-toolbar',{attrs:{"color":"secondary","dark":"","tabs":""}},[_c('v-toolbar-title',{domProps:{"textContent":_vm._s(_vm.stationName)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.hide($event)}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-tabs',{staticClass:"tab-switcher",attrs:{"slot":"extension","fixed":"","centered":"","color":"secondary"},slot:"extension",model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('v-tab',{attrs:{"href":"#groundwater-quality"}},[_vm._v("\n                    Groundwater Quality\n                ")])],1)],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('v-tab-item',{attrs:{"id":"groundwater-quality"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(_vm.stationData === null)?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_c('div',[(_vm.show && _vm.activeTab === 'groundwater-quality')?_c('gw-quality-table'):_vm._e()],1)])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2Yd3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2iIR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions_appColors__ = __webpack_require__("QW0U");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        color: {
            default: String(__WEBPACK_IMPORTED_MODULE_0__functions_appColors__["s" /* navIcon */]),
            type: String
        }
    }
});

/***/ }),

/***/ "2sQ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClimateSnowWaterEquivalent_vue__ = __webpack_require__("odbt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c41dccaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClimateSnowWaterEquivalent_vue__ = __webpack_require__("HEse");
function injectStyle (ssrContext) {
  __webpack_require__("2863")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClimateSnowWaterEquivalent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c41dccaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClimateSnowWaterEquivalent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3GP0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroundwaterQualityTable_vue__ = __webpack_require__("lD6Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d022a5d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroundwaterQualityTable_vue__ = __webpack_require__("YIYp");
function injectStyle (ssrContext) {
  __webpack_require__("xRYM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroundwaterQualityTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d022a5d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroundwaterQualityTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Zu0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3h8O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3j7W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4+uC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Manually fire resize() on a chart.js chart when showChartModal changes in vuex.
 * This is a hack to ensure the chart.js responsive resize watcher initializes in IE11.
 * See KBWT-402; The chart initializes inside a hidden chart modal with display: none,
 * so the initial height/width are 0, and chart.js@2.7.2 doesn't resize when the modal is shown.
 * Include this on a chart component. This assumes the chart is called `this.chart`
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        showChartModal: function showChartModal() {
            return this.$store.state.showChartModal;
        }
    },
    watch: {
        // manually fire chart.resize() whenever the chart state changes
        showChartModal: function showChartModal() {
            if (this.chart) {
                this.chart.resize();
            }
        }
    }
});

/***/ }),

/***/ "40ol":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4F+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GwLevelHydrograph_vue__ = __webpack_require__("Svpl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fd26b30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GwLevelHydrograph_vue__ = __webpack_require__("o5bc");
function injectStyle (ssrContext) {
  __webpack_require__("P4ca")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GwLevelHydrograph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fd26b30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GwLevelHydrograph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4jZd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartTooltip_vue__ = __webpack_require__("xScb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c40f7612_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartTooltip_vue__ = __webpack_require__("IMJV");
function injectStyle (ssrContext) {
  __webpack_require__("gOPW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartTooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c40f7612_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartTooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4nVf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_file_download__ = __webpack_require__("3UNf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_js_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__apollo_apollo__ = __webpack_require__("YQr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_checkQueryData__ = __webpack_require__("ieMF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_watershedData__ = __webpack_require__("yjwP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_map__ = __webpack_require__("aiDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SidebarSparkline__ = __webpack_require__("XFj9");






var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['query getWatershed($wfi: Int!) {\n                        getWatershedWFI(wfi: $wfi) {\n                            wfi\n                            fwa\n                            name\n                            rollup {\n                                mean_annual_discharge\n                                upstream_area\n                            }\n                            elevation {\n                                max\n                                mean\n                                min\n                            }\n                            outlet_coordinates\n                        }\n                    }'], ['query getWatershed($wfi: Int!) {\n                        getWatershedWFI(wfi: $wfi) {\n                            wfi\n                            fwa\n                            name\n                            rollup {\n                                mean_annual_discharge\n                                upstream_area\n                            }\n                            elevation {\n                                max\n                                mean\n                                min\n                            }\n                            outlet_coordinates\n                        }\n                    }']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












// components


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'watershed-details',
    mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_checkQueryData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_watershedData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_map__["a" /* default */]],
    components: {
        SparkLine: __WEBPACK_IMPORTED_MODULE_14__components_SidebarSparkline__["a" /* default */]
    },
    data: function data() {
        return {
            name: 'Watershed',
            fwa: null,
            queryDone: false,
            properties: [],
            outletCoords: null,
            queryCoords: null,
            meanElevation: null,
            upstreamArea: null,
            mad: null
        };
    },

    computed: {
        selectedWatershed: function selectedWatershed() {
            return this.$store.state.map.selectedWatershed;
        },
        watershedId: function watershedId() {
            if (this.selectedWatershed) {
                return this.selectedWatershed.id;
            }
            return null;
        }
    },
    mounted: function mounted() {
        this.initialize();
    },

    methods: {
        /**
         * handle initial data fetching and potentially watershed changes
         */
        initialize: function initialize() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                // reset local vars
                                _this.queryDone = false;
                                _this.queryData = {};

                                // fetch data
                                _context.next = 4;
                                return _this.getData();

                            case 4:
                                _this.buildProps();

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        /**
         * retrieve and download watershed GeoJSON
         */
        downloadGeoJSON: function downloadGeoJSON() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _ref, data;

                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(_this2.$cfg.API_URL + '/watershed/' + _this2.watershedId + '.geojson', {
                                    responseType: 'blob'
                                });

                            case 2:
                                _ref = _context2.sent;
                                data = _ref.data;

                                __WEBPACK_IMPORTED_MODULE_8_js_file_download___default()(data, 'watershed-' + _this2.watershedId + '.geojson');

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },

        /**
         * query the API and fetch watershed data
         */
        getData: function getData() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var wfi, _ref2, data, queryData, outletCoordsXY, _selectedWatershed$co, lng, lat;

                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__constants_actions__["b" /* ADD_LOADING */], 'load watershed data');

                                _context3.prev = 1;
                                wfi = _this3.watershedId;

                                // query for watershed details

                                _context3.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_9__apollo_apollo__["a" /* apolloClient */].query({
                                    query: __WEBPACK_IMPORTED_MODULE_6_graphql_tag___default()(_templateObject),
                                    variables: {
                                        wfi: wfi
                                    }
                                });

                            case 5:
                                _ref2 = _context3.sent;
                                data = _ref2.data;
                                queryData = data.getWatershedWFI;

                                // store results

                                _this3.name = queryData.name;
                                _this3.fwa = queryData.fwa;
                                _this3.mad = queryData.rollup.mean_annual_discharge;
                                _this3.meanElevation = queryData.elevation.mean;
                                _this3.minElevation = queryData.elevation.min;
                                _this3.maxElevation = queryData.elevation.max;
                                // Convert into KM2
                                _this3.upstreamArea = queryData.rollup.upstream_area / 1000000;
                                outletCoordsXY = queryData.outlet_coordinates;

                                _this3.outletCoords = {
                                    lat: outletCoordsXY.y,
                                    lng: outletCoordsXY.x
                                };
                                if (_this3.selectedWatershed.coords) {
                                    _selectedWatershed$co = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_this3.selectedWatershed.coords, 2), lng = _selectedWatershed$co[0], lat = _selectedWatershed$co[1];

                                    _this3.queryCoords = {
                                        lng: lng,
                                        lat: lat
                                    };
                                } else {
                                    _this3.queryCoords = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this3.outletCoords);
                                }

                                _this3.queryDone = true;
                                _context3.next = 24;
                                break;

                            case 21:
                                _context3.prev = 21;
                                _context3.t0 = _context3['catch'](1);

                                _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__constants_actions__["D" /* TRIGGER_TOAST */], 'Error retrieving watershed data');

                            case 24:
                                _context3.prev = 24;

                                _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__constants_actions__["d" /* REMOVE_LOADING */], 'load watershed data');
                                return _context3.finish(24);

                            case 27:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3, [[1, 21, 24, 27]]);
            }))();
        },

        /**
         * build an array of properties to display
         */
        buildProps: function buildProps() {
            var properties = [];
            var numFormat = this.$options.filters.numFormat;

            if (this.queryCoords) {
                var _queryCoords = this.queryCoords,
                    lat = _queryCoords.lat,
                    lng = _queryCoords.lng;

                properties.push({
                    title: 'Query Location',
                    value: __WEBPACK_IMPORTED_MODULE_7_numeral___default()(lat).format('0,0.[00000]') + ', ' + __WEBPACK_IMPORTED_MODULE_7_numeral___default()(lng).format('0,0.[00000]')
                });
            }

            if (this.outletCoords) {
                var _outletCoords = this.outletCoords,
                    _lat = _outletCoords.lat,
                    _lng = _outletCoords.lng;

                properties.push({
                    title: 'Outlet',
                    value: _lat + ', ' + _lng
                });
            }

            if (this.upstreamArea) {
                var area = numFormat(this.upstreamArea, '0,0.[0]');
                properties.push({
                    title: 'Watershed Area',
                    value: area + ' km\xB2'
                });
            }
            // min, mean, max elevation (where available)
            var elevations = [];
            if (this.minElevation !== null) {
                var min = numFormat(this.minElevation, '0,0.[0]');
                elevations.push(min + ' m (min)');
            }
            if (this.meanElevation !== null) {
                var mean = numFormat(this.meanElevation, '0,0.[0]');
                elevations.push(mean + ' m (mean)');
            }
            if (this.maxElevation !== null) {
                var max = numFormat(this.maxElevation, '0,0.[0]');
                elevations.push(max + ' m (max)');
            }
            if (elevations.length > 0) {
                properties.push({
                    title: 'Elevation',
                    value: elevations.join(', ')
                });
            }

            if (this.mad) {
                var mad = numFormat(this.mad, '0,0.[00]');
                properties.push({
                    title: 'Mean Annual Discharge',
                    value: mad + ' m\xB3/s'
                });
            }

            this.properties = properties;
        },

        /**
         * Generate a report for a watershed
         */
        generateReport: function generateReport() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var watershed, _queryCoords2, lng, lat, _ref3, data;

                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                window.gtag('event', 'Report', { action: 'generate', label: 'User initiated report generation' });
                                watershed = _this4.watershedId;

                                _this4.$root.$emit('report-generating', {
                                    name: _this4.name,
                                    wfi: watershed
                                });
                                _this4.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__constants_actions__["D" /* TRIGGER_TOAST */], 'Report added to queue');
                                _context4.prev = 4;
                                _queryCoords2 = _this4.queryCoords, lng = _queryCoords2.lng, lat = _queryCoords2.lat;
                                _context4.next = 8;
                                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(_this4.$cfg.API_URL + '/report/watershed', {
                                    wfi: watershed,
                                    fwa: _this4.fwa,
                                    lat: Number(lat),
                                    lng: Number(lng),
                                    name: _this4.name
                                }, { timeout: 5000000 });

                            case 8:
                                _ref3 = _context4.sent;
                                data = _ref3.data;

                                _this4.$root.$emit('report-generated', {
                                    file: data.file,
                                    wfi: watershed
                                });
                                _context4.next = 16;
                                break;

                            case 13:
                                _context4.prev = 13;
                                _context4.t0 = _context4['catch'](4);

                                _this4.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__constants_actions__["D" /* TRIGGER_TOAST */], 'Error generating report');

                            case 16:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4, [[4, 13]]);
            }))();
        },

        /**
         * clear selected watershed
         */
        clearSelection: function clearSelection() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__constants_actions__["h" /* SELECT_WATERSHED */], null);
        }
    },
    watch: {
        selectedWatershed: function selectedWatershed(val) {
            if (val && val.id) {
                // re-initialize component when a new watershed is selected
                this.initialize();
            }
        }
    }
});

/***/ }),

/***/ "4oE4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SidebarStationStreamflow__ = __webpack_require__("dTuk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SidebarStationSurfaceQuality__ = __webpack_require__("Maap");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SidebarStationGroundQuality__ = __webpack_require__("Euhy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SidebarStationGroundLevel__ = __webpack_require__("kMCa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SidebarStationClimate__ = __webpack_require__("OeZI");
//
//
//
//
//
//
//
//
//
//
//
//

// components






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'selected-station',
    components: {
        StreamflowStation: __WEBPACK_IMPORTED_MODULE_0__components_SidebarStationStreamflow__["a" /* default */],
        SurfaceQualityStation: __WEBPACK_IMPORTED_MODULE_1__components_SidebarStationSurfaceQuality__["a" /* default */],
        GroundQualityStation: __WEBPACK_IMPORTED_MODULE_2__components_SidebarStationGroundQuality__["a" /* default */],
        GroundLevelStation: __WEBPACK_IMPORTED_MODULE_3__components_SidebarStationGroundLevel__["a" /* default */],
        ClimateStation: __WEBPACK_IMPORTED_MODULE_4__components_SidebarStationClimate__["a" /* default */]
    },
    data: function data() {
        return {};
    },

    computed: {
        station: function station() {
            return this.$store.state.map.selectedStation;
        },
        routeName: function routeName() {
            return this.$route.name.toLowerCase();
        }
    }
});

/***/ }),

/***/ "4qPv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"station-details gw-level"},[(!_vm.queryDone)?_c('div',{staticClass:"loading"},[_c('p',[_vm._v("Loading station data...")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),_vm._v(" "),(_vm.station && _vm.queryDone)?_c('div',{staticClass:"station"},[_c('h3',{staticClass:"headline station-name primary--text",domProps:{"textContent":_vm._s(_vm.queryData.name)}}),_vm._v(" "),_c('p',{staticClass:"body-2 mb-1 network-info"},[_vm._v("\n            "+_vm._s(_vm.networkId)),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":_vm.networkUrl}},[_vm._v(_vm._s(_vm.network))])]),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_vm._l((_vm.properties),function(ref){
var title = ref.title;
var value = ref.value;
return (value)?_c('div',{staticClass:"properties-item mb-3"},[_c('h4',{staticClass:"subheading field-title grey--text",domProps:{"textContent":_vm._s(title)}}),_vm._v(" "),_c('div',{staticClass:"body-1 field-value",domProps:{"textContent":_vm._s(value)}})]):_vm._e()}),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_c('download-csv-button',{attrs:{"redistribute":_vm.dataRedistirbute,"station-id":_vm.stationId}}),_vm._v(" "),_c('h3',{staticClass:"mt-3 mb-1 subheading"},[_vm._v("Level")]),_vm._v(" "),(_vm.checkChartData(this.queryData, 'hydrograph', this.checkGroundLevelDataFields.hydrograph))?_c('spark-line',{attrs:{"id":"hydrographSparkline","height":"76","width":"300","datasets":_vm.hydrographDatasets,"options":{
            scales: {
                yAxes: [{
                    ticks: {
                        display: false,
                        beginAtZero: false,
                    },
                    gridLines: {
                        display: false,
                        drawBorder: false,
                    },
                }],
                xAxes: [{
                    ticks: {
                        display: false,
                        },
                    gridLines: {
                        display: false,
                        drawBorder: false,
                    },
                }],
            },
        }},on:{"click":function($event){_vm.showChartModal('hydrograph')}}}):_vm._e(),_vm._v(" "),(!_vm.checkChartData(this.queryData, 'hydrograph', this.checkGroundLevelDataFields.hydrograph))?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"my-3"})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4rqJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "549J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-legend",class:{ showing: _vm.value }},[_c('div',{staticClass:"mapboxgl-ctrl mapboxgl-ctrl-group map-legend-control",style:({ top: _vm.topStyle }),attrs:{"id":"map-legend-button"},on:{"click":function($event){_vm.show(!_vm.value)}}},[_c('v-tooltip',{attrs:{"right":""}},[_c('button',{attrs:{"slot":"activator","type":"button"},slot:"activator"},[_c('v-icon',{staticClass:"mbgl-color"},[_vm._v("info")])],1),_vm._v(" "),_c('span',[_vm._v("Map legend")])])],1),_vm._v(" "),(_vm.value)?_c('div',{staticClass:"legend-items mapboxgl-ctrl mapboxgl-ctrl-group mbgl-color",style:({ top: _vm.topStyle }),attrs:{"id":"map-legend-popup"},on:{"click":function($event){_vm.show(false)}}},[_c('v-list',{attrs:{"dense":"","light":"","subheader":""}},[_c('v-subheader',[_c('span',{staticClass:"selection-subhead mbgl-color"},[_vm._v("\n                    Map legend\n                ")])]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('v-list-tile',{key:item.name,staticClass:"list-item",attrs:{"avatar":""}},[_c('div',{staticClass:"icon-wrap"},[_c('div',{staticClass:"map-circle",style:(_vm.getCircleStyle(item))})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.title)}})],1)],1)})],2)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5SKL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5U9U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5h6Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5pN9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"streamflow-stage-chart"},[_c('div',{staticClass:"yearly-data-select"},[_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"d-flex":"","sm3":""}},[_c('v-select',{attrs:{"width":"200","label":"Select","items":_vm.yearlyDataAvailable,"multiple":"","max-height":"400","hint":"Add yearly data","persistent-hint":""},model:{value:(_vm.yearlyDataDisplay),callback:function ($$v) {_vm.yearlyDataDisplay=$$v},expression:"yearlyDataDisplay"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":"","d-flex":"","justify-center":"","align-content-end":""}},[_c('v-btn',{attrs:{"outline":""},on:{"click":_vm.downloadChart}},[_c('v-icon',[_vm._v("file_download")]),_vm._v(" Download PNG")],1)],1)],1)],1),_vm._v(" "),_c('a',{ref:"downloadUrl",staticStyle:{"display":"none"},attrs:{"href":"#"}}),_vm._v(" "),_c('div',{staticClass:"chart-wrap"},[_c('v-btn',{staticClass:"zoom-btn",attrs:{"icon":""},on:{"click":_vm.resetZoom}},[_c('v-icon',[_vm._v("zoom_out")])],1),_vm._v(" "),_c('canvas',{attrs:{"id":_vm.chartId}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5qLp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClimateSnow_vue__ = __webpack_require__("25jo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e6f3406_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClimateSnow_vue__ = __webpack_require__("T/Fn");
function injectStyle (ssrContext) {
  __webpack_require__("U/+O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClimateSnow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e6f3406_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClimateSnow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "67Rs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "68bA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_popper_js__ = __webpack_require__("Zgw8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hash_sum__ = __webpack_require__("/uYw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hash_sum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hash_sum__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var DEFAULT_STEP_OPTIONS = {
    placement: 'bottom'
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'v-step',
    props: {
        step: {
            type: Object
        },
        previousStep: {
            type: Function
        },
        nextStep: {
            type: Function
        },
        stop: {
            type: Function
        },
        isFirst: {
            type: Boolean
        },
        isLast: {
            type: Boolean
        }
    },
    data: function data() {
        return {
            hash: __WEBPACK_IMPORTED_MODULE_2_hash_sum___default()(this.step.target)
        };
    },

    computed: {
        params: function params() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_STEP_OPTIONS, this.step.params);
        }
    },
    mounted: function mounted() {
        var targetElement = document.querySelector(this.step.target);

        if (targetElement) {
            /* eslint-disable no-new */
            new __WEBPACK_IMPORTED_MODULE_1_popper_js__["a" /* default */](targetElement, this.$refs['v-step-' + this.hash], this.params);
        } else {
            this.stop();
        }
    }
});

/***/ }),

/***/ "6BH1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6Ba5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6S68":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-wrap",class:_vm.classObj},[_c('mapbox-gl-map',{attrs:{"id":"map","accessToken":_vm.$cfg.mapboxgl.accessToken,"options":_vm.getMapOptions()},on:{"loaded":_vm.mapLoaded}}),_vm._v(" "),_c('chart-modal'),_vm._v(" "),_c('overlap-picker',{attrs:{"features":_vm.overlapFeatures},on:{"select":_vm.selectStation},scopedSlots:_vm._u([{key:"header",fn:function(slotScope){return [_vm._v("\n            "+_vm._s(slotScope.numFeatures)+" stations at these coordinates\n        ")]}},{key:"listItem",fn:function(slotScope){return [_c('v-list-tile-title',{domProps:{"textContent":_vm._s(slotScope.feature.properties.name)}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v("\n                "+_vm._s(slotScope.feature.properties.network)+"\n            ")])]}}]),model:{value:(_vm.showOverlapPicker),callback:function ($$v) {_vm.showOverlapPicker=$$v},expression:"showOverlapPicker"}}),_vm._v(" "),_c('style-switcher',{on:{"switchedStyle":_vm.addLayers},model:{value:(_vm.showStyleSwitcher),callback:function ($$v) {_vm.showStyleSwitcher=$$v},expression:"showStyleSwitcher"}}),_vm._v(" "),_c('map-save-button',{attrs:{"featuresUrl":_vm.mapSourceUrl},model:{value:(_vm.showMapSave),callback:function ($$v) {_vm.showMapSave=$$v},expression:"showMapSave"}},[_c('template',{attrs:{"slot":"features-headline"},slot:"features-headline"},[_vm._v("Download stations")])],2),_vm._v(" "),_c('map-legend',{attrs:{"items":_vm.getLegendLayers()},model:{value:(_vm.showMapLegend),callback:function ($$v) {_vm.showMapLegend=$$v},expression:"showMapLegend"}}),_vm._v(" "),_c('map-sidebar',{attrs:{"filters":_vm.filters}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Tn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions_appColors__ = __webpack_require__("QW0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MapLegend__ = __webpack_require__("+GTB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_actions__ = __webpack_require__("UOq2");




/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        showMapLegend: {
            get: function get() {
                return this.$store.state.map.showMapLegend;
            },
            set: function set(val) {
                this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__constants_actions__["z" /* SHOW_MAP_LEGEND */], val);
            }
        }
    },
    components: {
        mapLegend: __WEBPACK_IMPORTED_MODULE_1__components_MapLegend__["a" /* default */]
    },
    methods: {
        /**
         * return a formatted legend config object
         * @return {Object} map legend configuration
         */
        getLegendLayers: function getLegendLayers() {
            return [{
                title: 'Historical data',
                color: String(__WEBPACK_IMPORTED_MODULE_0__functions_appColors__["l" /* markerHistorical */])
            }, {
                title: 'Current data',
                color: String(__WEBPACK_IMPORTED_MODULE_0__functions_appColors__["i" /* markerCurrent */])
            }];
        }
    }
});

/***/ }),

/***/ "6UOv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"24px","height":"24px","viewBox":"0 0 24 24","enable-background":"new 0 0 24 24","xml:space":"preserve"}},[_c('path',{attrs:{"fill":_vm.color,"d":"M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10c5.52,0,10-4.48,10-10C22,6.48,17.52,2,12,2z M8.208,16.105h9.584v1.371\n    H6.838V6.522h1.37V16.105z M9.919,14.423c-0.566,0-1.027-0.461-1.027-1.026c0-0.566,0.46-1.025,1.027-1.025\n    c0.03,0,0.061,0,0.09,0.002l1.104-1.839c-0.105-0.161-0.167-0.354-0.167-0.561c0-0.566,0.46-1.027,1.027-1.027\n    c0.566,0,1.028,0.46,1.028,1.027c0,0.207-0.063,0.399-0.168,0.561l1.104,1.839c0.028-0.002,0.06-0.002,0.088-0.002\n    c0.022,0,0.045,0,0.068,0l1.823-3.188c-0.112-0.165-0.181-0.365-0.181-0.579c0-0.567,0.462-1.027,1.027-1.027\n    c0.567,0,1.026,0.46,1.026,1.027s-0.459,1.027-1.026,1.027c-0.021,0-0.045,0-0.066-0.002l-1.824,3.189\n    c0.113,0.164,0.18,0.365,0.18,0.578c0,0.565-0.46,1.026-1.027,1.026c-0.565,0-1.024-0.461-1.024-1.026\n    c0-0.205,0.062-0.4,0.165-0.562l-1.103-1.839c-0.03,0.002-0.06,0.003-0.09,0.003c-0.03,0-0.061-0.001-0.089-0.003l-1.104,1.839\n    c0.105,0.16,0.167,0.354,0.167,0.562C10.946,13.962,10.486,14.423,9.919,14.423z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6bpK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-context-menu"},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text pa-2 pl-3 spaced"},[_c('h3',{staticClass:"title"},[_vm._v("Coordinates")]),_vm._v(" "),_c('v-btn',{staticClass:"primary right close-button ma-0 pa-0",attrs:{"flat":"","icon":""},on:{"click":function($event){_vm.$emit('close')}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-center"},[_c('input',{ref:"click-coordinates",staticClass:"subheading text-xs-center",attrs:{"readonly":"","id":"click-coordinates","type":"text"},domProps:{"value":_vm.displayCoords},on:{"click":function (ref) {
	var target = ref.target;

	return target.select();
}}})]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":_vm.copyCoordinates}},[_vm._v("Copy to clipboard")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6ntq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FDMonthlyFlowStats_vue__ = __webpack_require__("uXQQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16e60bf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FDMonthlyFlowStats_vue__ = __webpack_require__("Bz91");
function injectStyle (ssrContext) {
  __webpack_require__("q8xZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FDMonthlyFlowStats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16e60bf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FDMonthlyFlowStats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6qpg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"24px","height":"24px","viewBox":"0 0 24 24","enable-background":"new 0 0 24 24","xml:space":"preserve"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":_vm.color,"d":"M11.986,1.98c-5.521,0-10,4.48-10,10c0,5.52,4.479,10,10,10c5.52,0,10-4.48,10-10\n    C21.986,6.46,17.506,1.98,11.986,1.98z"}}),_vm._v(" "),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#FFFFFF","d":"M15.258,9.449L15.258,9.449c0.537,0.434,0.892,1.096,0.903,1.836\n    c0.774,0.338,1.313,1.109,1.313,2.008c0,1.205-0.979,2.188-2.188,2.188H7.845c-1.211,0-2.188-0.98-2.188-2.188\n    c0-0.898,0.543-1.672,1.319-2.008c-0.004-0.061-0.006-0.121-0.006-0.181c0-1.692,1.373-3.063,3.063-3.063\n    c0.229,0,0.443,0.023,0.658,0.071l0,0c0.384-0.819,1.216-1.386,2.18-1.386c1.33,0,2.408,1.078,2.408,2.406\n    C15.279,9.24,15.271,9.346,15.258,9.449L15.258,9.449z"}}),_vm._v(" "),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":_vm.color,"d":"M12.986,7.824c-0.767,0-1.128,0.128-1.453,0.766\n    c0.548,0.209,0.549,0.392,0.895,0.854c0.368-0.228,0.465-0.386,0.98-0.464c0.375-0.031,0.453-0.016,0.828,0.031\n    C14.236,9.011,14.074,7.824,12.986,7.824z"}}),_vm._v(" "),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#FFFFFF","d":"M7.406,17.607c0-0.633,1.101-1.688,1.101-1.688\n    s1.088,1.057,1.088,1.688c0,0.451-0.355,0.939-1.088,0.939C7.772,18.547,7.406,18.096,7.406,17.607L7.406,17.607z"}}),_vm._v(" "),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#FFFFFF","d":"M10.47,18.045c0-0.631,1.101-1.688,1.101-1.688\n    s1.09,1.057,1.09,1.688c0,0.451-0.356,0.938-1.09,0.938C10.837,18.984,10.47,18.535,10.47,18.045L10.47,18.045z"}}),_vm._v(" "),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#FFFFFF","d":"M13.535,17.607c0-0.633,1.1-1.688,1.1-1.688s1.09,1.057,1.09,1.688\n    c0,0.451-0.355,0.939-1.09,0.939C13.901,18.547,13.535,18.096,13.535,17.607L13.535,17.607z"}}),_vm._v(" "),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#FFFFFF","d":"M12.879,4.124c-0.272,0-0.492,0.211-0.492,0.49V5.59\n    c0,0.268,0.229,0.486,0.492,0.486c0.272,0,0.492-0.212,0.492-0.486V4.614C13.371,4.342,13.143,4.124,12.879,4.124L12.879,4.124z"}}),_vm._v(" "),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#FFFFFF","d":"M16.177,5.877c-0.191-0.191-0.498-0.199-0.695-0.003l-0.4,0.4\n    c-0.188,0.19-0.184,0.509,0.006,0.692c0.191,0.193,0.496,0.198,0.689,0.002l0.402-0.398C16.37,6.381,16.36,6.063,16.177,5.877\n    L16.177,5.877z"}}),_vm._v(" "),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#FFFFFF","d":"M17.758,9.144c0-0.271-0.212-0.494-0.487-0.494h-0.98\n    c-0.266,0-0.485,0.23-0.485,0.494c0,0.273,0.211,0.492,0.485,0.492h0.98C17.54,9.634,17.758,9.408,17.758,9.144L17.758,9.144z"}}),_vm._v(" "),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#FFFFFF","d":"M9.585,5.956c-0.193,0.19-0.199,0.5-0.004,0.693l0.4,0.398\n    c0.188,0.189,0.507,0.185,0.694-0.002c0.191-0.191,0.196-0.499,0.003-0.692l-0.4-0.4C10.088,5.762,9.772,5.771,9.585,5.956\n    L9.585,5.956z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7HhR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"climate-temperature-chart"},[_c('div',{staticClass:"yearly-data-select"},[_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"d-flex":"","sm3":""}},[_c('v-select',{attrs:{"width":"200","label":"Select","items":_vm.yearlyDataAvailable,"multiple":"","max-height":"400","hint":"Add yearly data","persistent-hint":""},model:{value:(_vm.yearlyDataDisplay),callback:function ($$v) {_vm.yearlyDataDisplay=$$v},expression:"yearlyDataDisplay"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":"","d-flex":"","justify-center":"","align-content-end":""}},[_c('v-btn',{attrs:{"outline":""},on:{"click":_vm.downloadChart}},[_c('v-icon',[_vm._v("file_download")]),_vm._v(" Download PNG")],1)],1)],1)],1),_vm._v(" "),_c('a',{ref:"downloadUrl",staticStyle:{"display":"none"},attrs:{"href":"#"}}),_vm._v(" "),_c('div',{staticClass:"chart-wrap"},[_c('v-btn',{staticClass:"zoom-btn",attrs:{"icon":""},on:{"click":_vm.resetZoom}},[_c('v-icon',[_vm._v("zoom_out")])],1),_vm._v(" "),_c('canvas',{attrs:{"id":_vm.chartId}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Kvn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Streamflow_vue__ = __webpack_require__("hxIM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b2de1ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Streamflow_vue__ = __webpack_require__("nY6U");
function injectStyle (ssrContext) {
  __webpack_require__("IuoA")
  __webpack_require__("sw+o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b2de1ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Streamflow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b2de1ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Streamflow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "82N8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"climate-manual-snow-survey-chart"},[_c('div',{staticClass:"yearly-data-select"},[_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"d-flex":"","sm3":""}},[_c('v-select',{attrs:{"width":"200","label":"Select","items":_vm.yearlyDataAvailable,"multiple":"","max-height":"400","hint":"Add yearly data","persistent-hint":""},model:{value:(_vm.yearlyDataDisplay),callback:function ($$v) {_vm.yearlyDataDisplay=$$v},expression:"yearlyDataDisplay"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":"","d-flex":"","justify-center":"","align-content-end":""}},[_c('v-btn',{attrs:{"outline":""},on:{"click":_vm.downloadChart}},[_c('v-icon',[_vm._v("file_download")]),_vm._v(" Download PNG")],1)],1)],1)],1),_vm._v(" "),_c('a',{ref:"downloadUrl",staticStyle:{"display":"none"},attrs:{"href":"#"}}),_vm._v(" "),_c('div',{staticClass:"chart-wrap"},[_c('v-btn',{staticClass:"zoom-btn",attrs:{"icon":""},on:{"click":_vm.resetZoom}},[_c('v-icon',[_vm._v("zoom_out")])],1),_vm._v(" "),_c('canvas',{attrs:{"id":_vm.chartId}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "89KZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8H5j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions_appColors__ = __webpack_require__("QW0U");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        color: {
            default: String(__WEBPACK_IMPORTED_MODULE_0__functions_appColors__["s" /* navIcon */]),
            type: String
        }
    }
});

/***/ }),

/***/ "8WYj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3SparklineWrapper_vue__ = __webpack_require__("cueH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_450747a9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D3SparklineWrapper_vue__ = __webpack_require__("Zp+G");
function injectStyle (ssrContext) {
  __webpack_require__("+jVx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3SparklineWrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_450747a9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D3SparklineWrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8bU7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_streamflowData__ = __webpack_require__("Nt91");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ScrollingTable__ = __webpack_require__("92Dq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3__ = __webpack_require__("vwbq");
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'monthly-mean-flow-table',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_streamflowData__["a" /* default */]],
    components: {
        ScrollingTable: __WEBPACK_IMPORTED_MODULE_1__components_ScrollingTable__["a" /* default */]
    },
    methods: {
        getColor: function getColor(item, max, min) {
            if (item.full_month === false) {
                return 'rgb(230,230,230)';
            }
            var val = item.value;
            // Define the colors
            var low = [245, 252, 255];
            var high = [111, 145, 164];
            var result = [255, 255, 255];

            // Check if a value is the same as max
            if (val === max) {
                return 'rgb(' + high[0] + ', ' + high[1] + ', ' + high[2] + ')';
            }

            // Check if the value is the same as min
            if (val === min) {
                return 'rgb(' + low[0] + ', ' + low[1] + ', ' + low[2] + ')';
            }

            // Calculate the color for the value
            for (var i = 0; i < result.length; i++) {
                // eslint-disable-line no-plusplus
                result[i] = Math.round(low[i] + (val - min) * ((high[i] - low[i]) / (max - min)));
            }

            // Return the result
            return 'rgb(' + result[0] + ', ' + result[1] + ', ' + result[2] + ')';
        }
    },
    computed: {
        scrollingTableData: function scrollingTableData() {
            var _this = this;

            var tableData = this.tableData || [];

            if (this.tableData.length === 0) {
                return [];
            }

            // check if the tableData array is formatted, but still all null values
            if (this.tableData.length === 4) {
                // header, min, max, mean
                var emptyTable = true;
                for (var rowNum = 1; rowNum < 4; rowNum += 1) {
                    var row = this.tableData[rowNum];
                    // check cell value, skipping first (label) column
                    if (row.some(function (cell, colNum) {
                        return cell.value !== null && colNum > 0;
                    })) {
                        emptyTable = false;
                        break;
                    }
                }

                if (emptyTable) {
                    return [];
                }
            }

            // colorize cells

            var _loop = function _loop(r, numRows) {
                var row = tableData[r];
                var vals = row.slice(1).map(function (e) {
                    return e.value;
                });
                var min = __WEBPACK_IMPORTED_MODULE_2_d3__["o" /* min */](vals);
                var max = __WEBPACK_IMPORTED_MODULE_2_d3__["l" /* max */](vals);
                row.forEach(function (col, c) {
                    if (c === 0) return;
                    var color = _this.getColor(col, max, min);
                    tableData[r][c].color = color;
                });
            };

            for (var r = 1, numRows = tableData.length; r < numRows; r += 1) {
                _loop(r, numRows);
            }

            return tableData;
        }
    }
});

/***/ }),

/***/ "8lxH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"24px","height":"24px","viewBox":"0 0 24 24","enable-background":"new 0 0 24 24","xml:space":"preserve"}},[_c('path',{attrs:{"fill":_vm.color,"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12,1.999c-5.521,0-10,4.48-10,10C2,17.52,6.479,22,12,22\n    c5.52,0,10-4.48,10-10.001C22,6.479,17.52,1.999,12,1.999z M7.032,8.274H5.79v8.694c0,0.683,0.559,1.242,1.242,1.242h8.694v-1.242\n    H7.032V8.274z M16.968,5.79H9.517c-0.684,0-1.242,0.559-1.242,1.242v7.452c0,0.683,0.559,1.241,1.242,1.241h7.451\n    c0.683,0,1.242-0.559,1.242-1.241V7.032C18.21,6.349,17.65,5.79,16.968,5.79z M16.347,11.379h-6.209v-1.242h6.209V11.379z\n    M13.863,13.863h-3.726v-1.242h3.726V13.863z M16.347,8.896h-6.209V7.653h6.209V8.896z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8q94":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportInterstitial_vue__ = __webpack_require__("XC8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba0b5590_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportInterstitial_vue__ = __webpack_require__("/gII");
function injectStyle (ssrContext) {
  __webpack_require__("LZJ7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportInterstitial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba0b5590_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportInterstitial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8rkh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pluralize__ = __webpack_require__("DbJJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pluralize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pluralize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_D3SparklineWrapper__ = __webpack_require__("8WYj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_groundQualityData__ = __webpack_require__("DMv4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_getStationMetadata__ = __webpack_require__("s6bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SingleChartModal__ = __webpack_require__("vOnF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DownloadCsvButton__ = __webpack_require__("l2MX");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'station-details-ground-quality',
    components: {
        SparkLine: __WEBPACK_IMPORTED_MODULE_4__components_D3SparklineWrapper__["a" /* default */],
        SingleChartModal: __WEBPACK_IMPORTED_MODULE_7__components_SingleChartModal__["a" /* default */],
        DownloadCsvButton: __WEBPACK_IMPORTED_MODULE_8__components_DownloadCsvButton__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_groundQualityData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_getStationMetadata__["a" /* default */]],
    mounted: function mounted() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.getData();

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    data: function data() {
        return {
            allChartData: null,
            numVisibleSparklines: 5,
            chartDetails: null
        };
    },

    computed: {
        stationId: function stationId() {
            return this.station.id;
        },
        visibleSparklines: function visibleSparklines() {
            return this.sparklineData.slice(0, this.numVisibleSparklines);
        }
    },
    methods: {
        addCharts: function addCharts() {
            this.numVisibleSparklines += 5;
        },
        pluralize: function pluralize(term, num) {
            return __WEBPACK_IMPORTED_MODULE_2_pluralize___default()(term, num);
        },
        showChartModal: function showChartModal(tabName) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__constants_actions__["i" /* SET_CHART_MODAL_TAB */], tabName);
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__constants_actions__["y" /* SHOW_CHART_MODAL */], true);
        },

        /**
         * display a modal window showing a single chart
         * @param  {Object} chart data object with name & data keys
         */
        showSingleChart: function showSingleChart(chart) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var paramId, title, units;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                paramId = chart.paramId, title = chart.title, units = chart.units;

                                _this2.chartDetails = {
                                    stationId: _this2.stationId,
                                    paramId: paramId,
                                    title: title,
                                    units: units
                                };
                                _this2.showSingleChartModal = true;

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    },
    watch: {
        station: function station() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this3.numVisibleSparklines = 5;
                                _context3.next = 3;
                                return _this3.getData();

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        }
    }
});

/***/ }),

/***/ "92Dq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScrollingTable_vue__ = __webpack_require__("kNz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2426c911_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScrollingTable_vue__ = __webpack_require__("zAgp");
function injectStyle (ssrContext) {
  __webpack_require__("ILTc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScrollingTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2426c911_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScrollingTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9GbT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_actions__ = __webpack_require__("UOq2");


/*
 save map position in vuex, and react to changes
*/



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        mapCenter: function mapCenter() {
            return this.$store.state.map.center;
        }
    },
    methods: {
        /**
         * set the map position in vuex
         */
        setMapStatePosition: function setMapStatePosition() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var map, center;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.mapPromise;

                            case 2:
                                map = _context.sent;
                                center = map.getCenter();

                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__constants_actions__["r" /* SET_MAP_CENTER */], center);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    watch: {
        // re-center map if map.center changes in vuex
        mapCenter: function mapCenter(center) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var map, localCenter, lat, lng;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this2.mapPromise;

                            case 2:
                                map = _context2.sent;
                                localCenter = map.getCenter();

                                if (center.zoom) map.setZoom(center.zoom);
                                lat = center.lat, lng = center.lng;

                                if (!(localCenter.lat === lat && localCenter.lng === lng)) {
                                    _context2.next = 8;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 8:

                                try {
                                    map.setCenter([lng, lat]);
                                } catch (e) {
                                    _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__constants_actions__["x" /* SET_TOAST_TEXT */], e.message);
                                    _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__constants_actions__["C" /* SHOW_TOAST */]);
                                }

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    }
});

/***/ }),

/***/ "9UE/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"fill":_vm.color,"d":"M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A4gD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions_appColors__ = __webpack_require__("QW0U");
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        color: {
            default: String(__WEBPACK_IMPORTED_MODULE_0__functions_appColors__["s" /* navIcon */]),
            type: String
        }
    }
});

/***/ }),

/***/ "AEt0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Streamflow_vue__ = __webpack_require__("Wj++");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_110c980a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Streamflow_vue__ = __webpack_require__("6UOv");
function injectStyle (ssrContext) {
  __webpack_require__("GfAr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Streamflow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_110c980a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Streamflow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AHJT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__apollo_apollo__ = __webpack_require__("YQr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_map__ = __webpack_require__("aiDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_icons_Streamflow__ = __webpack_require__("AEt0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_icons_Watershed__ = __webpack_require__("IkOK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_icons_SwQuality__ = __webpack_require__("cu9N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_icons_GwQuality__ = __webpack_require__("txPp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_icons_GwLevel__ = __webpack_require__("Qxw7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_icons_Climate__ = __webpack_require__("u6mf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_icons_Geoname__ = __webpack_require__("nsvp");




var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n                    query($q: String!, $offset: Int!, $limit: Int!) {\n                        search(q: $q, offset: $offset, limit: $limit)\n                    }\n                '], ['\n                    query($q: String!, $offset: Int!, $limit: Int!) {\n                        search(q: $q, offset: $offset, limit: $limit)\n                    }\n                ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'search-bar',
    mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_map__["a" /* default */]],
    components: {
        iconWatershed: __WEBPACK_IMPORTED_MODULE_9__components_icons_Watershed__["a" /* default */],
        iconSwQuality: __WEBPACK_IMPORTED_MODULE_10__components_icons_SwQuality__["a" /* default */],
        iconGwQuality: __WEBPACK_IMPORTED_MODULE_11__components_icons_GwQuality__["a" /* default */],
        iconGwLevel: __WEBPACK_IMPORTED_MODULE_12__components_icons_GwLevel__["a" /* default */],
        iconClimate: __WEBPACK_IMPORTED_MODULE_13__components_icons_Climate__["a" /* default */],
        iconStreamflow: __WEBPACK_IMPORTED_MODULE_8__components_icons_Streamflow__["a" /* default */],
        iconGeoname: __WEBPACK_IMPORTED_MODULE_14__components_icons_Geoname__["a" /* default */]
    },
    data: function data() {
        return {
            coordsRegExp: /^(-?\d{1,3}(\.\d+)?),\s*(-?\d{1,3}(\.\d+)?)$/,
            query: '',
            results: [],
            // local loading indicator
            searching: false
        };
    },

    computed: {
        /**
         * return true if the search query looks like a coordinates string
         * @return {Boolean} true for coordinates
         */
        coordsQuery: function coordsQuery() {
            return this.coordsRegExp.test(this.query);
        },
        coords: function coords() {
            if (!this.coordsQuery) {
                return { lat: 0, lng: 0 };
            }
            var matches = this.query.match(this.coordsRegExp);
            return {
                lat: Number(matches[1]),
                lng: Number(matches[3])
            };
        },
        showResults: function showResults() {
            return Boolean(this.query);
        }
    },
    methods: {
        /**
         * set searching = true if there's a search query string,
         * otherwise set it false
         */
        startLoading: function startLoading() {
            if (this.query) {
                this.searching = true;
            } else {
                this.searching = false;
            }
        },

        // handle search input and run the query if applicable
        onInput: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function typing() {
            if (this.query) {
                this.getResults();
            }
        }, 200),
        // for demo purposes, do a fuzzymatch search on the local data
        getResults: function getResults() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_6__apollo_apollo__["a" /* apolloClient */].query({
                                    query: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject),
                                    variables: {
                                        q: _this.query,
                                        offset: 0,
                                        limit: 5
                                    }
                                });

                            case 3:
                                _ref = _context.sent;
                                data = _ref.data;

                                _this.results = data.search.hits.hits.map(function (item) {
                                    var type = item._source.type;
                                    if (type === 'stations') {
                                        var geocomment = item._source.geocomment;

                                        type = ['groundwater level', 'climate', 'streamflow monitoring', 'surface water quality', 'groundwater quality'].find(function (i) {
                                            return i === geocomment.toLowerCase();
                                        });
                                    }
                                    return {
                                        _id: item._id,
                                        _source: item._source,
                                        type: type
                                    };
                                });
                                _this.searching = false;
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](0);

                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["D" /* TRIGGER_TOAST */], 'Error retrieving search results');

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[0, 9]]);
            }))();
        },

        /**
         * focus the map on the selected feature, and show the sidebar
         * @param  {Object} result selected feature
         */
        selectResult: function selectResult(result) {
            window.gtag('event', 'Search', { action: 'selectresult', label: 'User selected a result from a search result' });
            var _result$_source = result._source,
                id = _result$_source.id,
                type = _result$_source.type,
                lng = _result$_source.x,
                lat = _result$_source.y;

            var currentRoutePath = this.$route.path;

            if (type === 'stations') {
                window.gtag('event', 'Search', { action: 'selectstation', label: 'User chose station from search' });
                var route = {
                    'groundwater level': 'groundwater-level',
                    climate: 'climate',
                    'streamflow monitoring': 'streamflow',
                    'surface water quality': 'surface-water-quality',
                    'groundwater quality': 'groundwater-quality'
                }[result._source.geocomment.toLowerCase()];
                route = '/' + route;

                if (currentRoutePath !== route) {
                    // store selected station in the loadState module
                    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["p" /* SET_LOADSTATE_SELECTED_FEATURE */], {
                        id: id,
                        coords: [lng, lat],
                        type: 'station'
                    });
                    // redirect to new page,
                    // which will then select it from the loadState module
                    this.$router.push(route);
                } else {
                    // select licence on this page
                    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["g" /* SELECT_STATION */], {
                        id: id,
                        coords: [lng, lat]
                    });
                    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], true);
                }
            } else if (type === 'licences') {
                window.gtag('event', 'Search', { action: 'selectwfi', label: 'User chose licence from search' });
                if (currentRoutePath !== '/watershed') {
                    // store selected licence in the loadState module
                    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["p" /* SET_LOADSTATE_SELECTED_FEATURE */], {
                        id: id,
                        coords: [lng, lat],
                        type: 'licence'
                    });
                    // redirect to watersheds page,
                    // which will then select it from the loadState module
                    this.$router.push('/watershed');
                } else {
                    // select licence on this page
                    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["f" /* SELECT_LICENCE */], {
                        id: id,
                        coords: [lng, lat]
                    });
                    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], true);
                }
            } else if (type === 'geonames') {
                window.gtag('event', 'Search', { action: 'selectwfi', label: 'User chose geoname from search' });
                this.selectGeoname({ lat: lat, lng: lng }, result._source.zoom);
            } else if (type === 'wfis') {
                window.gtag('event', 'Search', { action: 'selectwfi', label: 'User chose wfi from search' });

                var wfi = result._source.wfi;

                var coords = [result._source.lng, result._source.lat];

                if (currentRoutePath !== '/watershed') {
                    // store selected watershed in the loadState module
                    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["p" /* SET_LOADSTATE_SELECTED_FEATURE */], {
                        id: wfi,
                        coords: coords,
                        type: 'watershed'
                    });
                    // redirect to watersheds page,
                    // which will then select it from the loadState module
                    this.$router.push('/watershed');
                } else {
                    // select licence on this page
                    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["h" /* SELECT_WATERSHED */], {
                        id: wfi,
                        coords: coords
                    });
                    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], true);
                }
            }
            // clear search and hide results
            this.query = '';
        },
        selectGeoname: function selectGeoname(coords, zoom) {
            this.goToCoordinates(coords, zoom);
            this.query = '';
        },

        /**
         * set the map center in vuex
         * @param {Object} coords object with lng, lat
         * @param {Number} zoom level
         */
        goToCoordinates: function goToCoordinates(coords) {
            var _this2 = this;

            var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 14;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var lng, lat, map, lngLat;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                window.gtag('event', 'Search', { action: 'gotocoordinates', label: 'User chose coordinates from search' });

                                lng = coords.lng, lat = coords.lat;

                                if (!(lat > 90 || lat < -90)) {
                                    _context2.next = 5;
                                    break;
                                }

                                _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["D" /* TRIGGER_TOAST */], 'Latitude must be between -90 and 90');
                                return _context2.abrupt('return');

                            case 5:
                                _context2.next = 7;
                                return _this2.mapPromise;

                            case 7:
                                map = _context2.sent;
                                lngLat = {
                                    lng: lng,
                                    lat: lat
                                };

                                // once the flyTo is done,

                                map.once('moveend', function () {
                                    // fire event click at these coordinates
                                    map.fire('click', {
                                        lngLat: lngLat,
                                        originalEvent: {} // required
                                    });
                                });

                                // animate to these coordinates
                                map.flyTo({
                                    center: lngLat,
                                    zoom: zoom
                                });

                                // clear query to hide the results
                                _this2.query = '';

                            case 12:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    }
});

/***/ }),

/***/ "AHST":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.datasets)?_c('div',{staticClass:"sidebar-sparkline"},[_c('canvas',{staticClass:"chart",attrs:{"id":_vm.id,"height":_vm.height,"width":_vm.width}}),_vm._v(" "),_c('div',{staticClass:"hover-cta"},[_c('v-btn',{on:{"click":function($event){_vm.$emit('click')}}},[_vm._v("View more...")])],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AhwZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_map__ = __webpack_require__("aiDF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'map-style-switcher',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_map__["a" /* default */]],
    props: {
        value: Boolean
    },
    data: function data() {
        return {
            currentStyle: {
                name: 'Default',
                value: 'default',
                url: this.$cfg.mapboxgl.baseStyle
            },
            // basic mapbox styles
            styles: [{
                name: 'Default',
                value: 'default',
                url: this.$cfg.mapboxgl.baseStyle
            }, {
                name: 'Basic',
                value: 'basic',
                url: 'mapbox://styles/mapbox/basic-v9'
            }, {
                name: 'Bright',
                value: 'bright',
                url: 'mapbox://styles/mapbox/bright-v9'
            }, {
                name: 'Light',
                value: 'light',
                url: 'mapbox://styles/mapbox/light-v9'
            }, {
                name: 'Dark',
                value: 'dark',
                url: 'mapbox://styles/mapbox/dark-v9'
            }, {
                name: 'Satellite',
                value: 'satellite',
                url: 'mapbox://styles/mapbox/satellite-v9'
            }]
        };
    },

    methods: {
        /**
         * change visible state of the style selector
         * hides by default
         * @param  {Boolean} [on=false] true for visible
         */
        show: function show() {
            var on = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.$emit('input', on);
        }
    },
    watch: {
        currentStyle: function currentStyle() {
            var _this = this;

            // don't try to change the style if the map isn't loaded
            if (this.map === null) {
                return;
            }

            // hide the selection menu
            this.show(false);

            // set map style URL
            this.map.setStyle(this.currentStyle.url);

            // emit an event, notify the parent page to re-add map layers, etc.
            this.map.once('style.load', function () {
                _this.$emit('switchedStyle', _this.currentStyle.url);
            });
        }
    }
});

/***/ }),

/***/ "AstN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        resetZoom: function resetZoom() {
            this.chart.resetZoom();
        }
    }
});

/***/ }),

/***/ "AuO9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);


/**
 * methods for translating between geojson property values
 * and lookup table IDs.
 *
 * Map styling & filtering in particular depend on the lookup IDs
 * so be sure the lookup tables are loaded successfully
 * before doing any map stuff that uses the IDs.
 */




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            propertyLookups: null
        };
    },

    methods: {
        /**
         * get geojson property lookup tables
         * to translate between ids and property values
         * @return {Object} lookups Object
         */
        getLookupTables: function getLookupTables() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var lookupTableUrl, _ref, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__constants_actions__["b" /* ADD_LOADING */], 'get map data lookup values');
                                lookupTableUrl = _this.mapSourceUrl + '/lookups.json';
                                _context.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(lookupTableUrl);

                            case 5:
                                _ref = _context.sent;
                                data = _ref.data;

                                _this.propertyLookups = data;

                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__constants_actions__["d" /* REMOVE_LOADING */], 'get map data lookup values');
                                _context.next = 14;
                                break;

                            case 11:
                                _context.prev = 11;
                                _context.t0 = _context['catch'](0);

                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__constants_actions__["D" /* TRIGGER_TOAST */], 'Error loading map data');

                            case 14:
                                return _context.abrupt('return', _this.propertyLookups);

                            case 15:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[0, 11]]);
            }))();
        },

        /**
         * get property value from lookup id
         * @param  {String} property property name (key)
         * @param  {Number} id       id from lookup table
         * @return {String}          property value
         */
        lookupPropertyById: function lookupPropertyById(property, id) {
            var lookups = this.propertyLookups[property];
            return lookups[id];
        },

        /**
         * get property id from value
         * returns -1 if not found
         * @param  {String} property property name (key)
         * @param  {String} name     property value
         * @return {Number}          id from lookup table
         */
        lookupPropertyByValue: function lookupPropertyByValue(property, name) {
            var lookups = this.propertyLookups[property];
            if (!lookups) return -1;
            var id = lookups.indexOf(name);
            return id;
        }
    }
});

/***/ }),

/***/ "AucO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B93r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"800"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('v-card',{staticClass:"tour-intro"},[_c('v-card-title',{staticClass:"headline"},[_vm._v("Welcome to the BC Water Tool")]),_vm._v(" "),_c('v-card-text',{staticClass:"body"},[_c('p',[_vm._v("The BC Water Tool is a modular application which provides access to water related data and knowledge in support of sustainable resource management. On this site you’ll find custom watershed reports for every stream, river and watershed in the Kootenay Boundary Region. You’ll also find monitoring data from more than 50 organizations, at more than 50,000 locations across southern BC.                    ")]),_vm._v(" "),_c('p',[_vm._v("This short tour will help you find your way around. Let’s get started!\n                ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){_vm.cancel($event)}}},[_vm._v("No Thanks")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.start($event)}}},[_vm._v("Sure")])],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOverlay),expression:"showOverlay"}],staticClass:"tour-container"},[_c('v-tour',{attrs:{"name":_vm.name,"steps":_vm.steps,"callbacks":_vm.tourCallbacks},scopedSlots:_vm._u([{key:"default",fn:function(tour){return [_c('transition',_vm._l((tour.steps),function(step,index){return (tour.currentStep === index)?_c('v-step',{key:index,attrs:{"step":step,"previous-step":tour.previousStep,"next-step":tour.nextStep,"stop":tour.stop,"isFirst":tour.isFirst,"isLast":tour.isLast}},[_c('v-layout',{staticStyle:{"color":"#444"},attrs:{"slot":"content"},slot:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(step.content)}})]),_vm._v(" "),_c('v-layout',{attrs:{"slot":"actions"},slot:"actions"},[_c('v-card-actions',[(tour.currentStep > 0)?_c('v-btn',{attrs:{"flat":"","small":"","color":"primary"},on:{"click":tour.previousStep}},[_c('v-icon',[_vm._v("chevron_left")]),_vm._v("Previous")],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","small":"","color":"error"},on:{"click":tour.stop}},[_vm._v("Leave Tour"),_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","small":"","color":"primary"},on:{"click":function (){tour.isLast ? tour.stop() : tour.nextStep()}}},[_vm._v("Next"),_c('v-icon',[_vm._v("chevron_right")])],1)],1)],1)],1):_vm._e()}))]}}])}),_vm._v(" "),_c('v-tour',{attrs:{"name":'finalStep',"steps":_vm.finalStep,"callbacks":_vm.finalCallbacks},scopedSlots:_vm._u([{key:"default",fn:function(tour){return [_c('transition',_vm._l((tour.steps),function(step,index){return (tour.currentStep === index)?_c('v-step',{key:index,attrs:{"step":step,"previous-step":tour.previousStep,"next-step":tour.nextStep,"stop":tour.stop,"isFirst":tour.isFirst,"isLast":tour.isLast}},[_c('v-layout',{staticStyle:{"color":"#444"},attrs:{"slot":"content"},slot:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(step.content)}})]),_vm._v(" "),_c('v-layout',{attrs:{"slot":"actions"},slot:"actions"},[_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","small":"","color":"primary"},nativeOn:{"click":function($event){tour.stop($event)}}},[_vm._v("OK"),_c('v-icon',[_vm._v("check")])],1)],1)],1)],1):_vm._e()}))]}}])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOverlay),expression:"showOverlay"}],attrs:{"id":"tour-highlighter"}},[_c('svg',{attrs:{"id":"overlay","width":_vm.viewWidth,"height":_vm.viewHeight,"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":_vm.pathOverlay}})])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BF4R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"map-filters watershed-page-filters"},[_c('v-card-title',[_c('div',{staticClass:"titlecloser"},[_c('h1',{staticClass:"headline mb-2"},[_vm._v("\n                Map Filters\n            ")]),_vm._v(" "),_c('v-btn',{staticClass:"closefilters",attrs:{"flat":"","icon":"","small":""},on:{"click":_vm.hideSidebar}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("Use filters to refine the features shown on the map.")]),_vm._v(" "),(_vm.filterLoaded('network'))?_c('v-container',{attrs:{"fluid":""}},[_c('p',{staticClass:"header-label"},[_vm._v("Network")]),_vm._v(" "),_c('div',{staticClass:"fixed-height"},[_c('div',{staticClass:"h-container"},_vm._l((_vm.networkOptions),function(item){return _c('div',[_c('v-checkbox',{attrs:{"label":item.label,"value":item.value,"color":"primary","hide-details":""},model:{value:(_vm.network),callback:function ($$v) {_vm.network=$$v},expression:"network"}})],1)}))])]):_vm._e(),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),(_vm.filterLoaded('status'))?_c('v-container',{attrs:{"fluid":""}},[_c('p',{staticClass:"header-label"},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"fixed-height"},[_c('div',{staticClass:"h-container"},_vm._l((_vm.statusOptions),function(item){return _c('div',[_c('v-checkbox',{attrs:{"label":item.label,"value":item.value,"color":"primary","hide-details":""},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1)}))])]):_vm._e(),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),(_vm.filterLoaded('type'))?_c('v-container',{attrs:{"fluid":""}},[_c('p',{staticClass:"header-label"},[_vm._v("Licence type")]),_vm._v(" "),_c('div',{staticClass:"fixed-height"},[_c('div',{staticClass:"h-container"},_vm._l((_vm.typeOptions),function(item){return _c('div',[_c('v-checkbox',{attrs:{"label":item.label,"value":item.value,"color":"primary","hide-details":""},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1)}))])]):_vm._e(),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),(_vm.filterLoaded('purpose'))?_c('v-container',{attrs:{"fluid":""}},[_c('v-checkbox',{attrs:{"label":"Purpose","color":"primary","hide-details":"","indeterminate":_vm.purpose.length !== 0 && _vm.purpose.length !== _vm.purposeDefault().length},model:{value:(_vm.purposeCheckbox),callback:function ($$v) {_vm.purposeCheckbox=$$v},expression:"purposeCheckbox"}}),_vm._v(" "),_c('div',{staticClass:"fixed-height"},[_c('div',{staticClass:"h-container multi"},_vm._l((_vm.purposeOptions),function(item){return _c('div',[_c('v-checkbox',{attrs:{"label":item.label,"value":item.value,"color":"primary","hide-details":""},model:{value:(_vm.purpose),callback:function ($$v) {_vm.purpose=$$v},expression:"purpose"}})],1)}))])],1):_vm._e(),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),(_vm.filterLoaded('quantity'))?_c('v-container',{attrs:{"fluid":""}},[_c('p',{staticClass:"header-label"},[_vm._v("Quantity")]),_vm._v(" "),_c('div',{staticClass:"fixed-height"},[_c('div',{staticClass:"h-container"},_vm._l((_vm.quantityOptions),function(item){return _c('div',[_c('v-checkbox',{attrs:{"label":item.label,"value":item.value,"color":"primary","hide-details":""},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}})],1)}))])]):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"secondary"},on:{"click":_vm.reset}},[_vm._v("Reset filters")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.filterDialog),callback:function ($$v) {_vm.filterDialog=$$v},expression:"filterDialog"}},[_c('v-card',[_c('v-card-title',[_vm._v("\n                Save Filter\n            ")]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Filter Name"},model:{value:(_vm.filterKey),callback:function ($$v) {_vm.filterKey=$$v},expression:"filterKey"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterUrl),expression:"filterUrl"}],ref:"url",staticClass:"url",domProps:{"value":(_vm.filterUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filterUrl=$event.target.value}}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","disabled":_vm.filterDialogSaved,"flat":""},on:{"click":function($event){$event.stopPropagation();_vm.save($event)}}},[_vm._v("Save")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.close($event)}}},[_vm._v("Close")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BJ4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WatershedFilters__ = __webpack_require__("OEKW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SidebarLicence__ = __webpack_require__("KBSf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SidebarWatershed__ = __webpack_require__("C5mr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_actions__ = __webpack_require__("UOq2");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'map-sidebar',
    components: {
        MapFilters: __WEBPACK_IMPORTED_MODULE_1__components_WatershedFilters__["a" /* default */],
        LicenceDetails: __WEBPACK_IMPORTED_MODULE_2__components_SidebarLicence__["a" /* default */],
        WatershedDetails: __WEBPACK_IMPORTED_MODULE_3__components_SidebarWatershed__["a" /* default */]
    },
    data: function data() {
        return {
            showFilters: false
        };
    },

    computed: {
        show: {
            get: function get() {
                return this.$store.state.sidebar.show;
            },
            set: function set(val) {
                this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], val);
            }
        },
        context: function context() {
            return this.$store.state.sidebar.context;
        },
        classObj: function classObj() {
            return [this.show ? 'showing' : 'hidden'];
        },

        // if filters are loaded into vuex and the filter options query is done
        filtersLoaded: function filtersLoaded() {
            var filters = this.$store.state.loadedFilters.length > 0;
            var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.filterOptions).length > 0;
            return filters && options;
        }
    },
    methods: {
        /**
         * scroll the sidebar to the top and show the filters component
         */
        revealFilters: function revealFilters() {
            // scroll to reveal the filters panel
            var el = document.getElementById('filters-panel');
            el.scrollIntoView();
            this.showFilters = true;
        },

        /**
         * set sidebar context to live results list
         */
        showLiveList: function showLiveList() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__constants_actions__["w" /* SET_SIDEBAR_CONTEXT */], 'live');
        }
    }
});

/***/ }),

/***/ "BWCH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTour_vue__ = __webpack_require__("EepR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bff35722_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VTour_vue__ = __webpack_require__("cHxK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTour_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bff35722_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VTour_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BXLE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_file_download__ = __webpack_require__("3UNf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_short_unique_id__ = __webpack_require__("toEy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_short_unique_id___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_short_unique_id__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apollo_apollo__ = __webpack_require__("YQr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_map__ = __webpack_require__("aiDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_actions__ = __webpack_require__("UOq2");




var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation createShortUrl($key: String!, $values: JSON!) {\n                    setUrlShortener(key: $key, values: $values)\n                }'], ['mutation createShortUrl($key: String!, $values: JSON!) {\n                    setUrlShortener(key: $key, values: $values)\n                }']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_map__["a" /* default */]],
    props: {
        value: Boolean,
        featuresUrl: String
    },
    data: function data() {
        return {
            loadingCsv: false,
            mapViewShortUrl: '...'
        };
    },
    mounted: function mounted() {
        this.mapViewShortUrl = window.location.href;
    },

    methods: {
        /**
         * change visible state of the dialog
         * hides by default
         * @param  {Boolean} [on=false] true for visible
         */
        show: function show() {
            var on = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.$emit('input', on);
        },

        /**
         * fetch CSV file and trigger download
         */
        downloadCsv: function downloadCsv() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, data;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loadingCsv = true;

                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this.featuresUrl + '/all.csv');

                            case 3:
                                _ref = _context.sent;
                                data = _ref.data;

                                __WEBPACK_IMPORTED_MODULE_4_js_file_download___default()(data, 'map-data.csv');

                                _this.loadingCsv = false;

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        /**
         * refresh short URL from the current map state
         */
        createShortUrl: function createShortUrl() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var uid, random, pageRoute, routePart, shortUrlPrefix, key, domainPart, fullShortUrl, filterSettings, map, mapZoom, mapCenter, values, result;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                // create short url string
                                uid = new __WEBPACK_IMPORTED_MODULE_6_short_unique_id___default.a();
                                random = uid.randomUUID(6);
                                pageRoute = _this2.$route.path;
                                routePart = pageRoute.replace('/', '');
                                shortUrlPrefix = 'saved/';
                                key = '' + shortUrlPrefix + routePart + '-' + random;
                                domainPart = window.location.origin;
                                fullShortUrl = domainPart + '/' + key;

                                _this2.mapViewShortUrl = fullShortUrl;

                                // create JSON object of map and filter settings
                                filterSettings = _this2.$store.state.filterSettings;
                                _context2.next = 12;
                                return _this2.mapPromise;

                            case 12:
                                map = _context2.sent;
                                mapZoom = map.getZoom();
                                mapCenter = map.getCenter();
                                values = {
                                    mapZoom: mapZoom,
                                    mapCenter: mapCenter,
                                    filterSettings: filterSettings,
                                    pageRoute: pageRoute
                                };
                                _context2.next = 18;
                                return __WEBPACK_IMPORTED_MODULE_7__apollo_apollo__["a" /* apolloClient */].mutate({
                                    mutation: __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default()(_templateObject),
                                    variables: { key: key, values: values }
                                });

                            case 18:
                                result = _context2.sent;
                                return _context2.abrupt('return', result);

                            case 20:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        copyShortUrl: function copyShortUrl() {
            this.selectShortUrlInput();
            document.execCommand('Copy');
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__constants_actions__["D" /* TRIGGER_TOAST */], 'Copied URL to the clipboard');
        },
        selectShortUrlInput: function selectShortUrlInput() {
            var input = document.getElementById('short-url-input');
            input.select();
        }
    },
    watch: {
        value: function value(val) {
            if (val) {
                this.createShortUrl();
            }
        }
    }
});

/***/ }),

/***/ "BbJx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        // array of overlapping map features
        // (geojson with properties)
        features: {
            type: Array,
            required: true
        },
        // v-model
        value: {
            type: Boolean,
            required: true
        }
    },
    data: function data() {
        return {
            show: true
        };
    },

    computed: {
        numFeatures: function numFeatures() {
            return this.features.length;
        }
    },
    methods: {
        /**
         * emit an event to select the given feature
         * @param  {Object} feature geojson feature
         */
        select: function select(feature) {
            this.$emit('select', feature);
            this.hide();
        },

        /**
         * emit event to hide the component
         */
        hide: function hide() {
            this.$emit('input', false);
        }
    }
});

/***/ }),

/***/ "Bdm2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_streamflowData__ = __webpack_require__("Nt91");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ScrollingTable__ = __webpack_require__("92Dq");

//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'flow-metrics-table',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_streamflowData__["a" /* default */]],
    components: {
        ScrollingTable: __WEBPACK_IMPORTED_MODULE_2__components_ScrollingTable__["a" /* default */]
    },
    computed: {
        headers: function headers() {
            var tableData = this.queryData.flow_metrics;
            if (!tableData || !tableData.headers) return [];
            return tableData.headers.map(function (i) {
                return {
                    text: i,
                    value: i
                };
            });
        },
        items: function items() {
            var tableData = this.queryData.flow_metrics;
            if (!tableData || !tableData.items) return [];
            return tableData.items;
        },

        // @TODO: format table data like this in the API
        // ...and skip all these computed getters
        scrollingTableData: function scrollingTableData() {
            var headers = this.headers.map(function (e) {
                var text = e.text;
                return {
                    text: text
                };
            });

            var items = this.items.map(function (e) {
                var vals = e.map(function (cel) {
                    var celObj = {
                        text: cel
                    };
                    return celObj;
                });

                return vals;
            });

            var tableData = [headers].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(items));

            return tableData;
        }
    }
});

/***/ }),

/***/ "BnFB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-duration-date-picker"},[_c('div',{staticClass:"input year-select"},[_c('v-select',{attrs:{"items":_vm.yearOptions,"label":"Year from","single-line":""},model:{value:(_vm.yearFrom),callback:function ($$v) {_vm.yearFrom=$$v},expression:"yearFrom"}})],1),_vm._v(" "),_c('span',[_vm._v("–")]),_vm._v(" "),_c('div',{staticClass:"input year-select"},[_c('v-select',{attrs:{"items":_vm.yearOptions,"label":"Year to","single-line":""},model:{value:(_vm.yearTo),callback:function ($$v) {_vm.yearTo=$$v},expression:"yearTo"}})],1),_vm._v(" "),_c('div',{staticClass:"input month-select"},[_c('v-select',{attrs:{"items":_vm.monthOptions,"label":"Month","item-text":"label","item-value":"value","single-line":""},model:{value:(_vm.month),callback:function ($$v) {_vm.month=$$v},expression:"month"}})],1),_vm._v(" "),_c('div',{staticClass:"input reset-button"},[_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":_vm.reset}},[_vm._v("Reset Dates")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bz91":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"monthly-flow-statistics-chart"},[_c('svg',{attrs:{"id":"flow-duration-monthly-flow","width":_vm.svgWidth,"height":_vm.svgHeight}},[_c('g',{staticClass:"chart",attrs:{"transform":("translate(" + (_vm.margin.left) + "," + (_vm.margin.top) + ")")}})]),_vm._v(" "),(_vm.tooltipVisible)?_c('chart-tooltip',{attrs:{"top":_vm.tooltipPosition[1],"left":_vm.tooltipPosition[0],"content":_vm.tooltipText}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C5mr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarWatershed_vue__ = __webpack_require__("4nVf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_635d5af2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarWatershed_vue__ = __webpack_require__("xyEH");
function injectStyle (ssrContext) {
  __webpack_require__("WfCQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-635d5af2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarWatershed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_635d5af2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarWatershed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CHjK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroundwaterLevel_vue__ = __webpack_require__("mWem");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_158eb6e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroundwaterLevel_vue__ = __webpack_require__("tNUJ");
function injectStyle (ssrContext) {
  __webpack_require__("Or+1")
  __webpack_require__("SVZu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-158eb6e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroundwaterLevel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_158eb6e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroundwaterLevel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ccyh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('v-layout',{staticClass:"layout-main"},[_c('v-navigation-drawer',{staticClass:"nav-main",staticStyle:{"z-index":"4"},attrs:{"clipped":"","absolute":"","permanent":"","touchless":"","stateless":"","id":"navDrawer","mini-variant":!_vm.expandDrawer}},[_c('v-list',_vm._l((_vm.items),function(item,i){return _c('v-tooltip',{key:i,attrs:{"right":"","id":("nav-drawer-" + i),"disabled":_vm.expandDrawer}},[_c('v-list-tile',{attrs:{"slot":"activator","router":"","to":item.to,"exact":""},slot:"activator"},[_c('v-list-tile-action',[_c(item.iconComponent,{tag:"component",staticClass:"nav-icon icon-svg-inline",attrs:{"color":_vm.iconColor(item)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.title)}})],1)],1),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(item.title)}})],1)}))],1),_vm._v(" "),_c('v-toolbar',{staticClass:"primary ontop",attrs:{"dark":"","fixed":"","clipped-left":"","app":""}},[_c('v-tooltip',{staticClass:"ml-0",attrs:{"bottom":""}},[_c('v-toolbar-side-icon',{attrs:{"slot":"activator","id":"navigationToggle"},on:{"click":_vm.toggle},slot:"activator"}),_vm._v(" "),(_vm.expandDrawer)?_c('span',[_vm._v("Collapse navigation menu")]):_c('span',[_vm._v("Expand navigation menu")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"toolbar-route-header",domProps:{"textContent":_vm._s(_vm.routeHeader)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-progress-circular',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"mr-2",attrs:{"indeterminate":"","color":"accent"}}),_vm._v(" "),_c('search-bar'),_vm._v(" "),(_vm.mapRoute)?_c('sidebar-toggle',{attrs:{"id":"sidebar-toggle"}}):_vm._e()],1),_vm._v(" "),_c('v-content',{staticClass:"content-wrap"},[_c('toast-container'),_vm._v(" "),_c('v-container',{staticClass:"page",class:[_vm.routeName, { 'map-page': _vm.mapRoute }],attrs:{"fluid":""}},[_c('router-view')],1)],1),_vm._v(" "),_c('alerts-container'),_vm._v(" "),_c('div',{attrs:{"id":"tourActivator"}},[_c('v-tooltip',{attrs:{"right":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","fab":"","hover":""},on:{"click":function($event){_vm.showTour = true}},slot:"activator"},[_c('v-icon',[_vm._v("help")])],1),_vm._v(" "),_c('span',[_vm._v("Show website tour")])],1)],1),_vm._v(" "),_c('report-interstitial'),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.mapRoute && !_vm.mapSourceLoaded)?_c('div',{staticClass:"map-loading-scrim"},[_c('span',{staticClass:"display-2 white--text mb-1"},[_vm._v("Loading")]),_vm._v(" "),_c('div',{staticClass:"loading-wrap"},[_c('v-progress-linear',{attrs:{"color":"accent","indeterminate":true}})],1)]):_vm._e()]),_vm._v(" "),_c('disclaimer-modal',{model:{value:(_vm.showDisclaimer),callback:function ($$v) {_vm.showDisclaimer=$$v},expression:"showDisclaimer"}})],1),_vm._v(" "),_c('tour',{attrs:{"name":"websiteTour"},model:{value:(_vm.showTour),callback:function ($$v) {_vm.showTour=$$v},expression:"showTour"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cj1z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_file_download__ = __webpack_require__("3UNf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapbox_mapbox_gl_draw_dist_mapbox_gl_draw__ = __webpack_require__("uZ0T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapbox_mapbox_gl_draw_dist_mapbox_gl_draw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__mapbox_mapbox_gl_draw_dist_mapbox_gl_draw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_mutations__ = __webpack_require__("cLT6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_map__ = __webpack_require__("aiDF");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    mounted: function mounted() {
        this.addDrawMode();
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_map__["a" /* default */]],
    data: function data() {
        return {
            draw: null,
            currentMode: 'simple_select'
        };
    },

    methods: {
        addDrawMode: function addDrawMode() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var map;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this.mapPromise;

                            case 2:
                                map = _context2.sent;

                                _this.draw = new __WEBPACK_IMPORTED_MODULE_5__mapbox_mapbox_gl_draw_dist_mapbox_gl_draw___default.a({
                                    displayControlsDefault: false,
                                    controls: {}
                                });
                                map.on('draw.modechange', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                                    var geojson, _ref2, file;

                                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    geojson = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.draw.getAll().features[0].geometry);

                                                    _this.draw.deleteAll();
                                                    _context.next = 4;
                                                    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this.$cfg.API_URL + '/licences/lasso.csv', {
                                                        geojson: geojson
                                                    }, {
                                                        responseType: 'blob'
                                                    });

                                                case 4:
                                                    _ref2 = _context.sent;
                                                    file = _ref2.data;

                                                    __WEBPACK_IMPORTED_MODULE_4_js_file_download___default()(file, 'bulk-' + Date.now() + '.csv');
                                                    _this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__constants_mutations__["q" /* SET_POLYGON_SELECTING */], false);

                                                case 8:
                                                case 'end':
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, _this);
                                })));
                                map.addControl(_this.draw);

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }))();
        },
        togglePolygon: function togglePolygon() {
            if (this.currentMode === 'simple_select') {
                this.currentMode = 'draw_polygon';
            } else {
                this.currentMode = 'simple_select';
            }
            this.draw.changeMode(this.currentMode);
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__constants_mutations__["q" /* SET_POLYGON_SELECTING */], this.currentMode === 'draw_polygon');
        }
    }
});

/***/ }),

/***/ "CypH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D0cP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ScrollingTable__ = __webpack_require__("92Dq");


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['query stationChemTable($id: Int!) {\n                getStation(id: $id) {\n                    chemistry {\n                        table\n                    }\n                }\n            }'], ['query stationChemTable($id: Int!) {\n                getStation(id: $id) {\n                    chemistry {\n                        table\n                    }\n                }\n            }']);

//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ScrollingTable: __WEBPACK_IMPORTED_MODULE_2__components_ScrollingTable__["a" /* default */]
    },
    computed: {
        stationId: function stationId() {
            var station = this.$store.state.map.selectedStation;
            if (!station) {
                return null;
            }
            return station.id;
        }
    },
    apollo: {
        tableData: {
            query: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject),
            variables: function variables() {
                return {
                    id: this.stationId
                };
            },
            update: function update(data) {
                var formatted = data.getStation.chemistry.table;
                return formatted;
            }
        }
    }
});

/***/ }),

/***/ "D0on":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_mutations__ = __webpack_require__("cLT6");


var _mutations, _actions;




/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        // toast component visibility
        show: false,
        // text to display
        text: ''
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants_mutations__["C" /* SHOW_TOAST */], function (state) {
        var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        state.show = show;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants_mutations__["x" /* SET_TOAST_TEXT */], function (state, text) {
        state.text = text;
    }), _mutations),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["C" /* SHOW_TOAST */], function (_ref, show) {
        var commit = _ref.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["C" /* SHOW_TOAST */], show);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["x" /* SET_TOAST_TEXT */], function (_ref2, text) {
        var commit = _ref2.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["x" /* SET_TOAST_TEXT */], text);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["D" /* TRIGGER_TOAST */], function (_ref3, text) {
        var commit = _ref3.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["x" /* SET_TOAST_TEXT */], text);
        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["C" /* SHOW_TOAST */], true);
    }), _actions)
});

/***/ }),

/***/ "D4BO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DMv4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_deep_freeze__ = __webpack_require__("TxmA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_deep_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_deep_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apollo_apollo__ = __webpack_require__("YQr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__functions_parseDates__ = __webpack_require__("YxQF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_actions__ = __webpack_require__("UOq2");





var _templateObject = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default()(['query stationGWChem($id: Int!) {\n                getStation(id: $id) {\n                    name\n                    nid\n                    net\n                    yr\n                    ty\n                    established_date\n                    licence_link\n                    location_purpose\n                    location_type\n                    description\n                    chemistry {\n                      sparkline\n                    }\n                }\n            }'], ['query stationGWChem($id: Int!) {\n                getStation(id: $id) {\n                    name\n                    nid\n                    net\n                    yr\n                    ty\n                    established_date\n                    licence_link\n                    location_purpose\n                    location_type\n                    description\n                    chemistry {\n                      sparkline\n                    }\n                }\n            }']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default()(['query chemistryQuery {\n                getChemistryLookup {\n                    display\n                    variable\n                }\n            }'], ['query chemistryQuery {\n                getChemistryLookup {\n                    display\n                    variable\n                }\n            }']);









/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            gettingData: false,
            dataQuery: __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject),
            showSingleChartModal: false,
            queryDone: false,
            queryData: {},
            chemistryData: {},
            chemistryQuery: __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject2),
            chartData: [],
            sparklineData: [],
            properties: []
        };
    },

    methods: {
        /**
         * query the API and fetch station data
         */
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, data, sparklineData;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this.station) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                _this.queryDone = false;
                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__constants_actions__["b" /* ADD_LOADING */], 'load station data');
                                _context.prev = 4;
                                _context.next = 7;
                                return __WEBPACK_IMPORTED_MODULE_7__apollo_apollo__["a" /* apolloClient */].query({
                                    query: _this.dataQuery,
                                    variables: { id: _this.station.id }
                                });

                            case 7:
                                _ref = _context.sent;
                                data = _ref.data;


                                // populate variables
                                _this.queryData = data.getStation;
                                // parse date values and re-freeze query results
                                sparklineData = _this.queryData.chemistry.sparkline.map(function (e) {
                                    var newObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, e);
                                    newObj.data = Object(__WEBPACK_IMPORTED_MODULE_8__functions_parseDates__["a" /* default */])(e.data);
                                    return newObj;
                                });

                                _this.sparklineData = __WEBPACK_IMPORTED_MODULE_6_deep_freeze___default()(sparklineData);
                                _context.next = 17;
                                break;

                            case 14:
                                _context.prev = 14;
                                _context.t0 = _context['catch'](4);

                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__constants_actions__["D" /* TRIGGER_TOAST */], 'Error retrieving station data');

                            case 17:

                                _this.queryDone = true;
                                _this.buildProps();

                                // format chemistry data for charts
                                _this.chartData = _this.queryData.chemistry.formatted_chemistry_chart_data;
                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__constants_actions__["d" /* REMOVE_LOADING */], 'load station data');

                            case 21:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[4, 14]]);
            }))();
        },

        /**
         * build an array of properties to display
         */
        buildProps: function buildProps() {
            var data = this.queryData;
            var properties = [];

            properties.push({
                title: 'Description',
                value: data.description
            });

            if (data.established_date) {
                var establishedDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(data.established_date).format('YYYY-MM-DD');

                properties.push({
                    title: 'Established',
                    value: establishedDate
                });
            }

            properties.push({
                title: 'Location Purpose',
                value: data.location_purpose
            });

            properties.push({
                title: 'Location Type',
                value: data.location_type
            });

            this.properties = properties;
        }
    },
    computed: {
        station: function station() {
            return this.$store.state.map.selectedStation;
        },
        name: function name() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.name;
        },
        networkUrl: function networkUrl() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.licence_link;
        },
        network: function network() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.net;
        },
        networkId: function networkId() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.nid;
        },
        type: function type() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.ty;
        },
        years: function years() {
            if (!this.queryDone) {
                return [];
            }
            return this.queryData.yr;
        },
        numYears: function numYears() {
            if (this.years.length === 2) {
                var years = this.years[1] - this.years[0];
                return years + 1;
            }
            return 0;
        }
    },
    watch: {
        station: function station(newStation, oldStation) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this2.gettingData === newStation.id)) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                _this2.gettingData = newStation.id;

                                if (!(oldStation === null || newStation && oldStation.id !== newStation.id)) {
                                    _context2.next = 6;
                                    break;
                                }

                                _context2.next = 6;
                                return _this2.getData();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    }
});

/***/ }),

/***/ "DN0E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mapbox_gl__ = __webpack_require__("1e2d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mapbox_gl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mapbox_gl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__turf_bbox_polygon__ = __webpack_require__("UzRZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__turf_boolean_within__ = __webpack_require__("ZL0r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__apollo_apollo__ = __webpack_require__("YQr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__functions_appColors__ = __webpack_require__("QW0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_saveMapPosition__ = __webpack_require__("vPEI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_map__ = __webpack_require__("aiDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_watershedData__ = __webpack_require__("yjwP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_mapLegend__ = __webpack_require__("6Tn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_MapDraw__ = __webpack_require__("KMRt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mixins_overlapPicker__ = __webpack_require__("wnug");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_revealFeature__ = __webpack_require__("mbVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mixins_lookupGeojsonProperties__ = __webpack_require__("AuO9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__functions_labelLayer__ = __webpack_require__("KaMZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__functions_waterLayer__ = __webpack_require__("sP/z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__mixins_mapStatePosition__ = __webpack_require__("9GbT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_MapboxGlMap__ = __webpack_require__("GLA1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_MapStyleSwitcher__ = __webpack_require__("VxAk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_WatershedSidebar__ = __webpack_require__("nCzW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_MapContextMenu__ = __webpack_require__("lKjY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_MapSaveButton__ = __webpack_require__("e5y2");








var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['query getWatershed($lat: Float!, $lng: Float!, $searchDistance: Int!) {\n                        getWatershed(lat: $lat, lng: $lng, searchDistance: $searchDistance) {\n                            data\n                            wfi\n                            fwa\n                            name\n                        }\n                    }'], ['query getWatershed($lat: Float!, $lng: Float!, $searchDistance: Int!) {\n                        getWatershed(lat: $lat, lng: $lng, searchDistance: $searchDistance) {\n                            data\n                            wfi\n                            fwa\n                            name\n                        }\n                    }']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['query {\n                    getLicenceFilters\n                }'], ['query {\n                    getLicenceFilters\n                }']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['query getWatershed($wfi: Int!) {\n                        getWatershedWFI(wfi: $wfi) {\n                            name\n                            fwa\n                            data\n                        }\n                    }'], ['query getWatershed($wfi: Int!) {\n                        getWatershedWFI(wfi: $wfi) {\n                            name\n                            fwa\n                            data\n                        }\n                    }']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




























/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'WatershedPage',
    components: {
        MapboxGlMap: __WEBPACK_IMPORTED_MODULE_26__components_MapboxGlMap__["a" /* default */],
        StyleSwitcher: __WEBPACK_IMPORTED_MODULE_27__components_MapStyleSwitcher__["a" /* default */],
        MapSidebar: __WEBPACK_IMPORTED_MODULE_28__components_WatershedSidebar__["a" /* default */],
        MapSaveButton: __WEBPACK_IMPORTED_MODULE_30__components_MapSaveButton__["a" /* default */],
        MapDraw: __WEBPACK_IMPORTED_MODULE_19__components_MapDraw__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_15__mixins_saveMapPosition__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__mixins_map__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__mixins_watershedData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__mixins_mapLegend__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__mixins_overlapPicker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__mixins_revealFeature__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__mixins_lookupGeojsonProperties__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__mixins_mapStatePosition__["a" /* default */]],
    data: function data() {
        return {
            map: null,
            mapZoom: 5.8,
            tooltipMarker: null,
            contextMenu: null,
            mapLayersReady: false,
            watershedGeojson: null,
            mapSourceUrl: this.$cfg.API_URL + '/licences',
            // map filters
            filters: ['network', 'status', 'type', 'purpose', 'quantity'],
            mapLayers: [],
            showStyleSwitcher: false,
            showMapSave: false,
            queryLocationMarker: null
        };
    },

    computed: {
        showingSidebar: function showingSidebar() {
            return this.$store.state.sidebar.show;
        },
        classObj: function classObj() {
            return [{
                'showing-sidebar': this.showingSidebar
            }];
        },

        // selected licence feature
        selectedLicence: function selectedLicence() {
            return this.$store.state.map.selectedLicence;
        },

        // selected watershed
        selectedWatershed: function selectedWatershed() {
            return this.$store.state.map.selectedWatershed;
        },
        filterSettings: function filterSettings() {
            return this.$store.state.filterSettings;
        }
    },
    beforeCreate: function beforeCreate() {
        var _this = this;

        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["b" /* ADD_LOADING */], 'load watershed page');
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["t" /* SET_MAP_SOURCE_DATA_LOADED */], false);
        // update the mapLoaded promise in vuex
        var mapLoadedPromise = new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            _this.$on('mapLoaded', function (map) {
                resolve(map);
            });
            _this.$on('mapLoadError', function (err) {
                reject(err);
            });
        });
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["s" /* SET_MAP_PROMISE */], mapLoadedPromise);
    },
    mounted: function mounted() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this2.getLookupTables();

                        case 2:
                            // define map layers array
                            _this2.mapLayers = _this2.getMapLayersArray();

                            // add load event handlers
                            // before the sources and layers are added
                            _context.next = 5;
                            return _this2.addLoadEventHandlers();

                        case 5:
                            _context.next = 7;
                            return _this2.addLayers(_this2.$cfg.mapboxgl.baseStyle);

                        case 7:
                            _this2.mapLayersReady = true;

                            // set up map when licence data becomes available
                            // @TODO: ensure this happens only once per map load,
                            // ...and in order
                            _context.next = 10;
                            return _this2.initTooltip();

                        case 10:
                            _context.next = 12;
                            return _this2.addLayerEventHandlers();

                        case 12:
                            _context.next = 14;
                            return _this2.addViewEventHandlers();

                        case 14:
                            _context.next = 16;
                            return _this2.loadStateFromVuex();

                        case 16:
                            _context.next = 18;
                            return _this2.initFilters();

                        case 18:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }))();
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        // unload and reset map filters
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["E" /* UNLOAD_FILTERS */]);
        // reset sidebar & switch back to the live list view
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], false);
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["w" /* SET_SIDEBAR_CONTEXT */], 'live');
        // reset sidebar context and selected features
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["h" /* SELECT_WATERSHED */], null);
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["f" /* SELECT_LICENCE */], null);
        // reset vuex mapPromise to null (ie, "no map")
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["s" /* SET_MAP_PROMISE */], null);
        next();
    },

    methods: {
        /**
         * return a string template for the licence number
         * prepended with "Licence number:", etc. as needed
         * @param  {String} licenceNum licence number from geojson properties
         * @param  {String} [term='']  licence term, "long" or "short"
         * @return {String}            display string
         */
        licenceNumberTemplate: function licenceNumberTemplate(licenceNum) {
            var term = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            var tooltipTpl = '' + licenceNum;
            if (term === 'long') {
                tooltipTpl = 'Licence number: ' + tooltipTpl;
            }
            return tooltipTpl;
        },

        /**
         * process any state items queued in the "loadState" module
         * then reset all items to null
         */
        loadStateFromVuex: function loadStateFromVuex() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var loadState, map, _loadState$selectFeat, id, coords, _loadState$selectFeat2, _id, _coords;

                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                loadState = _this3.$store.state.loadState;
                                _context2.next = 3;
                                return _this3.mapPromise;

                            case 3:
                                map = _context2.sent;


                                if (loadState.mapCenter) {
                                    map.setCenter(loadState.mapCenter);
                                }

                                if (loadState.mapZoom) {
                                    map.setZoom(loadState.mapZoom);
                                }

                                if (loadState.mapFilterSettings) {
                                    _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["k" /* SET_FILTER_SETTINGS */], loadState.mapFilterSettings);
                                }

                                if (loadState.selectFeature && loadState.selectFeature.type === 'watershed') {
                                    _loadState$selectFeat = loadState.selectFeature, id = _loadState$selectFeat.id, coords = _loadState$selectFeat.coords;

                                    // select licence on this page

                                    _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["h" /* SELECT_WATERSHED */], {
                                        id: id,
                                        coords: coords
                                    });
                                    _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], true);
                                }

                                if (loadState.selectFeature && loadState.selectFeature.type === 'licence') {
                                    _loadState$selectFeat2 = loadState.selectFeature, _id = _loadState$selectFeat2.id, _coords = _loadState$selectFeat2.coords;

                                    _this3.selectLicence({
                                        properties: { id: _id },
                                        geometry: { coordinates: _coords }
                                    });
                                }

                                // clear loadState module
                                _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["e" /* RESET_LOADSTATE_ITEMS */]);

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },

        /**
         * get an array of map layer configs
         * @return {Array} formatted config array
         */
        getMapLayersArray: function getMapLayersArray() {
            var _this4 = this;

            // marker layer ids (so we can do loop operations on all layers)
            return [{
                type: 'licenceData',
                sourceId: 'licenceData-data',
                color: ['match', ['get', 'type'], this.lookupPropertyByValue('type', 'GW'), ['match', ['get', 'term'], this.lookupPropertyByValue('term', 'short'), String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["k" /* markerGwShort */]), this.lookupPropertyByValue('term', 'long'), String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["j" /* markerGwLong */]),
                /* other */String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["r" /* markerUnknown */])], this.lookupPropertyByValue('type', 'SW'), ['match', ['get', 'term'], this.lookupPropertyByValue('term', 'short'), String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["q" /* markerSwShort */]), this.lookupPropertyByValue('term', 'long'), String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["p" /* markerSwLong */]),
                /* other */String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["r" /* markerUnknown */])],
                /* other */String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["r" /* markerUnknown */])],
                pointLayer: 'licenceData-points',
                /**
                 * callback for map sourcedata event
                 * @param  {Object} event mapbox gl sourcedata event
                 */
                sourceCallback: function sourceCallback() {
                    var source = _this4.map.getSource('licenceData-data');
                    if (source && _this4.map.isSourceLoaded('licenceData-data')) {
                        _this4.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["t" /* SET_MAP_SOURCE_DATA_LOADED */], true);
                    }
                }
            }];
        },

        /**
         * return an array of all interactive feature layer ids
         * @return {Array} layer id strings
         */
        getInteractiveLayers: function getInteractiveLayers() {
            var featureLayers = [];
            this.mapLayers.forEach(function (l) {
                featureLayers.push(l.pointLayer);
            });
            return featureLayers;
        },

        /**
         * map loaded callback
         * @param  {mapboxgl.Map} map map object
         */
        mapLoaded: function mapLoaded(map) {
            this.map = map;

            // add navigation controls
            map.addControl(new __WEBPACK_IMPORTED_MODULE_8_mapbox_gl___default.a.NavigationControl({
                // hide rotation control
                showCompass: false
            }), 'top-left');
            // add scale control
            map.addControl(new __WEBPACK_IMPORTED_MODULE_8_mapbox_gl___default.a.ScaleControl({
                maxWidth: 75
            }));

            // fulfill promise
            this.$emit('mapLoaded', map);
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["d" /* REMOVE_LOADING */], 'load watershed page');
        },

        /**
         * initialize tooltip object
         * to be controlled with showTooltip, hideTooltip
         */
        initTooltip: function initTooltip() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var map, el;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this5.mapPromise;

                            case 2:
                                map = _context3.sent;
                                el = document.createElement('div');

                                el.classList.add('tooltip-marker');
                                el.classList.add('hidden');

                                _this5.tooltipMarker = new __WEBPACK_IMPORTED_MODULE_8_mapbox_gl___default.a.Marker(el, {
                                    offset: [72, 0]
                                }).setLngLat(map.getCenter()).addTo(map);

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this5);
            }))();
        },

        /**
         * show tooltip with given html and coordinates
         * @param  {mapboxgl.LngLat} coordinates LngLatLike coordinates
         * @param  {String} html        tooltip HTML content
         */
        showTooltip: function showTooltip(coordinates, html) {
            var el = this.tooltipMarker.getElement();
            this.tooltipMarker.setLngLat(coordinates);
            el.innerHTML = html;
            el.classList.remove('hidden');
        },

        /**
         * hide the map tooltip
         */
        hideTooltip: function hideTooltip() {
            var el = this.tooltipMarker.getElement();
            el.classList.add('hidden');
        },

        /**
         * add mapbox sources and layers
         */
        addPointLayers: function addPointLayers(layerAbove) {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var map, selectedLicenceId;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this6.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["b" /* ADD_LOADING */], 'add map sources');
                                _context4.next = 3;
                                return _this6.mapPromise;

                            case 3:
                                map = _context4.sent;


                                // add split-up sources
                                _this6.mapLayers.forEach(function (_ref) {
                                    var sourceId = _ref.sourceId;

                                    // reset map source data loaded var
                                    _this6.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["t" /* SET_MAP_SOURCE_DATA_LOADED */], false);
                                    map.addSource(sourceId, {
                                        type: 'geojson',
                                        data: _this6.mapSourceUrl + '/all.geojson',
                                        buffer: 0
                                    });
                                });

                                // unclustered points layers
                                _this6.mapLayers.forEach(function (_ref2) {
                                    var pointLayer = _ref2.pointLayer,
                                        sourceId = _ref2.sourceId,
                                        color = _ref2.color;

                                    map.addLayer({
                                        id: pointLayer,
                                        type: 'circle',
                                        source: sourceId,
                                        paint: {
                                            'circle-color': color,
                                            // make circles larger as the user zooms in
                                            'circle-radius': ['interpolate', ['linear'], ['zoom'], 1, 2, 18, 6],
                                            'circle-stroke-width': ['interpolate', ['linear'], ['zoom'], 1, 1, 18, 2],
                                            'circle-stroke-color': ['match', ['get', 'st'], _this6.lookupPropertyByValue('st', 'ACTIVE APPL.'), String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["o" /* markerStrokeActiveAppl */]), _this6.lookupPropertyByValue('st', 'CURRENT'), String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["n" /* markerStroke */]),
                                            /* other */String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["r" /* markerUnknown */])]
                                        }
                                    });

                                    // move the layer below layerAbove, if specified
                                    if (layerAbove) {
                                        map.moveLayer(pointLayer, layerAbove);
                                    }
                                });

                                // add non-interactive layers to highlight the selected marker
                                map.addLayer({
                                    id: 'selected-point-bg',
                                    type: 'circle',
                                    source: _this6.getMapLayersArray()[0].sourceId,
                                    // a green circle to appear beneath the selected feature
                                    paint: {
                                        'circle-color': String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["m" /* markerSelected */]),
                                        // make circles larger as the user zooms in
                                        'circle-radius': ['interpolate', ['linear'], ['zoom'], 1, 12, 18, 16],
                                        'circle-opacity': 0
                                    }
                                });
                                map.addLayer({
                                    id: 'selected-point',
                                    type: 'circle',
                                    source: _this6.getMapLayersArray()[0].sourceId,
                                    // same as the selected feature, but slightly larger
                                    paint: {
                                        'circle-color': _this6.getMapLayersArray()[0].color,
                                        // make circles larger as the user zooms in
                                        'circle-radius': ['interpolate', ['linear'], ['zoom'], 1, 4, 18, 8],
                                        'circle-stroke-width': 2,
                                        'circle-opacity': 0,
                                        'circle-stroke-opacity': 0,
                                        'circle-stroke-color': ['match', ['get', 'st'], _this6.lookupPropertyByValue('st', 'ACTIVE APPL.'), String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["o" /* markerStrokeActiveAppl */]), _this6.lookupPropertyByValue('st', 'CURRENT'), String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["n" /* markerStroke */]),
                                        /* other */String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["r" /* markerUnknown */])]
                                    }
                                });

                                // re-set highlighted marker (if any)
                                selectedLicenceId = _this6.selectedLicence ? _this6.selectedLicence.id : null;

                                _this6.updateSelectedMarker(selectedLicenceId);
                                _this6.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["d" /* REMOVE_LOADING */], 'add map sources');

                            case 11:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this6);
            }))();
        },

        /**
         * add study area mask polygon
         * @param  {String}  layerAbove layer id to go stack new layers (e.g. labels)
         */
        addStudyArea: function addStudyArea(layerAbove) {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
                var map;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return _this7.mapPromise;

                            case 2:
                                map = _context5.sent;


                                // add study area mask
                                map.addSource('kwt-study-area', {
                                    type: 'geojson',
                                    data: '/static/kwt_studyarea_split.geojson'
                                });
                                map.addLayer({
                                    id: 'kwt-study-area',
                                    type: 'fill',
                                    source: 'kwt-study-area',
                                    paint: {
                                        'fill-color': String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["z" /* studyAreaMask */]),
                                        'fill-opacity': 0.65
                                    }
                                });

                                // move the layer below layerAbove, if specified
                                if (layerAbove) {
                                    map.moveLayer('kwt-study-area', layerAbove);
                                }

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this7);
            }))();
        },

        /**
         * add user-defined map sources and layers
         * @param  {String}  styleUrl mapbox style URL (for ordering layers)
         */
        addLayers: function addLayers(styleUrl) {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
                var labelLayerId, waterLayerId;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                labelLayerId = Object(__WEBPACK_IMPORTED_MODULE_23__functions_labelLayer__["a" /* default */])(styleUrl);
                                waterLayerId = Object(__WEBPACK_IMPORTED_MODULE_24__functions_waterLayer__["a" /* default */])(styleUrl);

                                // add study area mask [below labels, if any]

                                _context6.next = 4;
                                return _this8.addStudyArea(labelLayerId);

                            case 4:
                                _context6.next = 6;
                                return _this8.addWatershedLayer(waterLayerId);

                            case 6:
                                _context6.next = 8;
                                return _this8.updateWatershedSource();

                            case 8:
                                _context6.next = 10;
                                return _this8.addPointLayers(labelLayerId);

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this8);
            }))();
        },

        /**
         * bind event handlers to map features
         */
        addLayerEventHandlers: function addLayerEventHandlers() {
            var _this9 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
                var map;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return _this9.mapPromise;

                            case 2:
                                map = _context7.sent;


                                // change mouse cursor on mouseover
                                _this9.getInteractiveLayers().forEach(function (layerId) {
                                    map.on('mousemove', layerId, function () {
                                        map.getCanvas().style.cursor = 'pointer';
                                    });
                                    map.on('mouseleave', layerId, function () {
                                        map.getCanvas().style.cursor = '';
                                    });
                                });

                                // update sidebar on map/marker click
                                map.on('click', function (ev) {
                                    if (_this9.$store.state.selectingPolygon) return;

                                    // check for features at click location
                                    if (ev.point) {
                                        var markerFeatures = _this9.map.queryRenderedFeatures(ev.point, {
                                            layers: _this9.getInteractiveLayers()
                                        });
                                        if (markerFeatures.length > 0) {
                                            // show the marker disambiguator if there are more than one
                                            if (markerFeatures.length > 1) {
                                                _this9.overlapFeatures = markerFeatures;
                                                _this9.showOverlapPicker = true;
                                                return;
                                            }

                                            // if only one feature was clicked, select it
                                            _this9.selectLicence(markerFeatures[0]);
                                            return;
                                        }
                                    }

                                    // if an empty area on the map was clicked, switch to watershed
                                    var zoom = map.getZoom();
                                    _this9.watershedClick(ev.lngLat, zoom);
                                });

                                // show tooltip on mouseover
                                _this9.mapLayers.forEach(function (_ref3) {
                                    var pointLayer = _ref3.pointLayer;

                                    map.on('mousemove', pointLayer, function (ev) {
                                        var feature = ev.features[0];
                                        var featureCoords = feature.geometry.coordinates;
                                        // show tooltip with some useful properties
                                        var term = _this9.lookupPropertyById('term', feature.properties.term);
                                        var tooltipTpl = _this9.licenceNumberTemplate(feature.properties.nid, term);
                                        _this9.showTooltip(featureCoords, tooltipTpl);
                                    });
                                    map.on('mouseleave', pointLayer, function () {
                                        _this9.hideTooltip();
                                    });
                                });

                                // track map zoom level
                                map.on('zoom', function () {
                                    _this9.mapZoom = map.getZoom();
                                });

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this9);
            }))();
        },

        /**
         * update the map layer paint properties to highlight the selected feature
         * @param  {String}  markerId marker ID to highlight
         */
        updateSelectedMarker: function updateSelectedMarker(markerId) {
            var _this10 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
                var map;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return _this10.mapPromise;

                            case 2:
                                map = _context8.sent;

                                // show the selected marker in the "selected-point" layer
                                map.setPaintProperty('selected-point', 'circle-opacity', ['case', ['==', ['get', 'id'], markerId], 1, 0]);
                                map.setPaintProperty('selected-point', 'circle-stroke-opacity', ['case', ['==', ['get', 'id'], markerId], 1, 0]);
                                // show the green highlight underneath the selected marker
                                map.setPaintProperty('selected-point-bg', 'circle-opacity', ['case', ['==', ['get', 'id'], markerId], 0.5, 0]);

                            case 6:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this10);
            }))();
        },

        /**
         * bind listeners for map loading events
         */
        addLoadEventHandlers: function addLoadEventHandlers() {
            var _this11 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
                var map;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return _this11.mapPromise;

                            case 2:
                                map = _context9.sent;

                                // bind event listener to track when the source is loaded
                                _this11.mapLayers.forEach(function (_ref4) {
                                    var sourceCallback = _ref4.sourceCallback;

                                    map.on('sourcedata', sourceCallback);
                                });

                            case 4:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this11);
            }))();
        },

        /**
         * bind event handlers to map view events
         * (zoom, pan, etc.)
         */
        addViewEventHandlers: function addViewEventHandlers() {
            var _this12 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
                var map;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return _this12.mapPromise;

                            case 2:
                                map = _context10.sent;


                                // update bounding box in vuex
                                map.on('moveend', function () {
                                    return _this12.calculateBounds();
                                });
                                _this12.calculateBounds(); // initial run

                                // save map position in localstorage
                                map.on('moveend', function () {
                                    _this12.saveMapPosition('bcwt');
                                });

                                // save map position in vuex
                                map.on('moveend', _this12.setMapStatePosition);

                                // show context menu on right mouse click
                                map.on('contextmenu', _this12.showContextMenu);

                            case 8:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this12);
            }))();
        },

        /**
         * calculate the viewport bounding box and update vuex
         */
        calculateBounds: function calculateBounds() {
            var _this13 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
                var _ref5;

                var map, bounds, bbox;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return _this13.mapPromise;

                            case 2:
                                map = _context11.sent;
                                bounds = map.getBounds().toArray();
                                // convert to bbox format for turf

                                bbox = (_ref5 = []).concat.apply(_ref5, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(bounds));

                                _this13.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["q" /* SET_MAP_BOUNDS */], bbox);

                            case 6:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, _this13);
            }))();
        },

        /**
        * create and return a Mapbox GL popup
        * @param  {mapboxgl.LngLat} lngLat     LngLatLike coordinates
        * @param  {Object} vComponent Vue component for the popup contents
        * @param  {Object} propsData  props to pass to the vue component
        * @return {mapboxgl.Popup}            Map popup object
        */
        createMapPopup: function createMapPopup(lngLat, vComponent, propsData) {
            // create (empty) map popup
            var mapboxPopup = new __WEBPACK_IMPORTED_MODULE_8_mapbox_gl___default.a.Popup({
                closeButton: false // we'll use a custom close button
            }).setLngLat(lngLat).setHTML('<div class="click-popup"></div>').addTo(this.map);

            // manually mount Popup component to the empty map popup
            var popupContentEl = mapboxPopup._content.querySelector('.click-popup'); // eslint-disable-line
            var PopupConstructor = __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].extend(vComponent);
            var PopupComponent = new PopupConstructor({
                store: this.$store,
                propsData: propsData
            }).$mount(popupContentEl);

            // remove mapbox popup on close event
            PopupComponent.$on('close', function () {
                mapboxPopup.remove();
            });

            // destroy Popup component on popup close
            // (happens any time a map popup is removed
            // including a new popup taking its place
            // and manual close events) (see: "closeOnClick")
            mapboxPopup.on('close', function () {
                PopupComponent.$destroy();
            });

            return mapboxPopup;
        },
        showContextMenu: function showContextMenu(_ref6) {
            var lngLat = _ref6.lngLat;

            if (this.contextMenu) {
                this.contextMenu.remove();
            }
            this.contextMenu = this.createMapPopup(lngLat, __WEBPACK_IMPORTED_MODULE_29__components_MapContextMenu__["a" /* default */], {
                lngLat: lngLat
            });
        },

        /**
         * return (non-reactive) Mapbox GL constructor options
         * @return {Object} map options
         */
        getMapOptions: function getMapOptions() {
            return {
                style: this.$cfg.mapboxgl.baseStyle,
                center: this.loadMapPosition('bcwt').center || [-116.9, 50.4],
                zoom: this.loadMapPosition('bcwt').zoom || 5.8,
                attributionControl: false
            };
        },

        /**
         * handle watershed clicks (clicks on the map with no features)
         * @param  {Object}  lngLat object with lat, lng
         * @param  {Number}  zoom   map zoom level
         */
        watershedClick: function watershedClick(lngLat, zoom) {
            var _this14 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee12() {
                var lng, lat, _ref7, data, wfi;

                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                window.gtag('event', 'Watershed', { action: 'click', label: 'User clicked to find watershed' });
                                lng = lngLat.lng, lat = lngLat.lat;

                                // query for watershed polygon

                                _this14.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["b" /* ADD_LOADING */], 'query watershed data');
                                _context12.prev = 3;
                                _context12.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_12__apollo_apollo__["a" /* apolloClient */].query({
                                    query: __WEBPACK_IMPORTED_MODULE_9_graphql_tag___default()(_templateObject),
                                    variables: {
                                        lng: lng,
                                        lat: lat,
                                        searchDistance: _this14.getSearchDistance(zoom)
                                    }
                                });

                            case 6:
                                _ref7 = _context12.sent;
                                data = _ref7.data;

                                _this14.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["d" /* REMOVE_LOADING */], 'query watershed data');

                                if (!(data.getWatershed.wfi === 0)) {
                                    _context12.next = 12;
                                    break;
                                }

                                _this14.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["D" /* TRIGGER_TOAST */], 'No watershed data is available at these coordinates.');
                                return _context12.abrupt('return');

                            case 12:

                                // update watershed polygon source data (layer will automatically update)
                                _this14.watershedGeojson = data.getWatershed.data;
                                _context12.next = 15;
                                return _this14.updateWatershedSource();

                            case 15:
                                wfi = data.getWatershed.wfi;

                                // set query watershed ID in vuex

                                _this14.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["h" /* SELECT_WATERSHED */], {
                                    id: wfi,
                                    coords: [lng, lat]
                                });
                                _this14.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["w" /* SET_SIDEBAR_CONTEXT */], 'watershed');
                                _this14.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], true);
                                _context12.next = 24;
                                break;

                            case 21:
                                _context12.prev = 21;
                                _context12.t0 = _context12['catch'](3);

                                // if watershed graphql query fails, display a notice
                                _this14.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["D" /* TRIGGER_TOAST */], 'Error loading watershed.');

                            case 24:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, _this14, [[3, 21]]);
            }))();
        },

        /**
         * update the watershed polygon source data to this.watershedGeojson
         */
        updateWatershedSource: function updateWatershedSource() {
            var _this15 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee13() {
                var map, polygonGeojson, source;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return _this15.mapPromise;

                            case 2:
                                map = _context13.sent;
                                polygonGeojson = _this15.watershedGeojson;

                                // update source data (layer will automatically update)

                                source = map.getSource('watershed-polygon');

                                source.setData({
                                    type: 'Feature',
                                    geometry: polygonGeojson
                                });

                            case 6:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, _this15);
            }))();
        },

        /**
         * return a formatted legend config object
         * @return {Object} map legend configuration
         */
        getLegendLayers: function getLegendLayers() {
            return [{
                title: 'Water Licence (Surface Water)',
                color: String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["p" /* markerSwLong */])
            }, {
                title: 'Use Approval (Surface Water)',
                color: String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["q" /* markerSwShort */])
            }, {
                title: 'Water Licence (Groundwater)',
                color: String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["j" /* markerGwLong */])
            }, {
                title: 'Use Approval (Groundwater)',
                color: String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["k" /* markerGwShort */])
            }, {
                title: 'Active Application',
                color: '#FFFFFF',
                borderColor: String(__WEBPACK_IMPORTED_MODULE_13__functions_appColors__["o" /* markerStrokeActiveAppl */])
            }];
        },

        /**
         * set the selected licence feature
         * @param  {Object} licence geojson feature from map query
         */
        selectLicence: function selectLicence(licence) {
            window.gtag('event', 'Licence', { action: 'select', label: 'User selected licence' });
            var id = licence.properties.id;
            var coords = licence.geometry.coordinates;
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["f" /* SELECT_LICENCE */], {
                id: id,
                coords: coords
            });
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], true);
        },
        initFilters: function initFilters() {
            var _this16 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee14() {
                var filterOptions;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return _this16.getFilterOptions();

                            case 2:
                                filterOptions = _context14.sent;

                                _this16.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["j" /* SET_FILTER_OPTIONS */], filterOptions);
                                _this16.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["l" /* SET_LOADED_FILTERS */], _this16.filters);

                            case 5:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, _this16);
            }))();
        },
        getFilterOptions: function getFilterOptions() {
            var _this17 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee15() {
                var _ref8, data;

                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _this17.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["b" /* ADD_LOADING */], 'get licence filters');
                                _context15.prev = 1;
                                _context15.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_12__apollo_apollo__["a" /* apolloClient */].query({
                                    query: __WEBPACK_IMPORTED_MODULE_9_graphql_tag___default()(_templateObject2)
                                });

                            case 4:
                                _ref8 = _context15.sent;
                                data = _ref8.data;
                                return _context15.abrupt('return', data.getLicenceFilters);

                            case 9:
                                _context15.prev = 9;
                                _context15.t0 = _context15['catch'](1);

                                _this17.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["D" /* TRIGGER_TOAST */], 'Error retrieving licence filters');

                            case 12:
                                _context15.prev = 12;

                                _this17.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["d" /* REMOVE_LOADING */], 'get licence filters');
                                return _context15.finish(12);

                            case 15:
                                return _context15.abrupt('return', []);

                            case 16:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, _this17, [[1, 9, 12, 15]]);
            }))();
        },
        updateMapFilters: function updateMapFilters() {
            var _this18 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee16() {
                var settings, mapboxFilters, map, isEmpty, expressions, _expressions, _expressions2, _expressions3, _expressions4;

                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                settings = _this18.filterSettings;
                                mapboxFilters = ['all'];
                                _context16.next = 4;
                                return _this18.mapPromise;

                            case 4:
                                map = _context16.sent;
                                isEmpty = false;

                                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(settings).forEach(function (item) {
                                    if (Array.isArray(item) && item.length === 0) {
                                        isEmpty = true;
                                    }
                                });

                                if (!isEmpty) {
                                    _context16.next = 10;
                                    break;
                                }

                                map.setFilter('licenceData-points', ['has', 'any']);
                                return _context16.abrupt('return');

                            case 10:

                                // network
                                if (settings.network) {
                                    expressions = settings.network.map(function (value) {
                                        var valueId = _this18.lookupPropertyByValue('net', value);
                                        return ['==', ['get', 'net'], valueId];
                                    });

                                    if (expressions.length > 0) {
                                        mapboxFilters.push(['any'].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(expressions)));
                                    } else {
                                        // if no options are selected
                                        // something to select 0 features
                                        mapboxFilters.push(['has', 'net']);
                                    }
                                }

                                // status
                                if (settings.status) {
                                    _expressions = settings.status.map(function (value) {
                                        var valueId = _this18.lookupPropertyByValue('st', value);
                                        return ['==', ['get', 'st'], valueId];
                                    });

                                    if (_expressions.length > 0) {
                                        mapboxFilters.push(['any'].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_expressions)));
                                    } else {
                                        // if no options are selected
                                        // something to select 0 features
                                        mapboxFilters.push(['!has', 'st']);
                                    }
                                }

                                // "type" and "term" (combined)
                                if (settings.type) {
                                    _expressions2 = settings.type.map(function (value) {
                                        var _value$split = value.split(' '),
                                            _value$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_value$split, 2),
                                            type = _value$split2[0],
                                            term = _value$split2[1];

                                        var typeId = _this18.lookupPropertyByValue('type', type);
                                        var termId = _this18.lookupPropertyByValue('term', term);
                                        var typeExpression = ['==', ['get', 'type'], typeId];
                                        var termExpression = ['==', ['get', 'term'], termId];
                                        return ['all', typeExpression, termExpression];
                                    });

                                    if (_expressions2.length > 0) {
                                        mapboxFilters.push(['any'].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_expressions2)));
                                    } else {
                                        // if no options are selected
                                        // something to select 0 features
                                        mapboxFilters.push(['!has', 'type']);
                                    }
                                }

                                // "purpose"
                                if (settings.purpose) {
                                    _expressions3 = settings.purpose.map(function (value) {
                                        var valueId = _this18.lookupPropertyByValue('ind', value);
                                        return ['==', ['get', 'ind'], valueId];
                                    });

                                    if (_expressions3.length > 0) {
                                        mapboxFilters.push(['any'].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_expressions3)));
                                    } else {
                                        // if no options are selected
                                        // something to select 0 features
                                        mapboxFilters.push(['!has', 'ind']);
                                    }
                                }

                                // "quantity"
                                if (settings.quantity) {
                                    // feature[yearMax] >= filter[yearMin]
                                    _expressions4 = settings.quantity.map(function (value) {
                                        var range = value.split('-');

                                        var _range$map = range.map(function (v) {
                                            return Number(v);
                                        }),
                                            _range$map2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_range$map, 2),
                                            min = _range$map2[0],
                                            max = _range$map2[1];

                                        return ['all',
                                        // always filter out nulls if a value is set
                                        ['!=', null, ['get', 'qty']], ['>=', ['to-number', // cast to number
                                        ['get', 'qty']], min], ['<=', ['to-number', // cast to number
                                        ['get', 'qty']], max]];
                                    });

                                    if (_expressions4.length > 0) {
                                        mapboxFilters.push(['any'].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_expressions4)));
                                    } else {
                                        // if no options are selected
                                        // something to select 0 features
                                        mapboxFilters.push(['!has', 'qty']);
                                    }
                                }

                                map.setFilter('licenceData-points', mapboxFilters);

                            case 16:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, _this18);
            }))();
        },

        /**
         * hide all map tools, optionally skipping one
         * to leave it open
         * @param  {String} skip variable name to skip
         */
        hideMapTools: function hideMapTools(skip) {
            var _this19 = this;

            var vars = ['showMapLegend', 'showStyleSwitcher'];
            if (skip) {
                vars = vars.filter(function (e) {
                    return e !== skip;
                });
            }
            vars.forEach(function (e) {
                _this19[e] = false;
            });
        },

        /**
         * select a watershed by moving the map to a location and firing a click event
         */
        selectWatershed: function selectWatershed(wfi, coords) {
            var _this20 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee17() {
                var map, lngLat, _ref9, data, bbox, mapBounds, lng, lat, featureGeojson;

                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                _context17.next = 2;
                                return _this20.mapPromise;

                            case 2:
                                map = _context17.sent;
                                lngLat = __WEBPACK_IMPORTED_MODULE_8_mapbox_gl___default.a.LngLat.convert(coords);
                                _context17.prev = 4;
                                _context17.next = 7;
                                return __WEBPACK_IMPORTED_MODULE_12__apollo_apollo__["a" /* apolloClient */].query({
                                    query: __WEBPACK_IMPORTED_MODULE_9_graphql_tag___default()(_templateObject3),
                                    variables: {
                                        wfi: wfi
                                    }
                                });

                            case 7:
                                _ref9 = _context17.sent;
                                data = _ref9.data;


                                // update watershed polygon source data (layer will automatically update)
                                _this20.watershedGeojson = data.getWatershedWFI.data;
                                _context17.next = 12;
                                return _this20.updateWatershedSource();

                            case 12:

                                // add/update query location map marker
                                _this20.updateQueryLocationMarker(lngLat);

                                // move the map if the feature is outside be viewport
                                bbox = _this20.$store.state.map.bbox;
                                mapBounds = Object(__WEBPACK_IMPORTED_MODULE_10__turf_bbox_polygon__["a" /* default */])(bbox);
                                lng = lngLat.lng, lat = lngLat.lat;
                                featureGeojson = {
                                    type: 'Feature',
                                    properties: {},
                                    geometry: {
                                        type: 'Point',
                                        coordinates: [lng, lat]
                                    }
                                };


                                if (!Object(__WEBPACK_IMPORTED_MODULE_11__turf_boolean_within__["a" /* default */])(featureGeojson, mapBounds)) {
                                    // animate to these coordinates
                                    // @IDEA: maybe we can just get the coords from the bbox of the polygon?
                                    map.flyTo({
                                        center: lngLat,
                                        zoom: 14
                                    });
                                }
                                _context17.next = 23;
                                break;

                            case 20:
                                _context17.prev = 20;
                                _context17.t0 = _context17['catch'](4);

                                _this20.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["D" /* TRIGGER_TOAST */], 'Error loading watershed data');

                            case 23:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, _this20, [[4, 20]]);
            }))();
        },

        /**
         * add or update watershed query location marker element
         * @param  {LngLat}  [coords=null] query location coordinates
         */
        updateQueryLocationMarker: function updateQueryLocationMarker() {
            var _this21 = this;

            var coords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee18() {
                var map, el;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                if (!(coords === null)) {
                                    _context18.next = 4;
                                    break;
                                }

                                if (_this21.queryLocationMarker) {
                                    _this21.queryLocationMarker.remove();
                                }
                                _this21.queryLocationMarker = null;
                                return _context18.abrupt('return');

                            case 4:
                                if (!(_this21.queryLocationMarker === null)) {
                                    _context18.next = 17;
                                    break;
                                }

                                _context18.next = 7;
                                return _this21.mapPromise;

                            case 7:
                                map = _context18.sent;
                                el = document.createElement('div');

                                el.className = 'marker query-location';
                                el.style.backgroundImage = 'url(/static/marker-icon-orange.svg)';
                                el.style.width = '45px';
                                el.style.height = '53px';

                                // show sidebar on click
                                el.addEventListener('click', function (ev) {
                                    ev.stopPropagation();
                                    _this21.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["w" /* SET_SIDEBAR_CONTEXT */], 'watershed');
                                    _this21.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], true);
                                });

                                // show tooltip on mouseover
                                el.addEventListener('mousemove', function () {
                                    var markerCoords = _this21.queryLocationMarker.getLngLat();
                                    _this21.showTooltip(markerCoords, 'Watershed query location');
                                });
                                el.addEventListener('mouseleave', function () {
                                    _this21.hideTooltip();
                                });

                                // add marker to map
                                _this21.queryLocationMarker = new __WEBPACK_IMPORTED_MODULE_8_mapbox_gl___default.a.Marker(el, {
                                    // @TODO: offset this correctly. can't find the API docs for v0.44.2
                                    offset: [-0, -10]
                                }).setLngLat(coords).addTo(map);

                            case 17:

                                // update marker location
                                if (coords) {
                                    _this21.queryLocationMarker.setLngLat(coords);
                                }

                            case 18:
                            case 'end':
                                return _context18.stop();
                        }
                    }
                }, _callee18, _this21);
            }))();
        }
    },
    watch: {
        // hide tooltip on zoom
        mapZoom: function mapZoom() {
            this.hideTooltip();
        },

        // focus on newly-selected licences
        selectedLicence: function selectedLicence(licence) {
            if (licence) {
                this.revealFeature(licence);
                this.updateSelectedMarker(licence.id);
            }
        },

        // focus on newly-selected watersheds
        selectedWatershed: function selectedWatershed(watershed) {
            if (watershed) {
                var id = watershed.id,
                    coords = watershed.coords;

                this.selectWatershed(id, coords);
            } else {
                // if selection is cleared
                this.updateQueryLocationMarker(null);
                this.watershedGeojson = null;
                this.clearWatershedPolygon();
            }
        },

        // update mapbox filters when filter settings change
        filterSettings: function filterSettings() {
            this.updateMapFilters();
        },

        // when a map tool is shown, hide all the others
        showMapLegend: function showMapLegend(val) {
            if (val) {
                this.hideMapTools('showMapLegend');
            }
        },

        // when a map tool is shown, hide all the others
        showStyleSwitcher: function showStyleSwitcher(val) {
            if (val) {
                this.hideMapTools('showStyleSwitcher');
            }
        }
    }
});

/***/ }),

/***/ "DUX4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_mutations__ = __webpack_require__("cLT6");


var _mutations, _actions;




/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        // specifically track if source data is loaded
        // used for showing a separate loading indicator
        sourceDataLoaded: false,
        // viewport extent in minX, minY, maxX, maxY order
        bbox: [],
        // map center coordinates with lng, lat
        center: {},

        // selected map features
        selectedWatershed: null,
        selectedStation: null,
        selectedLicence: null,

        // map legend
        showMapLegend: true
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants_mutations__["m" /* SET_MAP_BOUNDS */], function (state, bbox) {
        state.bbox = bbox;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants_mutations__["v" /* SET_SELECTED_WATERSHED */], function (state, watershed) {
        state.selectedWatershed = watershed;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants_mutations__["s" /* SET_SELECTED_STATION */], function (state, station) {
        state.selectedStation = station;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants_mutations__["r" /* SET_SELECTED_LICENCE */], function (state, licence) {
        state.selectedLicence = licence;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants_mutations__["n" /* SET_MAP_CENTER */], function (state, centerCoords) {
        state.center = centerCoords;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants_mutations__["p" /* SET_MAP_SOURCE_DATA_LOADED */], function (state, loaded) {
        state.sourceDataLoaded = loaded;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants_mutations__["z" /* SHOW_MAP_LEGEND */], function (state, loaded) {
        state.showMapLegend = loaded;
    }), _mutations),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["q" /* SET_MAP_BOUNDS */], function (_ref, bbox) {
        var commit = _ref.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["m" /* SET_MAP_BOUNDS */], bbox);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["g" /* SELECT_STATION */], function (_ref2, station) {
        var commit = _ref2.commit;

        // change the sidebar context
        if (station) {
            commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["w" /* SET_SIDEBAR_CONTEXT */], 'station');
        } else {
            commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["w" /* SET_SIDEBAR_CONTEXT */], 'live');
        }
        // set the id
        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["s" /* SET_SELECTED_STATION */], station);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["f" /* SELECT_LICENCE */], function (_ref3, licence) {
        var commit = _ref3.commit;

        // change the sidebar context
        if (licence) {
            commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["w" /* SET_SIDEBAR_CONTEXT */], 'licence');
        } else {
            commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["w" /* SET_SIDEBAR_CONTEXT */], 'live');
        }
        // set the id
        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["r" /* SET_SELECTED_LICENCE */], licence);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["h" /* SELECT_WATERSHED */], function (_ref4, watershed) {
        var commit = _ref4.commit;

        // set the id
        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["v" /* SET_SELECTED_WATERSHED */], watershed);
        // change the sidebar context
        if (watershed) {
            commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["w" /* SET_SIDEBAR_CONTEXT */], 'watershed');
        } else {
            commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["w" /* SET_SIDEBAR_CONTEXT */], 'live');
        }
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["r" /* SET_MAP_CENTER */], function (_ref5, centerCoords) {
        var commit = _ref5.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["n" /* SET_MAP_CENTER */], centerCoords);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["t" /* SET_MAP_SOURCE_DATA_LOADED */], function (_ref6) {
        var commit = _ref6.commit;
        var loaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["p" /* SET_MAP_SOURCE_DATA_LOADED */], loaded);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["z" /* SHOW_MAP_LEGEND */], function (_ref7, show) {
        var commit = _ref7.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["z" /* SHOW_MAP_LEGEND */], show);
    }), _actions)
});

/***/ }),

/***/ "Desb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DwHN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-save"},[_c('div',{staticClass:"mapboxgl-ctrl mapboxgl-ctrl-group map-save-control",attrs:{"id":"map-save-button"},on:{"click":function($event){_vm.show(!_vm.value)}}},[_c('v-tooltip',{attrs:{"right":""}},[_c('button',{attrs:{"slot":"activator","type":"button"},slot:"activator"},[_c('v-icon',{staticClass:"mbgl-color"},[_vm._v("save")])],1),_vm._v(" "),_c('span',[_vm._v("Save...")])])],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","value":_vm.value,"max-width":"450"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline primary white--text"},[_vm._v("\n                Save\n                "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text close-button ma-0 pa-0",attrs:{"flat":"","icon":""},on:{"click":function($event){_vm.show(false)}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('h3',{staticClass:"subheadline"},[_vm._v("\n                    Save map view\n                ")]),_vm._v(" "),_c('p',[_vm._v("Use this URL to save or share your current view and filters")]),_vm._v(" "),_c('v-text-field',{attrs:{"id":"short-url-input","label":"Map view URL","prepend-icon":"mdi-clipboard-text","prepend-icon-cb":_vm.copyShortUrl,"color":"accent","hide-details":"","full-width":"","readonly":"","value":_vm.mapViewShortUrl},on:{"click":_vm.selectShortUrlInput}}),_vm._v(" "),(_vm.featuresUrl)?[_c('h3',{staticClass:"subheadline"},[_vm._t("features-headline",[_vm._v("Download map features")])],2),_vm._v(" "),_c('p',[_vm._v("Download map data as a CSV file")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","block":"","large":""},on:{"click":_vm.downloadCsv}},[(_vm.loadingCsv)?_c('v-progress-circular',{staticClass:"mr-2",attrs:{"width":3,"indeterminate":"","color":"white"}}):_vm._e(),_vm._v("\n                        Download map data\n                    ")],1)]:_vm._e()],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EepR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var DEFAULT_CALLBACKS = {
    onStart: function onStart() {},
    onPreviousStep: function onPreviousStep() {},
    onNextStep: function onNextStep() {},
    onStop: function onStop() {}
};

var DEFAULT_OPTIONS = {
    useKeyboardNavigation: true,
    startTimeout: 0
};

var KEYS = {
    ARROW_RIGHT: 39,
    ARROW_LEFT: 37,
    ESCAPE: 27,
    ENTER: 13
};
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'v-tour',
    props: {
        steps: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        name: {
            type: String
        },
        options: {
            type: Object,
            default: function _default() {
                return DEFAULT_OPTIONS;
            }
        },
        callbacks: {
            type: Object,
            default: function _default() {
                return DEFAULT_CALLBACKS;
            }
        }
    },
    data: function data() {
        return {
            currentStep: -1
        };
    },
    mounted: function mounted() {
        this.$tours[this.name] = this;

        if (this.customOptions.useKeyboardNavigation) {
            window.addEventListener('keyup', this.handleKeyup);
        }
    },
    beforeDestroy: function beforeDestroy() {
        // Remove the keyup listener if it has been defined
        if (this.customOptions.useKeyboardNavigation) {
            window.removeEventListener('keyup', this.handleKeyup);
        }
    },

    computed: {
        // Allow us to define custom options and merge them with the default options.
        // Since options is a computed property, it is reactive and can be updated during runtime.
        customOptions: function customOptions() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_OPTIONS, this.options);
        },
        customCallbacks: function customCallbacks() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_CALLBACKS, this.callbacks);
        },

        // Return true if the tour is active, which means that there's a VStep displayed
        isRunning: function isRunning() {
            return this.currentStep > -1 && this.currentStep < this.numberOfSteps;
        },
        isFirst: function isFirst() {
            return this.currentStep === 0;
        },
        isLast: function isLast() {
            return this.currentStep === this.steps.length - 1;
        },
        numberOfSteps: function numberOfSteps() {
            return this.steps.length;
        }
    },
    methods: {
        start: function start() {
            var _this = this;

            // Wait for the DOM to be loaded, then start the tour
            setTimeout(function () {
                _this.customCallbacks.onStart();
                _this.currentStep = 0;
            }, this.customOptions.startTimeout);
        },
        previousStep: function previousStep() {
            if (this.currentStep > 0) {
                this.customCallbacks.onPreviousStep(this.currentStep);
                this.currentStep -= 1;
            }
        },
        nextStep: function nextStep() {
            if (this.currentStep < this.numberOfSteps - 1 && this.currentStep !== -1) {
                this.customCallbacks.onNextStep(this.currentStep);
                this.currentStep += 1;
            } else if (this.currentStep === this.numberOfSteps - 1) {
                this.stop();
            }
        },
        stop: function stop() {
            this.customCallbacks.onStop();
            this.currentStep = -1;
        },
        handleKeyup: function handleKeyup(e) {
            /* eslint-disable default-case */
            switch (e.keyCode) {
                case KEYS.ARROW_RIGHT:
                    this.nextStep();
                    break;
                case KEYS.ARROW_LEFT:
                    this.previousStep();
                    break;
                case KEYS.ESCAPE:
                    this.stop();
                    break;
                case KEYS.ENTER:
                    this.nextStep();
                    break;
            }
        }
    }
});

/***/ }),

/***/ "Euhy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarStationGroundQuality_vue__ = __webpack_require__("8rkh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59d2e6d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarStationGroundQuality_vue__ = __webpack_require__("WYgs");
function injectStyle (ssrContext) {
  __webpack_require__("2Yd3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59d2e6d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarStationGroundQuality_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59d2e6d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarStationGroundQuality_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F+3s":
/***/ (function(module, exports) {

module.exports = {"name":"crossfilter2","version":"1.4.5","description":"Fast multidimensional filtering for coordinated views.","license":"Apache-2.0","keywords":["analytics","visualization","crossfilter"],"author":{"name":"Mike Bostock","url":"http://bost.ocks.org/mike"},"contributors":[{"name":"Jason Davies","url":"http://www.jasondavies.com/"}],"maintainers":[{"name":"Gordon Woodhull","url":"https://github.com/gordonwoodhull"},{"name":"Tanner Linsley","url":"https://github.com/tannerlinsley"},{"name":"Ethan Jewett","url":"https://github.com/esjewett"}],"homepage":"http://crossfilter.github.com/crossfilter/","main":"./index.js","types":"./index.d.ts","repository":{"type":"git","url":"http://github.com/crossfilter/crossfilter.git"},"dependencies":{"lodash.result":"^4.4.0"},"devDependencies":{"browserify":"^13.0.0","d3":"3.5","eslint":"2.10.2","package-json-versionify":"1.0.2","semver":"^5.3.0","sinon":"^4.0.2","uglify-js":"2.4.0","vows":"0.7.0"},"scripts":{"benchmark":"node test/benchmark.js","build":"browserify index.js -t package-json-versionify --standalone crossfilter -o crossfilter.js && uglifyjs --compress --mangle --screw-ie8 crossfilter.js -o crossfilter.min.js","clean":"rm -f crossfilter.js crossfilter.min.js","test":"./node_modules/.bin/vows --verbose && eslint src/"},"files":["src","index.js","index.d.ts","crossfilter.js","crossfilter.min.js"],"eslintConfig":{"env":{"browser":true,"node":true},"globals":{"Uint8Array":true,"Uint16Array":true,"Uint32Array":true},"extends":"eslint:recommended"}}

/***/ }),

/***/ "G3uD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.show,"persistent":"","scrollable":"","fullscreen":"","transition":"scale-transition"}},[_c('v-card',{staticClass:"chart-modal"},[_c('v-toolbar',{attrs:{"color":"secondary","dark":"","tabs":""}},[_c('v-toolbar-title',{domProps:{"textContent":_vm._s(_vm.stationName)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.hide($event)}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-tabs',{staticClass:"tab-switcher",attrs:{"slot":"extension","fixed":"","centered":"","color":"secondary"},slot:"extension",model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('v-tab',{attrs:{"href":"#precipitation"}},[_vm._v("\n                        Precipitation\n                    ")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#temperature"}},[_vm._v("\n                        Temperature\n                    ")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#snow"}},[_vm._v("\n                        Snow Depth\n                    ")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#snow-water-equivalent"}},[_vm._v("\n                        Snow Water Equivalent\n                    ")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#manual-snow-survey"}},[_vm._v("\n                        Manual Snow Survey\n                    ")])],1)],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('v-tab-item',{attrs:{"id":"precipitation"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(!_vm.checkChartData(this.stationData, 'precipitation', this.checkClimateDataFields.precipitation))?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_c('div',[(_vm.activeTab === 'precipitation')?_c('precipitation-chart',{key:_vm.stationId,staticClass:"chart-precipitation"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"data-note"},[_vm._v("Data may be from a live sensor and has not gone through QA, so may contain errors.")])],1)])],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"temperature"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(!_vm.checkChartData(this.stationData, 'temperature', this.checkClimateDataFields.temperature))?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_c('div',[(_vm.activeTab === 'temperature')?_c('temperature-chart',{key:_vm.stationId,staticClass:"chart-temperature"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"data-note"},[_vm._v("Data may be from a live sensor and has not gone through QA, so may contain errors.")])],1)])],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"snow"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(!_vm.checkChartData(this.stationData, 'snow_on_ground_depth', this.checkClimateDataFields.snow_on_ground_depth))?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_c('div',[(_vm.activeTab === 'snow')?_c('snow-chart',{key:_vm.stationId,staticClass:"chart-snow"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"data-note"},[_vm._v("Data may be from a live sensor and has not gone through QA, so may contain errors.")])],1)])],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"snow-water-equivalent"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(!_vm.checkChartData(this.stationData, 'snow_water_equivalent', this.checkClimateDataFields.snow_water_equivalent))?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_c('div',[(_vm.activeTab === 'snow-water-equivalent')?_c('snow-water-equiv-chart',{key:_vm.stationId,staticClass:"chart-snow-water-equiv"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"data-note"},[_vm._v("Data may be from a live sensor and has not gone through QA, so may contain errors.")])],1)])],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"manual-snow-survey"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(!_vm.checkChartData(this.stationData, 'manual_snow_survey', this.checkClimateDataFields.manual_snow_survey))?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_c('div',[(_vm.activeTab === 'manual-snow-survey')?_c('manual-snow-survey-chart',{key:_vm.stationId,staticClass:"chart-manual-snow-survey"}):_vm._e()],1)])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G7Vm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GI3Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GLA1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapboxGlMap_vue__ = __webpack_require__("cZsT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e3a6200_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapboxGlMap_vue__ = __webpack_require__("jlXn");
function injectStyle (ssrContext) {
  __webpack_require__("67Rs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapboxGlMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e3a6200_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapboxGlMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GfAr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GghS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3Sparkline_vue__ = __webpack_require__("yJFt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4358ce3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D3Sparkline_vue__ = __webpack_require__("NJgh");
function injectStyle (ssrContext) {
  __webpack_require__("6BH1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_D3Sparkline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4358ce3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_D3Sparkline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GkUN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClimateManualSnowSurvey_vue__ = __webpack_require__("/AML");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaebf5b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClimateManualSnowSurvey_vue__ = __webpack_require__("82N8");
function injectStyle (ssrContext) {
  __webpack_require__("v1v/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClimateManualSnowSurvey_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaebf5b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClimateManualSnowSurvey_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gn66":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlowDurationTool_vue__ = __webpack_require__("qgrT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b4e5ccc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlowDurationTool_vue__ = __webpack_require__("Th3G");
function injectStyle (ssrContext) {
  __webpack_require__("t37k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlowDurationTool_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b4e5ccc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlowDurationTool_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GuOa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selected-licence"},[(!_vm.queryDone)?_c('div',{staticClass:"loading"},[_c('p',[_vm._v("Loading licence data...")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),_vm._v(" "),(_vm.queryDone)?_c('div',{staticClass:"licence"},[_c('h3',{staticClass:"headline licence-name primary--text",domProps:{"textContent":_vm._s(_vm.queryData.name)}}),_vm._v(" "),_c('p',{staticClass:"body-2 mb-1 network-info"},[_vm._v("\n            "+_vm._s(_vm.licenceTerm)+" - "+_vm._s(_vm.licenceType)),_c('br'),_vm._v("\n            "+_vm._s(_vm.brandingOrganization)+"\n        ")]),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_vm._l((_vm.properties),function(ref){
var title = ref.title;
var value = ref.value;
return (value)?_c('div',{staticClass:"properties-item mb-3"},[_c('h4',{staticClass:"subheading field-title grey--text",domProps:{"textContent":_vm._s(title)}}),_vm._v(" "),_c('div',{staticClass:"body-1 field-value",domProps:{"textContent":_vm._s(value)}})]):_vm._e()})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H+MB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return data; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__ = __webpack_require__("oPhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_appColors__ = __webpack_require__("QW0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_chartTooltipDate__ = __webpack_require__("rgFZ");






var container = function container(data) {
    return {
        type: 'line',
        data: data,
        plugins: [__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default.a],
        options: {
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
                mode: 'index',
                axis: 'x',
                intersect: false,
                position: 'nearest',
                callbacks: {
                    label: function label(tooltipItem, d) {
                        var label = d.datasets[tooltipItem.datasetIndex].label || '';
                        var value = __WEBPACK_IMPORTED_MODULE_0_numeral___default()(tooltipItem.yLabel).format('0,0.[00]');
                        return label + ': ' + value + ' m';
                    },

                    title: __WEBPACK_IMPORTED_MODULE_4__functions_chartTooltipDate__["a" /* default */]
                }
            },
            annotation: {
                events: [],
                annotations: [{
                    drawTime: 'afterDatasetsDraw',
                    id: 'vline',
                    type: 'line',
                    mode: 'vertical',
                    scaleID: 'x-axis-0',
                    value: __WEBPACK_IMPORTED_MODULE_1_moment___default()(),
                    borderColor: 'black',
                    borderWidth: 3,
                    label: {
                        backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["A" /* todayMarker */],
                        content: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('LL'),
                        enabled: true
                    }
                }]
            },
            pan: {
                enabled: true,
                mode: 'y',
                speed: 10,
                threshold: 10
            },
            zoom: {
                enabled: true,
                mode: 'y',
                limits: {
                    max: 100,
                    min: 1
                }
            },
            scales: {
                xAxes: [{
                    type: 'time',
                    distribution: 'linear',
                    time: {
                        tooltipFormat: 'MMM DD, YYYY',
                        unit: 'month'
                    }
                }],
                yAxes: [{
                    ticks: {
                        reverse: true,
                        beginAtZero: false
                    },
                    scaleLabel: {
                        display: true,
                        labelString: 'Depth to Water (m)'
                    }
                }],
                // disable animations
                animation: false
            }
        }
    };
};

var data = function data(labels, currentData, historicalData) {
    return {
        labels: labels,
        datasets: [{
            type: 'line',
            label: 'Current',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["d" /* currentBorder */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["d" /* currentBorder */],
            borderWidth: 2,
            fill: false,
            pointRadius: 0,
            pointHitRadius: 1,
            // steppedLine: 'before',
            data: currentData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.v
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical mean',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["g" /* historicalMean */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["g" /* historicalMean */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 24,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.a
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 75th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            borderWidth: 2,
            fill: '+1',
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 24,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p75
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 25th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 24,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p25
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical Max',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            borderWidth: 2,
            fill: '+1',
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 24,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.max
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical Min',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 24,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.min
                };
                return valObj;
            })
        }]
    };
};

/***/ }),

/***/ "HEse":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"climate-snow-water-equiv-chart"},[_c('div',{staticClass:"yearly-data-select"},[_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"d-flex":"","sm3":""}},[_c('v-select',{attrs:{"width":"200","label":"Select","items":_vm.yearlyDataAvailable,"multiple":"","max-height":"400","hint":"Add yearly data","persistent-hint":""},model:{value:(_vm.yearlyDataDisplay),callback:function ($$v) {_vm.yearlyDataDisplay=$$v},expression:"yearlyDataDisplay"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":"","d-flex":"","justify-center":"","align-content-end":""}},[_c('v-btn',{attrs:{"outline":""},on:{"click":_vm.downloadChart}},[_c('v-icon',[_vm._v("file_download")]),_vm._v(" Download PNG")],1)],1)],1)],1),_vm._v(" "),_c('a',{ref:"downloadUrl",staticStyle:{"display":"none"},attrs:{"href":"#"}}),_vm._v(" "),_c('div',{staticClass:"chart-wrap"},[_c('v-btn',{staticClass:"zoom-btn",attrs:{"icon":""},on:{"click":_vm.resetZoom}},[_c('v-icon',[_vm._v("zoom_out")])],1),_vm._v(" "),_c('canvas',{attrs:{"id":_vm.chartId}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HHov":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actions__ = __webpack_require__("UOq2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'map-context-menu',
    props: ['lngLat'],
    computed: {
        coords: function coords() {
            return this.lngLat.toArray();
        },
        lng: function lng() {
            return this.coords[0];
        },
        lat: function lat() {
            return this.coords[1];
        },
        displayCoords: function displayCoords() {
            // use filter function
            var numFormat = this.$options.filters.numFormat;
            var lat = numFormat(this.lat, '0.00000');
            var lng = numFormat(this.lng, '0.00000');
            return lat + ', ' + lng;
        }
    },
    methods: {
        copyCoordinates: function copyCoordinates() {
            var coordsField = this.$refs['click-coordinates'];
            coordsField.select();
            document.execCommand('Copy');
            // clear selection
            document.getSelection().removeAllRanges();

            // notify user that text was copied
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__constants_actions__["D" /* TRIGGER_TOAST */], 'Copied coordinates to clipboard');
        }
    }
});

/***/ }),

/***/ "HvOn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortByKey;
/**
 * returns an Array.sort callback that sorts objects by value of 'key'
 * @param  {String}  key               key in the Object to use for sorting
 * @param  {Boolean} [ignoreCase=true] if true, do case-insensitive comparison
 * @return {Function}                  Array.sort callback function
 */
function sortByKey(key) {
    var ignoreCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    /**
     * sort an object alphabetically by a key
     * Array.sort callback, returns -1, 0, or 1
     * @param  {Object} a object with a 'label' member
     * @param  {Object} b object with a 'label' member
     * @return {Number}   -1, 0, or 1 for sorting
     */
    return function (a, b) {
        var labelA = a[key];
        var labelB = b[key];
        if (ignoreCase) {
            labelA = labelA.toUpperCase();
            labelB = labelB.toUpperCase();
        }
        if (labelA < labelB) {
            return -1;
        }
        if (labelA > labelB) {
            return 1;
        }
        // if labels are equal
        return 0;
    };
}

/***/ }),

/***/ "Hw2Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_GwLevelHydrograph__ = __webpack_require__("4F+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_StationGroundLevelTable__ = __webpack_require__("uehw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_checkQueryData__ = __webpack_require__("ieMF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_groundLevelData__ = __webpack_require__("djs4");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'chart-modal',
    components: {
        HydrographChart: __WEBPACK_IMPORTED_MODULE_1__components_charts_GwLevelHydrograph__["a" /* default */],
        StationGroundLevelTable: __WEBPACK_IMPORTED_MODULE_2__components_charts_StationGroundLevelTable__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_checkQueryData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_groundLevelData__["a" /* default */]],
    computed: {
        show: function show() {
            return this.$store.state.showChartModal;
        },

        activeTab: {
            get: function get() {
                return this.$store.state.chartModalActiveTab;
            },
            set: function set(val) {
                this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__constants_actions__["i" /* SET_CHART_MODAL_TAB */], val);
            }
        },
        stationData: function stationData() {
            return this.queryData;
        },
        stationName: function stationName() {
            if (this.stationData) {
                return this.stationData.name;
            }
            return '';
        },
        stationId: function stationId() {
            if (this.station) {
                return this.station.id;
            }
            return '';
        }
    },
    methods: {
        hide: function hide() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__constants_actions__["y" /* SHOW_CHART_MODAL */], false);
        }
    }
});

/***/ }),

/***/ "IA+h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IDfn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ILTc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IMJV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-tooltip elevation-3 white",style:(_vm.styles)},_vm._l((_vm.content),function(line){return _c('div',[('text' in line)?_c('div',{staticClass:"text",class:line.class},[_vm._v("\n            "+_vm._s(line.text)+"\n        ")]):_vm._e(),_vm._v(" "),('label' in line)?_c('div',{staticClass:"label-value",class:line.class},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(line.label)+":")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(line.value))])]):_vm._e()])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcYZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IdF8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IkOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Watershed_vue__ = __webpack_require__("qO0w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69ee8e0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Watershed_vue__ = __webpack_require__("8lxH");
function injectStyle (ssrContext) {
  __webpack_require__("1sRJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Watershed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69ee8e0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Watershed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IuoA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J8oE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-wrap",class:_vm.classObj},[_c('mapbox-gl-map',{attrs:{"id":"map","accessToken":_vm.$cfg.mapboxgl.accessToken,"options":_vm.getMapOptions()},on:{"loaded":_vm.mapLoaded}}),_vm._v(" "),(_vm.$store.state.showChartModal)?_c('chart-modal'):_vm._e(),_vm._v(" "),_c('overlap-picker',{attrs:{"features":_vm.overlapFeatures},on:{"select":_vm.selectStation},scopedSlots:_vm._u([{key:"header",fn:function(slotScope){return [_vm._v("\n            "+_vm._s(slotScope.numFeatures)+" stations at these coordinates\n        ")]}},{key:"listItem",fn:function(slotScope){return [_c('v-list-tile-title',{domProps:{"textContent":_vm._s(slotScope.feature.properties.name)}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v("\n                "+_vm._s(slotScope.feature.properties.nid)+"\n            ")])]}}]),model:{value:(_vm.showOverlapPicker),callback:function ($$v) {_vm.showOverlapPicker=$$v},expression:"showOverlapPicker"}}),_vm._v(" "),_c('style-switcher',{on:{"switchedStyle":_vm.addLayers},model:{value:(_vm.showStyleSwitcher),callback:function ($$v) {_vm.showStyleSwitcher=$$v},expression:"showStyleSwitcher"}}),_vm._v(" "),_c('map-save-button',{attrs:{"featuresUrl":_vm.mapSourceUrl},model:{value:(_vm.showMapSave),callback:function ($$v) {_vm.showMapSave=$$v},expression:"showMapSave"}},[_c('template',{attrs:{"slot":"features-headline"},slot:"features-headline"},[_vm._v("Download stations")])],2),_vm._v(" "),_c('map-legend',{attrs:{"items":_vm.getLegendLayers()},model:{value:(_vm.showMapLegend),callback:function ($$v) {_vm.showMapLegend=$$v},expression:"showMapLegend"}}),_vm._v(" "),_c('map-sidebar',{attrs:{"filters":_vm.filters}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JKMa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.show,"persistent":"","scrollable":"","fullscreen":"","transition":"scale-transition"}},[_c('v-card',{staticClass:"chart-modal"},[_c('v-toolbar',{attrs:{"color":"secondary","dark":"","tabs":""}},[_c('v-toolbar-title',{domProps:{"textContent":_vm._s(_vm.stationName)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.hide($event)}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-tabs',{staticClass:"tab-switcher",attrs:{"slot":"extension","fixed":"","centered":"","color":"secondary"},slot:"extension",model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('v-tab',{attrs:{"href":"#surface-water-quality"}},[_vm._v("\n                    Surface Water Quality\n                ")])],1)],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('v-tab-item',{attrs:{"id":"surface-water-quality"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(_vm.stationData === null)?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_c('div',[(_vm.show && _vm.activeTab === 'surface-water-quality')?_c('sw-quality-table'):_vm._e()],1)])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JLkL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        /**
         * format 12-month historical data into 18 months
         * @param  {Array} data12Months 12-month data
         * @param  {Function} formatter   formatter callback
         * @return {Array}              18-month data
         */
        formatHistoricalData: function formatHistoricalData(data12Months, formatter) {
            // build 18 months of historical values from 12 months of data
            // use the last 13 months, plus the next 5 months

            // clone the year of data to form last year, this year, next year
            var currentMonth = __WEBPACK_IMPORTED_MODULE_1_moment___default()().get('month');
            var lastYear = __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1, 'years').startOf('year');
            var data3Years = data12Months.concat(data12Months, data12Months).map(function (e, i) {
                var date = lastYear.clone().add(i, 'months');
                var days = [];
                for (var num = 0; num < date.daysInMonth(); num++) {
                    // eslint-disable-line no-plusplus
                    var day = date.clone().add(num, 'days');
                    days.push(formatter(day, e));
                }
                return days;
            });
            var data18Months = [];
            data3Years.slice(currentMonth, currentMonth + 19).forEach(function (month) {
                data18Months.push.apply(data18Months, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(month));
            });
            return data18Months;
        }
    }
});

/***/ }),

/***/ "JO4y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"timeout":3000,"bottom":true},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","color":"accent"},nativeOn:{"click":function($event){_vm.show = false}}},[_vm._v("Close")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K+N6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-wrap",class:_vm.classObj},[_c('mapbox-gl-map',{attrs:{"id":"map","accessToken":_vm.$cfg.mapboxgl.accessToken,"options":_vm.getMapOptions()},on:{"loaded":_vm.mapLoaded}}),_vm._v(" "),_c('overlap-picker',{attrs:{"features":_vm.overlapFeatures},on:{"select":_vm.selectLicence},scopedSlots:_vm._u([{key:"header",fn:function(slotScope){return [_vm._v("\n            "+_vm._s(slotScope.numFeatures)+" licences at these coordinates\n        ")]}},{key:"listItem",fn:function(slotScope){return [_c('v-list-tile-title',{domProps:{"textContent":_vm._s(_vm.licenceNumberTemplate(
                    slotScope.feature.properties.nid,
                    _vm.lookupPropertyById('term', slotScope.feature.properties.term)
            ))}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v("\n                "+_vm._s(_vm._f("numFormat")(slotScope.feature.properties.qty,'0,0.[00]'))+" m³/year;\n                "+_vm._s(_vm.lookupPropertyById('ind', slotScope.feature.properties.ind))+"\n            ")])]}}]),model:{value:(_vm.showOverlapPicker),callback:function ($$v) {_vm.showOverlapPicker=$$v},expression:"showOverlapPicker"}}),_vm._v(" "),_c('style-switcher',{on:{"switchedStyle":_vm.addLayers},model:{value:(_vm.showStyleSwitcher),callback:function ($$v) {_vm.showStyleSwitcher=$$v},expression:"showStyleSwitcher"}}),_vm._v(" "),_c('map-save-button',{attrs:{"featuresUrl":_vm.mapSourceUrl},model:{value:(_vm.showMapSave),callback:function ($$v) {_vm.showMapSave=$$v},expression:"showMapSave"}},[_c('template',{attrs:{"slot":"features-headline"},slot:"features-headline"},[_vm._v("Download licences")])],2),_vm._v(" "),_c('map-legend',{attrs:{"items":_vm.getLegendLayers()},model:{value:(_vm.showMapLegend),callback:function ($$v) {_vm.showMapLegend=$$v},expression:"showMapLegend"}}),_vm._v(" "),_c('map-draw'),_vm._v(" "),_c('map-sidebar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KBSf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLicence_vue__ = __webpack_require__("aHL1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fb2df8d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLicence_vue__ = __webpack_require__("GuOa");
function injectStyle (ssrContext) {
  __webpack_require__("Vas+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLicence_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fb2df8d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLicence_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KMRt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapDraw_vue__ = __webpack_require__("Cj1z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18735f38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapDraw_vue__ = __webpack_require__("mZW9");
function injectStyle (ssrContext) {
  __webpack_require__("3Zu0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapDraw_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18735f38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapDraw_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KW/8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlowMetricsTable_vue__ = __webpack_require__("Bdm2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0ce5e6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlowMetricsTable_vue__ = __webpack_require__("0uOx");
function injectStyle (ssrContext) {
  __webpack_require__("3h8O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlowMetricsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0ce5e6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlowMetricsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KaMZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = labelLayer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);

// map of style urls to the first label layer id
// use this to re-order user layers beneath map labels
var labelLayers = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
labelLayers.set('mapbox://styles/mapbox/basic-v9', 'poi_label');
labelLayers.set('mapbox://styles/foundryspatial/cjlebyluk82lh2rnuo14qng0g', 'housenum-label');
labelLayers.set('mapbox://styles/mapbox/bright-v9', 'water_label');
labelLayers.set('mapbox://styles/mapbox/light-v9', 'waterway-label');
labelLayers.set('mapbox://styles/mapbox/dark-v9', 'waterway-label');
labelLayers.set('mapbox://styles/mapbox/satellite-v9', null);

/**
 * get the first label layer for a given mapbox style
 * @param  {String} styleUrl mapbox style url
 * @return {String|null}     map layer id, or null
 */
function labelLayer(styleUrl) {
  return labelLayers.get(styleUrl);
}

/***/ }),

/***/ "LZJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ljcf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M1/d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_ClimatePrecipitation__ = __webpack_require__("gmpa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_ClimateTemperature__ = __webpack_require__("26vA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_ClimateSnow__ = __webpack_require__("5qLp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_charts_ClimateSnowWaterEquivalent__ = __webpack_require__("2sQ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_charts_ClimateManualSnowSurvey__ = __webpack_require__("GkUN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_checkQueryData__ = __webpack_require__("ieMF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_climateData__ = __webpack_require__("epYP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'chart-modal',
    components: {
        PrecipitationChart: __WEBPACK_IMPORTED_MODULE_1__components_charts_ClimatePrecipitation__["a" /* default */],
        TemperatureChart: __WEBPACK_IMPORTED_MODULE_2__components_charts_ClimateTemperature__["a" /* default */],
        SnowChart: __WEBPACK_IMPORTED_MODULE_3__components_charts_ClimateSnow__["a" /* default */],
        SnowWaterEquivChart: __WEBPACK_IMPORTED_MODULE_4__components_charts_ClimateSnowWaterEquivalent__["a" /* default */],
        ManualSnowSurveyChart: __WEBPACK_IMPORTED_MODULE_5__components_charts_ClimateManualSnowSurvey__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_checkQueryData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_climateData__["a" /* default */]],
    computed: {
        show: function show() {
            return this.$store.state.showChartModal;
        },

        activeTab: {
            get: function get() {
                return this.$store.state.chartModalActiveTab;
            },
            set: function set(val) {
                this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__constants_actions__["i" /* SET_CHART_MODAL_TAB */], val);
            }
        },
        stationData: function stationData() {
            return this.queryData;
        },
        stationName: function stationName() {
            if (this.stationData) {
                return this.stationData.name;
            }
            return '';
        },
        stationId: function stationId() {
            if (this.station) {
                return this.station.id;
            }
            return '';
        }
    },
    methods: {
        hide: function hide() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__constants_actions__["y" /* SHOW_CHART_MODAL */], false);
        }
    }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ced6bc0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Ccyh");
function injectStyle (ssrContext) {
  __webpack_require__("tx64")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ced6bc0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MFnw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-duration-curve-chart"},[_c('div',[_c('svg',{attrs:{"id":"flow-duration-curve","width":_vm.svgWidth,"height":_vm.svgHeight}},[_c('g',{staticClass:"chart",attrs:{"transform":("translate(" + (_vm.margin.left) + "," + (_vm.margin.top) + ")")}})])]),_vm._v(" "),(_vm.tooltipVisible)?_c('chart-tooltip',{attrs:{"top":_vm.tooltipPosition[1],"left":_vm.tooltipPosition[0],"content":_vm.tooltipText}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MGb7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alerts_vue__ = __webpack_require__("wVEN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_038461cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alerts_vue__ = __webpack_require__("MIXW");
function injectStyle (ssrContext) {
  __webpack_require__("lg2u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alerts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_038461cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alerts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MIXW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alerts-container"},[_c('transition-group',{attrs:{"name":"scale-transition"}},_vm._l((_vm.alerts),function(alert){return _c('v-alert',{key:alert.id,attrs:{"color":alert.color,"icon":alert.icon,"dismissible":"","value":true},on:{"input":function($event){_vm.dismissed(alert.id)}}},[_vm._v("\n            "+_vm._s(alert.text)+"\n        ")])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Maap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarStationSurfaceQuality_vue__ = __webpack_require__("sh5l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_005e1da2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarStationSurfaceQuality_vue__ = __webpack_require__("WfLv");
function injectStyle (ssrContext) {
  __webpack_require__("IdF8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-005e1da2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarStationSurfaceQuality_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_005e1da2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarStationSurfaceQuality_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mde6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"inline-icon-sw-quality",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"24px","height":"24px","viewBox":"0 0 24 24","enable-background":"new 0 0 24 24","xml:space":"preserve"}},[_c('path',{attrs:{"fill":_vm.color,"d":"M12,2C6.48,2,2,6.48,2,12c0,5.521,4.48,10.001,10,10.001S22,17.521,22,12C22,6.48,17.52,2,12,2z\n    M13.67,14.542c0-0.383-0.137-0.69-0.408-0.923c-0.271-0.232-0.746-0.451-1.425-0.656c-1.185-0.342-2.081-0.747-2.687-1.217\n    c-0.605-0.469-0.909-1.112-0.909-1.928s0.348-1.482,1.042-2c0.695-0.517,1.583-0.776,2.663-0.776c1.094,0,1.985,0.291,2.673,0.872\n    c0.689,0.581,1.021,1.298,0.998,2.15l-0.014,0.041H13.67c0-0.46-0.154-0.833-0.463-1.118c-0.307-0.285-0.738-0.427-1.295-0.427\n    c-0.533,0-0.945,0.119-1.237,0.355s-0.438,0.54-0.438,0.909c0,0.337,0.156,0.614,0.468,0.831c0.313,0.216,0.852,0.445,1.617,0.687\n    c1.1,0.305,1.93,0.709,2.496,1.21c0.564,0.501,0.848,1.159,0.848,1.976c0,0.852-0.336,1.524-1.008,2.017\n    c-0.674,0.492-1.561,0.738-2.664,0.738c-1.084,0-2.03-0.279-2.837-0.837c-0.807-0.559-1.198-1.342-1.176-2.349l0.014-0.041h1.941\n    c0,0.593,0.181,1.026,0.544,1.302c0.361,0.276,0.867,0.414,1.514,0.414c0.543,0,0.957-0.111,1.244-0.335S13.67,14.915,13.67,14.542z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MqQW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mvmn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.show,"persistent":"","scrollable":"","fullscreen":"","transition":"scale-transition"}},[_c('v-card',{staticClass:"chart-modal"},[_c('v-toolbar',{attrs:{"color":"secondary","dark":"","tabs":""}},[_c('v-toolbar-title',{domProps:{"textContent":_vm._s(_vm.stationName)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.hide($event)}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-tabs',{staticClass:"tab-switcher",attrs:{"slot":"extension","fixed":"","centered":"","color":"secondary"},slot:"extension",model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('v-tab',{attrs:{"href":"#seven-day-flow"}},[_vm._v("\n                        Seven Day Flow\n                    ")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#flow-duration-tool"}},[_vm._v("\n                        Flow Duration Tool\n                    ")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#monthly-mean-flow"}},[_vm._v("\n                        Monthly Mean Flow\n                    ")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#flow-metrics"}},[_vm._v("\n                        Flow Metrics\n                    ")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#stage"}},[_vm._v("\n                        Stage\n                    ")])],1)],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('v-tab-item',{attrs:{"id":"seven-day-flow","lazy":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(!_vm.checkChartData(this.stationData, 'seven_day_flow', this.checkStreamflowDataFields.seven_day_flow))?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_c('div',[(_vm.activeTab === 'seven-day-flow')?_c('seven-day-flow-chart',{key:_vm.stationId,staticClass:"chart-seven-day-flow"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"data-note"},[_vm._v("Data may be from a live sensor and has not gone through QA, so may contain errors.")])],1)])],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"flow-duration-tool","lazy":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',[(_vm.activeTab === 'flow-duration-tool')?_c('flow-duration-tool',{key:_vm.stationId,staticClass:"chart-flow-duration-tool"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"data-note"},[_vm._v("Data may be from a live sensor and has not gone through QA, so may contain errors.")])],1)])],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"monthly-mean-flow","lazy":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(_vm.show && _vm.activeTab === 'monthly-mean-flow')?_c('monthly-mean-flow-table'):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"flow-metrics","lazy":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(_vm.show && _vm.activeTab === 'flow-metrics')?_c('flow-metrics-table'):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"stage","lazy":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(!_vm.checkChartData(this.stationData, 'stage', this.checkStreamflowDataFields.stage))?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_c('div',[(_vm.activeTab === 'stage')?_c('stage-chart',{key:_vm.stationId,staticClass:"stage-flow"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"data-note"},[_vm._v("Data may be from a live sensor and has not gone through QA, so may contain errors.")])],1)])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N6HB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHGE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:'v-step-' + _vm.hash,staticClass:"v-step",attrs:{"id":'v-step-' + _vm.hash}},[_vm._t("header",[(_vm.step.header)?_c('div',{staticClass:"v-step__header"},[(_vm.step.header.title)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.step.header.title)}}):_vm._e()]):_vm._e()]),_vm._v(" "),_vm._t("content",[_c('div',{staticClass:"v-step__content"},[(_vm.step.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.step.content)}}):_c('div',[_vm._v("This is a demo step! The id of this step is "+_vm._s(_vm.hash)+" and it targets "+_vm._s(_vm.step.target)+".")])])]),_vm._v(" "),_vm._t("actions",[_c('div',{staticClass:"v-step__buttons"},[(!_vm.isLast)?_c('button',{staticClass:"v-step__button",on:{"click":_vm.stop}},[_vm._v("Skip tour")]):_vm._e(),_vm._v(" "),(!_vm.isFirst)?_c('button',{staticClass:"v-step__button",on:{"click":_vm.previousStep}},[_vm._v("Previous")]):_vm._e(),_vm._v(" "),(!_vm.isLast)?_c('button',{staticClass:"v-step__button",on:{"click":_vm.nextStep}},[_vm._v("Next")]):_vm._e(),_vm._v(" "),(_vm.isLast)?_c('button',{staticClass:"v-step__button",on:{"click":_vm.stop}},[_vm._v("Finish")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"popper__arrow v-step__arrow",class:{ 'v-step__arrow--dark': _vm.step.header && _vm.step.header.title },attrs:{"x-arrow":_vm.params.placement}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mapbox_gl_dist_mapbox_gl_css__ = __webpack_require__("xnE8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mapbox_gl_dist_mapbox_gl_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mapbox_gl_dist_mapbox_gl_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapbox_mapbox_gl_draw_dist_mapbox_gl_draw_css__ = __webpack_require__("5h6Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapbox_mapbox_gl_draw_dist_mapbox_gl_draw_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__mapbox_mapbox_gl_draw_dist_mapbox_gl_draw_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_apollo__ = __webpack_require__("69U5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_worker__ = __webpack_require__("8smA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_browserupdate__ = __webpack_require__("KYRN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_browserupdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_browserupdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_tour_VTour__ = __webpack_require__("BWCH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_tour_VStep__ = __webpack_require__("r1oa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__apollo_apollo__ = __webpack_require__("YQr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__app_config__ = __webpack_require__("RnQ3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__functions_numFormat__ = __webpack_require__("+TRb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__functions_appColors__ = __webpack_require__("QW0U");
// import external/vendor styles




















// install Vuetify
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a, {
    theme: {
        primary: String(__WEBPACK_IMPORTED_MODULE_17__functions_appColors__["u" /* primary */]),
        secondary: String(__WEBPACK_IMPORTED_MODULE_17__functions_appColors__["v" /* secondary */]),
        accent: String(__WEBPACK_IMPORTED_MODULE_17__functions_appColors__["a" /* accent */])
    }
});

var VueTour = {
    install: function install(Vobj) {
        Vobj.component(__WEBPACK_IMPORTED_MODULE_9__components_tour_VTour__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_9__components_tour_VTour__["a" /* default */]);
        Vobj.component(__WEBPACK_IMPORTED_MODULE_10__components_tour_VStep__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_10__components_tour_VStep__["a" /* default */]);
        Vobj.prototype.$tours = {};
    }
};

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(VueTour);

// Give charts white background for exporting into images
__WEBPACK_IMPORTED_MODULE_7_chart_js___default.a.plugins.register({
    beforeDraw: function beforeDraw(chartInstance) {
        var ctx = chartInstance.chart.ctx;
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height);
    }
});

// install app.config plugin
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15__app_config__["a" /* AppConfigPlugin */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_worker__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_apollo__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_browserupdate___default.a, {
    options: {
        required: { c: 49, f: 49 },
        // chrome, firefox <49 gets notified (both about 2 years old)
        // defaults for others are pretty sane
        reminder: 24, // remind again in 24h after being dismissed.
        no_permanent_hide: true // don't let them permanently hide this - upgrade your damn browser!
    }
    // test: true, // uncomment this if you want to see what it looks like.
});
// add number formatting filter
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].filter('numFormat', __WEBPACK_IMPORTED_MODULE_16__functions_numFormat__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_13__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_11__store_store__["a" /* default */],
    apolloProvider: __WEBPACK_IMPORTED_MODULE_14__apollo_apollo__["b" /* apolloProvider */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_12__App__["a" /* default */]);
    }
});

/***/ }),

/***/ "NJgh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg-wrap spark-line"},[_c('svg',{staticClass:"spark-line-chart"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NncQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-wrap surface-quality-table"},[(_vm.tableData)?_c('scrolling-table',{staticClass:"scroll-table",attrs:{"data":_vm.tableData}}):_vm._e(),_vm._v(" "),(!_vm.tableData)?_c('div',{staticClass:"loading"},[_c('p',[_vm._v("Loading...")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Nt91":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apollo_apollo__ = __webpack_require__("YQr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions_appColors__ = __webpack_require__("QW0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_actions__ = __webpack_require__("UOq2");




var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['query stationStreamflow($id: Int!, $type: Int!) {\n                getStation(id: $id) {\n                    name\n                    nid\n                    net\n                    yr\n                    ty\n                    description\n                    area\n                    mean_annual_discharge\n                    flow_metrics\n                    licence_link\n                    formatted_seven_day_flow_chart_data\n                    formatted_stage_chart_data\n                    seven_day_flow {\n                        current\n                        historical\n                    }\n                    monthly_mean_flow(type: $type) {\n                        current\n                        yearly\n                    }\n                    stage {\n                        current\n                        historical\n                        yearly\n                    }\n                }\n            }'], ['query stationStreamflow($id: Int!, $type: Int!) {\n                getStation(id: $id) {\n                    name\n                    nid\n                    net\n                    yr\n                    ty\n                    description\n                    area\n                    mean_annual_discharge\n                    flow_metrics\n                    licence_link\n                    formatted_seven_day_flow_chart_data\n                    formatted_stage_chart_data\n                    seven_day_flow {\n                        current\n                        historical\n                    }\n                    monthly_mean_flow(type: $type) {\n                        current\n                        yearly\n                    }\n                    stage {\n                        current\n                        historical\n                        yearly\n                    }\n                }\n            }']);







/* harmony default export */ __webpack_exports__["a"] = ({
    mounted: function mounted() {
        this.initialize();
    },
    data: function data() {
        return {
            queryDone: false,
            queryData: {},
            tableData: [],
            dataQuery: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject),
            properties: [],
            sevenDayFlowDatasets: null,
            stageDatasets: null
        };
    },

    methods: {
        /**
         * handle initial data fetching and potentially station changes
         */
        initialize: function initialize() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                // reset local vars
                                _this.queryDone = false;
                                _this.queryData = {};

                                _this.sevenDayFlowDatasets = null;
                                _this.stageDatasets = null;

                                if (_this.station) {
                                    _context.next = 6;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 6:
                                _context.next = 8;
                                return _this.getData();

                            case 8:
                                _this.formatTableData();
                                _this.buildProps();

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        /**
         * query the API and fetch station data
         */
        getData: function getData() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _ref, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (_this2.station) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["b" /* ADD_LOADING */], 'load station data');
                                _context2.prev = 3;
                                _context2.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_4__apollo_apollo__["a" /* apolloClient */].query({
                                    query: _this2.dataQuery,
                                    variables: {
                                        id: _this2.station.id,
                                        type: 1
                                    }
                                });

                            case 6:
                                _ref = _context2.sent;
                                data = _ref.data;


                                // populate variables
                                _this2.buildDatasets(data.getStation);
                                _this2.queryData = data.getStation;

                                _this2.queryDone = true;
                                _context2.next = 16;
                                break;

                            case 13:
                                _context2.prev = 13;
                                _context2.t0 = _context2['catch'](3);

                                _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["D" /* TRIGGER_TOAST */], 'Error retrieving station data');

                            case 16:
                                _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["d" /* REMOVE_LOADING */], 'load station data');

                            case 17:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[3, 13]]);
            }))();
        },

        /**
         * build an array of properties to display
         */
        buildProps: function buildProps() {
            var data = this.queryData;
            var numFormat = this.$options.filters.numFormat;
            var properties = [];

            properties.push({
                title: 'Description',
                value: data.description
            });

            properties.push({
                title: 'Date Range',
                value: this.years[0] + '-' + this.years[1]
            });

            if (data.area) {
                var area = numFormat(data.area, '0,0.[00]');
                properties.push({
                    title: 'Drainage Area',
                    value: area + ' km\xB2'
                });
            }

            if (data.mean_annual_discharge) {
                var mad = data.mean_annual_discharge;
                var format = '0,0.[00]';
                // extra decimal places for small values
                if (mad < 1) {
                    format = '0,0.[000]';
                }
                mad = numFormat(data.mean_annual_discharge, format);
                properties.push({
                    title: 'Mean Annual Discharge',
                    value: mad + ' m\xB3/s'
                });
            }

            this.properties = properties;
        },

        /**
         *
         * @return {{headers: *[], dataMap: {avg: {}, max: {}, min: {}}}}
         */
        formatTableData: function formatTableData() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (_this3.station) {
                                    _context3.next = 2;
                                    break;
                                }

                                return _context3.abrupt('return');

                            case 2:
                                _context3.next = 4;
                                return _this3.$worker.run(function (yearly, current) {
                                    var headers = [{ text: 'Year' }, { text: 'Jan' }, { text: 'Feb' }, { text: 'Mar' }, { text: 'Apr' }, { text: 'May' }, { text: 'Jun' }, { text: 'Jul' }, { text: 'Aug' }, { text: 'Sep' }, { text: 'Oct' }, { text: 'Nov' }, { text: 'Dec' }];

                                    var items = [];

                                    var currentMean = ['Mean'].concat(current.map(function (e) {
                                        return e.avg;
                                    }));
                                    currentMean = currentMean.map(function (e) {
                                        return { text: e, value: e };
                                    });
                                    var currentMax = ['Maximum'].concat(current.map(function (e) {
                                        return e.max;
                                    }));
                                    currentMax = currentMax.map(function (e) {
                                        return { text: e, value: e };
                                    });
                                    var currentMin = ['Minimum'].concat(current.map(function (e) {
                                        return e.min;
                                    }));
                                    currentMin = currentMin.map(function (e) {
                                        return { text: e, value: e };
                                    });

                                    items.push(currentMean, currentMax, currentMin);

                                    var currentMap = {
                                        avg: {
                                            year: 'Mean'
                                        },
                                        max: {
                                            year: 'Maximum'
                                        },
                                        min: {
                                            year: 'Minimum'
                                        }
                                    };

                                    current.forEach(function (item) {
                                        currentMap.avg[item.m] = item.avg;
                                        currentMap.max[item.m] = item.max;
                                        currentMap.min[item.m] = item.min;
                                    });

                                    var yearlyMap = {};
                                    yearly.forEach(function (item) {
                                        var year = item.year,
                                            m = item.m,
                                            v = item.v,
                                            days = item.days,
                                            qa = item.qa,
                                            full_month = item.full_month;

                                        if (yearlyMap[year] === undefined) {
                                            yearlyMap[year] = [{ text: year }];
                                        }

                                        var text = v;
                                        if (v || v === 0) {
                                            text = String(v);
                                            if (qa === false) {
                                                text += '*';
                                            }
                                            if (full_month === false) {
                                                // eslint-disable-line camelcase
                                                text += '&nbsp;<sup>(' + days + ')</sup>';
                                            }
                                        }

                                        yearlyMap[year][m] = {
                                            text: text,
                                            value: v,
                                            days: days,
                                            qa: qa,
                                            full_month: full_month
                                        };
                                    });

                                    // Set data
                                    var yearlyItems = self.Object.values(yearlyMap);
                                    return [].concat([headers], items, yearlyItems);
                                }, [_this3.queryData.monthly_mean_flow.yearly, _this3.queryData.monthly_mean_flow.current]);

                            case 4:
                                _this3.tableData = _context3.sent;

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        buildDatasets: function buildDatasets(data) {
            // reduce number of data points to plot on the spark line
            var sevenDayFlowHistorical = data.seven_day_flow.historical;
            var stageHistorical = data.stage.historical;
            // const sevenDayFlowCurrent = data.seven_day_flow.current;

            this.sevenDayFlowDatasets = [{
                label: 'Historical 50th %ile',
                data: sevenDayFlowHistorical.map(function (d) {
                    return d.p50;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_5__functions_appColors__["y" /* sparklineColor2 */],
                borderWidth: 1
            }, {
                label: 'Historical Max',
                data: sevenDayFlowHistorical.map(function (d) {
                    return d.max;
                }),
                backgroundColor: __WEBPACK_IMPORTED_MODULE_5__functions_appColors__["w" /* sparklineBgColor */],
                borderColor: 'rgba(0,0,0,0)' // transparent
            }, {
                label: 'Historical Min',
                data: sevenDayFlowHistorical.map(function (d) {
                    return d.min;
                }),
                backgroundColor: __WEBPACK_IMPORTED_MODULE_5__functions_appColors__["w" /* sparklineBgColor */],
                borderColor: 'rgba(0,0,0,0)', // transparent
                fill: '-1'
            }];
            this.stageDatasets = [{
                label: 'Historical 50th %ile',
                data: stageHistorical.map(function (d) {
                    return d.a;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_5__functions_appColors__["y" /* sparklineColor2 */],
                borderWidth: 1
            }, {
                label: 'Historical Max',
                data: stageHistorical.map(function (d) {
                    return d.max;
                }),
                backgroundColor: __WEBPACK_IMPORTED_MODULE_5__functions_appColors__["w" /* sparklineBgColor */],
                borderColor: 'rgba(0,0,0,0)' // transparent
            }, {
                label: 'Historical Min',
                data: stageHistorical.map(function (d) {
                    return d.min;
                }),
                backgroundColor: __WEBPACK_IMPORTED_MODULE_5__functions_appColors__["w" /* sparklineBgColor */],
                borderColor: 'rgba(0,0,0,0)', // transparent
                fill: '-1'
            }];
        }
    },
    computed: {
        station: function station() {
            return this.$store.state.map.selectedStation;
        },
        name: function name() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.name;
        },
        networkUrl: function networkUrl() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.licence_link;
        },
        network: function network() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.net;
        },
        networkId: function networkId() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.nid;
        },
        type: function type() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.ty;
        },
        years: function years() {
            if (!this.queryDone) {
                return [];
            }
            return this.queryData.yr;
        },
        numYears: function numYears() {
            if (this.years.length === 2) {
                var years = this.years[1] - this.years[0];
                return years + 1;
            }
            return 0;
        }
    },
    watch: {
        station: function station() {
            // re-initialize component when a new station is selected
            this.initialize();
        }
    }
});

/***/ }),

/***/ "Nuxx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_checkQueryData__ = __webpack_require__("ieMF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_surfaceQualityData__ = __webpack_require__("eTdZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_SurfaceQualityTable__ = __webpack_require__("erNo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'chart-modal',
    components: {
        SwQualityTable: __WEBPACK_IMPORTED_MODULE_3__components_charts_SurfaceQualityTable__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_checkQueryData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_surfaceQualityData__["a" /* default */]],
    computed: {
        show: function show() {
            return this.$store.state.showChartModal;
        },

        activeTab: {
            get: function get() {
                return this.$store.state.chartModalActiveTab;
            },
            set: function set(val) {
                this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__constants_actions__["i" /* SET_CHART_MODAL_TAB */], val);
            }
        },
        stationData: function stationData() {
            return this.queryData;
        },
        stationName: function stationName() {
            if (this.stationData) {
                return this.stationData.name;
            }
            return '';
        }
    },
    methods: {
        hide: function hide() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__constants_actions__["y" /* SHOW_CHART_MODAL */], false);
        }
    }
});

/***/ }),

/***/ "OAsj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_groundLevelData__ = __webpack_require__("djs4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ScrollingTable__ = __webpack_require__("92Dq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3__ = __webpack_require__("vwbq");
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'station-ground-level-table',
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_groundLevelData__["a" /* default */]],
    components: {
        ScrollingTable: __WEBPACK_IMPORTED_MODULE_1__components_ScrollingTable__["a" /* default */]
    },
    methods: {
        getColor: function getColor(val, max, min) {
            // Define the colors
            var low = [245, 252, 255];
            var high = [111, 145, 164];
            var result = [255, 255, 255];

            // Check if a value is the same as max
            if (val === max) {
                return 'rgb(' + high[0] + ', ' + high[1] + ', ' + high[2] + ')';
            }

            // Check if the value is the same as min
            if (val === min) {
                return 'rgb(' + low[0] + ', ' + low[1] + ', ' + low[2] + ')';
            }

            // Calculate the color for the value
            for (var i = 0; i < result.length; i++) {
                // eslint-disable-line no-plusplus
                result[i] = Math.round(low[i] + (val - min) * ((high[i] - low[i]) / (max - min)));
            }

            // Return the result
            return 'rgb(' + result[0] + ', ' + result[1] + ', ' + result[2] + ')';
        }
    },
    computed: {
        scrollingTableData: function scrollingTableData() {
            var _this = this;

            var tableData = this.tableData || [];

            // colorize cells

            var _loop = function _loop(r, numRows) {
                var row = tableData[r];
                var vals = row.slice(1).map(function (e) {
                    return e.text;
                });
                var min = __WEBPACK_IMPORTED_MODULE_2_d3__["o" /* min */](vals);
                var max = __WEBPACK_IMPORTED_MODULE_2_d3__["l" /* max */](vals);
                row.forEach(function (col, c) {
                    if (c === 0) return;
                    var val = col.text;
                    var color = _this.getColor(val, max, min);
                    tableData[r][c].color = color;
                });
            };

            for (var r = 1, numRows = tableData.length; r < numRows; r += 1) {
                _loop(r, numRows);
            }

            return tableData;
        }
    }
});

/***/ }),

/***/ "OEKW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WatershedFilters_vue__ = __webpack_require__("htoR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_796868e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WatershedFilters_vue__ = __webpack_require__("BF4R");
function injectStyle (ssrContext) {
  __webpack_require__("cISp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WatershedFilters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_796868e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WatershedFilters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OTPV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OeZI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarStationClimate_vue__ = __webpack_require__("xWn7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc733a76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarStationClimate_vue__ = __webpack_require__("/QY9");
function injectStyle (ssrContext) {
  __webpack_require__("pVK1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bc733a76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarStationClimate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc733a76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarStationClimate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Oh47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_charts_ChartTooltip__ = __webpack_require__("4jZd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions_sciNotationFmt__ = __webpack_require__("XMAy");


//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ChartTooltip: __WEBPACK_IMPORTED_MODULE_4__components_charts_ChartTooltip__["a" /* default */]
    },
    props: {
        // filtered data from crossfilter group.all()
        data: {
            type: Array,
            required: true
        },
        // all (unfiltered) data (for preserving scales/ranges)
        dataAll: {
            type: Array,
            required: true
        },
        // dimension filters from crossfilter dimension.currentFilter()
        dimensionFilter: {
            required: true
        }
    },
    data: function data() {
        return {
            // @TEMP: make these into props
            svgHeight: window.innerHeight - 275,
            svgWidth: window.innerWidth / 3.34,
            svg: null,
            g: null,
            margin: {
                top: 40,
                bottom: 35,
                left: 50,
                right: 50
            },
            height: 270,
            width: 500,
            xScaleLog: null,
            yScaleTime: null,
            barHeight: 11, // this gets changed later on but we can use this initial value
            axisTop: null,
            initialized: false,
            // tooltip props
            tooltipPosition: [0, 0],
            tooltipVisible: false,
            tooltipText: []
        };
    },

    computed: {
        chartData: function chartData() {
            return this.formatData(this.data);
        },
        chartDataAll: function chartDataAll() {
            return this.formatData(this.dataAll);
        }
    },
    mounted: function mounted() {
        this.initializeSvg();
    },

    methods: {
        /**
         * initialize svg chart element and define variables
         */
        initializeSvg: function initializeSvg() {
            // initialize chart & vars
            this.svg = __WEBPACK_IMPORTED_MODULE_2_d3__["w" /* select */]('#flow-duration-annual-runoff');
            this.g = this.svg.select('g.chart');
            // chart (not element) size
            this.width = +this.svg.attr('width') - this.margin.left - this.margin.right;
            // calculate the height of this chart with respect to the number of datapoints in the chart
            // makes the calculation of the barheight below render with uniform values.
            // 1px for padding
            this.height = __WEBPACK_IMPORTED_MODULE_2_d3__["l" /* max */]([this.chartDataAll.length * (this.barHeight + 1), 200]);
            this.svgHeight = this.height + this.margin.top;
            // this.height = +this.svg.attr('height') - this.margin.top - this.margin.bottom;
            // initialize scales
            this.xScaleLog = __WEBPACK_IMPORTED_MODULE_2_d3__["s" /* scaleLog */]().rangeRound([0, this.width]).clamp(true);
            this.yScaleTime = __WEBPACK_IMPORTED_MODULE_2_d3__["u" /* scaleTime */]().rangeRound([0, this.height]);
            // transition for bar size and axis
            this.transition = __WEBPACK_IMPORTED_MODULE_2_d3__["C" /* transition */]().duration(500);
            // set y-scale input domain
            var maxDate = __WEBPACK_IMPORTED_MODULE_2_d3__["l" /* max */](this.chartDataAll, function (d) {
                return d.date;
            });
            this.yScaleTime.domain([__WEBPACK_IMPORTED_MODULE_2_d3__["o" /* min */](this.chartDataAll, function (d) {
                return d.date;
            }), __WEBPACK_IMPORTED_MODULE_2_d3__["x" /* timeDay */].offset(__WEBPACK_IMPORTED_MODULE_2_d3__["B" /* timeYear */].offset(maxDate), -1)] // end of year
            );

            // top axis
            this.axisTop = __WEBPACK_IMPORTED_MODULE_2_d3__["c" /* axisTop */](this.xScaleLog).tickSize(6).ticks(2).tickFormat(__WEBPACK_IMPORTED_MODULE_5__functions_sciNotationFmt__["a" /* default */]);
            this.g.append('g').attr('class', 'axis axis--x').attr('transform', 'translate(0,-3)');

            // left axis
            this.g.append('g').attr('class', 'axis axis--y').attr('transform', 'translate(-2,0)').call(__WEBPACK_IMPORTED_MODULE_2_d3__["b" /* axisLeft */](this.yScaleTime).ticks(this.chartDataAll.length, '%Y'));

            // add brush
            this.brush = __WEBPACK_IMPORTED_MODULE_2_d3__["f" /* brushY */]().extent([[0, 0], [this.width, this.height]]).on('end', this.brushEnded);

            // define & update bars
            this.updateChart();

            // axis label
            this.g.append('text').attr('class', 'axis-label').attr('transform', 'translate(3,3) rotate(-90)').attr('y', 6).attr('dy', '0.71em').attr('text-anchor', 'end').text('Runoff (m³)');

            // add selection brush
            this.g.append('g').attr('class', 'brush annual-runoff').call(this.brush);

            // track mouse events on the chart area
            this.g.on('mousemove', this.mouseMove);
            this.g.on('mouseout', this.mouseOut);

            this.initialized = true;
        },

        /**
         * format input data with d3 date objects and adjusted values
         * fills in missing years with null values
         * @param  {Array} input input data from Crossfilter
         * @return {Array}       adjusted data with year, date, & adjusted value
         */
        formatData: function formatData(input) {
            if (!input.length) {
                return [];
            }
            // fill in any missing years with null values
            var denseArray = [];
            var firstYear = input[0].key;
            var lastYear = input[input.length - 1].key;
            var yearMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
            input.forEach(function (e) {
                yearMap.set(e.key, e);
            });
            for (var i = firstYear; i < lastYear; i += 1) {
                var thisYear = yearMap.get(i);
                if (thisYear) {
                    denseArray.push(thisYear);
                } else {
                    denseArray.push({
                        key: i,
                        value: null
                    });
                }
            }

            // parse dates and adjust values
            var formatted = denseArray.map(function (d) {
                var year = d.key;
                var date = __WEBPACK_IMPORTED_MODULE_2_d3__["A" /* timeParse */]('%Y')(year);
                var value = d.value === null ? null : d.value * 86400; // convert to m3/yr
                return {
                    date: date,
                    value: value
                };
            });

            return formatted;
        },

        /**
         * update chart bars & axis when data changes
         */
        updateChart: function updateChart() {
            var _this = this;

            // adjust scales: update x-scale input domain
            var minXVal = __WEBPACK_IMPORTED_MODULE_2_d3__["o" /* min */](this.chartData, function (d) {
                return d.value;
            });
            this.xScaleLog.domain([__WEBPACK_IMPORTED_MODULE_2_d3__["l" /* max */]([1, minXVal]), __WEBPACK_IMPORTED_MODULE_2_d3__["l" /* max */](this.chartData, function (d) {
                return d.value;
            })]).nice();

            // update x-axis
            this.g.select('.axis--x').transition(this.transition).call(this.axisTop).selectAll('text').attr('transform', 'translate(13,-10) rotate(-45)');

            // d3 "data join"
            var bars = this.g.selectAll('.bar').data(this.chartData);

            // enter selection: create new elements
            bars.enter().append('rect').attr('class', 'bar').attr('x', 0).attr('y', function (d) {
                return _this.yScaleTime(d.date);
            }).attr('height', this.barHeight)
            // update selection: resize bars
            .merge(bars).transition(this.transition).attr('width', function (d) {
                return _this.xScaleLog(d.value) || 0;
            });
        },

        /**
         * callback for d3 brush end selection events
         * calculates the year range of the selection
         */
        brushEnded: function brushEnded() {
            if (!__WEBPACK_IMPORTED_MODULE_2_d3__["i" /* event */].sourceEvent) return; // Only transition after input.
            // clear filters for empty selection
            if (!__WEBPACK_IMPORTED_MODULE_2_d3__["i" /* event */].selection) {
                this.clearFilters();
                return;
            }

            var s = __WEBPACK_IMPORTED_MODULE_2_d3__["i" /* event */].selection;
            var d0 = s.map(this.yScaleTime.invert);
            var d1 = d0.map(__WEBPACK_IMPORTED_MODULE_2_d3__["B" /* timeYear */].round);

            // If empty when rounded, use floor & ceil instead.
            if (d1[0] >= d1[1]) {
                d1[0] = __WEBPACK_IMPORTED_MODULE_2_d3__["B" /* timeYear */].floor(d0[0]);
                d1[1] = __WEBPACK_IMPORTED_MODULE_2_d3__["B" /* timeYear */].offset(d1[0]);
            }

            __WEBPACK_IMPORTED_MODULE_2_d3__["w" /* select */]('.brush.annual-runoff').transition().call(__WEBPACK_IMPORTED_MODULE_2_d3__["i" /* event */].target.move, d1.map(this.yScaleTime));

            this.updateFilters(d1);
        },

        /**
         * emit an event with a new filter range
         * @param  {Array} dates array with min and max years
         */
        updateFilters: function updateFilters(dates) {
            var years = dates.map(function (y) {
                return +__WEBPACK_IMPORTED_MODULE_2_d3__["y" /* timeFormat */]('%Y')(y);
            });
            // "filterRange does not include the top point"
            years[1] += 1; // adjust for crossfilter behavior
            this.$emit('updateFilters', years);
        },

        /**
         * emit null to clear dimension filters
         */
        clearFilters: function clearFilters() {
            this.$emit('updateFilters', null);
        },

        /**
         * move brush to reflect changed filters
         * pass null to clear brush
         * @param  {Array|null} years params for group.filter method
         */
        setBrush: function setBrush(selection) {
            var _this2 = this;

            // clear brush on null (no transition)
            if (selection === null) {
                __WEBPACK_IMPORTED_MODULE_2_d3__["w" /* select */]('.brush.annual-runoff').call(this.brush.move, null);
                return;
            }
            // convert years integer to pixel values
            var selectionRange = selection.map(function (y) {
                var date = new Date(y, 1, 1);
                return _this2.yScaleTime(date);
            });
            // move brush
            __WEBPACK_IMPORTED_MODULE_2_d3__["w" /* select */]('.brush.annual-runoff').transition(this.transition).call(this.brush.move, selectionRange);
        },

        /**
         * update tooltip when the mouse moves
         */
        mouseMove: function mouseMove() {
            var _d3$mouse = __WEBPACK_IMPORTED_MODULE_2_d3__["p" /* mouse */](this.g.node()),
                _d3$mouse2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_d3$mouse, 2),
                gX = _d3$mouse2[0],
                gY = _d3$mouse2[1];
            // hide on mouseout


            if (gX < 0 || gX > this.width || gY < 0 || gY > this.height) {
                this.mouseOut();
                return;
            }

            // position relative to the root flow duration tool element
            this.tooltipPosition = __WEBPACK_IMPORTED_MODULE_2_d3__["p" /* mouse */](this.$parent.$el);
            var date = this.yScaleTime.invert(gY);
            var yearString = __WEBPACK_IMPORTED_MODULE_2_d3__["y" /* timeFormat */]('%Y')(date);
            var bisect = __WEBPACK_IMPORTED_MODULE_2_d3__["d" /* bisector */](function (d) {
                return d.date;
            }).left;
            var i = bisect(this.chartData, __WEBPACK_IMPORTED_MODULE_2_d3__["B" /* timeYear */].floor(date));
            var yearData = this.chartData[i];
            if (!yearData) {
                return;
            }
            var value = yearData.value;

            value = __WEBPACK_IMPORTED_MODULE_3_numeral___default()(value).format('0,0');

            this.tooltipText = [{ text: yearString, class: 'headline' }, { text: 'Discharge', class: 'subheading' }, { text: value + ' m\xB3', class: 'blue darken-2 white--text' }];
            this.tooltipVisible = true;
        },

        /**
         * hide the tooltip on mouseout
         */
        mouseOut: function mouseOut() {
            this.tooltipVisible = false;
        }
    },
    watch: {
        // update chart when data changes
        data: {
            handler: function handler() {
                this.updateChart();
            },

            deep: true
        },
        // update brush selection when cf filter changes externally
        dimensionFilter: function dimensionFilter(selection) {
            this.setBrush(selection);
        }
    }
});

/***/ }),

/***/ "Or+1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P1ll":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"station-details streamflow"},[(!_vm.queryDone)?_c('div',{staticClass:"loading"},[_c('p',[_vm._v("Loading station data...")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),_vm._v(" "),(_vm.station && _vm.queryDone)?_c('div',{staticClass:"station"},[_c('h3',{staticClass:"headline station-name primary--text",domProps:{"textContent":_vm._s(_vm.queryData.name)}}),_vm._v(" "),_c('p',{staticClass:"body-2 mb-1 network-info"},[_vm._v("\n            "+_vm._s(_vm.networkId)),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":_vm.networkUrl}},[_vm._v(_vm._s(_vm.network))])]),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_vm._l((_vm.properties),function(ref){
var title = ref.title;
var value = ref.value;
return (value)?_c('div',{staticClass:"properties-item mb-3"},[_c('h4',{staticClass:"subheading field-title grey--text",domProps:{"textContent":_vm._s(title)}}),_vm._v(" "),_c('div',{staticClass:"body-1 field-value",domProps:{"textContent":_vm._s(value)}})]):_vm._e()}),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_c('download-csv-button',{attrs:{"redistribute":_vm.dataRedistirbute,"station-id":_vm.stationId}}),_vm._v(" "),_c('h3',{staticClass:"mt-3 mb-1 subheading"},[_vm._v("7-day Flow")]),_vm._v(" "),(_vm.checkChartData(this.queryData, 'seven_day_flow', this.checkStreamflowDataFields.seven_day_flow))?_c('spark-line',{attrs:{"id":"seven-day-sparkline","height":"76","width":"300","datasets":_vm.sevenDayFlowDatasets},on:{"click":function($event){_vm.showChartModal('seven-day-flow')}}}):_vm._e(),_vm._v(" "),(!_vm.checkChartData(this.queryData, 'seven_day_flow', this.checkStreamflowDataFields.seven_day_flow))?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_c('h3',{staticClass:"mt-3 mb-1 subheading"},[_vm._v("Stage")]),_vm._v(" "),(_vm.checkChartData(this.queryData, 'stage', this.checkStreamflowDataFields.stage))?_c('spark-line',{attrs:{"id":"stage-sparkline","height":"76","width":"300","datasets":_vm.stageDatasets},on:{"click":function($event){_vm.showChartModal('stage')}}}):_vm._e(),_vm._v(" "),(!_vm.checkChartData(this.queryData, 'stage', this.checkStreamflowDataFields.stage))?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"my-3"})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P4ca":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QU/y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartModalGwLevel_vue__ = __webpack_require__("Hw2Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_239ad7fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartModalGwLevel_vue__ = __webpack_require__("Yiam");
function injectStyle (ssrContext) {
  __webpack_require__("n8sP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-239ad7fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartModalGwLevel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_239ad7fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartModalGwLevel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QW0U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return secondary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return navIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return navIconActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return markerStroke; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return markerStrokeActiveAppl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return markerSelected; });
/* unused harmony export markerSelectedStroke */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return markerUnknown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return markerHistorical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return markerCurrent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return markerSwShort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return markerSwLong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return markerGwShort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return markerGwLong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return watershedPolygon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return studyAreaMask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return sparklineColor1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return sparklineColor2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return sparklineBgColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return waterBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return waterBg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return currentBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return currentBg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return historicalMedian; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return historicalMean; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return historical1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return historical2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return todayMarker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return axisBorder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors__ = __webpack_require__("IHMs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__("vwbq");
/**
 * app color palette
 */

// @TODO: don't use d3Color in here, it's too weird




// layout
var primary = __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base;
var secondary = __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.blueGrey.lighten3;
var accent = __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.accent1;
// - navigation
var navIcon = primary;
var navIconActive = accent;

// map makers
var markerStroke = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.shades.white);
var markerStrokeActiveAppl = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])('#E3A82B');
var markerSelected = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.green.accent3);
var markerSelectedStroke = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.shades.black);
var markerUnknown = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])('#CCCCCC');

// station map markers
var markerHistorical = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])('#5A8ED1');
var markerCurrent = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])('#F17D43');

// licence map markers
var markerSwShort = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])('#F8B422');
var markerSwLong = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])('#224A86');
var markerGwShort = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])('#47C0F7');
var markerGwLong = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])('#B660C5');

// polygon map layers
var watershedPolygon = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.orange.accent4);
var studyAreaMask = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.shades.white);

// sparkline colors
var sparklineColor1 = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.darken2);
var sparklineColor2 = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.lightBlue.darken1);
var sparklineBgColor = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.blueGrey.lighten4);
sparklineBgColor.opacity = 0.6;

// station chart colors
var waterBorder = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.lightBlue.lighten2);
var waterBg = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.lightBlue.lighten3);
waterBg.opacity = 0.6;
var currentBorder = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.orange.lighten2);
var currentBg = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.orange.lighten3);
currentBg.opacity = 0.3;
var historicalMedian = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.blueGrey.darken2);
var historicalMean = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.blueGrey.darken2);
var historical1 = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.blueGrey.lighten2);
var historical2 = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.blueGrey.lighten3);
var todayMarker = __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.orange.lighten2; //  some reason if I wrap this in d3Color it turns up grey.

// axis/gridline colors
var axisBorder = Object(__WEBPACK_IMPORTED_MODULE_1_d3__["g" /* color */])(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.grey.lighten2);

/***/ }),

/***/ "QgFt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return data; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__ = __webpack_require__("oPhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_appColors__ = __webpack_require__("QW0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_chartTooltipDate__ = __webpack_require__("rgFZ");






var container = function container(data) {
    return {
        type: 'line',
        data: data,
        plugins: [__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default.a],
        options: {
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
                mode: 'x',
                intersect: false,
                position: 'nearest',
                callbacks: {
                    label: function label(tooltipItem, d) {
                        var label = d.datasets[tooltipItem.datasetIndex].label || '';
                        var value = __WEBPACK_IMPORTED_MODULE_0_numeral___default()(tooltipItem.yLabel).format('0,0.[0]');
                        return label + ': ' + value + ' \xB0C';
                    },

                    title: __WEBPACK_IMPORTED_MODULE_4__functions_chartTooltipDate__["a" /* default */]
                }
            },
            annotation: {
                events: [],
                annotations: [{
                    drawTime: 'afterDatasetsDraw',
                    id: 'vline',
                    type: 'line',
                    mode: 'vertical',
                    scaleID: 'x-axis-0',
                    value: __WEBPACK_IMPORTED_MODULE_1_moment___default()(),
                    borderColor: 'black',
                    borderWidth: 3,
                    label: {
                        backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["A" /* todayMarker */],
                        content: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('LL'),
                        enabled: true
                    }
                }]
            },
            pan: {
                enabled: true,
                mode: 'y',
                speed: 10,
                threshold: 10
            },
            zoom: {
                enabled: true,
                mode: 'y',
                limits: {
                    max: 100,
                    min: 1
                }
            },
            scales: {
                xAxes: [{
                    type: 'time',
                    distribution: 'linear',
                    time: {
                        tooltipFormat: 'MMM DD, YYYY',
                        unit: 'month'
                    }
                }],
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'Temperature (°C)'
                    },
                    ticks: {
                        min: -50,
                        max: 50
                    }
                }],
                // disable animations
                animation: false
            }
        }
    };
};

var data = function data(labels, currentData, historicalData) {
    return {
        labels: labels,
        datasets: [{
            type: 'line',
            label: 'Current max',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["d" /* currentBorder */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["c" /* currentBg */],
            borderWidth: 2,
            fill: '+1',
            // steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 1,
            data: currentData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.max
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Current min',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["d" /* currentBorder */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["c" /* currentBg */],
            borderWidth: 2,
            fill: '-1',
            // steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 1,
            data: currentData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.min
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical max average',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            borderWidth: 2,
            fill: '+1',
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.maxavg
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical min average',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            borderWidth: 2,
            fill: '-1',
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.minavg
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical max 90th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            borderWidth: 2,
            fill: '+1',
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.maxp90
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical min 10th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            borderWidth: 2,
            fill: '-1',
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.minp10
                };
                return valObj;
            })
        }]
    };
};

/***/ }),

/***/ "Qgob":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QwVp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_yearlyChart__ = __webpack_require__("tMAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_formatHistoricalDailyData__ = __webpack_require__("/SS+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_formatHistoricalDailyDateData__ = __webpack_require__("r0h7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_exportChart__ = __webpack_require__("h326");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_resetChart__ = __webpack_require__("AstN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_streamflowData__ = __webpack_require__("Nt91");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_ie11ChartResize__ = __webpack_require__("4+uC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__chartData_streamflowSevenDayFlow__ = __webpack_require__("vqYP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_chart_js__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_yearlyChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_formatHistoricalDailyData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_formatHistoricalDailyDateData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_exportChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_resetChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_streamflowData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_ie11ChartResize__["a" /* default */]],
    data: function data() {
        return {
            chart: null,
            chartId: 'canvas-seven-day-flow',
            dataType: 'seven_day_flow',
            chartInterval: 'd'
        };
    },

    computed: {
        chartData: function chartData() {
            if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.queryData).length > 0) {
                return this.queryData.seven_day_flow;
            }
            return null;
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.chart.destroy();
    },
    mounted: function mounted() {
        // Set chart interval to month
        if (this.chartData) {
            this.updateChart();
        }
    },

    methods: {
        /**
         * create datasets and chart context object
         * @return {Object} chart.js context object
         */
        formatDatasets: function formatDatasets() {
            var _chartData$datasets;

            var chartData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.queryData.formatted_seven_day_flow_chart_data));

            var yearlyOverlayDatasets = this.formatYearlyData(this.formatHistoricalDateData);
            (_chartData$datasets = chartData.datasets).unshift.apply(_chartData$datasets, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(yearlyOverlayDatasets));
            return chartData;
        },

        /**
         * set up the chart and do the initial render
         */
        renderChart: function renderChart() {
            var chartData = this.formatDatasets();

            this.chart = new __WEBPACK_IMPORTED_MODULE_11_chart_js___default.a(this.chartId, Object(__WEBPACK_IMPORTED_MODULE_10__chartData_streamflowSevenDayFlow__["a" /* container */])(chartData));
        },

        /**
         * update the datasets and re-render the chart
         */
        updateChart: function updateChart() {
            // do the initial render if the chart isn't defined yet
            if (this.chart === null) {
                this.renderChart();
                return;
            }
            this.chart.data = this.formatDatasets();
            this.chart.update({
                duration: 0
            });
        }
    },
    watch: {
        chartData: function chartData(val) {
            this.yearlyData = {};
            this.yearlyDataDisplay = [];
            if (val) {
                this.updateChart();
            }
        },
        updateData: function updateData(val) {
            if (val) {
                this.updateChart();
                this.updateData = false;
            }
        }
    }
});

/***/ }),

/***/ "Qxw7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GwLevel_vue__ = __webpack_require__("Sux8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9e78d12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GwLevel_vue__ = __webpack_require__("f/OW");
function injectStyle (ssrContext) {
  __webpack_require__("RzLa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GwLevel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9e78d12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GwLevel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QzKR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RKaC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-wrap",class:_vm.classObj},[_c('mapbox-gl-map',{attrs:{"id":"map","accessToken":_vm.$cfg.mapboxgl.accessToken,"options":_vm.getMapOptions()},on:{"loaded":_vm.mapLoaded}}),_vm._v(" "),_c('chart-modal'),_vm._v(" "),_c('overlap-picker',{attrs:{"features":_vm.overlapFeatures},on:{"select":_vm.selectStation},scopedSlots:_vm._u([{key:"header",fn:function(slotScope){return [_vm._v("\n            "+_vm._s(slotScope.numFeatures)+" stations at these coordinates\n        ")]}},{key:"listItem",fn:function(slotScope){return [_c('v-list-tile-title',{domProps:{"textContent":_vm._s(slotScope.feature.properties.name)}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v("\n                "+_vm._s(slotScope.feature.properties.network)+"\n            ")])]}}]),model:{value:(_vm.showOverlapPicker),callback:function ($$v) {_vm.showOverlapPicker=$$v},expression:"showOverlapPicker"}}),_vm._v(" "),_c('style-switcher',{on:{"switchedStyle":_vm.addLayers},model:{value:(_vm.showStyleSwitcher),callback:function ($$v) {_vm.showStyleSwitcher=$$v},expression:"showStyleSwitcher"}}),_vm._v(" "),_c('map-save-button',{attrs:{"featuresUrl":_vm.mapSourceUrl},model:{value:(_vm.showMapSave),callback:function ($$v) {_vm.showMapSave=$$v},expression:"showMapSave"}},[_c('template',{attrs:{"slot":"features-headline"},slot:"features-headline"},[_vm._v("Download stations")])],2),_vm._v(" "),_c('map-legend',{attrs:{"items":_vm.getLegendLayers()},model:{value:(_vm.showMapLegend),callback:function ($$v) {_vm.showMapLegend=$$v},expression:"showMapLegend"}}),_vm._v(" "),_c('map-sidebar',{attrs:{"filters":_vm.filters}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RWxs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FDAnnualRunoff_vue__ = __webpack_require__("Oh47");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c767209a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FDAnnualRunoff_vue__ = __webpack_require__("lIcG");
function injectStyle (ssrContext) {
  __webpack_require__("oT8a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FDAnnualRunoff_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c767209a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FDAnnualRunoff_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RnQ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppConfigPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deep_freeze__ = __webpack_require__("TxmA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deep_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_deep_freeze__);


var config = {
    development: {
        mapboxgl: {
            accessToken: 'pk.eyJ1IjoiZm91bmRyeXNwYXRpYWwiLCJhIjoiNzk1YTU3OTZmMjZiMzQ3YzM5YzIwODNiNjhkM2MzMDQifQ.sfy6Aux5O-BBqbSVNaec1A',
            baseStyle: 'mapbox://styles/foundryspatial/cjlebyluk82lh2rnuo14qng0g'
        },
        API_URL: 'http://' + Object({"NODE_ENV":"production"}).HOST + ':8000'
    },
    production: {
        mapboxgl: {
            accessToken: 'pk.eyJ1IjoiZm91bmRyeXNwYXRpYWwiLCJhIjoiNzk1YTU3OTZmMjZiMzQ3YzM5YzIwODNiNjhkM2MzMDQifQ.sfy6Aux5O-BBqbSVNaec1A',
            baseStyle: 'mapbox://styles/foundryspatial/cjlebyluk82lh2rnuo14qng0g'
        },
        API_URL: 'https://kwt-api.bcwatertool.ca'
    },
    testing: {
        mapboxgl: {
            accessToken: 'pk.eyJ1IjoiZm91bmRyeXNwYXRpYWwiLCJhIjoiNzk1YTU3OTZmMjZiMzQ3YzM5YzIwODNiNjhkM2MzMDQifQ.sfy6Aux5O-BBqbSVNaec1A',
            baseStyle: 'mapbox://styles/foundryspatial/cjlebyluk82lh2rnuo14qng0g'
        },
        API_URL: 'http://' + Object({"NODE_ENV":"production"}).HOST + ':8000'
    }
}["production"];

// prevent changes to the config at runtime
var frozenConfig = __WEBPACK_IMPORTED_MODULE_0_deep_freeze___default()(config);
/* harmony default export */ __webpack_exports__["b"] = (frozenConfig);

// provide a vue plugin to access the config globall
// via this.$cfg
var AppConfigPlugin = {
    install: function install(Vue) {
        // We call Vue.mixin() here to inject functionality into all components.
        Vue.mixin({
            data: function data() {
                return {
                    $cfg: {}
                };
            },
            beforeCreate: function beforeCreate() {
                this.$cfg = frozenConfig;
            }
        });
    }
};

/***/ }),

/***/ "RtwO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartModalStreamflow_vue__ = __webpack_require__("supx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c3b3fb5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartModalStreamflow_vue__ = __webpack_require__("Mvmn");
function injectStyle (ssrContext) {
  __webpack_require__("40ol")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c3b3fb5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartModalStreamflow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c3b3fb5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartModalStreamflow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RwPU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return container; });
/* unused harmony export data */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__ = __webpack_require__("oPhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_appColors__ = __webpack_require__("QW0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_chartTooltipDate__ = __webpack_require__("rgFZ");






var container = function container(data) {
    return {
        type: 'line',
        plugins: [__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default.a],
        data: data,
        options: {
            animation: {
                duration: 0
            },
            hover: {
                animationDuration: 0
            },
            elements: {
                line: {
                    tension: 0 // disables bezier curves
                }
            },
            responsiveAnimationDuration: 0,
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
                mode: 'index',
                intersect: false,
                position: 'nearest',
                callbacks: {
                    label: function label(tooltipItem, d) {
                        var label = d.datasets[tooltipItem.datasetIndex].label || '';
                        var value = __WEBPACK_IMPORTED_MODULE_0_numeral___default()(tooltipItem.yLabel).format('0,0.[00]');
                        return label + ': ' + value + ' m';
                    },

                    title: __WEBPACK_IMPORTED_MODULE_4__functions_chartTooltipDate__["a" /* default */]
                }
            },
            annotation: {
                events: [],
                annotations: [{
                    drawTime: 'afterDatasetsDraw',
                    id: 'vline',
                    type: 'line',
                    mode: 'vertical',
                    scaleID: 'x-axis-0',
                    value: __WEBPACK_IMPORTED_MODULE_1_moment___default()(),
                    borderColor: 'black',
                    borderWidth: 3,
                    label: {
                        backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["A" /* todayMarker */],
                        content: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('LL'),
                        enabled: true
                    }
                }]
            },
            pan: {
                enabled: true,
                mode: 'y',
                speed: 10,
                threshold: 10
            },
            zoom: {
                enabled: true,
                mode: 'y',
                limits: {
                    max: 100,
                    min: 1
                }
            },
            scales: {
                xAxes: [{
                    type: 'time',
                    distribution: 'linear',
                    time: {
                        tooltipFormat: 'MMM DD, YYYY',
                        unit: 'month'
                    }
                }],
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'Stage (m)'
                    }
                }],
                // disable animations
                animation: false
            }
        }
    };
};

var data = function data(labels, currentData, historicalData) {
    return {
        labels: labels,
        datasets: [{
            type: 'line',
            label: 'Current',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["d" /* currentBorder */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["d" /* currentBorder */],
            borderWidth: 2,
            fill: false,
            pointRadius: 0,
            pointHitRadius: 1,
            // steppedLine: 'before',
            data: currentData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.v
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 50th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["h" /* historicalMedian */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["h" /* historicalMedian */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.a
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 75th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            borderWidth: 2,
            fill: '+1',
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p75
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 25th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p25
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical Max',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            borderWidth: 2,
            fill: '+1',
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.max
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical Min',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.min
                };
                return valObj;
            })
        }]
    };
};

/***/ }),

/***/ "RzLa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SVZu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SWHv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ScZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_chart_js__);




//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sidebar-sparkline',
    props: {
        datasets: {
            required: true
        },
        options: {
            type: Object
        },
        labels: {
            type: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a
        },
        id: {
            required: true,
            type: String
        },
        height: {
            type: [Number, String],
            default: 100
        },
        width: {
            type: [Number, String],
            default: 300
        }
    },
    data: function data() {
        return {
            chart: null,
            defaultDataset: {
                borderColor: '#ff0000',
                borderWidth: 2,
                pointRadius: 0,
                fill: false
            },
            defaultOptions: {
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            display: false,
                            beginAtZero: true
                        },
                        gridLines: {
                            display: false,
                            drawBorder: false
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            display: false,
                            drawBorder: false
                        },
                        ticks: {
                            display: false
                        }
                    }]
                },
                animation: {
                    duration: 0
                },
                tooltips: {
                    enabled: false
                }
            }
        };
    },
    beforeDestroy: function beforeDestroy() {
        this.chart.destroy();
    },

    computed: {
        // allow custom labels
        scaleLabels: function scaleLabels() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.labels;

                            case 2:
                                if (!_context.sent) {
                                    _context.next = 4;
                                    break;
                                }

                                return _context.abrupt('return', _this.labels);

                            case 4:
                                _context.next = 6;
                                return _this.datasets;

                            case 6:
                                _context.t0 = function () {
                                    return '';
                                };

                                return _context.abrupt('return', _context.sent[0].data.map(_context.t0));

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    mounted: function mounted() {
        this.renderChart();
    },
    updated: function updated() {
        // re-render charts when data changes
        this.renderChart();
    },

    methods: {
        renderChart: function renderChart() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var data, labels, datasets, options;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this2.datasets;

                            case 2:
                                data = _context2.sent;

                                if (!(!data || _this2.chart !== null)) {
                                    _context2.next = 5;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 5:
                                _context2.next = 7;
                                return _this2.scaleLabels;

                            case 7:
                                labels = _context2.sent;

                                // merge datasets with default options
                                datasets = data.map(function (d) {
                                    var merged = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.defaultDataset, d);
                                    return merged;
                                });
                                // merge with default options

                                options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.defaultOptions, _this2.options);

                                _this2.chart = new __WEBPACK_IMPORTED_MODULE_4_chart_js___default.a(_this2.id, { // eslint-disable-line
                                    type: 'line',
                                    data: {
                                        labels: labels,
                                        datasets: datasets
                                    },
                                    options: options
                                });

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    }
});

/***/ }),

/***/ "Sux8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions_appColors__ = __webpack_require__("QW0U");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        color: {
            default: String(__WEBPACK_IMPORTED_MODULE_0__functions_appColors__["s" /* navIcon */]),
            type: String
        }
    }
});

/***/ }),

/***/ "Svpl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_yearlyChart__ = __webpack_require__("tMAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_formatHistoricalMonthlyData__ = __webpack_require__("JLkL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_formatHistoricalMonthlyDateData__ = __webpack_require__("dKxa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_exportChart__ = __webpack_require__("h326");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_resetChart__ = __webpack_require__("AstN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_groundLevelData__ = __webpack_require__("djs4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_ie11ChartResize__ = __webpack_require__("4+uC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chartData_gwLevelHydrograph__ = __webpack_require__("H+MB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_yearlyChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_formatHistoricalMonthlyData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_formatHistoricalMonthlyDateData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_exportChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_resetChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_groundLevelData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_ie11ChartResize__["a" /* default */]],
    data: function data() {
        return {
            chart: null,
            chartId: 'canvas-gw-hydrograph',
            dataType: 'hydrograph'
        };
    },

    computed: {
        chartData: function chartData() {
            return this.queryData.hydrograph;
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.chart.destroy();
    },
    mounted: function mounted() {
        // Set chart interval to month
        this.chartInterval = 'm';
        if (this.chartData) {
            this.updateChart();
        }
    },

    methods: {
        /**
         * create datasets and chart context object
         * @return {Object} chart.js context object
         */
        formatDatasets: function formatDatasets() {
            var _chartData$datasets;

            var historicalData = this.formatHistoricalData(this.chartData.historical, function (date, e) {
                var formatted = {
                    d: date,
                    a: e.a,
                    min: e.min,
                    max: e.max,
                    p25: e.p25,
                    p75: e.p75
                };
                return formatted;
            });
            var currentData = this.formatCurrentData(this.chartData.current);
            var currentDates = currentData.map(function (d) {
                return d.d;
            });

            var chartData = Object(__WEBPACK_IMPORTED_MODULE_8__chartData_gwLevelHydrograph__["b" /* data */])(currentDates, currentData, historicalData);

            var yearlyOverlayDatasets = this.formatYearlyData(this.formatHistoricalDateData);
            (_chartData$datasets = chartData.datasets).unshift.apply(_chartData$datasets, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(yearlyOverlayDatasets));
            return chartData;
        },

        /**
         * set up the chart and do the initial render
         */
        renderChart: function renderChart() {
            var chartData = this.formatDatasets();

            this.chart = new __WEBPACK_IMPORTED_MODULE_9_chart_js___default.a(this.chartId, Object(__WEBPACK_IMPORTED_MODULE_8__chartData_gwLevelHydrograph__["a" /* container */])(chartData));
        },

        /**
         * update the datasets and re-render the chart
         */
        updateChart: function updateChart() {
            // do the initial render if the chart isn't defined yet
            if (this.chart === null) {
                this.renderChart();
                return;
            }
            this.chart.data = this.formatDatasets();
            this.chart.update({
                duration: 0
            });
        },

        /**
         * format current hydrograph data with date objects
         * @param  {Array} currentData hydrograph data with string dates
         * @return {Array}             hydrograph data with moment.js dates
         */
        formatCurrentData: function formatCurrentData(currentData) {
            var dataWithDates = currentData.map(function (d) {
                var date = __WEBPACK_IMPORTED_MODULE_10_moment___default()(d.d);
                return {
                    d: date,
                    v: d.v
                };
            });

            return dataWithDates;
        }
    },
    watch: {
        /**
         * update the chart when the data changes
         */
        chartData: function chartData(val) {
            this.yearlyData = {};
            this.yearlyDataDisplay = [];
            if (val) {
                this.updateChart();
            }
        },
        updateData: function updateData(val) {
            if (val) {
                this.updateChart();
                this.updateData = false;
            }
        }
    }
});

/***/ }),

/***/ "T/Fn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"climate-snow-depth-chart"},[_c('div',{staticClass:"yearly-data-select"},[_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"d-flex":"","sm3":""}},[_c('v-select',{attrs:{"width":"200","label":"Select","items":_vm.yearlyDataAvailable,"multiple":"","max-height":"400","hint":"Add yearly data","persistent-hint":""},model:{value:(_vm.yearlyDataDisplay),callback:function ($$v) {_vm.yearlyDataDisplay=$$v},expression:"yearlyDataDisplay"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":"","d-flex":"","justify-center":"","align-content-end":""}},[_c('v-btn',{attrs:{"outline":""},on:{"click":_vm.downloadChart}},[_c('v-icon',[_vm._v("file_download")]),_vm._v(" Download PNG")],1)],1)],1)],1),_vm._v(" "),_c('a',{ref:"downloadUrl",staticStyle:{"display":"none"},attrs:{"href":"#"}}),_vm._v(" "),_c('div',{staticClass:"chart-wrap"},[_c('v-btn',{staticClass:"zoom-btn",attrs:{"icon":""},on:{"click":_vm.resetZoom}},[_c('v-icon',[_vm._v("zoom_out")])],1),_vm._v(" "),_c('canvas',{attrs:{"id":_vm.chartId}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Th3G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-duration-tool"},[(!_vm.queryDone)?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("Loading...")])]):_vm._e(),_vm._v(" "),(_vm.queryDone && !_vm.hasData)?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_vm._e(),_vm._v(" "),(_vm.hasData)?_c('div',{staticClass:"chart-wrap"},[_c('div',{staticClass:"date-select-wrap"},[_c('filter-date-picker',{attrs:{"monthsFilter":_vm.monthsFilter,"yearsFilter":_vm.yearsFilter,"dateRange":_vm.dateRange},on:{"reset":_vm.resetFilters,"setMonths":_vm.applyMonthFilter,"setYears":_vm.applyYearFilter}})],1),_vm._v(" "),_c('div',{staticClass:"charts-layout-wrap"},[_c('div',{staticClass:"charts-col charts-col-1"},[_c('div',{staticClass:"fdt-chart monthly-flow-statistics"},[_c('h1',{staticClass:"headline"},[_vm._v("Monthly Flow Statistics")]),_vm._v(" "),(_vm.monthDataAll.length)?_c('monthly-flow',{attrs:{"dimensionFilter":_vm.monthsFilter,"data":_vm.monthData,"dataAll":_vm.monthDataAll},on:{"updateFilters":_vm.applyMonthFilter}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"fdt-chart flow-duration-curve"},[_c('h1',{staticClass:"headline"},[_vm._v("Flow Duration")]),_vm._v(" "),(_vm.curveDataAll.length)?_c('flow-duration-curve',{attrs:{"data":_vm.curveData}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"charts-col charts-col-2"},[_c('div',{staticClass:"fdt-chart annual-total-runoff"},[_c('h1',{staticClass:"headline"},[_vm._v("Total Runoff")]),_vm._v(" "),(_vm.yearDataAll.length)?_c('annual-runoff',{attrs:{"dimensionFilter":_vm.yearsFilter,"data":_vm.yearData,"dataAll":_vm.yearDataAll},on:{"updateFilters":_vm.applyYearFilter}}):_vm._e()],1)])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U/+O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UIT0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurfaceWaterQuality_vue__ = __webpack_require__("va/E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78e80049_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurfaceWaterQuality_vue__ = __webpack_require__("J8oE");
function injectStyle (ssrContext) {
  __webpack_require__("Ljcf")
  __webpack_require__("bK93")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78e80049"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurfaceWaterQuality_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78e80049_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurfaceWaterQuality_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UOq2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_MAP_BOUNDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SHOW_MAP_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SHOW_MAP_LEGEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SHOW_NAV_DRAWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_SIDEBAR_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_MAP_PROMISE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REMOVE_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REMOVE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SHOW_CHART_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_CHART_MODAL_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SHOW_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_TOAST_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return TRIGGER_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SELECT_STATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SELECT_WATERSHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SELECT_LICENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_MAP_CENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_SELECTED_STATION_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_SELECTED_TABLE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_MAP_SOURCE_DATA_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_LOADED_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_FILTER_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_FILTER_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return UNLOAD_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESET_LOADSTATE_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_LOADSTATE_MAP_CENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_LOADSTATE_MAP_ZOOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_LOADSTATE_MAP_FILTER_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_LOADSTATE_SELECTED_FEATURE; });
var SET_MAP_BOUNDS = 'SET_MAP_BOUNDS';
var SHOW_MAP_SIDEBAR = 'SHOW_MAP_SIDEBAR';
var SHOW_MAP_LEGEND = 'SHOW_MAP_LEGEND';
var SHOW_NAV_DRAWER = 'SHOW_NAV_DRAWER';
var SET_SIDEBAR_CONTEXT = 'SET_SIDEBAR_CONTEXT';
var SET_MAP_PROMISE = 'SET_MAP_PROMISE';
var ADD_ALERT = 'ADD_ALERT';
var REMOVE_ALERT = 'REMOVE_ALERT';
var ADD_LOADING = 'ADD_LOADING';
var REMOVE_LOADING = 'REMOVE_LOADING';
var SHOW_CHART_MODAL = 'SHOW_CHART_MODAL';
var SET_CHART_MODAL_TAB = 'SET_CHART_MODAL_TAB';
var SHOW_TOAST = 'SHOW_TOAST';
var SET_TOAST_TEXT = 'SET_TOAST_TEXT';
var TRIGGER_TOAST = 'TRIGGER_TOAST';
var SELECT_STATION = 'SELECT_STATION';
var SELECT_WATERSHED = 'SELECT_WATERSHED';
var SELECT_LICENCE = 'SELECT_LICENCE';
var SET_MAP_CENTER = 'SET_MAP_CENTER';
var SET_SELECTED_STATION_DATA = 'SET_SELECTED_STATION_DATA';
var SET_SELECTED_TABLE_DATA = 'SET_SELECTED_TABLE_DATA';
var SET_MAP_SOURCE_DATA_LOADED = 'SET_MAP_SOURCE_DATA_LOADED';
var SET_LOADED_FILTERS = 'SET_LOADED_FILTERS';
var SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS';
var SET_FILTER_SETTINGS = 'SET_FILTER_SETTINGS';
var UNLOAD_FILTERS = 'UNLOAD_FILTERS';
var RESET_LOADSTATE_ITEMS = 'RESET_LOADSTATE_ITEMS';
var SET_LOADSTATE_MAP_CENTER = 'SET_LOADSTATE_MAP_CENTER';
var SET_LOADSTATE_MAP_ZOOM = 'SET_LOADSTATE_MAP_ZOOM';
var SET_LOADSTATE_MAP_FILTER_SETTINGS = 'SET_LOADSTATE_MAP_FILTER_SETTINGS';
var SET_LOADSTATE_SELECTED_FEATURE = 'SET_LOADSTATE_SELECTED_FEATURE';

/***/ }),

/***/ "UVyt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartModalClimate_vue__ = __webpack_require__("M1/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dfd5b2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartModalClimate_vue__ = __webpack_require__("G3uD");
function injectStyle (ssrContext) {
  __webpack_require__("rcZh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1dfd5b2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartModalClimate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dfd5b2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartModalClimate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V8RN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShortUrlHandler_vue__ = __webpack_require__("retR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ca4c08b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShortUrlHandler_vue__ = __webpack_require__("eLQR");
function injectStyle (ssrContext) {
  __webpack_require__("priH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShortUrlHandler_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ca4c08b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShortUrlHandler_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VAnR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_ChartTooltip__ = __webpack_require__("4jZd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_sciNotationFmt__ = __webpack_require__("XMAy");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ChartTooltip: __WEBPACK_IMPORTED_MODULE_3__components_charts_ChartTooltip__["a" /* default */]
    },
    props: {
        // filtered data from crossfilter group.all()
        data: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            svgHeight: (window.innerHeight - 320) / 2,
            svgWidth: window.innerWidth / 3.34 * 2,
            svg: null,
            g: null,
            margin: {
                top: 35,
                bottom: 35,
                left: 40,
                right: 50
            },
            height: 225,
            width: 225,
            xScaleLinear: null, // literally just a linear distribution of 0-100 all the time.
            yScaleLog: null,
            barHeight: 4,
            axisLeft: null,
            initialized: false,
            line: null,
            focusCircle: null,
            // tooltip props
            tooltipPosition: [0, 0],
            tooltipVisible: false,
            tooltipText: []
        };
    },
    mounted: function mounted() {
        this.initializeSvg();
    },

    computed: {
        chartData: function chartData() {
            return this.formatData(this.data);
        }
    },
    methods: {
        formatData: function formatData(data) {
            // Don't show the chart if there are less than 100 points of data
            if (data.length < 100) {
                return [];
            }

            // Calculate quantiles 1-100% for the [filtered/sorted] data
            var flowDurations = [];

            for (var i = 0; i <= 100; i += 1) {
                var percent = i / 100;
                var quantile = __WEBPACK_IMPORTED_MODULE_1_d3__["q" /* quantile */](data, percent, function (d) {
                    return d.v;
                });
                flowDurations.push({
                    percent: percent,
                    flow: quantile
                });
            }

            return flowDurations;
        },
        initializeSvg: function initializeSvg() {
            var _this = this;

            // initialize chart & vars
            this.svg = __WEBPACK_IMPORTED_MODULE_1_d3__["w" /* select */]('#flow-duration-curve');
            this.g = this.svg.select('g.chart');

            // chart (not element) size
            this.width = +this.svg.attr('width') - this.margin.left - this.margin.right;
            this.height = +this.svg.attr('height') - this.margin.top - this.margin.bottom;

            // initialize scale functions
            this.xScaleLinear = __WEBPACK_IMPORTED_MODULE_1_d3__["r" /* scaleLinear */]().rangeRound([0, this.width]);
            this.yScaleLog = __WEBPACK_IMPORTED_MODULE_1_d3__["s" /* scaleLog */]().rangeRound([this.height, 0]).clamp(true);

            // transition effects for the line
            this.transition = __WEBPACK_IMPORTED_MODULE_1_d3__["C" /* transition */]().duration(500);

            // set x-scale input domain (giving a bit of margin)
            this.xScaleLinear.domain([-0.05, 1.05]);

            // bottom axis
            this.g.append('g').attr('class', 'axis axis--x').attr('transform', 'translate(0,' + this.height + ')').call(__WEBPACK_IMPORTED_MODULE_1_d3__["a" /* axisBottom */](this.xScaleLinear).tickFormat(__WEBPACK_IMPORTED_MODULE_1_d3__["j" /* format */]('.0%')));
            // left axis
            this.axisLeft = __WEBPACK_IMPORTED_MODULE_1_d3__["b" /* axisLeft */](this.yScaleLog).ticks(3).tickFormat(__WEBPACK_IMPORTED_MODULE_4__functions_sciNotationFmt__["a" /* default */]);
            this.g.append('g').attr('class', 'axis axis--y').attr('transform', 'translate(-2,0)');
            this.line = __WEBPACK_IMPORTED_MODULE_1_d3__["k" /* line */]().x(function (d) {
                return _this.xScaleLinear(d.percent);
            }).y(function (d) {
                return _this.yScaleLog(d.flow);
            });
            this.g.append('path').attr('class', 'flow-duration-path').attr('d', this.line(this.chartData));
            // define & update bars
            this.updateChart();

            // axis label
            this.g.append('text').attr('class', 'axis-label').attr('transform', 'translate(3,3) rotate(-90)').attr('y', 6).attr('dy', '0.71em').attr('text-anchor', 'end').text('Flow (m³/s)');

            // add mouseover focus circle
            this.focusCircle = this.g.append('circle').attr('class', 'focus-circle').attr('opacity', 0).attr('r', 5);

            // add mouse move overlay
            var mouseArea = this.g.append('rect').attr('class', 'mouse-area').attr('height', this.height).attr('width', this.width);

            // track mouse events on the chart area
            mouseArea.on('mousemove', this.mouseMove);
            mouseArea.on('mouseout', this.mouseOut);

            this.initialized = true;
        },
        updateChart: function updateChart() {
            this.yScaleLog.domain([0.001, __WEBPACK_IMPORTED_MODULE_1_d3__["l" /* max */](this.chartData, function (d) {
                return d.flow;
            })]).nice();

            this.g.select('.axis--y').transition(this.transition).call(this.axisLeft);

            this.g.select('.flow-duration-path').transition(this.transition).attr('d', this.line(this.chartData));
        },

        /**
         * update tooltip when the mouse moves
         */
        mouseMove: function mouseMove() {
            // mouse coordinates within the g element
            var _d3$mouse = __WEBPACK_IMPORTED_MODULE_1_d3__["p" /* mouse */](this.g.node()),
                _d3$mouse2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_d3$mouse, 1),
                gX = _d3$mouse2[0];
            // x value at these mouse coordinates


            var valX = this.xScaleLinear.invert(gX);

            // hide on mouseout
            if (valX < 0 || valX > 1) {
                this.mouseOut();
                return;
            }

            // bisect the data using the array key (0-100)
            var i = Math.round(valX * 100);
            var xData = this.chartData[i];
            if (!xData) {
                return;
            }
            var lineY = this.yScaleLog(xData.flow);
            var valY = this.yScaleLog.invert(lineY);

            // move and show focus circle
            this.focusCircle.attr('opacity', 1).attr('cy', lineY).attr('cx', gX);

            // position relative to the root flow duration tool element
            this.tooltipPosition = __WEBPACK_IMPORTED_MODULE_1_d3__["p" /* mouse */](this.$parent.$el);

            var percentage = __WEBPACK_IMPORTED_MODULE_2_numeral___default()(valX * 100).format('0');
            var flow = __WEBPACK_IMPORTED_MODULE_2_numeral___default()(valY).format('0,0.[00]');
            this.tooltipText = [{ text: percentage + '% Exceedance Flow', class: 'headline' }, { text: flow + ' m\xB3/s', class: 'light-blue darken-4 white--text' }];

            this.tooltipVisible = true;
        },

        /**
         * hide the tooltip on mouseout
         */
        mouseOut: function mouseOut() {
            // hide focus circle
            this.focusCircle.attr('opacity', 0);

            // hide tooltip
            this.tooltipVisible = false;
        }
    },
    watch: {
        // update chart when data changes
        data: {
            handler: function handler() {
                this.updateChart();
            },

            deep: true
        }
    }
});

/***/ }),

/***/ "VOyy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_yearlyChart__ = __webpack_require__("tMAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_formatHistoricalMonthlyData__ = __webpack_require__("JLkL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_formatHistoricalMonthlyDateData__ = __webpack_require__("dKxa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_exportChart__ = __webpack_require__("h326");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_resetChart__ = __webpack_require__("AstN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_climateData__ = __webpack_require__("epYP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_ie11ChartResize__ = __webpack_require__("4+uC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__chartData_climatePrecipitationChart__ = __webpack_require__("1T91");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_chartjs_plugin_annotation__ = __webpack_require__("+WEU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_chartjs_plugin_annotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_chartjs_plugin_annotation__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_yearlyChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_formatHistoricalMonthlyData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_formatHistoricalMonthlyDateData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_exportChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_resetChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_climateData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_ie11ChartResize__["a" /* default */]],
    data: function data() {
        return {
            chart: null,
            chartId: 'canvas-precip',
            dataType: 'precipitation'
        };
    },

    computed: {
        chartData: function chartData() {
            return this.queryData.precipitation;
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.chart.destroy();
    },
    mounted: function mounted() {
        // Set chart interval to month
        this.chartInterval = 'm';
        if (this.chartData) {
            this.updateChart();
        }
    },

    methods: {
        /**
         * create datasets and chart context object
         * @return {Object} chart.js context object
         */
        formatDatasets: function formatDatasets() {
            var _chartData$datasets;

            var historicalData = this.formatHistoricalData(this.chartData.historical, function (date, e) {
                return {
                    d: date,
                    p10: e.p10,
                    p25: e.p25,
                    p50: e.p50,
                    p75: e.p75,
                    p90: e.p90
                };
            });
            var currentData = this.formatCurrentData(this.chartData.current);
            var currentDates = currentData.map(function (d) {
                return d.d;
            });

            var chartData = Object(__WEBPACK_IMPORTED_MODULE_10__chartData_climatePrecipitationChart__["b" /* data */])(currentDates, currentData, historicalData);

            var yearlyOverlayDatasets = this.formatYearlyData(this.formatHistoricalDateData);
            (_chartData$datasets = chartData.datasets).unshift.apply(_chartData$datasets, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(yearlyOverlayDatasets));
            return chartData;
        },

        /**
         * set up the chart and do the initial render
         */
        renderChart: function renderChart() {
            var chartData = this.formatDatasets();

            this.chart = new __WEBPACK_IMPORTED_MODULE_11_chart_js___default.a(this.chartId, Object(__WEBPACK_IMPORTED_MODULE_10__chartData_climatePrecipitationChart__["a" /* container */])(chartData));
        },

        /**
         * update the datasets and re-render the chart
         */
        updateChart: function updateChart() {
            // do the initial render if the chart isn't defined yet
            if (this.chart === null) {
                this.renderChart();
                return;
            }
            this.chart.data = this.formatDatasets();
            this.chart.update({
                duration: 0
            });
        },

        /**
         * format current precipitation data with date objects
         * @param  {Array} currentData precipitation data with string dates
         * @return {Array}             precipitation data with moment.js dates
         */
        formatCurrentData: function formatCurrentData(currentData) {
            var dataWithDates = currentData.map(function (d) {
                var date = __WEBPACK_IMPORTED_MODULE_12_moment___default()(d.d);
                return {
                    d: date,
                    v: d.v
                };
            });

            var mtdData = this.monthToDateCurrent(dataWithDates);

            var dataWithMtd = dataWithDates.map(function (d, i) {
                var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, d);
                data.mtd = mtdData[i];
                return data;
            });

            return dataWithMtd;
        },

        /**
         * calculate month-to-date precipitation totals
         * @param  {Array} currentData current daily precipitation
         * @return {Array}             daily MTD totals
         */
        monthToDateCurrent: function monthToDateCurrent(currentData) {
            var monthlyTotals = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
            var dailyMTD = [];

            currentData.forEach(function (d, i) {
                var date = d.d;
                var month = date.utc().get('month');
                var year = date.utc().get('year');
                var monthlyTotalKey = year + '-' + month;
                var monthlyTotal = monthlyTotals.get(monthlyTotalKey) || 0;

                monthlyTotal += Number(d.v);
                monthlyTotals.set(monthlyTotalKey, monthlyTotal);

                dailyMTD[i] = monthlyTotal;
            });

            return dailyMTD;
        }
    },
    watch: {
        /**
         * update the chart when the data changes
         */
        chartData: function chartData(val) {
            this.yearlyData = {};
            this.yearlyDataDisplay = [];
            if (val) {
                this.updateChart();
            }
        },
        updateData: function updateData(val) {
            if (val) {
                this.updateChart();
                this.updateData = false;
            }
        }
    }
});

/***/ }),

/***/ "VSUu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions_appColors__ = __webpack_require__("QW0U");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        color: {
            default: String(__WEBPACK_IMPORTED_MODULE_0__functions_appColors__["s" /* navIcon */]),
            type: String
        }
    }
});

/***/ }),

/***/ "VVRy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return data; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__ = __webpack_require__("oPhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_appColors__ = __webpack_require__("QW0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_chartTooltipDate__ = __webpack_require__("rgFZ");






var container = function container(data) {
    return {
        type: 'line',
        data: data,
        plugins: [__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default.a],
        options: {
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
                mode: 'x',
                intersect: false,
                position: 'nearest',
                callbacks: {
                    label: function label(tooltipItem, d) {
                        var label = d.datasets[tooltipItem.datasetIndex].label || '';
                        var value = __WEBPACK_IMPORTED_MODULE_0_numeral___default()(tooltipItem.yLabel).format('0,0.[00]');
                        return label + ': ' + value + ' cm';
                    },

                    title: __WEBPACK_IMPORTED_MODULE_4__functions_chartTooltipDate__["a" /* default */]
                }
            },
            annotation: {
                events: [],
                annotations: [{
                    drawTime: 'afterDatasetsDraw',
                    id: 'vline',
                    type: 'line',
                    mode: 'vertical',
                    scaleID: 'x-axis-0',
                    value: __WEBPACK_IMPORTED_MODULE_1_moment___default()(),
                    borderColor: 'black',
                    borderWidth: 3,
                    label: {
                        backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["A" /* todayMarker */],
                        content: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('LL'),
                        enabled: true
                    }
                }]
            },
            pan: {
                enabled: true,
                mode: 'y',
                speed: 10,
                threshold: 10
            },
            zoom: {
                enabled: true,
                mode: 'y',
                limits: {
                    max: 100,
                    min: 1
                }
            },
            scales: {
                xAxes: [{
                    type: 'time',
                    distribution: 'linear',
                    time: {
                        tooltipFormat: 'MMM DD, YYYY',
                        unit: 'month'
                    }
                }],
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'Snow Water Equiv. (cm)'
                    }
                }],
                // disable animations
                animation: false
            }
        }
    };
};

var data = function data(label, currentData, historicalData) {
    return {
        labels: label,
        datasets: [{
            type: 'line',
            label: 'Current Snow Water Equiv.',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["d" /* currentBorder */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["c" /* currentBg */],
            borderWidth: 2,
            fill: true,
            pointRadius: 0,
            pointHitRadius: 1,
            // steppedLine: 'before',
            data: currentData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.v
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical mean',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["g" /* historicalMean */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["g" /* historicalMean */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            // pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.a
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 75th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            borderWidth: 2,
            fill: '+1',
            steppedLine: 'before',
            pointRadius: 0,
            // pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p75
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 25th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            // pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p25
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 90th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            borderWidth: 2,
            fill: '+1',
            steppedLine: 'before',
            pointRadius: 0,
            // pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p90
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 10th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            // pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p10
                };
                return valObj;
            })
        }]
    };
};

/***/ }),

/***/ "Vas+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VeNL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vo26":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_appColors__ = __webpack_require__("QW0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SingleChart__ = __webpack_require__("f0CU");



var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['query stationChemChart($id: Int!, $paramId: Int!, $unit: String!) {\n                getStation(id: $id) {\n                    chemistry {\n                        single_chart(paramId: $paramId, unit: $unit),\n                    }\n                }\n            }'], ['query stationChemChart($id: Int!, $paramId: Int!, $unit: String!) {\n                getStation(id: $id) {\n                    chemistry {\n                        single_chart(paramId: $paramId, unit: $unit),\n                    }\n                }\n            }']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        SingleChart: __WEBPACK_IMPORTED_MODULE_4__components_SingleChart__["a" /* default */]
    },
    data: function data() {
        return {
            chart: null,
            id: 'single-chart-modal-canvas',
            chartDatasets: null,
            defaultDataset: {
                borderColor: String(__WEBPACK_IMPORTED_MODULE_3__functions_appColors__["x" /* sparklineColor1 */]),
                borderWidth: 2,
                pointRadius: 1,
                fill: false,
                cubicInterpolationMode: 'monotone'
            },
            defaultOptions: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        gridLines: {
                            color: String(__WEBPACK_IMPORTED_MODULE_3__functions_appColors__["b" /* axisBorder */])
                        }
                    }],
                    xAxes: [{
                        type: 'time',
                        distribution: 'linear',
                        time: {
                            tooltipFormat: 'MMM DD, YYYY',
                            unit: 'month'
                        }
                    }]
                }
            }

        };
    },

    props: {
        show: {
            type: Boolean,
            default: false
        },
        chartDetails: {
            type: Object,
            required: false
        }
    },
    computed: {
        enabled: {
            get: function get() {
                return this.show;
            },
            set: function set(val) {
                this.close(val);
            }
        },
        title: function title() {
            var _chartDetails = this.chartDetails,
                title = _chartDetails.title,
                units = _chartDetails.units;

            return title + ' (' + units + ')';
        },
        chartKey: function chartKey() {
            var _chartDetails2 = this.chartDetails,
                paramId = _chartDetails2.paramId,
                units = _chartDetails2.units;

            return paramId + '__' + units;
        }
    },
    apollo: {
        chartData: {
            query: __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject),
            variables: function variables() {
                return {
                    id: this.chartDetails.stationId,
                    paramId: this.chartDetails.paramId,
                    unit: this.chartDetails.units
                };
            },
            update: function update(data) {
                var chart = data.getStation.chemistry.single_chart;
                var formatted = chart.map(function (e) {
                    var d = e.dt;
                    var v = Number(e.v);
                    return {
                        v: v,
                        d: d
                    };
                });
                return formatted;
            },
            result: function result() {
                this.renderChart();
            }
        }
    },
    methods: {
        close: function close(val) {
            this.$emit('close', val);
        },

        /**
         * initial chart configuration
         * (@TEMP: format for chart.js until the single-chart component switches to D3)
         */
        renderChart: function renderChart() {
            var _this = this;

            if (this.chart !== null) {
                return;
            }
            this.chart = {};

            // create datasets
            var datasets = [{}].map(function (d) {
                var merged = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.defaultDataset, d);
                return merged;
            });
            var labels = this.chartData.map(function (e) {
                return e.d;
            });

            // merge with default options
            var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultOptions);

            // set y-axis label
            var units = this.chartDetails.units;
            if (units) {
                options.scales.yAxes[0].scaleLabel = {
                    display: true,
                    labelString: units
                };
            }

            datasets[0].data = this.chartData.map(function (e) {
                return e.v;
            });
            datasets[0].label = this.chartDetails.title;

            this.chartDatasets = {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: datasets
                },
                options: options
            };
        }
    }
});

/***/ }),

/***/ "Vq0p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        monthsFilter: {
            required: true
        },
        yearsFilter: {
            required: true
        },
        dateRange: {
            required: true
        }
    },
    data: function data() {
        return {
            monthOptions: [{ label: 'January', value: 1 }, { label: 'February', value: 2 }, { label: 'March', value: 3 }, { label: 'April', value: 4 }, { label: 'May', value: 5 }, { label: 'June', value: 6 }, { label: 'July', value: 7 }, { label: 'August', value: 8 }, { label: 'September', value: 9 }, { label: 'October', value: 10 }, { label: 'November', value: 11 }, { label: 'December', value: 12 }]
        };
    },

    computed: {
        // month selection dropdown
        month: {
            // update the control if only one month is selected: [n, n+1]
            get: function get() {
                var months = this.monthsFilter;
                if (months && months[0] + 1 === months[1]) {
                    return months[0];
                }
                // unset the control if anything else is selected
                return null;
            },

            // change filters to this one month
            set: function set(val) {
                this.$emit('setMonths', [val, val + 1]);
            }
        },
        // "year from" selection dropdown
        yearFrom: {
            get: function get() {
                var years = this.yearsFilter;
                if (years) {
                    return years[0];
                }
                return null;
            },
            set: function set(val) {
                this.setYear('min', val);
            }
        },
        // "year to" selection dropdown
        yearTo: {
            get: function get() {
                var years = this.yearsFilter;
                if (years) {
                    return years[1];
                }
                return null;
            },
            set: function set(val) {
                this.setYear('max', val);
            }
        },
        yearOptions: function yearOptions() {
            var years = [];
            if (this.dateRange) {
                var _dateRange = this.dateRange,
                    min = _dateRange.min,
                    max = _dateRange.max;

                for (var i = min; i <= max; i += 1) {
                    years.push(i);
                }
            }
            return years;
        }
    },
    methods: {
        /**
         * adjust year values as needed, and emit change event
         * @param {String} field    field name (min or max)
         * @param {Number} newValue new value to change
         */
        setYear: function setYear(field, newValue) {
            // adjust range if necessary
            var min = this.yearFrom;
            var max = this.yearTo;

            if (field === 'min') {
                min = newValue;
                // if max is unset or < min
                if (!max || max < min) {
                    max = this.dateRange.max;
                }
            } else if (field === 'max') {
                max = newValue;
                // if min is unset or > max
                if (!min || min > max) {
                    min = this.dateRange.min;
                }
            }
            this.$emit('setYears', [min, max]);
        },

        /**
         * emit reset event to parent
         */
        reset: function reset() {
            this.$emit('reset');
        }
    }
});

/***/ }),

/***/ "VxAk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapStyleSwitcher_vue__ = __webpack_require__("AhwZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_563b976e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapStyleSwitcher_vue__ = __webpack_require__("ep/F");
function injectStyle (ssrContext) {
  __webpack_require__("D4BO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-563b976e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapStyleSwitcher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_563b976e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapStyleSwitcher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WTTq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WYgs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"station-details ground-quality"},[(!_vm.queryDone)?_c('div',{staticClass:"loading"},[_c('p',[_vm._v("Loading station data...")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),_vm._v(" "),(_vm.station && _vm.queryDone)?_c('div',{staticClass:"station"},[_c('h3',{staticClass:"headline station-name primary--text",domProps:{"textContent":_vm._s(_vm.queryData.name)}}),_vm._v(" "),_c('p',{staticClass:"body-2 mb-1 network-info"},[_vm._v("\n            "+_vm._s(_vm.networkId)),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":_vm.networkUrl}},[_vm._v(_vm._s(_vm.network))])]),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_vm._l((_vm.properties),function(ref){
var title = ref.title;
var value = ref.value;
return (value)?_c('div',{staticClass:"properties-item mb-3"},[_c('h4',{staticClass:"subheading field-title grey--text",domProps:{"textContent":_vm._s(title)}}),_vm._v(" "),_c('div',{staticClass:"body-1 field-value",domProps:{"textContent":_vm._s(value)}})]):_vm._e()}),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_c('h4',{staticClass:"subheading field-title grey--text"},[_vm._v("Parameters")]),_vm._v(" "),_c('v-btn',{staticClass:"my-3",attrs:{"block":"","large":"","color":"primary"},on:{"click":function($event){_vm.showChartModal('groundwater-quality')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("table_chart")]),_vm._v("\n            View Table\n        ")],1),_vm._v(" "),_c('download-csv-button',{attrs:{"redistribute":_vm.dataRedistirbute,"station-id":_vm.stationId}}),_vm._v(" "),_vm._l((_vm.visibleSparklines),function(sparkline){return _c('div',{key:((sparkline.paramId) + "__" + (sparkline.units)),staticClass:"sparkline-wrap elevation-1"},[_c('spark-line',{attrs:{"data":sparkline}}),_vm._v(" "),_c('div',{staticClass:"hover-cta"},[_c('v-btn',{on:{"click":function($event){_vm.showSingleChart(sparkline)}}},[_vm._v("View more...")])],1)],1)}),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.numVisibleSparklines < this.sparklineData.length),expression:"numVisibleSparklines < this.sparklineData.length"}],attrs:{"block":"","color":"info"},on:{"click":_vm.addCharts}},[_vm._v("\n            More Charts\n        ")])],2):_vm._e(),_vm._v(" "),(_vm.showSingleChartModal)?_c('single-chart-modal',{attrs:{"show":_vm.showSingleChartModal,"chartDetails":_vm.chartDetails},on:{"close":function($event){_vm.showSingleChartModal = false}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WfCQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WfLv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"station-details surface-quality"},[(!_vm.queryDone)?_c('div',{staticClass:"loading"},[_c('p',[_vm._v("Loading station data...")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),_vm._v(" "),(_vm.station && _vm.queryDone)?_c('div',{staticClass:"station"},[_c('h3',{staticClass:"headline station-name primary--text",domProps:{"textContent":_vm._s(_vm.queryData.name)}}),_vm._v(" "),_c('p',{staticClass:"body-2 mb-1 network-info"},[_vm._v("\n            "+_vm._s(_vm.networkId)),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":_vm.networkUrl}},[_vm._v(_vm._s(_vm.network))])]),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_vm._l((_vm.properties),function(ref){
var title = ref.title;
var value = ref.value;
return (value)?_c('div',{staticClass:"properties-item mb-3"},[_c('h4',{staticClass:"subheading field-title grey--text",domProps:{"textContent":_vm._s(title)}}),_vm._v(" "),_c('div',{staticClass:"body-1 field-value",domProps:{"textContent":_vm._s(value)}})]):_vm._e()}),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_c('h4',{staticClass:"subheading field-title grey--text"},[_vm._v("Parameters")]),_vm._v(" "),_c('v-btn',{staticClass:"my-3",attrs:{"block":"","large":"","color":"primary"},on:{"click":function($event){_vm.showChartModal('surface-water-quality')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("table_chart")]),_vm._v("\n            View Table\n        ")],1),_vm._v(" "),_c('download-csv-button',{attrs:{"redistribute":_vm.dataRedistirbute,"station-id":_vm.stationId}}),_vm._v(" "),_vm._l((_vm.visibleSparklines),function(sparkline){return _c('div',{key:((sparkline.paramId) + "__" + (sparkline.units)),staticClass:"sparkline-wrap elevation-1"},[_c('spark-line',{attrs:{"data":sparkline}}),_vm._v(" "),_c('div',{staticClass:"hover-cta"},[_c('v-btn',{on:{"click":function($event){_vm.showSingleChart(sparkline)}}},[_vm._v("View more...")])],1)],1)}),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.numVisibleSparklines < this.sparklineData.length),expression:"numVisibleSparklines < this.sparklineData.length"}],attrs:{"block":"","color":"info"},on:{"click":_vm.addCharts}},[_vm._v("\n            More Charts\n        ")])],2):_vm._e(),_vm._v(" "),(_vm.showSingleChartModal)?_c('single-chart-modal',{attrs:{"show":_vm.showSingleChartModal,"chartDetails":_vm.chartDetails},on:{"close":function($event){_vm.showSingleChartModal = false}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wj++":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions_appColors__ = __webpack_require__("QW0U");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        color: {
            default: String(__WEBPACK_IMPORTED_MODULE_0__functions_appColors__["s" /* navIcon */]),
            type: String
        }
    }
});

/***/ }),

/***/ "XC8b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_actions__ = __webpack_require__("UOq2");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'report-interstitial',
    mounted: function mounted() {
        var _this = this;

        this.$root.$on('report-generating', function (e) {
            _this.newReports.unshift({
                name: e.name,
                loading: true,
                downloading: false,
                timestamp: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('LT'),
                wfi: e.wfi
            });
        });

        this.$root.$on('report-generated', function (e) {
            var report = _this.newReports.find(function (i) {
                return i.wfi === e.wfi;
            });
            report.loading = false;
            report.file = e.file;
        });
    },
    data: function data() {
        return {
            fab: false,
            direction: 'left',
            loading: true,
            downloading: false,
            newReports: []
        };
    },

    computed: {
        downloadingNum: function downloadingNum() {
            var num = 0;
            this.newReports.forEach(function (_ref) {
                var loading = _ref.loading;

                if (loading) {
                    num += 1;
                }
            });
            return num;
        },
        downloadedNum: function downloadedNum() {
            var num = 0;
            this.newReports.forEach(function (_ref2) {
                var loading = _ref2.loading;

                if (!loading) {
                    num += 1;
                }
            });
            return num;
        }
    },
    methods: {
        downloadReport: function downloadReport(downloadWfi) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var report, _ref3, data, blob, link;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                window.gtag('event', 'Report', { action: 'download', label: 'User downloaded report' });
                                report = _this2.newReports.find(function (i) {
                                    return i.wfi === downloadWfi;
                                });

                                report.downloading = true;
                                _context.prev = 3;
                                _context.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(_this2.$cfg.API_URL + '/report/' + report.file, {
                                    responseType: 'blob'
                                });

                            case 6:
                                _ref3 = _context.sent;
                                data = _ref3.data;
                                blob = new Blob([data], { type: 'application/pdf' });

                                if (window.navigator.msSaveOrOpenBlob) {
                                    window.navigator.msSaveBlob(blob, report.file);
                                } else {
                                    link = document.createElement('a');

                                    link.href = window.URL.createObjectURL(blob);
                                    link.setAttribute('download', report.file);
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                }
                                report.downloading = false;
                                _context.next = 17;
                                break;

                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context['catch'](3);

                                window.gtag('event', 'Report', { action: 'downloaderror', label: 'There was an error downloading the report' });
                                _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__constants_actions__["D" /* TRIGGER_TOAST */], 'Error downloading report');

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[3, 13]]);
            }))();
        }
    }
});

/***/ }),

/***/ "XFj9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarSparkline_vue__ = __webpack_require__("ScZU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41b8108d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarSparkline_vue__ = __webpack_require__("AHST");
function injectStyle (ssrContext) {
  __webpack_require__("IcYZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarSparkline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41b8108d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarSparkline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XMAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__("vwbq");

/**
 * scientific notation number formatter
 */


/**
 * return a string in the format  <base>×10<exponent>
 * @param  {Number} d unformatted number
 * @return {String}   scientific notation-formatted string
 */
/* harmony default export */ __webpack_exports__["a"] = (function (d) {
  var superScript = ['⁰', '¹', '²', '³', '⁴', '⁵', '⁶', '⁷', '⁸', '⁹'];
  if (d < 1000) {
    // scientific notation not necessary
    return d;
  }
  var exponentFmt = __WEBPACK_IMPORTED_MODULE_1_d3__["j" /* format */]('.1e'); // temp function
  var values = exponentFmt(d).toString().split('e+'); // this assumes it's always > 1

  var _values = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(values, 2),
      base = _values[0],
      exponent = _values[1];

  base = parseInt(base, 10);
  exponent = exponent.split('');
  exponent = exponent.map(function (n) {
    return superScript[n];
  }).join('');
  return base + '\xD710' + exponent;
});

/***/ }),

/***/ "XONj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            chart: null,
            id: 'single-chart-modal-canvas'
        };
    },

    props: {
        chartData: {
            type: Object,
            required: true
        }
    },
    computed: {},
    methods: {
        /**
         * create the chart.js chart object
         */
        renderChart: function renderChart() {
            if (this.chart !== null) {
                return;
            }
            this.chart = {};

            this.chart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(this.id, this.chartData);
        }
    },
    // render the chart once the canvas element exists
    // (don't mount this component until the data prop is ready)
    mounted: function mounted() {
        this.renderChart();
    }
});

/***/ }),

/***/ "XXI4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StreamflowStageChart_vue__ = __webpack_require__("xg4G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56597a00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StreamflowStageChart_vue__ = __webpack_require__("5pN9");
function injectStyle (ssrContext) {
  __webpack_require__("G7Vm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StreamflowStageChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56597a00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StreamflowStageChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YIYp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-wrap groundwater-quality-table"},[(_vm.tableData)?_c('scrolling-table',{staticClass:"scroll-table",attrs:{"data":_vm.tableData}}):_vm._e(),_vm._v(" "),(!_vm.tableData)?_c('div',{staticClass:"loading"},[_c('p',[_vm._v("Loading...")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YQr3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apolloClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apolloProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apollo__ = __webpack_require__("69U5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_client__ = __webpack_require__("u1/p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_cache_inmemory__ = __webpack_require__("+dIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_link_http__ = __webpack_require__("rp1p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_fetch__ = __webpack_require__("j9g7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_config__ = __webpack_require__("RnQ3");









var httpLink = new __WEBPACK_IMPORTED_MODULE_3_apollo_link_http__["a" /* HttpLink */]({
    uri: __WEBPACK_IMPORTED_MODULE_5__app_config__["b" /* default */].API_URL + '/graphql',
    fetch: __WEBPACK_IMPORTED_MODULE_4_isomorphic_fetch___default.a
});

var apolloClient = new __WEBPACK_IMPORTED_MODULE_1_apollo_client__["a" /* ApolloClient */]({
    link: httpLink,
    cache: new __WEBPACK_IMPORTED_MODULE_2_apollo_cache_inmemory__["a" /* InMemoryCache */](),
    connectToDevTools: true
});

var apolloProvider = new __WEBPACK_IMPORTED_MODULE_0_vue_apollo__["a" /* default */]({
    defaultClient: apolloClient
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Watershed__ = __webpack_require__("gdcu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Streamflow__ = __webpack_require__("7Kvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_GroundwaterLevel__ = __webpack_require__("CHjK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_GroundwaterQuality__ = __webpack_require__("cS3I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_SurfaceWaterQuality__ = __webpack_require__("UIT0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Climate__ = __webpack_require__("iSqZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_ShortUrlHandler__ = __webpack_require__("V8RN");










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{
        path: '/',
        redirect: '/watershed'
    }, {
        path: '/watershed',
        name: 'Watershed',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Watershed__["a" /* default */],
        meta: {
            pageId: 'watershed',
            titleTag: 'Kootenay Boundary Water Tool - Watershed',
            toolHeader: 'Kootenay Boundary Water Tool - Watershed'
        }
    }, {
        path: '/streamflow',
        name: 'Streamflow',
        component: __WEBPACK_IMPORTED_MODULE_3__pages_Streamflow__["a" /* default */],
        meta: {
            pageId: 'streamflow',
            titleTag: 'BC Water Tool - Streamflow & Water Levels',
            toolHeader: 'BC Water Tool - Streamflow & Water Levels'
        }
    }, {
        path: '/groundwater-level',
        name: 'GroundwaterLevel',
        component: __WEBPACK_IMPORTED_MODULE_4__pages_GroundwaterLevel__["a" /* default */],
        meta: {
            pageId: 'groundwaterlevel',
            titleTag: 'BC Water Tool - Groundwater Levels',
            toolHeader: 'BC Water Tool - Groundwater Levels'
        }
    }, {
        path: '/groundwater-quality',
        name: 'GroundwaterQuality',
        component: __WEBPACK_IMPORTED_MODULE_5__pages_GroundwaterQuality__["a" /* default */],
        meta: {
            pageId: 'groundwaterquality',
            titleTag: 'BC Water Tool - Groundwater Quality',
            toolHeader: 'BC Water Tool - Groundwater Quality'
        }
    }, {
        path: '/surface-water-quality',
        name: 'SurfaceWaterQuality',
        component: __WEBPACK_IMPORTED_MODULE_6__pages_SurfaceWaterQuality__["a" /* default */],
        meta: {
            pageId: 'surfacewaterquality',
            titleTag: 'BC Water Tool - Surface Water Quality',
            toolHeader: 'BC Water Tool - Surface Water Quality'
        }
    }, {
        path: '/climate',
        name: 'Climate',
        component: __WEBPACK_IMPORTED_MODULE_7__pages_Climate__["a" /* default */],
        meta: {
            pageId: 'climate',
            titleTag: 'BC Water Tool - Climate',
            toolHeader: 'BC Water Tool - Climate'
        }
    },
    // interceptor route for saved state short URLs
    {
        path: '/saved/:shortUrl',
        component: __WEBPACK_IMPORTED_MODULE_8__pages_ShortUrlHandler__["a" /* default */],
        meta: {
            pageId: 'shorturlhandler'
        }
    }]
});

// change document title on route change
router.beforeEach(function (to, from, next) {
    document.title = to.meta.titleTag || 'BC Water Tool';
    next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yiam":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.show,"persistent":"","scrollable":"","fullscreen":"","transition":"scale-transition"}},[_c('v-card',{staticClass:"chart-modal"},[_c('v-toolbar',{attrs:{"color":"secondary","dark":"","tabs":""}},[_c('v-toolbar-title',{domProps:{"textContent":_vm._s(_vm.stationName)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.hide($event)}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-tabs',{staticClass:"tab-switcher",attrs:{"slot":"extension","fixed":"","centered":"","color":"secondary"},slot:"extension",model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('v-tab',{attrs:{"href":"#hydrograph"}},[_vm._v("\n                        Hydrograph\n                    ")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#monthly-mean-levels"}},[_vm._v("\n                        Monthly Mean Levels\n                    ")])],1)],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('v-tab-item',{attrs:{"id":"hydrograph"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(!_vm.checkChartData(this.stationData, 'hydrograph', this.checkGroundLevelDataFields.hydrograph))?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_c('div',[(_vm.activeTab === 'hydrograph')?_c('hydrograph-chart',{key:_vm.stationId,staticClass:"chart-hydrograph"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"data-note"},[_vm._v("Data may be from a live sensor and has not gone through QA, so may contain errors.")])],1)])],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"monthly-mean-levels"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(_vm.show && _vm.activeTab === 'monthly-mean-levels')?_c('station-ground-level-table'):_vm._e()],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YihI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return data; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__ = __webpack_require__("oPhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_appColors__ = __webpack_require__("QW0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_chartTooltipDate__ = __webpack_require__("rgFZ");






var container = function container(data) {
    return {
        type: 'line',
        data: data,
        plugins: [__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default.a],
        options: {
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
                mode: 'x',
                intersect: false,
                position: 'nearest',
                callbacks: {
                    label: function label(tooltipItem, d) {
                        var label = d.datasets[tooltipItem.datasetIndex].label || '';
                        var value = __WEBPACK_IMPORTED_MODULE_0_numeral___default()(tooltipItem.yLabel).format('0,0.[00]');
                        return label + ': ' + value + ' cm';
                    },

                    title: __WEBPACK_IMPORTED_MODULE_4__functions_chartTooltipDate__["a" /* default */]
                }
            },
            annotation: {
                events: [],
                annotations: [{
                    drawTime: 'afterDatasetsDraw',
                    id: 'vline',
                    type: 'line',
                    mode: 'vertical',
                    scaleID: 'x-axis-0',
                    value: __WEBPACK_IMPORTED_MODULE_1_moment___default()(),
                    borderColor: 'black',
                    borderWidth: 3,
                    label: {
                        backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["A" /* todayMarker */],
                        content: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('LL'),
                        enabled: true
                    }
                }]
            },
            pan: {
                enabled: true,
                mode: 'y',
                speed: 10,
                threshold: 10
            },
            zoom: {
                enabled: true,
                mode: 'y',
                limits: {
                    max: 100,
                    min: 1
                }
            },
            scales: {
                xAxes: [{
                    type: 'time',
                    distribution: 'linear',
                    time: {
                        tooltipFormat: 'MMM DD, YYYY',
                        unit: 'month'
                    }
                }],
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'Snow Depth (cm)'
                    }
                }],
                // disable animations
                animation: false
            }
        }
    };
};

var data = function data(label, currentData, historicalData) {
    return {
        labels: label,
        datasets: [{
            type: 'line',
            label: 'Current Snow Depth',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["d" /* currentBorder */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["c" /* currentBg */],
            borderWidth: 2,
            fill: true,
            pointRadius: 0,
            pointHitRadius: 1,
            // steppedLine: 'before',
            data: currentData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.v
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical mean',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["g" /* historicalMean */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["g" /* historicalMean */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            // pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.a
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 75th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            borderWidth: 2,
            fill: '+1',
            steppedLine: 'before',
            pointRadius: 0,
            // pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p75
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 25th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            // pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p25
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 90th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            borderWidth: 2,
            fill: '+1',
            steppedLine: 'before',
            pointRadius: 0,
            // pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p90
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 10th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            // pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p10
                };
                return valObj;
            })
        }]
    };
};

/***/ }),

/***/ "YxQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/**
 * parse a data array and return a copy with date objects
 * uses Object.assign to make a shallow copy (because apollo-client deep-freezes results)
 * @param  {Array}  dataArray     chart data array with { d, v } objects
 * @param  {String} [dateKey='d'] use a key other than `d` for the date
 * @return {Array}                copy of the array with parsed dates
 */
/* harmony default export */ __webpack_exports__["a"] = (function (dataArray) {
  var dateKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'd';
  return dataArray.map(function (e) {
    var date = new Date(e[dateKey]);
    var newObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, e);
    newObj[dateKey] = date;
    return newObj;
  });
});

/***/ }),

/***/ "Z5Dx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZjrC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarStation_vue__ = __webpack_require__("4oE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69839620_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarStation_vue__ = __webpack_require__("dpsf");
function injectStyle (ssrContext) {
  __webpack_require__("jtHw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarStation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69839620_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarStation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zp+G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spark-line-wrapper"},[_c('div',{staticClass:"chart-title"},[_c('div',{staticClass:"caption"},[_c('b',[_vm._v(_vm._s(_vm.data.title)+" ("+_vm._s(_vm.data.units)+")")])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.dateRange))])]),_vm._v(" "),_c('div',{staticClass:"chart-display"},[_c('spark-line',{attrs:{"dot":true,"chartData":_vm.data.data}}),_vm._v(" "),_c('div',{staticClass:"chart-value"},[_c('div',[_vm._v("\n                Latest"),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("numFormat")(this.latest.v)))])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aD+S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return data; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__ = __webpack_require__("oPhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_appColors__ = __webpack_require__("QW0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_chartTooltipDate__ = __webpack_require__("rgFZ");






var container = function container(data) {
    return {
        type: 'mixed',
        data: data,
        plugins: [__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default.a],
        options: {
            legend: {
                display: true,
                labels: {
                    // because we split the datasets into two, we would get two sets of labels for each
                    // dataset.
                    // So: only show every second label in the legend.
                    filter: function filter(label) {
                        return label.datasetIndex % 2 !== 0;
                    }
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
                mode: 'x',
                intersect: false,
                position: 'nearest',
                callbacks: {
                    label: function label(tooltipItem, d) {
                        var label = d.datasets[tooltipItem.datasetIndex].label || '';
                        var value = __WEBPACK_IMPORTED_MODULE_0_numeral___default()(tooltipItem.yLabel).format('0,0.[00]');
                        return label + ': ' + value + ' mm';
                    },

                    title: __WEBPACK_IMPORTED_MODULE_4__functions_chartTooltipDate__["a" /* default */]
                }
            },
            spanGaps: true,
            annotation: {
                events: [],
                annotations: [{
                    drawTime: 'afterDatasetsDraw',
                    id: 'vline',
                    type: 'line',
                    mode: 'vertical',
                    scaleID: 'x-axis-0',
                    value: __WEBPACK_IMPORTED_MODULE_1_moment___default()(),
                    borderColor: 'black',
                    borderWidth: 3,
                    label: {
                        backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["A" /* todayMarker */],
                        content: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('LL'),
                        enabled: true
                    }
                }]
            },
            pan: {
                enabled: true,
                mode: 'y',
                speed: 10,
                threshold: 10
            },
            zoom: {
                enabled: true,
                mode: 'y',
                limits: {
                    max: 100,
                    min: 1
                }
            },
            scales: {
                xAxes: [{
                    type: 'time',
                    distribution: 'linear',
                    time: {
                        tooltipFormat: 'MMM DD, YYYY',
                        unit: 'month'
                    }
                }],
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'Snow Water Equivalent (mm)'
                    }
                }],
                // disable animations
                animation: false
            }
        }
    };
};

var data = function data(label, currentData, historicalData) {
    /**
     * in order to have a gap for July 1st to October 31st, we need to split the data
     * based on their "date of year" values, which is 63 and 183.
     * this complicates the area fill a bit, keep track of the relative values
     */
    var hdatasplit = { first: [], last: [] };
    historicalData.forEach(function (el, i) {
        if (i <= 63) {
            hdatasplit.first.push(el);
        }
        if (i >= 183) {
            hdatasplit.last.push(el);
        }
    });
    var cdatasplit = { first: [], last: [] };
    currentData.forEach(function (el, i) {
        if (i <= 63) {
            cdatasplit.first.push(el);
        }
        if (i >= 183) {
            cdatasplit.last.push(el);
        }
    });
    var pRadius = 4;
    var bWidth = 0;
    var lTension = 0.3;
    return {
        labels: label,
        datasets: [{ // 0
            type: 'line',
            label: 'Current Manual Snow Survey',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["d" /* currentBorder */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["c" /* currentBg */],
            borderWidth: bWidth,
            fill: false,
            pointRadius: pRadius,
            pointHitRadius: 2,
            lineTension: lTension,
            // steppedLine: 'before',
            data: cdatasplit.first.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.v
                };
                return valObj;
            })
        }, { // 1
            type: 'line',
            label: 'Current Manual Snow Survey',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["d" /* currentBorder */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["c" /* currentBg */],
            borderWidth: bWidth,
            fill: false,
            pointRadius: pRadius,
            pointHitRadius: 2,
            lineTension: lTension,
            // steppedLine: 'before',
            data: cdatasplit.last.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.v
                };
                return valObj;
            })
        }, { // 2
            type: 'line',
            label: 'Historical mean',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["g" /* historicalMean */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["g" /* historicalMean */],
            borderWidth: bWidth,
            fill: false,
            // steppedLine: 'before',
            pointRadius: pRadius,
            pointHitRadius: 2,
            lineTension: lTension,
            // pointHitRadius: 1,
            data: hdatasplit.first.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p50
                };
                return valObj;
            })
        }, { // 3
            type: 'line',
            label: 'Historical Mean',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["g" /* historicalMean */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["g" /* historicalMean */],
            borderWidth: bWidth,
            fill: false,
            // steppedLine: 'before',
            pointRadius: pRadius,
            pointHitRadius: 2,
            lineTension: lTension,
            // pointHitRadius: 1,
            data: hdatasplit.last.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p50
                };
                return valObj;
            })
        }, { // 4
            type: 'line',
            label: 'Historical 75th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            borderWidth: bWidth,
            fill: '-2', // fill to 2
            // steppedLine: 'before',
            pointRadius: pRadius,
            pointHitRadius: 2,
            pointBackgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["g" /* historicalMean */],
            lineTension: lTension,
            // pointHitRadius: 1,
            data: hdatasplit.first.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p75
                };
                return valObj;
            })
        }, { // 5
            type: 'line',
            label: 'Historical 75th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            borderWidth: bWidth,
            fill: '-2', // fill to 7
            // steppedLine: 'before',
            pointRadius: pRadius,
            pointHitRadius: 2,
            pointBackgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["g" /* historicalMean */],
            lineTension: lTension,
            // pointHitRadius: 1,
            data: hdatasplit.last.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p75
                };
                return valObj;
            })
        }, { // 6
            type: 'line',
            label: 'Historical 25th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            borderWidth: bWidth,
            fill: '-4',
            // steppedLine: 'before',
            pointRadius: pRadius,
            pointHitRadius: 2,
            pointBackgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["g" /* historicalMean */],
            lineTension: lTension,
            // pointHitRadius: 1,
            data: hdatasplit.first.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p25
                };
                return valObj;
            })
        }, { // 7
            type: 'line',
            label: 'Historical 25th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            borderWidth: bWidth,
            fill: '-4',
            // steppedLine: 'before',
            pointRadius: pRadius,
            pointHitRadius: 2,
            pointBackgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["g" /* historicalMean */],
            lineTension: lTension,
            // pointHitRadius: 1,
            data: hdatasplit.last.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p25
                };
                return valObj;
            })
        }, { // 8
            type: 'line',
            label: 'Historical 90th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            borderWidth: bWidth,
            fill: '-4',
            // steppedLine: 'before',
            pointRadius: pRadius,
            pointHitRadius: 2,
            pointBackgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            lineTension: lTension,
            // pointHitRadius: 1,
            data: hdatasplit.first.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p90
                };
                return valObj;
            })
        }, { // 9
            type: 'line',
            label: 'Historical 90th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            borderWidth: bWidth,
            fill: '-4',
            // steppedLine: 'before',
            pointRadius: pRadius,
            pointHitRadius: 2,
            pointBackgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            lineTension: lTension,
            // pointHitRadius: 1,
            data: hdatasplit.last.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p90
                };
                return valObj;
            })
        }, { // 10
            type: 'line',
            label: 'Historical 10th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            borderWidth: bWidth,
            fill: '-4', // fill to 6
            // steppedLine: 'before',
            pointRadius: pRadius,
            pointHitRadius: 2,
            pointBackgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            lineTension: lTension,
            // pointHitRadius: 1,
            data: hdatasplit.first.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p10
                };
                return valObj;
            })
        }, { // 11
            type: 'line',
            label: 'Historical 10th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            borderWidth: bWidth,
            fill: '-4', // fill to 7
            // steppedLine: 'before',
            pointRadius: pRadius,
            pointHitRadius: 2,
            pointBackgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            lineTension: lTension,
            // pointHitRadius: 1,
            data: hdatasplit.last.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p10
                };
                return valObj;
            })
        }]
    };
};

/***/ }),

/***/ "aHL1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_to_sentence_case__ = __webpack_require__("xX8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_to_sentence_case___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_to_sentence_case__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__functions_licenceFieldTranslate__ = __webpack_require__("x2qp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__apollo_apollo__ = __webpack_require__("YQr3");




var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['query licenceDetails($id: String!) {\n                getLicence(id: $id) {\n                    name\n                    term\n                    type\n                    net\n                    nid\n                    pod\n                    src\n                    activity\n                    status\n                    effdate\n                    pdate\n                    expdate\n                    quantity_display\n                    flag\n                    hc\n                    wtn\n                }\n            }'], ['query licenceDetails($id: String!) {\n                getLicence(id: $id) {\n                    name\n                    term\n                    type\n                    net\n                    nid\n                    pod\n                    src\n                    activity\n                    status\n                    effdate\n                    pdate\n                    expdate\n                    quantity_display\n                    flag\n                    hc\n                    wtn\n                }\n            }']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'selected-licence',
    data: function data() {
        return {
            queryData: null,
            queryDone: false,
            dataQuery: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject),
            properties: []
        };
    },

    computed: {
        licence: function licence() {
            return this.$store.state.map.selectedLicence;
        },
        licenceId: function licenceId() {
            if (this.licence) {
                return this.licence.id;
            }
            return null;
        },
        dataQueryVars: function dataQueryVars() {
            return {
                id: this.licenceId
            };
        },

        // expand "GW" / "SW"
        licenceType: function licenceType() {
            var type = this.queryData.type || '';
            return __WEBPACK_IMPORTED_MODULE_7__functions_licenceFieldTranslate__["c" /* licenceType */](type);
        },

        // "water licence" / "use approval"
        licenceTerm: function licenceTerm() {
            var term = this.queryData.term || '';
            return __WEBPACK_IMPORTED_MODULE_7__functions_licenceFieldTranslate__["b" /* licenceTermType */](term);
        },

        // convert branding organization string to acronym
        brandingOrganization: function brandingOrganization() {
            var org = this.queryData.net || '';
            return __WEBPACK_IMPORTED_MODULE_7__functions_licenceFieldTranslate__["a" /* brandingOrganization */](org);
        }
    },
    methods: {
        /**
        * handle initial data fetching and potentially licence changes
        */
        initialize: function initialize() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                // reset local vars
                                _this.queryDone = false;
                                _this.queryData = null;

                                // fetch data
                                _context.next = 4;
                                return _this.getData();

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        /**
        * query the API and fetch station data
        */
        getData: function getData() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _ref, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["b" /* ADD_LOADING */], 'load station data');
                                _context2.prev = 1;
                                _context2.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_8__apollo_apollo__["a" /* apolloClient */].query({
                                    query: _this2.dataQuery,
                                    variables: _this2.dataQueryVars
                                });

                            case 4:
                                _ref = _context2.sent;
                                data = _ref.data;


                                // populate variables
                                _this2.queryData = data.getLicence;

                                _this2.queryDone = true;
                                _this2.buildProps();
                                _context2.next = 14;
                                break;

                            case 11:
                                _context2.prev = 11;
                                _context2.t0 = _context2['catch'](1);

                                _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["D" /* TRIGGER_TOAST */], 'Error retrieving licences');

                            case 14:
                                _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["d" /* REMOVE_LOADING */], 'load station data');

                            case 15:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[1, 11]]);
            }))();
        },

        /**
         * build an array of properties to display
         */
        buildProps: function buildProps() {
            var properties = [];
            var data = this.queryData;
            var displayDateFormat = 'MMMM Do, YYYY';
            // const numFormat = this.$options.filters.numFormat;

            // licence number and/or POD might be null
            if (data.nid || data.pod) {
                var licenceNumber = data.nid;
                var pod = data.pod;
                var titleArray = [];
                var valueArray = [];

                if (licenceNumber) {
                    titleArray.push('Licence Number');
                    valueArray.push(licenceNumber);
                }

                if (pod) {
                    titleArray.push('POD');
                    valueArray.push(pod);
                }

                var title = titleArray.join(' / ');
                var value = valueArray.join(' / ');

                properties.push({
                    title: title,
                    value: value
                });
            }

            properties.push({
                title: 'Source',
                value: data.src
            });

            properties.push({
                title: 'Purpose',
                value: data.activity
            });

            if (data.status) {
                var _value = __WEBPACK_IMPORTED_MODULE_5_to_sentence_case___default()(data.status);
                if (data.effdate) {
                    var date = __WEBPACK_IMPORTED_MODULE_4_moment___default()(data.effdate).format(displayDateFormat);
                    _value += ' (' + date + ')';
                }
                properties.push({
                    title: 'Status',
                    value: _value
                });
            }

            if (data.pdate) {
                var formatted = __WEBPACK_IMPORTED_MODULE_4_moment___default()(data.pdate).format(displayDateFormat);
                properties.push({
                    title: 'Priority Date',
                    value: '' + formatted
                });
            }

            if (data.expdate) {
                var _formatted = __WEBPACK_IMPORTED_MODULE_4_moment___default()(data.expdate).format(displayDateFormat);
                properties.push({
                    title: 'Expiry Date',
                    value: '' + _formatted
                });
            }

            properties.push({
                title: 'Quantity',
                value: data.quantity_display
            });

            properties.push({
                title: 'Flag',
                value: data.flag
            });

            properties.push({
                title: 'Hydraulic Connectivity',
                value: data.hc
            });

            properties.push({
                title: 'Well Tag Number',
                value: data.wtn
            });

            this.properties = properties;
        }
    },
    mounted: function mounted() {
        this.initialize();
    },

    watch: {
        licenceId: function licenceId() {
            // re-initialize component when a new licence is selected
            this.initialize();
        }
    }
});

/***/ }),

/***/ "aiDF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


/**
 * provide access to the fullscreen mapbox-gl map
 * this.mapPromise is available to queue things for when the map loads
 * this.map is available once the map has loaded, otherwise it's null
 * synchronously check if the map has loaded with (map !== null)
 * in an async method, you can use: const map = await this.mapPromise;
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            map: null
        };
    },

    computed: {
        mapPromise: function mapPromise() {
            return this.$store.state.mapPromise;
        }
    },
    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.mapPromise;

                        case 2:
                            _this.map = _context.sent;

                        case 3:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),

/***/ "b8W6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        dot: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        addCurrentDot: function addCurrentDot() {
            if (!this.dot) {
                return;
            }
            var lastVal = this.chartData[this.chartData.length - 1];
            if (lastVal.v === null) {
                return;
            }
            this.gChart.append('circle').attr('class', 'current-dot').attr('cx', this.xScaleTime(lastVal.d)).attr('cy', this.yScaleLinear(lastVal.v)).attr('r', 3);
        },
        addValueDots: function addValueDots() {
            var _this = this;

            var data = this.chartData;

            // add dots at each datapoint
            this.gChart.selectAll('circle.value-dot').data(data).enter().append('circle').attr('class', function (d, i) {
                return 'value-dot value-dot-' + i;
            }).style('opacity', 0).attr('cx', function (d) {
                return _this.xScaleTime(d.d);
            }).attr('cy', function (d) {
                return _this.yScaleLinear(d.v);
            }).attr('r', 5);
        },
        highlightDot: function highlightDot(index) {
            this.gChart.selectAll('circle.value-dot').style('opacity', function (d, i) {
                if (i === index) {
                    return 1;
                }
                return 0;
            });
        }
    }
});

/***/ }),

/***/ "bK93":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c/EY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cHxK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-tour"},[_vm._t("default",_vm._l((_vm.steps),function(step,index){return (_vm.currentStep === index)?_c('v-step',{key:index,attrs:{"step":step,"previous-step":_vm.previousStep,"next-step":_vm.nextStep,"stop":_vm.stop,"isFirst":_vm.isFirst,"isLast":_vm.isLast}}):_vm._e()}),{currentStep:_vm.currentStep,steps:_vm.steps,previousStep:_vm.previousStep,nextStep:_vm.nextStep,stop:_vm.stop,isFirst:_vm.isFirst,isLast:_vm.isLast})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cISp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cLT6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_MAP_BOUNDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SHOW_MAP_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SHOW_MAP_LEGEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SHOW_NAV_DRAWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_SIDEBAR_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_MAP_PROMISE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REMOVE_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REMOVE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SHOW_CHART_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_CHART_MODAL_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SHOW_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_TOAST_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_SELECTED_WATERSHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_SELECTED_STATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_SELECTED_LICENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_MAP_CENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_SELECTED_STATION_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_SELECTED_TABLE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_MAP_SOURCE_DATA_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_LOADED_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_FILTER_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_FILTER_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_LOADSTATE_MAP_CENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_LOADSTATE_MAP_ZOOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_LOADSTATE_MAP_FILTER_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_LOADSTATE_SELECTED_FEATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_POLYGON_SELECTING; });
var SET_MAP_BOUNDS = 'SET_MAP_BOUNDS';
var SHOW_MAP_SIDEBAR = 'SHOW_MAP_SIDEBAR';
var SHOW_MAP_LEGEND = 'SHOW_MAP_LEGEND';
var SHOW_NAV_DRAWER = 'SHOW_NAV_DRAWER';
var SET_SIDEBAR_CONTEXT = 'SET_SIDEBAR_CONTEXT';
var SET_MAP_PROMISE = 'SET_MAP_PROMISE';
var ADD_ALERT = 'ADD_ALERT';
var REMOVE_ALERT = 'REMOVE_ALERT';
var ADD_LOADING = 'ADD_LOADING';
var REMOVE_LOADING = 'REMOVE_LOADING';
var SHOW_CHART_MODAL = 'SHOW_CHART_MODAL';
var SET_CHART_MODAL_TAB = 'SET_CHART_MODAL_TAB';
var SHOW_TOAST = 'SHOW_TOAST';
var SET_TOAST_TEXT = 'SET_TOAST_TEXT';
var SET_SELECTED_WATERSHED = 'SET_SELECTED_WATERSHED';
var SET_SELECTED_STATION = 'SET_SELECTED_STATION';
var SET_SELECTED_LICENCE = 'SET_SELECTED_LICENCE';
var SET_MAP_CENTER = 'SET_MAP_CENTER';
var SET_SELECTED_STATION_DATA = 'SET_SELECTED_STATION_DATA';
var SET_SELECTED_TABLE_DATA = 'SET_SELECTED_TABLE_DATA';
var SET_MAP_SOURCE_DATA_LOADED = 'SET_MAP_SOURCE_DATA_LOADED';
var SET_LOADED_FILTERS = 'SET_LOADED_FILTERS';
var SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS';
var SET_FILTER_SETTINGS = 'SET_FILTER_SETTINGS';
var SET_LOADSTATE_MAP_CENTER = 'SET_LOADSTATE_MAP_CENTER';
var SET_LOADSTATE_MAP_ZOOM = 'SET_LOADSTATE_MAP_ZOOM';
var SET_LOADSTATE_MAP_FILTER_SETTINGS = 'SET_LOADSTATE_MAP_FILTER_SETTINGS';
var SET_LOADSTATE_SELECTED_FEATURE = 'SET_LOADSTATE_SELECTED_FEATURE';
var SET_POLYGON_SELECTING = 'SET_POLYGON_SELECTING';

/***/ }),

/***/ "cOEg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('aside',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"map-sidebar pa-2 elevation-3 white"},[(_vm.context === 'live')?_c('div',{staticClass:"live-list"},[(_vm.filtersLoaded)?_c('map-filters'):_vm._e(),_vm._v(" "),(!_vm.filtersLoaded)?_c('div',{staticClass:"loading loading-filters"},[_c('span',{staticClass:"mb-1"},[_vm._v("Loading map filters")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"accent"}})],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.context === 'licence')?_c('div',{staticClass:"licence-details"},[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticClass:"close-button right",attrs:{"slot":"activator","icon":""},on:{"click":_vm.showLiveList},slot:"activator"},[_c('v-icon',[_vm._v("filter_list")])],1),_vm._v(" "),_c('span',[_vm._v("View filters")])],1),_vm._v(" "),_c('licence-details')],1):_vm._e(),_vm._v(" "),(_vm.context === 'watershed')?_c('div',{staticClass:"watershed-details"},[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticClass:"close-button right",attrs:{"slot":"activator","icon":""},on:{"click":_vm.showLiveList},slot:"activator"},[_c('v-icon',[_vm._v("filter_list")])],1),_vm._v(" "),_c('span',[_vm._v("View filters")])],1),_vm._v(" "),_c('watershed-details')],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cS3I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroundwaterQuality_vue__ = __webpack_require__("waD6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d06478b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroundwaterQuality_vue__ = __webpack_require__("RKaC");
function injectStyle (ssrContext) {
  __webpack_require__("c/EY")
  __webpack_require__("wdo+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d06478b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroundwaterQuality_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d06478b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroundwaterQuality_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cZsT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mapbox_gl__ = __webpack_require__("1e2d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mapbox_gl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mapbox_gl__);

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'mapbox-gl-map',
    props: ['id', 'options', 'accessToken'],
    data: function data() {
        return {
            map: null
        };
    },
    mounted: function mounted() {
        var _this = this;

        // initialize MapboxGL map
        __WEBPACK_IMPORTED_MODULE_1_mapbox_gl___default.a.accessToken = this.accessToken;
        this.map = new __WEBPACK_IMPORTED_MODULE_1_mapbox_gl___default.a.Map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
            container: this.id,
            minZoom: 4,
            maxZoom: 15
        }, this.options));

        // disable map rotation using right click + drag
        this.map.dragRotate.disable();

        // disable map rotation using touch rotation gesture
        this.map.touchZoomRotate.disableRotation();

        // emit 'loaded' event
        this.map.on('load', function (loadEvent) {
            _this.$emit('loaded', _this.map, loadEvent);
        });
    }
});

/***/ }),

/***/ "cu9N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SwQuality_vue__ = __webpack_require__("2iIR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b26e684_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SwQuality_vue__ = __webpack_require__("Mde6");
function injectStyle (ssrContext) {
  __webpack_require__("z5wY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SwQuality_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b26e684_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SwQuality_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cueH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_D3Sparkline__ = __webpack_require__("GghS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        SparkLine: __WEBPACK_IMPORTED_MODULE_1__components_D3Sparkline__["a" /* default */]
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed: {
        first: function first() {
            var data = this.data.data;

            return data[0];
        },
        latest: function latest() {
            var data = this.data.data;

            return data[data.length - 1];
        },
        mean: function mean() {
            var data = this.data.data;

            return __WEBPACK_IMPORTED_MODULE_0_d3__["m" /* mean */](data, function (d) {
                return d.v;
            });
        },
        median: function median() {
            var data = this.data.data;

            return __WEBPACK_IMPORTED_MODULE_0_d3__["n" /* median */](data, function (d) {
                return d.v;
            });
        },
        dateRange: function dateRange() {
            var timeFormat = __WEBPACK_IMPORTED_MODULE_0_d3__["y" /* timeFormat */]('%Y-%m-%d');
            var d0 = timeFormat(this.first.d);
            var d1 = timeFormat(this.latest.d);
            return d0 + ' to ' + d1;
        }
    },
    filters: {
        numFormat: function numFormat(value) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.1f';

            if (!value) return '-';
            return __WEBPACK_IMPORTED_MODULE_0_d3__["j" /* format */](format)(value);
        }
    }
});

/***/ }),

/***/ "cz50":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"climate-precipitation-chart"},[_c('div',{staticClass:"yearly-data-select"},[_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"d-flex":"","sm3":""}},[_c('v-select',{attrs:{"width":"200","label":"Select","items":_vm.yearlyDataAvailable,"multiple":"","max-height":"400","hint":"Add yearly data","persistent-hint":""},model:{value:(_vm.yearlyDataDisplay),callback:function ($$v) {_vm.yearlyDataDisplay=$$v},expression:"yearlyDataDisplay"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":"","d-flex":"","justify-center":"","align-content-end":""}},[_c('v-btn',{attrs:{"outline":""},on:{"click":_vm.downloadChart}},[_c('v-icon',[_vm._v("file_download")]),_vm._v(" Download PNG")],1)],1)],1)],1),_vm._v(" "),_c('a',{ref:"downloadUrl",staticStyle:{"display":"none"},attrs:{"href":"#"}}),_vm._v(" "),_c('div',{staticClass:"chart-wrap"},[_c('v-btn',{staticClass:"zoom-btn",attrs:{"icon":""},on:{"click":_vm.resetZoom}},[_c('v-icon',[_vm._v("zoom_out")])],1),_vm._v(" "),_c('canvas',{attrs:{"id":_vm.chartId}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d0sm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StreamflowSevenDayChart_vue__ = __webpack_require__("QwVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79a18c02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StreamflowSevenDayChart_vue__ = __webpack_require__("oJTU");
function injectStyle (ssrContext) {
  __webpack_require__("pc19")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StreamflowSevenDayChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79a18c02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StreamflowSevenDayChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d1zR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tour_vue__ = __webpack_require__("ec4u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6644e910_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tour_vue__ = __webpack_require__("B93r");
function injectStyle (ssrContext) {
  __webpack_require__("5SKL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tour_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6644e910_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tour_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dKxa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        /**
         * format the historical data
         * @param {Array} data3Years
         * @param {Moment} yearStart
         * @return {Array} list of formatted data
         */
        formatHistoricalDateData: function formatHistoricalDateData(data3Years, yearStart) {
            return data3Years.concat(data3Years, data3Years).map(function (d, i) {
                var date = yearStart.clone().add(i, 'months');
                return {
                    d: date,
                    v: d.v
                };
            });
        }
    }
});

/***/ }),

/***/ "dTuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarStationStreamflow_vue__ = __webpack_require__("+5Z1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b457cbe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarStationStreamflow_vue__ = __webpack_require__("P1ll");
function injectStyle (ssrContext) {
  __webpack_require__("AucO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b457cbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarStationStreamflow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b457cbe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarStationStreamflow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "djs4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__apollo_apollo__ = __webpack_require__("YQr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__functions_appColors__ = __webpack_require__("QW0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_actions__ = __webpack_require__("UOq2");






var _templateObject = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral___default()(['query stationGwLevel($id: Int!, $type: Int!) {\n                getStation(id: $id) {\n                    name\n                    nid\n                    net\n                    yr\n                    ty\n                    licence_link\n                    aquifer_number,\n                    aquifer_class,\n                    aquifer_type,\n                    description\n                    hydrograph {\n                        historical\n                        current\n                    }\n                    monthly_mean_flow(type: $type) {\n                        current\n                        yearly\n                    }\n                }\n            }'], ['query stationGwLevel($id: Int!, $type: Int!) {\n                getStation(id: $id) {\n                    name\n                    nid\n                    net\n                    yr\n                    ty\n                    licence_link\n                    aquifer_number,\n                    aquifer_class,\n                    aquifer_type,\n                    description\n                    hydrograph {\n                        historical\n                        current\n                    }\n                    monthly_mean_flow(type: $type) {\n                        current\n                        yearly\n                    }\n                }\n            }']);







/* harmony default export */ __webpack_exports__["a"] = ({
    mounted: function mounted() {
        this.initialize();
    },
    data: function data() {
        return {
            queryDone: false,
            queryData: {},
            chemistryData: {},
            dataQuery: __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default()(_templateObject),
            properties: [],
            hydrographDatasets: null,
            tableData: null
        };
    },

    methods: {
        /**
         * handle initial data fetching and potentially station changes
         */
        initialize: function initialize() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                // reset local vars
                                _this.queryDone = false;
                                _this.queryData = {};

                                _this.hydrographDatasets = null;

                                if (_this.station) {
                                    _context.next = 5;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 5:
                                _context.next = 7;
                                return _this.getData();

                            case 7:
                                _this.formatTableData();
                                _this.buildProps();

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        /**
         * query the API and fetch station data
         */
        getData: function getData() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _ref, data;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (_this2.station) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                _context2.prev = 2;

                                _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__constants_actions__["b" /* ADD_LOADING */], 'load station data');
                                _context2.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_6__apollo_apollo__["a" /* apolloClient */].query({
                                    query: _this2.dataQuery,
                                    variables: {
                                        id: _this2.station.id,
                                        type: 3
                                    }
                                });

                            case 6:
                                _ref = _context2.sent;
                                data = _ref.data;


                                // populate variables
                                _this2.buildDatasets(data.getStation);
                                _this2.queryData = data.getStation;

                                _this2.queryDone = true;
                                _context2.next = 16;
                                break;

                            case 13:
                                _context2.prev = 13;
                                _context2.t0 = _context2['catch'](2);

                                _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__constants_actions__["D" /* TRIGGER_TOAST */], 'Error retrieving station data');

                            case 16:
                                _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__constants_actions__["d" /* REMOVE_LOADING */], 'load station data');

                            case 17:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[2, 13]]);
            }))();
        },

        /**
         * build an array of properties to display
         */
        buildProps: function buildProps() {
            var data = this.queryData;
            var properties = [];

            properties.push({
                title: 'Description',
                value: data.description
            });

            properties.push({
                title: 'Date Range',
                value: this.years[0] + '-' + this.years[1]
            });

            if (data.aquifer_number && data.aquifer_type) {
                properties.push({
                    title: 'Aquifer',
                    value: data.aquifer_number + ' - ' + data.aquifer_type
                });
            }

            properties.push({
                title: 'Aquifer Class',
                value: data.aquifer_class
            });

            this.properties = properties;
        },

        /**
         *
         * @return {{headers: *[], dataMap: {avg: {}, max: {}, min: {}}}}
         */
        formatTableData: function formatTableData() {
            var _queryData$monthly_me = this.queryData.monthly_mean_flow,
                yearly = _queryData$monthly_me.yearly,
                current = _queryData$monthly_me.current;

            var headers = [{ text: 'Year' }, { text: 'Jan' }, { text: 'Feb' }, { text: 'Mar' }, { text: 'Apr' }, { text: 'May' }, { text: 'Jun' }, { text: 'Jul' }, { text: 'Aug' }, { text: 'Sep' }, { text: 'Oct' }, { text: 'Nov' }, { text: 'Dec' }];

            var items = [];

            var currentMean = ['Mean'].concat(current.map(function (e) {
                return e.avg;
            }));
            currentMean = currentMean.map(function (e) {
                return { text: e };
            });
            var currentMax = ['Maximum'].concat(current.map(function (e) {
                return e.max;
            }));
            currentMax = currentMax.map(function (e) {
                return { text: e };
            });
            var currentMin = ['Minimum'].concat(current.map(function (e) {
                return e.min;
            }));
            currentMin = currentMin.map(function (e) {
                return { text: e };
            });

            items.push(currentMean, currentMax, currentMin);

            var currentMap = {
                avg: {
                    year: 'Mean'
                },
                max: {
                    year: 'Maximum'
                },
                min: {
                    year: 'Minimum'
                }
            };

            current.forEach(function (item) {
                currentMap.avg[item.m] = item.avg;
                currentMap.max[item.m] = item.max;
                currentMap.min[item.m] = item.min;
            });

            var yearlyMap = {};
            yearly.forEach(function (item) {
                var year = item.year,
                    m = item.m,
                    v = item.v;

                if (yearlyMap[year] === undefined) {
                    yearlyMap[year] = [year];
                }
                yearlyMap[year][m] = v;
            });

            // Set data
            var yearlyItems = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(yearlyMap);
            yearlyItems = yearlyItems.map(function (year) {
                return year.map(function (e) {
                    return { text: e };
                });
            });

            // console.log('table', headers, items, yearlyItems);
            this.tableData = [headers].concat(items, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(yearlyItems));
        },
        buildDatasets: function buildDatasets(data) {
            this.hydrographDatasets = [{
                label: 'Historical Mean',
                data: data.hydrograph.historical.map(function (d) {
                    return d.a;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_7__functions_appColors__["y" /* sparklineColor2 */]
            }, {
                label: 'Historical Max',
                data: data.hydrograph.historical.map(function (d) {
                    return d.max;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_7__functions_appColors__["x" /* sparklineColor1 */]
            }, {
                label: 'Historical Min',
                data: data.hydrograph.historical.map(function (d) {
                    return d.min;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_7__functions_appColors__["x" /* sparklineColor1 */],
                backgroundColor: __WEBPACK_IMPORTED_MODULE_7__functions_appColors__["w" /* sparklineBgColor */],
                fill: '-1'
            }];
        }
    },
    computed: {
        station: function station() {
            return this.$store.state.map.selectedStation;
        },
        name: function name() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.name;
        },
        networkUrl: function networkUrl() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.licence_link;
        },
        network: function network() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.net;
        },
        networkId: function networkId() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.nid;
        },
        type: function type() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.ty;
        },
        years: function years() {
            if (!this.queryDone) {
                return [];
            }
            return this.queryData.yr;
        },
        numYears: function numYears() {
            if (this.years.length === 2) {
                var years = this.years[1] - this.years[0];
                return years + 1;
            }
            return 0;
        }
    },
    watch: {
        station: function station() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                // re-initialize component when a new station is selected
                                _this3.initialize();

                            case 1:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        }
    }
});

/***/ }),

/***/ "dpsf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selected-station"},[(_vm.station)?_c('div',[(_vm.routeName === 'streamflow')?_c('streamflow-station'):_vm._e(),_vm._v(" "),(_vm.routeName === 'surfacewaterquality')?_c('surface-quality-station'):_vm._e(),_vm._v(" "),(_vm.routeName === 'groundwaterquality')?_c('ground-quality-station'):_vm._e(),_vm._v(" "),(_vm.routeName === 'groundwaterlevel')?_c('ground-level-station'):_vm._e(),_vm._v(" "),(_vm.routeName === 'climate')?_c('climate-station'):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dr3q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e5y2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapSaveButton_vue__ = __webpack_require__("BXLE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df9e283_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapSaveButton_vue__ = __webpack_require__("DwHN");
function injectStyle (ssrContext) {
  __webpack_require__("nv2y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapSaveButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df9e283_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapSaveButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eLQR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('p',[_vm._v("Loading saved map view...")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eTdZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_deep_freeze__ = __webpack_require__("TxmA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_deep_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_deep_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apollo_apollo__ = __webpack_require__("YQr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__functions_parseDates__ = __webpack_require__("YxQF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_actions__ = __webpack_require__("UOq2");





var _templateObject = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default()(['query stationSWChem($id: Int!) {\n                getStation(id: $id) {\n                    name\n                    nid\n                    net\n                    yr\n                    ty\n                    established_date\n                    licence_link\n                    location_purpose\n                    location_type\n                    description\n                    chemistry {\n                      sparkline\n                    }\n                }\n            }'], ['query stationSWChem($id: Int!) {\n                getStation(id: $id) {\n                    name\n                    nid\n                    net\n                    yr\n                    ty\n                    established_date\n                    licence_link\n                    location_purpose\n                    location_type\n                    description\n                    chemistry {\n                      sparkline\n                    }\n                }\n            }']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default()(['query chemistryQuery {\n                getChemistryLookup {\n                    display\n                    variable\n                }\n            }'], ['query chemistryQuery {\n                getChemistryLookup {\n                    display\n                    variable\n                }\n            }']);









/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            gettingData: false,
            dataQuery: __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject),
            showSingleChartModal: false,
            queryDone: false,
            queryData: {},
            chemistryData: {},
            chemistryQuery: __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject2),
            chartData: [],
            sparklineData: [],
            properties: []
        };
    },

    methods: {
        /**
         * query the API and fetch station data
         */
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, data, sparklineData;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this.station) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                _this.queryDone = false;
                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__constants_actions__["b" /* ADD_LOADING */], 'load station data');
                                _context.prev = 4;
                                _context.next = 7;
                                return __WEBPACK_IMPORTED_MODULE_7__apollo_apollo__["a" /* apolloClient */].query({
                                    query: _this.dataQuery,
                                    variables: { id: _this.station.id }
                                });

                            case 7:
                                _ref = _context.sent;
                                data = _ref.data;


                                // populate variables
                                _this.queryData = data.getStation;
                                // parse date values and re-freeze query results
                                sparklineData = _this.queryData.chemistry.sparkline.map(function (e) {
                                    var newObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, e);
                                    newObj.data = Object(__WEBPACK_IMPORTED_MODULE_8__functions_parseDates__["a" /* default */])(e.data);
                                    return newObj;
                                });

                                _this.sparklineData = __WEBPACK_IMPORTED_MODULE_6_deep_freeze___default()(sparklineData);
                                _context.next = 17;
                                break;

                            case 14:
                                _context.prev = 14;
                                _context.t0 = _context['catch'](4);

                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__constants_actions__["D" /* TRIGGER_TOAST */], 'Error retrieving station data');

                            case 17:

                                _this.queryDone = true;
                                _this.buildProps();

                                // format chemistry data for charts
                                _this.chartData = _this.queryData.chemistry.formatted_chemistry_chart_data;
                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__constants_actions__["d" /* REMOVE_LOADING */], 'load station data');

                            case 21:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[4, 14]]);
            }))();
        },

        /**
         * build an array of properties to display
         */
        buildProps: function buildProps() {
            var data = this.queryData;
            var properties = [];

            properties.push({
                title: 'Description',
                value: data.description
            });

            if (data.established_date) {
                var establishedDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(data.established_date).format('YYYY-MM-DD');

                properties.push({
                    title: 'Established',
                    value: establishedDate
                });
            }

            properties.push({
                title: 'Location Purpose',
                value: data.location_purpose
            });

            properties.push({
                title: 'Location Type',
                value: data.location_type
            });

            this.properties = properties;
        }
    },
    computed: {
        station: function station() {
            return this.$store.state.map.selectedStation;
        },
        name: function name() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.name;
        },
        networkUrl: function networkUrl() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.licence_link;
        },
        network: function network() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.net;
        },
        networkId: function networkId() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.nid;
        },
        type: function type() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.ty;
        },
        years: function years() {
            if (!this.queryDone) {
                return [];
            }
            return this.queryData.yr;
        },
        numYears: function numYears() {
            if (this.years.length === 2) {
                var years = this.years[1] - this.years[0];
                return years + 1;
            }
            return 0;
        }
    },
    watch: {
        station: function station(newStation, oldStation) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this2.gettingData === newStation.id)) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                _this2.gettingData = newStation.id;

                                if (!(oldStation === null || newStation && oldStation.id !== newStation.id)) {
                                    _context2.next = 6;
                                    break;
                                }

                                _context2.next = 6;
                                return _this2.getData();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    }
});

/***/ }),

/***/ "ec4u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_timers__ = __webpack_require__("ZPKS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_timers__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        name: {
            type: String,
            default: 'myTour'
        },
        value: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        var _this = this;

        return {
            tourCallbacks: {
                onStart: this.onStartTour,
                onNextStep: this.onNextStep,
                onPreviousStep: this.onPreviousStep,
                onStop: this.onStop
            },
            finalCallbacks: {
                onStart: this.onFinalStart,
                onStop: this.onFinalStop
            },
            showOverlay: false,
            // basic overlay, starts counter clockwise to define a 4 sided polygon, and then clockwise to define
            // the "cutout".
            pathOverlay: 'M 0 0 L 0 1  L 1 1 L 1 0 L 0 0 z M 3 3 L 4 3 L 4 4 L 3 4 L 3 3 z',
            viewHeight: 0,
            viewWidth: 0,
            finalStep: [{
                target: '#tourActivator',
                content: 'To activate this tour again, click on this icon!',
                params: {
                    placement: 'right',
                    adjustments: {
                        left: -10,
                        width: 20,
                        top: -10,
                        height: 20
                    }
                }
            }],
            steps: [{
                target: '#navDrawer',
                content: 'This is the Navigation Drawer. It lets you change the contents of the map. Click on any of the icons to change the map module and explore functionality in the tool.',
                params: {
                    placement: 'right',
                    adjustments: {
                        top: 64,
                        height: -64
                    }
                }
            }, {
                target: '#navigationToggle',
                content: 'The three horizontal lines at the top open and close the drawer.',
                params: {
                    placement: 'right',
                    before: function before() {
                        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__constants_actions__["B" /* SHOW_NAV_DRAWER */], true);
                        if (!document.querySelector('#hack-nav-drawer-0')) {
                            var hacks = [];
                            for (var i = 0; i <= 5; i += 1) {
                                hacks[i] = document.createElement('div');
                                hacks[i].classList.add('tourHack');
                                var referencebbox = document.querySelector('#nav-drawer-' + i).getBoundingClientRect();
                                hacks[i].style.top = referencebbox.top + 'px';
                                hacks[i].style.left = referencebbox.left + 'px';
                                hacks[i].style.width = referencebbox.width + 'px';
                                hacks[i].style.height = referencebbox.height + 'px';
                                hacks[i].setAttribute('id', 'hack-nav-drawer-' + i);
                                document.body.appendChild(hacks[i]);
                            }
                            Object(__WEBPACK_IMPORTED_MODULE_2_timers__["setTimeout"])(function () {
                                for (var _i = 0; _i <= 5; _i += 1) {
                                    var _referencebbox = document.querySelector('#nav-drawer-' + _i).getBoundingClientRect();
                                    hacks[_i].style.top = _referencebbox.top + 'px';
                                    hacks[_i].style.left = _referencebbox.left + 'px';
                                    hacks[_i].style.width = _referencebbox.width + 'px';
                                    hacks[_i].style.height = _referencebbox.height + 'px';
                                    hacks[_i].setAttribute('id', 'hack-nav-drawer-' + _i);
                                    document.body.appendChild(hacks[_i]);
                                }
                            }, 200);
                        }
                    }
                }
            }, {
                target: '#hack-nav-drawer-0',
                content: 'Markers show locations of existing water rights. Clicking on any stream, lake, or river will generate a custom, watershed based supply and demand report.',
                params: {
                    placement: 'right',
                    timeout: 100, // wait 100 ms before doing this. Nav drawer takes .5s to expand!
                    before: function before() {
                        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__constants_actions__["B" /* SHOW_NAV_DRAWER */], true);
                    }
                }
            }, {
                target: '#hack-nav-drawer-1',
                content: 'Markers show active and historical surface water quantity measurement locations.',
                params: {
                    placement: 'right',
                    before: function before() {
                        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__constants_actions__["B" /* SHOW_NAV_DRAWER */], true);
                    }
                }
            }, {
                target: '#hack-nav-drawer-2',
                content: 'Waterbodies where <strong>surface water quality</strong> has been measured.',
                params: {
                    placement: 'right',
                    before: function before() {
                        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__constants_actions__["B" /* SHOW_NAV_DRAWER */], true);
                    }
                }
            }, {
                target: '#hack-nav-drawer-3',
                content: 'Wells where <strong>groundwater quality</strong> has been measured.',
                params: {
                    placement: 'right',
                    before: function before() {
                        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__constants_actions__["B" /* SHOW_NAV_DRAWER */], true);
                    }
                }
            }, {
                target: '#hack-nav-drawer-4',
                content: 'Wells where <strong>groundwater levels</strong> have been measured.',
                params: {
                    placement: 'right',
                    before: function before() {
                        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__constants_actions__["B" /* SHOW_NAV_DRAWER */], true);
                    }
                }
            }, {
                target: '#hack-nav-drawer-5',
                content: 'Active and historical <strong>weather stations</strong> (temperature, precipitation, and snow).',
                params: {
                    placement: 'right',
                    before: function before() {
                        // in case the user clicks forward and then back.
                        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__constants_actions__["B" /* SHOW_NAV_DRAWER */], true);
                        if (!document.querySelector('#hack-nav-drawer-0')) {
                            var hacks = [];
                            for (var i = 0; i <= 5; i += 1) {
                                hacks[i] = document.createElement('div');
                                hacks[i].classList.add('tourHack');
                                var referencebbox = document.querySelector('#nav-drawer-' + i).getBoundingClientRect();
                                hacks[i].style.top = referencebbox.top + 'px';
                                hacks[i].style.left = referencebbox.left + 'px';
                                hacks[i].style.width = referencebbox.width + 'px';
                                hacks[i].style.height = referencebbox.height + 'px';
                                hacks[i].setAttribute('id', 'hack-nav-drawer-' + i);
                                document.body.appendChild(hacks[i]);
                            }
                            Object(__WEBPACK_IMPORTED_MODULE_2_timers__["setTimeout"])(function () {
                                for (var _i2 = 0; _i2 <= 5; _i2 += 1) {
                                    var _referencebbox2 = document.querySelector('#nav-drawer-' + _i2).getBoundingClientRect();
                                    hacks[_i2].style.top = _referencebbox2.top + 'px';
                                    hacks[_i2].style.left = _referencebbox2.left + 'px';
                                    hacks[_i2].style.width = _referencebbox2.width + 'px';
                                    hacks[_i2].style.height = _referencebbox2.height + 'px';
                                    hacks[_i2].setAttribute('id', 'hack-nav-drawer-' + _i2);
                                    document.body.appendChild(hacks[_i2]);
                                }
                            }, 200);
                        }
                    },
                    after: function after() {
                        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__constants_actions__["B" /* SHOW_NAV_DRAWER */], false);
                    }
                }
            }, {
                target: '.search-bar',
                content: 'Search for communities, rivers, lakes, water rights. You can also search by geographic coordinates (lat, long, decimal degrees), or Watershed Feature ID (WFI - you’ll find that unique reference on each report).',
                params: {
                    placement: 'bottom'
                }
            }, {
                target: '#sidebar-toggle',
                content: 'Click these three dots to open the context aware sidebar.',
                params: {
                    placement: 'left'
                }
            }, {
                target: '.map-sidebar',
                content: 'In the sidebar, you can filter the locations on the map. Filter options change depending on which module you are in.',
                params: {
                    before: function before() {
                        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], true);
                    },
                    after: function after() {
                        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], false);
                    },
                    placement: 'left'
                }
            }, {
                target: '#map-legend-button',
                content: 'Show the legend',
                params: {
                    placement: 'right'
                }
            }, {
                target: '#map-legend-popup',
                content: 'Gives you information on the various features of the map',
                params: {
                    placement: 'right',
                    timeout: 100, // wait 100 ms before doing this
                    before: function before() {
                        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__constants_actions__["z" /* SHOW_MAP_LEGEND */], true);
                    }
                }
            }, {
                target: '#map-style-switcher-button',
                content: 'Change the map background',
                params: {
                    placement: 'right'
                }
            }, {
                target: '#map-save-button',
                content: 'Click the save button to save your current map view and filters (add it to your bookmarks or share with a friend), and download map data.',
                params: {
                    placement: 'right'
                }
            }, {
                target: '.mapboxgl-ctrl-top-left>.mapboxgl-ctrl',
                content: 'Zoom in and out (you can also use the scrollwheel of your mouse)',
                params: {
                    placement: 'right'
                }
            }, {
                target: '.speed-dial',
                content: 'The orange numbers show the status of your reports generated. Click the icon to download.',
                params: {
                    placement: 'right',
                    adjustments: {
                        left: -10,
                        width: 20,
                        top: -10,
                        height: 20
                    }
                }
            }]
        };
    },

    methods: {
        start: function start() {
            this.$emit('input', false);
            this.$tours[this.name].start();
        },
        cancel: function cancel() {
            this.$tours.finalStep.start();
            localStorage.setItem('ShowTour', false);
            this.$emit('input', false);
        },
        onFinalStart: function onFinalStart() {
            this.showOverlay = true;
            this.moveHelperLayer(this.finalStep[0].target, 0, this.finalStep);
        },
        onStartTour: function onStartTour() {
            this.showOverlay = true;
            this.moveHelperLayer(this.steps[0].target, 0, this.steps);
        },

        // this is the function which runs when the user clicks "next" on at step <step>
        // so, if the user clicks "next" on step 2, the next step shown will be 3, and this function
        // is called before 3 runs.
        onNextStep: function onNextStep(step) {
            var _this2 = this;

            // give it a bit of time before we show the highlighter/overlay
            var to = 100;
            if (this.steps[step + 1].params && this.steps[step + 1].params.timeout) {
                if (this.steps[step + 1].params.timeout) {
                    to = this.steps[step + 1].params.timeout;
                }
            }
            Object(__WEBPACK_IMPORTED_MODULE_2_timers__["setTimeout"])(function () {
                _this2.moveHelperLayer(_this2.steps[step + 1].target, step + 1, _this2.steps);
            }, to);

            if (this.steps[step].params && this.steps[step].params.after) {
                if (typeof this.steps[step].params.after === 'function') {
                    this.steps[step].params.after();
                }
            }
            if (this.steps[step + 1].params && this.steps[step + 1].params.before) {
                if (typeof this.steps[step + 1].params.before === 'function') {
                    this.steps[step + 1].params.before();
                }
            }
        },

        // this is the function which runs when the user clicks "previous" on step <step>
        // similar to onNextStep but this is for clicking on the "previous" button.
        onPreviousStep: function onPreviousStep(step) {
            var _this3 = this;

            var to = 100;
            if (this.steps[step - 1].params && this.steps[step - 1].params.timeout) {
                if (this.steps[step - 1].params.timeout) {
                    to = this.steps[step - 1].params.timeout;
                }
            }
            // give it a bit of time before we show the highlighter/overlay
            Object(__WEBPACK_IMPORTED_MODULE_2_timers__["setTimeout"])(function () {
                _this3.moveHelperLayer(_this3.steps[step - 1].target, step - 1, _this3.steps);
            }, to);

            if (this.steps[step].params && this.steps[step].params.after) {
                if (typeof this.steps[step].params.after === 'function') {
                    this.steps[step].params.after();
                }
            }
            if (this.steps[step - 1].params && this.steps[step - 1].params.before) {
                if (typeof this.steps[step - 1].params.before === 'function') {
                    this.steps[step - 1].params.before();
                }
            }
        },
        onStop: function onStop() {
            if (!this.$tours.finalStep.isRunning && this.$tours[this.name].isRunning) {
                this.$tours.finalStep.start();
            } else if (this.$tours.finalStep.isRunning) {
                // finalStep is running, just exit, user might be angry and clicking esc furiously
                this.$tours.finalStep.currentStep = -1;
            }
        },
        onFinalStop: function onFinalStop() {
            this.showOverlay = false;
            localStorage.setItem('ShowTour', false);
        },

        // make an overlay with a "cutout" in svg
        // you'll probably want to look at generateOverlayPath instead of this.
        moveHelperLayer: function moveHelperLayer(targetSelector, step, stepGroup) {
            var target = document.querySelector(targetSelector);
            var boundingRect = target.getBoundingClientRect();
            if (boundingRect.width > 0) {
                var dims = {
                    left: boundingRect.left,
                    top: boundingRect.top,
                    width: boundingRect.width,
                    height: boundingRect.height };
                // if there are adjustments needed as per the steps defined, apply
                // them to the boundingbox for the "highlight" cutout of the path.
                // you can use this sort of thing to give yourself some padding if the
                // selector can't manage to highlight the full element.
                if (stepGroup[step].params && stepGroup[step].params.adjustments) {
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(stepGroup[step].params.adjustments).forEach(function (key) {
                        dims[key] += stepGroup[step].params.adjustments[key];
                    });
                }
                this.generateOverlayPath(dims);
            }
        },

        // generates the svg "overlay" with a cutout as defined as boundingRect
        generateOverlayPath: function generateOverlayPath(boundingRect) {
            this.viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            this.viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            this.pathOverlay = 'M 0 0 L 0 ' + this.viewHeight + ' L ' + this.viewWidth + ' ' + this.viewHeight + ' L ' + this.viewWidth + ' 0 L 0 0 z';
            // move to the top left point of the cutout
            this.pathOverlay += ' M ' + boundingRect.left + ' ' + boundingRect.top;
            // draw a Line to the top right point of the cutout
            this.pathOverlay += ' L ' + (boundingRect.left + boundingRect.width) + ' ' + boundingRect.top;
            // draw a Line to the bottom right point of the cutout
            this.pathOverlay += ' L ' + (boundingRect.left + boundingRect.width) + ' ' + (boundingRect.top + boundingRect.height);
            // draw a Line to the bottom left point of the cutout
            this.pathOverlay += ' L ' + boundingRect.left + ' ' + (boundingRect.top + boundingRect.height);
            // draw a Line to the top left point of the cutout, end path
            this.pathOverlay += ' L ' + boundingRect.left + ' ' + boundingRect.top + ' z';
        }
    },
    mounted: function mounted() {
        this.showOverlay = false;
    }
});

/***/ }),

/***/ "emTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_yearlyChart__ = __webpack_require__("tMAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_formatHistoricalDailyData__ = __webpack_require__("/SS+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_formatHistoricalDailyDateData__ = __webpack_require__("r0h7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_exportChart__ = __webpack_require__("h326");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_resetChart__ = __webpack_require__("AstN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_climateData__ = __webpack_require__("epYP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_ie11ChartResize__ = __webpack_require__("4+uC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chartData_climateTemperatureChart__ = __webpack_require__("QgFt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_yearlyChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_formatHistoricalDailyData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_formatHistoricalDailyDateData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_exportChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_resetChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_climateData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_ie11ChartResize__["a" /* default */]],
    data: function data() {
        return {
            chart: null,
            chartId: 'canvas-temperature',
            dataType: 'temperature'
        };
    },

    computed: {
        chartData: function chartData() {
            return this.queryData.temperature;
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.chart.destroy();
    },
    mounted: function mounted() {
        if (this.chartData) {
            this.updateChart();
        }
    },

    methods: {
        formatDatasets: function formatDatasets() {
            var _chartData$datasets;

            var historicalData = this.formatHistoricalData(this.chartData.historical, function (date, e) {
                var formatted = {
                    d: date,
                    maxp90: e.maxp90,
                    maxavg: e.maxavg,
                    minavg: e.minavg,
                    minp10: e.minp10
                };
                return formatted;
            });
            var currentData = this.formatCurrentData(this.chartData.current);
            var chartDates = historicalData.map(function (d) {
                return d.d;
            });

            var chartData = Object(__WEBPACK_IMPORTED_MODULE_8__chartData_climateTemperatureChart__["b" /* data */])(chartDates, currentData, historicalData);

            // yearly overlay datasets, if any
            var yearlyOverlayDatasets = this.formatYearlyData(this.formatHistoricalDateData);
            (_chartData$datasets = chartData.datasets).unshift.apply(_chartData$datasets, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(yearlyOverlayDatasets));
            return chartData;
        },

        /**
         * set up the chart and do the initial render
         */
        renderChart: function renderChart() {
            var chartData = this.formatDatasets();

            this.chart = new __WEBPACK_IMPORTED_MODULE_9_chart_js___default.a(this.chartId, Object(__WEBPACK_IMPORTED_MODULE_8__chartData_climateTemperatureChart__["a" /* container */])(chartData));
        },

        /**
         * update the datasets and re-render the chart
         */
        updateChart: function updateChart() {
            // do the initial render if the chart isn't defined yet
            if (this.chart === null) {
                this.renderChart();
                return;
            }
            this.chart.data = this.formatDatasets();
            this.chart.update({
                duration: 0
            });
        },

        /**
         * format current temperature data with date objects
         * @param  {Array} currentData temperature data with string dates
         * @return {Array}             temperature data with moment.js dates
         */
        formatCurrentData: function formatCurrentData(currentData) {
            var dataWithDates = currentData.map(function (d) {
                var date = __WEBPACK_IMPORTED_MODULE_10_moment___default()(d.d);
                return {
                    d: date,
                    min: d.min,
                    max: d.max
                };
            });

            return dataWithDates;
        }
    },
    watch: {
        /**
         * update the chart when the data changes
         */
        chartData: function chartData(val) {
            this.yearlyData = {};
            this.yearlyDataDisplay = [];
            if (val) {
                this.updateChart();
            }
        },
        updateData: function updateData(val) {
            if (val) {
                this.updateChart();
                this.updateData = false;
            }
        }
    }
});

/***/ }),

/***/ "ep/F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-style-switcher",class:{ showing: _vm.value }},[_c('div',{staticClass:"mapboxgl-ctrl mapboxgl-ctrl-group style-switcher-control",attrs:{"id":"map-style-switcher-button"},on:{"click":function($event){_vm.show(!_vm.value)}}},[_c('v-tooltip',{attrs:{"right":""}},[_c('button',{attrs:{"slot":"activator","type":"button"},slot:"activator"},[_c('v-icon',{staticClass:"mbgl-color"},[_vm._v("map")])],1),_vm._v(" "),_c('span',[_vm._v("Change map style")])])],1),_vm._v(" "),(_vm.value)?_c('div',{staticClass:"style-selection mapboxgl-ctrl mapboxgl-ctrl-group mbgl-color"},[_c('v-list',{attrs:{"dense":"","light":"","subheader":""}},[_c('v-subheader',[_c('span',{staticClass:"selection-subhead mbgl-color"},[_vm._v("Map style")])]),_vm._v(" "),_vm._l((_vm.styles),function(style){return _c('v-list-tile',{key:style.value,staticClass:"list-item",attrs:{"avatar":""},on:{"click":function($event){_vm.currentStyle = style}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentStyle),expression:"currentStyle"}],attrs:{"id":style.value,"type":"radio"},domProps:{"value":style,"checked":_vm._q(_vm.currentStyle,style)},on:{"change":function($event){_vm.currentStyle=style}}}),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(style.name)}})],1)],1)})],2)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "epYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apollo_apollo__ = __webpack_require__("YQr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__functions_appColors__ = __webpack_require__("QW0U");




var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['query stationClimate($id: Int!) {\n                getStation(id: $id) {\n                    name\n                    nid\n                    net\n                    yr\n                    ty\n                    description\n                    licence_link\n                    elevation\n                    temperature {\n                        current\n                        historical\n                    }\n                    precipitation{\n                        current\n                        historical\n                    }\n                    snow_on_ground_depth {\n                        current\n                        historical\n                    }\n                    snow_water_equivalent {\n                        current\n                        historical\n                    }\n                    manual_snow_survey {\n                        current\n                        historical\n                    }\n                }\n            }'], ['query stationClimate($id: Int!) {\n                getStation(id: $id) {\n                    name\n                    nid\n                    net\n                    yr\n                    ty\n                    description\n                    licence_link\n                    elevation\n                    temperature {\n                        current\n                        historical\n                    }\n                    precipitation{\n                        current\n                        historical\n                    }\n                    snow_on_ground_depth {\n                        current\n                        historical\n                    }\n                    snow_water_equivalent {\n                        current\n                        historical\n                    }\n                    manual_snow_survey {\n                        current\n                        historical\n                    }\n                }\n            }']);







/* harmony default export */ __webpack_exports__["a"] = ({
    mounted: function mounted() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this.initialize();

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    data: function data() {
        return {
            properties: [],
            queryData: {},
            queryDone: true,
            temperatureDatasets: null,
            precipitationDatasets: null,
            snowDatasets: null,
            SWEDatasets: null,
            MSSDatasets: null,
            dataQuery: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject)
        };
    },

    methods: {
        initialize: function initialize() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.queryDone = false;
                                _this2.queryData = {};

                                _this2.temperatureDatasets = null;
                                _this2.precipitationDatasets = null;
                                _this2.snowDatasets = null;

                                // fetch data
                                _context2.next = 7;
                                return _this2.getData();

                            case 7:
                                _this2.buildProps();

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        getData: function getData() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var _ref, data;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (_this3.station) {
                                    _context3.next = 2;
                                    break;
                                }

                                return _context3.abrupt('return');

                            case 2:
                                _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["b" /* ADD_LOADING */], 'load station data');
                                _context3.prev = 3;
                                _context3.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_4__apollo_apollo__["a" /* apolloClient */].query({
                                    query: _this3.dataQuery,
                                    variables: { id: _this3.station.id }
                                });

                            case 6:
                                _ref = _context3.sent;
                                data = _ref.data;

                                // populate variables
                                _this3.buildDatasets(data.getStation);
                                _this3.queryData = data.getStation;

                                _this3.queryDone = true;
                                _context3.next = 16;
                                break;

                            case 13:
                                _context3.prev = 13;
                                _context3.t0 = _context3['catch'](3);

                                _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["D" /* TRIGGER_TOAST */], 'Error retrieving station data');

                            case 16:
                                _context3.prev = 16;

                                _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["d" /* REMOVE_LOADING */], 'load station data');
                                return _context3.finish(16);

                            case 19:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3, [[3, 13, 16, 19]]);
            }))();
        },
        buildDatasets: function buildDatasets(data) {
            // reduce number of data points to plot on the spark line
            var temperatureData = data.temperature.historical.filter(function (v, i) {
                return i % 10 === 0;
            });

            this.temperatureDatasets = [{
                label: 'Max Avg. Temperature',
                data: temperatureData.map(function (d) {
                    return d.maxavg;
                }),
                // backgroundColor: sparklineBgColor,
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["y" /* sparklineColor2 */]
            }, {
                label: 'Min Avg. Temperature',
                data: temperatureData.map(function (d) {
                    return d.minavg;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["y" /* sparklineColor2 */],
                fill: '-1'
            }, {
                label: 'Max P90',
                data: temperatureData.map(function (d) {
                    return d.maxp90;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["x" /* sparklineColor1 */]
            }, {
                label: 'Min P10',
                data: temperatureData.map(function (d) {
                    return d.minp10;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["x" /* sparklineColor1 */],
                backgroundColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["w" /* sparklineBgColor */],
                fill: '-1'
            }];

            this.precipitationDatasets = [{
                label: '10th %ile',
                data: data.precipitation.historical.map(function (d) {
                    return d.p10;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["x" /* sparklineColor1 */]
            }, {
                label: '90th %ile',
                data: data.precipitation.historical.map(function (d) {
                    return d.p90;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["x" /* sparklineColor1 */],
                fill: '-1'
            }, {
                label: '25th %ile',
                data: data.precipitation.historical.map(function (d) {
                    return d.p25;
                }),
                backgroundColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["w" /* sparklineBgColor */],
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["y" /* sparklineColor2 */]
            }, {
                label: '75th %ile',
                data: data.precipitation.historical.map(function (d) {
                    return d.p75;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["y" /* sparklineColor2 */],
                fill: '-1'
            }];

            var snowData = data.snow_on_ground_depth.historical.filter(function (v, i) {
                return i % 10 === 0;
            });

            this.snowDatasets = [{
                label: '25th %ile',
                data: snowData.map(function (d) {
                    return d.p25;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["y" /* sparklineColor2 */]
            }, {
                label: '75th %ile',
                data: snowData.map(function (d) {
                    return d.p75;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["y" /* sparklineColor2 */],
                backgroundColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["w" /* sparklineBgColor */],
                fill: '-1'
            }, {
                label: '10th %ile',
                data: snowData.map(function (d) {
                    return d.p10;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["x" /* sparklineColor1 */]
            }, {
                label: '90th %ile',
                data: snowData.map(function (d) {
                    return d.p90;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["x" /* sparklineColor1 */],
                backgroundColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["w" /* sparklineBgColor */],
                fill: '-1'
            }];

            var SWEData = data.snow_water_equivalent.historical.filter(function (v, i) {
                return i % 10 === 0;
            });

            this.SWEDatasets = [{
                label: '25th %ile',
                data: SWEData.map(function (d) {
                    return d.p25;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["y" /* sparklineColor2 */],
                backgroundColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["w" /* sparklineBgColor */],
                fill: '-1'
            }, {
                label: '75th %ile',
                data: SWEData.map(function (d) {
                    return d.p75;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["y" /* sparklineColor2 */]
            }, {
                label: '10th %ile',
                data: SWEData.map(function (d) {
                    return d.p10;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["x" /* sparklineColor1 */]
            }, {
                label: '90th %ile',
                data: SWEData.map(function (d) {
                    return d.p90;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["x" /* sparklineColor1 */],
                backgroundColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["w" /* sparklineBgColor */],
                fill: '-1'
            }];
            var MSSData = data.manual_snow_survey.historical.filter(function (v, i) {
                return i % 10 === 0;
            });

            this.MSSDatasets = [{
                label: '25th %ile',
                data: MSSData.map(function (d) {
                    return d.p25;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["y" /* sparklineColor2 */],
                backgroundColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["w" /* sparklineBgColor */],
                fill: '-1'
            }, {
                label: '75th %ile',
                data: MSSData.map(function (d) {
                    return d.p75;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["y" /* sparklineColor2 */]
            }, {
                label: '10th %ile',
                data: MSSData.map(function (d) {
                    return d.p10;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["x" /* sparklineColor1 */]
            }, {
                label: '90th %ile',
                data: MSSData.map(function (d) {
                    return d.p90;
                }),
                borderColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["x" /* sparklineColor1 */],
                backgroundColor: __WEBPACK_IMPORTED_MODULE_6__functions_appColors__["w" /* sparklineBgColor */],
                fill: '-1'
            }];
        },

        /**
         * build an array of properties to display
         */
        buildProps: function buildProps() {
            var data = this.queryData;
            var properties = [];

            properties.push({
                title: 'Description',
                value: data.description
            });

            properties.push({
                title: 'Date Range',
                value: this.years[0] + '-' + this.years[1]
            });

            if (data.elevation) {
                properties.push({
                    title: 'Elevation',
                    value: data.elevation + 'm'
                });
            }

            properties.push({
                title: 'Status',
                value: data.ty
            });

            this.properties = properties;
        }
    },
    computed: {
        station: function station() {
            return this.$store.state.map.selectedStation;
        },
        name: function name() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.name;
        },
        networkUrl: function networkUrl() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.licence_link;
        },
        network: function network() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.net;
        },
        networkId: function networkId() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.nid;
        },
        type: function type() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.ty;
        },
        years: function years() {
            if (!this.queryDone) {
                return [];
            }
            return this.queryData.yr;
        },
        numYears: function numYears() {
            if (this.years.length === 2) {
                var years = this.years[1] - this.years[0];
                return years + 1;
            }
            return 0;
        },
        precipitationData: function precipitationData() {
            if (!this.queryDone) {
                return {};
            }
            return this.queryData.precipitation;
        },
        temperatureData: function temperatureData() {
            if (!this.queryDone) {
                return {};
            }
            return this.queryData.temperature;
        },
        snowData: function snowData() {
            if (!this.queryDone) {
                return {};
            }
            return this.queryData.snow_on_ground_depth;
        }
    },
    watch: {
        station: function station() {
            // re-initialize component when a new station is selected
            this.initialize();
        }
    }
});

/***/ }),

/***/ "erNo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurfaceQualityTable_vue__ = __webpack_require__("D0cP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32e8b81a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurfaceQualityTable_vue__ = __webpack_require__("NncQ");
function injectStyle (ssrContext) {
  __webpack_require__("Z5Dx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurfaceQualityTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32e8b81a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurfaceQualityTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f/OW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"24px","height":"24px","viewBox":"0 0 24 24","enable-background":"new 0 0 24 24","xml:space":"preserve"}},[_c('path',{attrs:{"fill":_vm.color,"d":"M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10c5.52,0,10-4.48,10-10C22,6.48,17.52,2,12,2z M8.209,17.479h-1.37V6.522\n    h10.954v1.371H8.209V17.479z M10.947,10.604c0,0.205-0.062,0.4-0.167,0.561l1.104,1.839c0.028-0.002,0.06-0.003,0.089-0.003\n    c0.03,0,0.062,0.001,0.09,0.003l1.104-1.839c-0.104-0.16-0.164-0.355-0.164-0.561c0-0.566,0.459-1.027,1.025-1.027\n    c0.565,0,1.027,0.461,1.027,1.027c0,0.213-0.066,0.414-0.181,0.578l1.824,3.188c0.021-0.002,0.045-0.002,0.065-0.002\n    c0.568,0,1.027,0.459,1.027,1.026c0,0.566-0.459,1.026-1.027,1.026c-0.565,0-1.027-0.46-1.027-1.026\n    c0-0.215,0.066-0.414,0.181-0.578l-1.821-3.188c-0.023,0-0.048,0-0.068,0c-0.029,0-0.062,0-0.09-0.002l-1.104,1.839\n    c0.104,0.161,0.168,0.354,0.168,0.561c0,0.566-0.463,1.027-1.028,1.027s-1.026-0.461-1.026-1.027c0-0.205,0.061-0.399,0.166-0.561\n    l-1.104-1.839C9.98,11.63,9.95,11.63,9.92,11.63c-0.566,0-1.027-0.459-1.027-1.025S9.354,9.577,9.92,9.577\n    C10.487,9.577,10.947,10.038,10.947,10.604z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f0CU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleChart_vue__ = __webpack_require__("XONj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba318824_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleChart_vue__ = __webpack_require__("uIz3");
function injectStyle (ssrContext) {
  __webpack_require__("CypH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ba318824"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba318824_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fLr5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('aside',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"map-sidebar pa-2 elevation-3 white"},[(_vm.context === 'live')?_c('div',{staticClass:"live-list"},[(_vm.filtersLoaded)?_c('map-filters',{attrs:{"filters":_vm.filters}}):_vm._e(),_vm._v(" "),(!_vm.filtersLoaded)?_c('div',{staticClass:"loading loading-filters"},[_c('span',{staticClass:"mb-1"},[_vm._v("Loading map filters")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"accent"}})],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.context === 'station')?_c('div',{staticClass:"station-details"},[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticClass:"close-button right",attrs:{"slot":"activator","icon":""},on:{"click":_vm.showLiveList},slot:"activator"},[_c('v-icon',[_vm._v("filter_list")])],1),_vm._v(" "),_c('span',[_vm._v("View filters")])],1),_vm._v(" "),_c('station-details')],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gOPW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gdcu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Watershed_vue__ = __webpack_require__("DN0E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d25ea5f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Watershed_vue__ = __webpack_require__("K+N6");
function injectStyle (ssrContext) {
  __webpack_require__("WTTq")
  __webpack_require__("qKdb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d25ea5f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Watershed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d25ea5f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Watershed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "geBB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "geYf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mapbox_gl__ = __webpack_require__("1e2d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mapbox_gl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mapbox_gl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__functions_appColors__ = __webpack_require__("QW0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__functions_labelLayer__ = __webpack_require__("KaMZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__apollo_apollo__ = __webpack_require__("YQr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_saveMapPosition__ = __webpack_require__("vPEI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_map__ = __webpack_require__("aiDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_overlapPicker__ = __webpack_require__("wnug");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_revealFeature__ = __webpack_require__("mbVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_lookupGeojsonProperties__ = __webpack_require__("AuO9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_mapStatePosition__ = __webpack_require__("9GbT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_MapContextMenu__ = __webpack_require__("lKjY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_MapboxGlMap__ = __webpack_require__("GLA1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_MapStyleSwitcher__ = __webpack_require__("VxAk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_StationsPageSidebar__ = __webpack_require__("x1Cl");








var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['query ($type: StationsFilterType!) {\n                    getStationFilters(type: $type)\n                }'], ['query ($type: StationsFilterType!) {\n                    getStationFilters(type: $type)\n                }']);

/**
 * common functions for "Monitoring Tools" pages
 * providing methods for dealing with "station" data
 * on the map, and in the vuex store
 */




// import getUniqueFeatures from '@/functions/getUniqueFeatures';



// local modules








// components





/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        MapboxGlMap: __WEBPACK_IMPORTED_MODULE_21__components_MapboxGlMap__["a" /* default */],
        StyleSwitcher: __WEBPACK_IMPORTED_MODULE_22__components_MapStyleSwitcher__["a" /* default */],
        MapSidebar: __WEBPACK_IMPORTED_MODULE_23__components_StationsPageSidebar__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_14__mixins_saveMapPosition__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__mixins_map__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__mixins_overlapPicker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__mixins_revealFeature__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__mixins_lookupGeojsonProperties__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__mixins_mapStatePosition__["a" /* default */]],
    data: function data() {
        return {
            mapZoom: 5.8,
            tooltipMarker: null,
            contextMenu: null,
            mapLayersReady: false,
            // station layer ids (so we can do loop operations on all layers)
            mapLayers: [],
            // map filters
            filters: [],
            showStyleSwitcher: false
        };
    },

    computed: {
        showingSidebar: function showingSidebar() {
            return this.$store.state.sidebar.show;
        },
        classObj: function classObj() {
            return [{
                'showing-sidebar': this.showingSidebar
            }];
        },

        // selected station feature
        selectedStation: function selectedStation() {
            return this.$store.state.map.selectedStation;
        },
        filterSettings: function filterSettings() {
            return this.$store.state.filterSettings;
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        // unload and reset map filters
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["E" /* UNLOAD_FILTERS */]);
        // reset sidebar & switch back to the live list view
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], false);
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["w" /* SET_SIDEBAR_CONTEXT */], 'live');
        // reset sidebar context and selected features
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["g" /* SELECT_STATION */], null);
        // reset vuex mapPromise to null (ie, "no map")
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["s" /* SET_MAP_PROMISE */], null);
        next();
    },
    beforeCreate: function beforeCreate() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
            var mapLoadedPromise;
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["b" /* ADD_LOADING */], 'load stations page');
                            _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["t" /* SET_MAP_SOURCE_DATA_LOADED */], false);
                            // update the mapLoaded promise in vuex
                            mapLoadedPromise = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                _this.$on('mapLoaded', function (map) {
                                    resolve(map);
                                });
                                _this.$on('mapLoadError', function (err) {
                                    reject(err);
                                });
                            });

                            _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["s" /* SET_MAP_PROMISE */], mapLoadedPromise);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    mounted: function mounted() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _this2.getLookupTables();

                        case 2:
                            // define map layers array
                            _this2.mapLayers = _this2.getMapLayersArray();

                            // add load event handlers
                            // before the sources and layers are added
                            _context2.next = 5;
                            return _this2.addLoadEventHandlers();

                        case 5:
                            _context2.next = 7;
                            return _this2.addLayers(_this2.$cfg.mapboxgl.baseStyle);

                        case 7:
                            _this2.mapLayersReady = true;

                            // set up map when station data becomes available
                            // @TODO: ensure this happens only once per map load,
                            // ...and in order
                            _context2.next = 10;
                            return _this2.initTooltip();

                        case 10:
                            _context2.next = 12;
                            return _this2.addLayerEventHandlers();

                        case 12:
                            _context2.next = 14;
                            return _this2.addViewEventHandlers();

                        case 14:
                            _context2.next = 16;
                            return _this2.loadStateFromVuex();

                        case 16:
                            _context2.next = 18;
                            return _this2.initFilters();

                        case 18:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },

    methods: {
        /**
         * process any state items queued in the "loadState" module
         * then reset all items to null
         */
        loadStateFromVuex: function loadStateFromVuex() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var loadState, map, _loadState$selectFeat, id, coords;

                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                loadState = _this3.$store.state.loadState;
                                _context3.next = 3;
                                return _this3.mapPromise;

                            case 3:
                                map = _context3.sent;


                                if (loadState.mapCenter) {
                                    map.setCenter(loadState.mapCenter);
                                }

                                if (loadState.mapZoom) {
                                    map.setZoom(loadState.mapZoom);
                                }

                                if (loadState.mapFilterSettings) {
                                    _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["k" /* SET_FILTER_SETTINGS */], loadState.mapFilterSettings);
                                }

                                // @NOTE: this will bring up the sidebar with the station title
                                // even if it's on the wrong page. As long as the payload of the loadState
                                // includes the correct page path, that shouldn't happen.
                                if (loadState.selectFeature && loadState.selectFeature.type === 'station') {
                                    _loadState$selectFeat = loadState.selectFeature, id = _loadState$selectFeat.id, coords = _loadState$selectFeat.coords;

                                    _this3.selectStation({
                                        properties: { id: id },
                                        geometry: { coordinates: coords }
                                    });
                                }

                                // clear loadState module
                                _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["e" /* RESET_LOADSTATE_ITEMS */]);

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },

        /**
         * get an array of map layer configs
         * @return {Array} formatted config array
         */
        getMapLayersArray: function getMapLayersArray() {
            var _this4 = this;

            // marker layer ids (so we can do loop operations on all layers)
            return [{
                type: 'stations',
                sourceId: 'stations-data',
                color: ['match', ['get', 'ty'], this.lookupPropertyByValue('ty', 'Historical'), String(__WEBPACK_IMPORTED_MODULE_9__functions_appColors__["l" /* markerHistorical */]), this.lookupPropertyByValue('ty', 'Current'), String(__WEBPACK_IMPORTED_MODULE_9__functions_appColors__["i" /* markerCurrent */]),
                /* other */'#ccc'],
                pointLayer: 'stations-points',
                /**
                 * callback for map sourcedata event
                 * @param  {Object} event mapbox gl sourcedata event
                 */
                sourceCallback: function sourceCallback() {
                    var source = _this4.map.getSource('stations-data');
                    if (source && _this4.map.isSourceLoaded('stations-data')) {
                        _this4.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["t" /* SET_MAP_SOURCE_DATA_LOADED */], true);
                    }
                }
            }];
        },

        /**
         * add user-defined map sources and layers
         * @param  {String}  styleUrl mapbox style URL (for ordering layers)
         */
        addLayers: function addLayers(styleUrl) {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var labelLayerId;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                labelLayerId = Object(__WEBPACK_IMPORTED_MODULE_10__functions_labelLayer__["a" /* default */])(styleUrl);

                                // add study area mask [below labels, if any]

                                _context4.next = 3;
                                return _this5.addStudyArea(labelLayerId);

                            case 3:
                                _context4.next = 5;
                                return _this5.addPointLayers(labelLayerId);

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        },

        /**
         * show tooltip with given html and coordinates
         * @param  {mapboxgl.LngLat} coordinates LngLatLike coordinates
         * @param  {String} html        tooltip HTML content
         */
        showTooltip: function showTooltip(coordinates, html) {
            var el = this.tooltipMarker.getElement();
            this.tooltipMarker.setLngLat(coordinates);
            el.innerHTML = html;
            el.classList.remove('hidden');
        },

        /**
         * hide the map tooltip
         */
        hideTooltip: function hideTooltip() {
            var el = this.tooltipMarker.getElement();
            el.classList.add('hidden');
        },

        /**
         * add study area mask polygon
         * @param  {String}  layerAbove layer id to go stack new layers (e.g. labels)
         */
        addStudyArea: function addStudyArea(layerAbove) {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
                var map;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return _this6.mapPromise;

                            case 2:
                                map = _context5.sent;


                                // add study area mask
                                map.addSource('bcwt-study-area', {
                                    type: 'geojson',
                                    data: '/static/bcwt_studyarea_split.geojson'
                                });
                                map.addLayer({
                                    id: 'bcwt-study-area',
                                    type: 'fill',
                                    source: 'bcwt-study-area',
                                    paint: {
                                        'fill-color': String(__WEBPACK_IMPORTED_MODULE_9__functions_appColors__["z" /* studyAreaMask */]),
                                        'fill-opacity': 0.65
                                    }
                                });

                                // move the layer below layerAbove, if specified
                                if (layerAbove) {
                                    map.moveLayer('bcwt-study-area', layerAbove);
                                }

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this6);
            }))();
        },

        /**
         * add mapbox sources and layers
         */
        addPointLayers: function addPointLayers(layerAbove) {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
                var map;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _this7.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["b" /* ADD_LOADING */], 'add map sources');
                                _context6.next = 3;
                                return _this7.mapPromise;

                            case 3:
                                map = _context6.sent;


                                // add split-up sources
                                _this7.mapLayers.forEach(function (_ref) {
                                    var sourceId = _ref.sourceId;

                                    // reset map source data loaded var
                                    _this7.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["t" /* SET_MAP_SOURCE_DATA_LOADED */], false);
                                    map.addSource(sourceId, {
                                        type: 'geojson',
                                        data: _this7.mapSourceUrl + '/all.geojson',
                                        buffer: 0
                                    });
                                });

                                // unclustered points layers
                                _this7.mapLayers.forEach(function (_ref2) {
                                    var pointLayer = _ref2.pointLayer,
                                        sourceId = _ref2.sourceId,
                                        color = _ref2.color;

                                    map.addLayer({
                                        id: pointLayer,
                                        type: 'circle',
                                        source: sourceId,
                                        paint: {
                                            'circle-color': color,
                                            // make circles larger as the user zooms in
                                            'circle-radius': ['interpolate', ['linear'], ['zoom'], 1, 2, 18, 6],
                                            'circle-stroke-width': ['interpolate', ['linear'], ['zoom'], 1, 1, 18, 2],
                                            'circle-stroke-color': String(__WEBPACK_IMPORTED_MODULE_9__functions_appColors__["n" /* markerStroke */])
                                        }
                                    });

                                    // move the layer below layerAbove, if specified
                                    if (layerAbove) {
                                        map.moveLayer(pointLayer, layerAbove);
                                    }
                                });

                                // add non-interactive layers to highlight the selected marker
                                map.addLayer({
                                    id: 'selected-point-bg',
                                    type: 'circle',
                                    source: _this7.getMapLayersArray()[0].sourceId,
                                    // a green circle to appear beneath the selected feature
                                    paint: {
                                        'circle-color': String(__WEBPACK_IMPORTED_MODULE_9__functions_appColors__["m" /* markerSelected */]),
                                        // make circles larger as the user zooms in
                                        'circle-radius': ['interpolate', ['linear'], ['zoom'], 1, 12, 18, 16],
                                        'circle-opacity': 0
                                    }
                                });
                                map.addLayer({
                                    id: 'selected-point',
                                    type: 'circle',
                                    source: _this7.getMapLayersArray()[0].sourceId,
                                    // same as the selected feature, but slightly larger
                                    paint: {
                                        'circle-color': _this7.getMapLayersArray()[0].color,
                                        // make circles larger as the user zooms in
                                        'circle-radius': ['interpolate', ['linear'], ['zoom'], 1, 4, 18, 8],
                                        'circle-stroke-width': 2,
                                        'circle-opacity': 0,
                                        'circle-stroke-opacity': 0,
                                        'circle-stroke-color': String(__WEBPACK_IMPORTED_MODULE_9__functions_appColors__["n" /* markerStroke */])
                                    }
                                });

                                // re-set highlighted marker (if any)
                                if (_this7.selectedStation) {
                                    _this7.updateSelectedMarker(_this7.selectedStation.id);
                                }
                                _this7.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["d" /* REMOVE_LOADING */], 'add map sources');

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this7);
            }))();
        },

        /**
         * return an array of all interactive feature layer ids
         * @return {Array} layer id strings
         */
        getInteractiveLayers: function getInteractiveLayers() {
            var featureLayers = [];
            this.mapLayers.forEach(function (l) {
                featureLayers.push(l.pointLayer);
            });
            return featureLayers;
        },

        /**
         * map loaded callback
         * @param  {mapboxgl.Map} map map object
         */
        mapLoaded: function mapLoaded(map) {
            this.map = map;

            // add navigation controls
            map.addControl(new __WEBPACK_IMPORTED_MODULE_8_mapbox_gl___default.a.NavigationControl({
                // hide rotation control
                showCompass: false
            }), 'top-left');
            // add scale control
            map.addControl(new __WEBPACK_IMPORTED_MODULE_8_mapbox_gl___default.a.ScaleControl({
                maxWidth: 75
            }));

            // fulfill promise
            this.$emit('mapLoaded', map);
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["d" /* REMOVE_LOADING */], 'load stations page');
        },

        /**
         * initialize tooltip object
         * to be controlled with showTooltip, hideTooltip
         */
        initTooltip: function initTooltip() {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
                var map, el;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return _this8.mapPromise;

                            case 2:
                                map = _context7.sent;
                                el = document.createElement('div');

                                el.classList.add('tooltip-marker');
                                el.classList.add('hidden');

                                _this8.tooltipMarker = new __WEBPACK_IMPORTED_MODULE_8_mapbox_gl___default.a.Marker(el, {
                                    offset: [72, 0]
                                }).setLngLat(map.getCenter()).addTo(map);

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this8);
            }))();
        },

        /**
         * bind listeners for map loading events
         */
        addLoadEventHandlers: function addLoadEventHandlers() {
            var _this9 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
                var map;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return _this9.mapPromise;

                            case 2:
                                map = _context8.sent;

                                // bind event listener to track when the source is loaded
                                _this9.mapLayers.forEach(function (_ref3) {
                                    var sourceCallback = _ref3.sourceCallback;

                                    map.on('sourcedata', sourceCallback);
                                });

                            case 4:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this9);
            }))();
        },

        /**
         * bind event handlers to map features
         */
        addLayerEventHandlers: function addLayerEventHandlers() {
            var _this10 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
                var map;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return _this10.mapPromise;

                            case 2:
                                map = _context9.sent;


                                // change mouse cursor on mouseover
                                _this10.getInteractiveLayers().forEach(function (layerId) {
                                    map.on('mousemove', layerId, function () {
                                        map.getCanvas().style.cursor = 'pointer';
                                    });
                                    map.on('mouseleave', layerId, function () {
                                        map.getCanvas().style.cursor = '';
                                    });
                                });

                                // show tooltip on mouseover
                                _this10.mapLayers.forEach(function (_ref4) {
                                    var pointLayer = _ref4.pointLayer;

                                    map.on('mousemove', pointLayer, function (ev) {
                                        var feature = ev.features[0];
                                        var featureCoords = feature.geometry.coordinates;
                                        // show tooltip with some useful properties
                                        _this10.showTooltip(featureCoords, '' + feature.properties.name);
                                    });
                                    map.on('mouseleave', pointLayer, function () {
                                        _this10.hideTooltip();
                                    });

                                    // update sidebar on marker click
                                    map.on('click', function (ev) {
                                        // check for fetures at click location
                                        if (ev.point) {
                                            var markerFeatures = _this10.map.queryRenderedFeatures(ev.point, {
                                                layers: _this10.getInteractiveLayers()
                                            });
                                            if (markerFeatures.length > 0) {
                                                // show the marker disambiguator if there are more than one
                                                if (markerFeatures.length > 1) {
                                                    _this10.overlapFeatures = markerFeatures;
                                                    _this10.showOverlapPicker = true;
                                                    return;
                                                }

                                                // if only one feature was clicked, select it
                                                _this10.selectStation(markerFeatures[0]);
                                            }
                                        }
                                        // don't do anything for bare map clicks
                                    });
                                });

                                // track map zoom level
                                map.on('zoom', function () {
                                    _this10.mapZoom = map.getZoom();
                                });

                            case 6:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this10);
            }))();
        },

        /**
         * update the map layer paint properties to highlight the selected feature
         * @param  {String}  markerId marker ID to highlight
         */
        updateSelectedMarker: function updateSelectedMarker(markerId) {
            var _this11 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
                var map;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return _this11.mapPromise;

                            case 2:
                                map = _context10.sent;

                                // show the selected marker in the "selected-point" layer
                                map.setPaintProperty('selected-point', 'circle-opacity', ['case', ['==', ['get', 'id'], markerId], 1, 0]);
                                map.setPaintProperty('selected-point', 'circle-stroke-opacity', ['case', ['==', ['get', 'id'], markerId], 1, 0]);
                                // show the green highlight underneath the selected marker
                                map.setPaintProperty('selected-point-bg', 'circle-opacity', ['case', ['==', ['get', 'id'], markerId], 0.5, 0]);

                            case 6:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this11);
            }))();
        },

        /**
         * bind event handlers to map view events
         * (zoom, pan, etc.)
         */
        addViewEventHandlers: function addViewEventHandlers() {
            var _this12 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
                var map;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return _this12.mapPromise;

                            case 2:
                                map = _context11.sent;


                                // update bounding box in vuex
                                map.on('moveend', function () {
                                    return _this12.calculateBounds();
                                });
                                _this12.calculateBounds(); // initial run

                                // save map position in localstorage
                                map.on('moveend', function () {
                                    _this12.saveMapPosition('bcwt');
                                });

                                // save map position in vuex
                                map.on('moveend', _this12.setMapStatePosition);

                                // show context menu on right mouse click
                                map.on('contextmenu', _this12.showContextMenu);

                            case 8:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, _this12);
            }))();
        },

        /**
         * calculate the viewport bounding box and update vuex
         */
        calculateBounds: function calculateBounds() {
            var _this13 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee12() {
                var _ref5;

                var map, bounds, bbox;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return _this13.mapPromise;

                            case 2:
                                map = _context12.sent;
                                bounds = map.getBounds().toArray();
                                // convert to bbox format for turf

                                bbox = (_ref5 = []).concat.apply(_ref5, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(bounds));

                                _this13.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["q" /* SET_MAP_BOUNDS */], bbox);

                            case 6:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, _this13);
            }))();
        },

        /**
        * create and return a Mapbox GL popup
        * @param  {mapboxgl.LngLat} lngLat     LngLatLike coordinates
        * @param  {Object} vComponent Vue component for the popup contents
        * @param  {Object} propsData  props to pass to the vue component
        * @return {mapboxgl.Popup}            Map popup object
        */
        createMapPopup: function createMapPopup(lngLat, vComponent, propsData) {
            // create (empty) map popup
            var mapboxPopup = new __WEBPACK_IMPORTED_MODULE_8_mapbox_gl___default.a.Popup({
                closeButton: false // we'll use a custom close button
            }).setLngLat(lngLat).setHTML('<div class="click-popup"></div>').addTo(this.map);

            // manually mount Popup component to the empty map popup
            var popupContentEl = mapboxPopup._content.querySelector('.click-popup'); // eslint-disable-line
            var PopupConstructor = __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].extend(vComponent);
            var PopupComponent = new PopupConstructor({
                store: this.$store,
                propsData: propsData
            }).$mount(popupContentEl);

            // remove mapbox popup on close event
            PopupComponent.$on('close', function () {
                mapboxPopup.remove();
            });

            // destroy Popup component on popup close
            // (happens any time a map popup is removed
            // including a new popup taking its place
            // and manual close events) (see: "closeOnClick")
            mapboxPopup.on('close', function () {
                PopupComponent.$destroy();
            });

            return mapboxPopup;
        },
        showContextMenu: function showContextMenu(_ref6) {
            var lngLat = _ref6.lngLat;

            if (this.contextMenu) {
                this.contextMenu.remove();
            }
            this.contextMenu = this.createMapPopup(lngLat, __WEBPACK_IMPORTED_MODULE_20__components_MapContextMenu__["a" /* default */], {
                lngLat: lngLat
            });
        },

        /**
         * return (non-reactive) Mapbox GL constructor options
         * @return {Object} map options
         */
        getMapOptions: function getMapOptions() {
            return {
                style: this.$cfg.mapboxgl.baseStyle,
                center: this.loadMapPosition('bcwt').center || [-121.2, 50.9],
                zoom: this.loadMapPosition('bcwt').zoom || 5.4,
                attributionControl: false
            };
        },

        /**
         * set the selected station feature
         * @param  {Object} station geojson feature from map query
         */
        selectStation: function selectStation(station) {
            window.gtag('event', 'Station', { action: 'select', label: 'User selected a station' });
            var id = station.properties.id;
            var coords = station.geometry.coordinates;
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["g" /* SELECT_STATION */], {
                id: id,
                coords: coords
            });
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], true);
        },
        initFilters: function initFilters() {
            var _this14 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee13() {
                var filterOptions;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return _this14.getFilterOptions();

                            case 2:
                                filterOptions = _context13.sent;

                                _this14.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["j" /* SET_FILTER_OPTIONS */], filterOptions);
                                _this14.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["l" /* SET_LOADED_FILTERS */], _this14.filters);

                            case 5:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, _this14);
            }))();
        },
        getFilterOptions: function getFilterOptions() {
            var _this15 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee14() {
                var _ref7, data;

                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _this15.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["b" /* ADD_LOADING */], 'get station filters');
                                _context14.prev = 1;
                                _context14.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_11__apollo_apollo__["a" /* apolloClient */].query({
                                    query: __WEBPACK_IMPORTED_MODULE_12_graphql_tag___default()(_templateObject),
                                    variables: {
                                        type: _this15.stationType
                                    }
                                });

                            case 4:
                                _ref7 = _context14.sent;
                                data = _ref7.data;
                                return _context14.abrupt('return', data.getStationFilters);

                            case 9:
                                _context14.prev = 9;
                                _context14.t0 = _context14['catch'](1);

                                _this15.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["D" /* TRIGGER_TOAST */], 'Error retrieving station filters');

                            case 12:
                                _context14.prev = 12;

                                _this15.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__constants_actions__["d" /* REMOVE_LOADING */], 'get station filters');
                                return _context14.finish(12);

                            case 15:
                                return _context14.abrupt('return', []);

                            case 16:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, _this15, [[1, 9, 12, 15]]);
            }))();
        },
        updateMapFilters: function updateMapFilters() {
            var _this16 = this;

            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee15() {
                var settings, mapboxFilters, map, isEmpty, expressions, _expressions, _expressions2, setting, expression, _setting, _expression, _expressions3;

                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                settings = _this16.filterSettings;
                                mapboxFilters = ['all'];
                                _context15.next = 4;
                                return _this16.mapPromise;

                            case 4:
                                map = _context15.sent;
                                isEmpty = false;

                                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(settings).forEach(function (item) {
                                    if (Array.isArray(item) && item.length === 0) {
                                        isEmpty = true;
                                    }
                                });

                                if (!isEmpty) {
                                    _context15.next = 10;
                                    break;
                                }

                                map.setFilter('stations-points', ['has', 'any']);
                                return _context15.abrupt('return');

                            case 10:

                                // network
                                if (settings.network) {
                                    expressions = settings.network.map(function (value) {
                                        var valueId = _this16.lookupPropertyByValue('net', value);
                                        return ['==', ['get', 'net'], valueId];
                                    });

                                    if (expressions.length > 0) {
                                        mapboxFilters.push(['any'].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(expressions)));
                                    } else {
                                        // if no options are selected
                                        // something to select 0 features
                                        mapboxFilters.push(['!has', 'net']);
                                    }
                                }

                                // analyses
                                if (settings.analyses) {
                                    _expressions = settings.analyses.map(function (value) {
                                        var valueString = value.toString();
                                        var ex = ['==', ['has', valueString, ['object', ['get', 'analysesObj']]], true];
                                        return ex;
                                    });

                                    if (_expressions.length > 0) {
                                        mapboxFilters.push(['any'].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_expressions)));
                                    } else {
                                        // if no options are selected
                                        // something to select 0 features
                                        mapboxFilters.push(['!has', 'analyses']);
                                    }
                                }

                                // status
                                if (settings.status) {
                                    _expressions2 = settings.status.map(function (value) {
                                        var valueId = _this16.lookupPropertyByValue('ty', value);
                                        return ['==', ['get', 'ty'], valueId];
                                    });

                                    if (_expressions2.length > 0) {
                                        mapboxFilters.push(['any'].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_expressions2)));
                                    } else {
                                        // if no options are selected
                                        // something to select 0 features
                                        mapboxFilters.push(['!has', 'ty']);
                                    }
                                }

                                // yearMin
                                if (settings.yearMin) {
                                    // station[yearMax] >= filter[yearMin]
                                    setting = settings.yearMin.value;
                                    expression = ['>=', ['to-number', // cast as number
                                    ['at', 1, ['get', 'yr']]], setting];

                                    mapboxFilters.push(expression);
                                }

                                // yearMax
                                if (settings.yearMax) {
                                    // station[yearMin] <= filter[yearMax]
                                    _setting = settings.yearMax.value;
                                    _expression = ['<=', ['to-number', // cast as number
                                    ['at', 0, ['get', 'yr']]], _setting];

                                    mapboxFilters.push(_expression);
                                }

                                // "area"
                                if (settings.area) {
                                    _expressions3 = settings.area.map(function (value) {
                                        var range = value.split('-');

                                        var _range$map = range.map(function (v) {
                                            return Number(v);
                                        }),
                                            _range$map2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_range$map, 2),
                                            min = _range$map2[0],
                                            max = _range$map2[1];

                                        return ['all',
                                        // always filter out nulls if a value is set
                                        ['!=', null, ['get', 'area']], ['>=', ['to-number', // cast to number
                                        ['get', 'area']], min], ['<=', ['to-number', // cast to number
                                        ['get', 'area']], max]];
                                    });

                                    if (_expressions3.length > 0) {
                                        mapboxFilters.push(['any'].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_expressions3)));
                                    } else {
                                        // if no options are selected
                                        // something to select 0 features
                                        mapboxFilters.push(['!has', 'area']);
                                    }
                                }

                                map.setFilter('stations-points', mapboxFilters);

                            case 17:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, _this16);
            }))();
        },

        /**
         * hide all map tools, optionally skipping one
         * to leave it open
         * @param  {String} skip variable name to skip
         */
        hideMapTools: function hideMapTools(skip) {
            var _this17 = this;

            var vars = ['showMapLegend', 'showStyleSwitcher'];
            if (skip) {
                vars = vars.filter(function (e) {
                    return e !== skip;
                });
            }
            vars.forEach(function (e) {
                _this17[e] = false;
            });
        }
    },
    watch: {
        // hide tooltip on zoom
        mapZoom: function mapZoom() {
            this.hideTooltip();
        },

        // focus on newly-selected stations
        selectedStation: function selectedStation(station) {
            if (station) {
                this.revealFeature(station);
                this.updateSelectedMarker(station.id);
            }
        },

        // update mapbox filters when filter settings change
        filterSettings: function filterSettings() {
            this.updateMapFilters();
        },

        // when a map tool is shown, hide all the others
        showMapLegend: function showMapLegend(val) {
            if (val) {
                this.hideMapTools('showMapLegend');
            }
        },

        // when a map tool is shown, hide all the others
        showStyleSwitcher: function showStyleSwitcher(val) {
            if (val) {
                this.hideMapTools('showStyleSwitcher');
            }
        }
    }
});

/***/ }),

/***/ "gmpa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClimatePrecipitation_vue__ = __webpack_require__("VOyy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75193390_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClimatePrecipitation_vue__ = __webpack_require__("cz50");
function injectStyle (ssrContext) {
  __webpack_require__("jdyK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClimatePrecipitation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75193390_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClimatePrecipitation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h326":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        downloadChart: function downloadChart() {
            var link = this.$refs.downloadUrl;
            link.download = 'chart-' + Math.round(Math.random() * 100000) + '.png';
            link.href = this.chart.canvas.toDataURL('image/png');
            link.click();
        }
    }
});

/***/ }),

/***/ "hN7P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-wrap groundwater-level-table"},[_c('scrolling-table',{staticClass:"scroll-table",attrs:{"data":_vm.scrollingTableData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hNqL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toast_vue__ = __webpack_require__("pmr1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45ca291f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toast_vue__ = __webpack_require__("JO4y");
function injectStyle (ssrContext) {
  __webpack_require__("IDfn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toast_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45ca291f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toast_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hZKn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_checkQueryData__ = __webpack_require__("ieMF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_groundQualityData__ = __webpack_require__("DMv4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_GroundwaterQualityTable__ = __webpack_require__("3GP0");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'chart-modal',
    components: {
        GwQualityTable: __WEBPACK_IMPORTED_MODULE_3__components_charts_GroundwaterQualityTable__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_checkQueryData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_groundQualityData__["a" /* default */]],
    computed: {
        show: function show() {
            return this.$store.state.showChartModal;
        },

        activeTab: {
            get: function get() {
                return this.$store.state.chartModalActiveTab;
            },
            set: function set(val) {
                this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__constants_actions__["i" /* SET_CHART_MODAL_TAB */], val);
            }
        },
        stationData: function stationData() {
            return this.queryData;
        },
        stationName: function stationName() {
            if (this.stationData) {
                return this.stationData.name;
            }
            return '';
        }
    },
    methods: {
        hide: function hide() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__constants_actions__["y" /* SHOW_CHART_MODAL */], false);
        }
    }
});

/***/ }),

/***/ "hr07":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"map-filters stations-page-filters"},[_c('v-card-title',[_c('div',{staticClass:"titlecloser"},[_c('h1',{staticClass:"headline mb-2"},[_vm._v("\n                Map Filters\n            ")]),_vm._v(" "),_c('v-btn',{staticClass:"closefilters",attrs:{"flat":"","icon":"","small":""},on:{"click":_vm.hideSidebar}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v("Use filters to refine the features shown on the map.")]),_vm._v(" "),(_vm.filterLoaded('network'))?_c('v-container',{attrs:{"fluid":""}},[_c('v-checkbox',{attrs:{"label":"Network","color":"primary","hide-details":"","indeterminate":_vm.network.length !== 0 && _vm.network.length !== _vm.networkDefault().length},model:{value:(_vm.networkCheckbox),callback:function ($$v) {_vm.networkCheckbox=$$v},expression:"networkCheckbox"}}),_vm._v(" "),_c('div',{staticClass:"fixed-height"},[_c('div',{staticClass:"h-container"},_vm._l((_vm.networkOptions),function(item){return _c('div',[_c('v-checkbox',{attrs:{"label":item.label,"value":item.value,"color":"primary","hide-details":""},model:{value:(_vm.network),callback:function ($$v) {_vm.network=$$v},expression:"network"}})],1)}))])],1):_vm._e(),_vm._v(" "),(_vm.filterLoaded('network'))?_c('v-divider',{attrs:{"inset":""}}):_vm._e(),_vm._v(" "),(_vm.filterLoaded('status'))?_c('v-container',{attrs:{"fluid":""}},[_c('p',{staticClass:"header-label"},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"fixed-height"},[_c('div',{staticClass:"h-container"},_vm._l((_vm.statusOptions),function(item){return _c('div',[_c('v-checkbox',{attrs:{"label":item.label,"value":item.value,"color":"primary","hide-details":""},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1)}))])]):_vm._e(),_vm._v(" "),(_vm.filterLoaded('status'))?_c('v-divider',{attrs:{"inset":""}}):_vm._e(),_vm._v(" "),(_vm.filterLoaded('analyses'))?_c('v-container',{attrs:{"fluid":""}},[_c('v-checkbox',{attrs:{"label":"Analyses","color":"primary","hide-details":"","indeterminate":_vm.analyses.length !== 0 && _vm.analyses.length !== _vm.analysesDefault().length},model:{value:(_vm.analysesCheckbox),callback:function ($$v) {_vm.analysesCheckbox=$$v},expression:"analysesCheckbox"}}),_vm._v(" "),_c('div',{staticClass:"fixed-height"},[_c('div',{staticClass:"h-container"},_vm._l((_vm.analysesOptions),function(item){return _c('div',[_c('v-checkbox',{attrs:{"label":item.label,"value":item.value,"color":"primary","hide-details":""},model:{value:(_vm.analyses),callback:function ($$v) {_vm.analyses=$$v},expression:"analyses"}})],1)}))])],1):_vm._e(),_vm._v(" "),(_vm.filterLoaded('analyses'))?_c('v-divider',{attrs:{"inset":""}}):_vm._e(),_vm._v(" "),(_vm.filterLoaded('area'))?_c('v-container',{attrs:{"fluid":""}},[_c('v-checkbox',{attrs:{"label":"Area","color":"primary","hide-details":"","indeterminate":_vm.area.length !== 0 && _vm.area.length !== _vm.areaDefault().length},model:{value:(_vm.areaCheckbox),callback:function ($$v) {_vm.areaCheckbox=$$v},expression:"areaCheckbox"}}),_vm._v(" "),_c('div',{staticClass:"fixed-height"},[_c('div',{staticClass:"h-container"},_vm._l((_vm.areaOptions),function(item){return _c('div',[_c('v-checkbox',{attrs:{"label":item.label,"value":item.value,"color":"primary","hide-details":""},model:{value:(_vm.area),callback:function ($$v) {_vm.area=$$v},expression:"area"}})],1)}))])],1):_vm._e(),_vm._v(" "),(_vm.filterLoaded('area'))?_c('v-divider',{attrs:{"inset":""}}):_vm._e(),_vm._v(" "),(_vm.filterLoaded('yearMin') && _vm.filterLoaded('yearMax'))?_c('v-container',{staticStyle:{"display":"flex","flex-direction":"row"},attrs:{"fluid":""}},[_c('v-flex',{staticStyle:{"padding-right":"15px"}},[_c('h2',{staticClass:"subheading"},[_vm._v("Year (min.)")]),_vm._v(" "),(_vm.filterLoaded('yearMin'))?_c('v-select',{attrs:{"items":_vm.yearOptions,"item-text":"label","return-object":"","solo":""},on:{"input":function (s) { return _vm.yearChanged('yearMin', s); }},model:{value:(_vm.yearMin),callback:function ($$v) {_vm.yearMin=$$v},expression:"yearMin"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',[_c('h2',{staticClass:"subheading"},[_vm._v("Year (max.)")]),_vm._v(" "),(_vm.filterLoaded('yearMax'))?_c('v-select',{attrs:{"items":_vm.yearOptions,"item-text":"label","return-object":"","solo":""},on:{"input":function (s) { return _vm.yearChanged('yearMax', s); }},model:{value:(_vm.yearMax),callback:function ($$v) {_vm.yearMax=$$v},expression:"yearMax"}}):_vm._e()],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"secondary"},on:{"click":_vm.reset}},[_vm._v("Reset filters")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "htoR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_map__ = __webpack_require__("aiDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__functions_sortByKey__ = __webpack_require__("HvOn");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'map-filters',
    mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_map__["a" /* default */]],
    data: function data() {
        return {
            network: [],
            networkOptions: [],

            status: [],
            statusOptions: [],

            type: [],
            typeOptions: [],

            purpose: [],
            purposeOptions: [],

            quantity: [],
            quantityOptions: [],

            filterKey: '',
            filterDialog: false,
            filterDialogSaved: false
        };
    },

    // load options and set values
    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
            var map;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.mapPromise;

                        case 2:
                            map = _context.sent;


                            // Load current filters when stations layer is initialized
                            map.on('style.load', function () {
                                var waiting = function waiting() {
                                    if (map.getLayer('licenceData-points') === undefined) {
                                        setTimeout(waiting, 25);
                                    } else {
                                        _this.setFormValues();
                                    }
                                };
                                waiting();
                            });
                            _this.initialize();

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },

    computed: {
        networkCheckbox: {
            get: function get() {
                return this.network.length !== 0;
            },
            set: function set() {
                if (this.network.length === this.networkDefault().length) {
                    this.clearFilter('network');
                } else {
                    this.resetFilter('network');
                }
            }
        },
        statusCheckbox: {
            get: function get() {
                return this.status.length !== 0;
            },
            set: function set() {
                if (this.status.length === this.statusDefault().length) {
                    this.clearFilter('status');
                } else {
                    this.resetFilter('status');
                }
            }
        },
        typeCheckbox: {
            get: function get() {
                return this.type.length !== 0;
            },
            set: function set() {
                if (this.type.length === this.typeDefault().length) {
                    this.clearFilter('type');
                } else {
                    this.resetFilter('type');
                }
            }
        },
        purposeCheckbox: {
            get: function get() {
                return this.purpose.length !== 0;
            },
            set: function set() {
                if (this.purpose.length === this.purposeDefault().length) {
                    this.clearFilter('purpose');
                } else {
                    this.resetFilter('purpose');
                }
            }
        },
        quantityCheckbox: {
            get: function get() {
                return this.quantity.length !== 0;
            },
            set: function set() {
                if (this.quantity.length === this.quantityDefault().length) {
                    this.clearFilter('quantity');
                } else {
                    this.resetFilter('quantity');
                }
            }
        },
        filterUrl: function filterUrl() {
            return 'localhost:8080/?term=' + this.filterKey;
        },

        // array of loaded filter names
        loadedFilters: function loadedFilters() {
            return this.$store.state.loadedFilters;
        },

        // options and ranges for filter dropdowns
        filterOptions: function filterOptions() {
            return this.$store.state.filterOptions;
        },

        // currently-set filters
        savedSettings: function savedSettings() {
            return this.$store.state.filterSettings;
        }
    },
    methods: {
        /**
         * (re-)initialize form fields
         */
        initialize: function initialize() {
            this.setOptions();
            this.setFormValues();
        },

        // used for the close button beside the card title.
        hideSidebar: function hideSidebar() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], false);
        },

        /**
         * populate form fields with filter options
         */
        setOptions: function setOptions() {
            // cheap deep clone filterOptions from vuex
            // so it can be sorted
            var options = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.filterOptions));
            var sortLabels = Object(__WEBPACK_IMPORTED_MODULE_7__functions_sortByKey__["a" /* default */])('label');
            // sort all option values alphabetically by label
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(options).forEach(function (option) {
                var _option = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(option, 2),
                    key = _option[0],
                    val = _option[1];

                // don't sort "quantity" options


                if (key === 'quantity') return;

                // sort array members
                options[key] = val.sort(sortLabels);
            });

            // set network options
            if (options.net) {
                this.networkOptions = options.net;
            }

            // set status options
            if (options.st) {
                this.statusOptions = options.st;
            }

            // set type options
            if (options.type) {
                this.typeOptions = options.type;
            }

            // set purpose options
            if (options.purpose) {
                this.purposeOptions = options.purpose;
            }

            // set purpose options
            if (options.quantity) {
                this.quantityOptions = options.quantity;
            }
        },

        /**
         * set form feld values to current/default settings
         */
        setFormValues: function setFormValues() {
            if (this.filterLoaded('network')) {
                this.network = this.getFilterValue('network') || this.networkDefault();
            }
            if (this.filterLoaded('status')) {
                this.status = this.getFilterValue('status') || this.statusDefault();
            }
            if (this.filterLoaded('type')) {
                this.type = this.getFilterValue('type') || this.typeDefault();
            }
            if (this.filterLoaded('purpose')) {
                this.purpose = this.getFilterValue('purpose') || this.purposeDefault();
            }
            if (this.filterLoaded('quantity')) {
                this.quantity = this.getFilterValue('quantity') || this.quantityDefault();
            }
        },

        /**
         * reset filters to their default settings
         */
        reset: function reset() {
            // reset locally
            if (this.filterLoaded('network')) {
                this.network = this.networkDefault();
            }
            if (this.filterLoaded('status')) {
                this.status = this.statusDefault();
            }
            if (this.filterLoaded('type')) {
                this.type = this.typeDefault();
            }
            if (this.filterLoaded('purpose')) {
                this.purpose = this.purposeDefault();
            }
            if (this.filterLoaded('quantity')) {
                this.quantity = this.quantityDefault();
            }
            // update vuex
            this.updateStore();
        },

        /**
         * handle any special cases and update vuex
         * @param  {String}  name          filter name
         * @param  {Object|Array}  val     new filter value
         * @param  {Boolean} [update=true] whether to update vuex
         */
        filterChanged: function filterChanged(name, val) {
            var update = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            if (update) {
                this.updateStore();
            }
        },

        /**
         * persist an object of filter settings to vuex
         * the map page itself will handle the actual filtering
         */
        updateStore: function updateStore() {
            var currentSettings = {};
            // only add if the filter isn't set to its default
            // @TODO: a testDefault method (can use to display if a filter is "set" or not)
            if (this.network.length !== this.networkDefault().length) {
                currentSettings.network = this.network;
            }
            if (this.status.length !== this.statusDefault().length) {
                currentSettings.status = this.status;
            }
            if (this.type.length !== this.typeDefault().length) {
                currentSettings.type = this.type;
            }
            if (this.purpose.length !== this.purposeDefault().length) {
                currentSettings.purpose = this.purpose;
            }
            if (this.quantity.length !== this.quantityDefault().length) {
                currentSettings.quantity = this.quantity;
            }
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["k" /* SET_FILTER_SETTINGS */], currentSettings);
        },
        resetFilter: function resetFilter(filter) {
            this[filter] = this[filter + 'Default']();
        },
        clearFilter: function clearFilter(filter) {
            this[filter] = [];
        },
        close: function close() {
            this.filterDialog = false;
            this.filterDialogSaved = false;
            this.filterKey = '';
        },

        /**
         * return saved filter values from vuex
         * @param  {String} name         filter name
         * @return {Object|Array|null}   filter value, or null if not set in vuex
         */
        getFilterValue: function getFilterValue(name) {
            if (this.savedSettings[name]) {
                return this.savedSettings[name];
            }
            return null;
        },

        /**
         * returns true if the filter is loaded on the current page
         * @param  {String} name filter name
         * @return {Boolean}     true if loaded in vuex
         */
        filterLoaded: function filterLoaded(name) {
            return this.loadedFilters.includes(name);
        },

        // default filter values
        networkDefault: function networkDefault() {
            return this.filterOptions.net.map(function (e) {
                return e.value;
            });
        },
        statusDefault: function statusDefault() {
            return this.filterOptions.st.map(function (e) {
                return e.value;
            });
        },
        typeDefault: function typeDefault() {
            return this.filterOptions.type.map(function (e) {
                return e.value;
            });
        },
        purposeDefault: function purposeDefault() {
            return this.filterOptions.purpose.map(function (e) {
                return e.value;
            });
        },
        quantityDefault: function quantityDefault() {
            return this.filterOptions.quantity.map(function (e) {
                return e.value;
            });
        }
    },
    watch: {
        network: function network() {
            this.filterChanged('type', 'network');
        },
        status: function status() {
            this.filterChanged('type', 'status');
        },
        type: function type() {
            this.filterChanged('type', 'type');
        },
        purpose: function purpose() {
            this.filterChanged('type', 'purpose');
        },
        quantity: function quantity() {
            this.filterChanged('type', 'quantity');
        },

        // re-initialize if the list of loaded filters changes
        loadedFilters: function loadedFilters() {
            this.initialize();
        },

        // re-initialize if the filter options changes
        filterOptions: function filterOptions() {
            this.initialize();
        }
    }
});

/***/ }),

/***/ "hxIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_stationsPage__ = __webpack_require__("geYf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_mapLegend__ = __webpack_require__("6Tn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ChartModalStreamflow__ = __webpack_require__("RtwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MapSaveButton__ = __webpack_require__("e5y2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// mixins






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'StreamflowPage',
    components: {
        ChartModal: __WEBPACK_IMPORTED_MODULE_2__components_ChartModalStreamflow__["a" /* default */],
        MapSaveButton: __WEBPACK_IMPORTED_MODULE_3__components_MapSaveButton__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_stationsPage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_mapLegend__["a" /* default */]],
    data: function data() {
        return {
            name: 'streamflow',
            mapSourceUrl: this.$cfg.API_URL + '/stations/streamflow',
            stationType: 'STREAMFLOW',
            filters: ['network', 'status', 'area', 'analyses', 'yearMin', 'yearMax'],
            showMapSave: false
        };
    }
});

/***/ }),

/***/ "iSqZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Climate_vue__ = __webpack_require__("+rz5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04c2f939_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Climate_vue__ = __webpack_require__("6S68");
function injectStyle (ssrContext) {
  __webpack_require__("MqQW")
  __webpack_require__("IA+h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04c2f939"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Climate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04c2f939_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Climate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ieMF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * methods for checking if query data exists
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            checkClimateDataFields: {
                precipitation: {
                    current: ['v'],
                    historical: ['p10', 'p25', 'p50', 'p75', 'p90']
                },
                snow_on_ground_depth: {
                    current: ['v'],
                    historical: ['p10', 'p25', 'a', 'p75', 'p90']
                },
                snow_water_equivalent: {
                    current: ['v'],
                    historical: ['p10', 'p25', 'a', 'p75', 'p90']
                },
                manual_snow_survey: {
                    current: ['v'],
                    historical: ['p10', 'p25', 'p50', 'p75', 'p90']
                },
                temperature: {
                    current: ['min', 'max'],
                    historical: ['maxavg', 'maxp90', 'minavg', 'minp10']
                }
            },
            checkGroundLevelDataFields: {
                hydrograph: {
                    current: ['v'],
                    historical: ['a', 'max', 'min', 'p25', 'p75']
                }
            },
            checkStreamflowDataFields: {
                monthly_mean_flow: {
                    current: ['avg', 'm', 'max', 'min'],
                    yearly: ['days', 'full_month', 'm', 'qa', 'v', 'year']
                },
                seven_day_flow: {
                    current: ['v'],
                    historical: ['max', 'min', 'p25', 'p50', 'p75']
                },
                stage: {
                    current: ['v'],
                    historical: ['max', 'min', 'p25', 'a', 'p75']
                }
            }
        };
    },

    methods: {
        /**
         * check a single dataset for any non-null values
         * @param  {Array}  dataSet array of data point objects
         * @param  {Array}  fields  array of field names to check
         * @return {Boolean}        true if any field has a non-null value
         */
        checkSingleDataset: function checkSingleDataset(dataSet, fields) {
            var hasData = dataSet.some(function (row) {
                var rowHasData = fields.some(function (field) {
                    return row[field] !== null;
                });
                return rowHasData;
            });
            return hasData;
        },

        /**
         * check one type of data for current and/or historical data
         * @param  {Object} data       data object
         * @param  {String} datasetKey key within the data object
         * @param  {Object} dataField  object with historical & current field names
         * @return {Boolean}        true if any field has a non-null value
         */
        checkChartData: function checkChartData(data, datasetKey, dataField) {
            var _this = this;

            var queryData = data && data[datasetKey];
            // if the data is null or the key doesn't exist
            if (!queryData) {
                return false;
            }

            var hasData = ['historical', 'current'].some(function (type) {
                var dataset = queryData[type];
                var fields = dataField[type];
                if (dataset === undefined) {
                    return false;
                }

                return _this.checkSingleDataset(dataset, fields);
            });
            return hasData;
        }
    }
});

/***/ }),

/***/ "jHET":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-wrap monthly-mean-flow-table"},[_c('scrolling-table',{staticClass:"scroll-table",attrs:{"data":_vm.scrollingTableData}}),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footnotes"},[_c('p',[_vm._v("* Incomplete and Unverified Data")]),_vm._v(" "),_c('p',[_vm._v("(n) Incomplete month. Number of days used in average.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jdyK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jlXn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mapbox-gl-map",attrs:{"id":_vm.id}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mapboxgl-ctrl mapboxgl-ctrl-attrib mapboxgl-ctrl-bottom-right",staticStyle:{"position":"fixed","bottom":"0"},attrs:{"id":"attribution"}},[_c('div',{staticClass:"mapboxgl-ctrl mapboxgl-ctrl-attrib"},[_c('a',{attrs:{"href":"https://www.mapbox.com/about/maps/","target":"_blank"}},[_vm._v("© Mapbox")]),_vm._v("  | \n            "),_c('a',{attrs:{"href":"https://www.openstreetmap.org/about/","target":"_blank"}},[_vm._v("© OpenStreetMap")]),_vm._v("  | \n            "),_c('a',{attrs:{"target":"_blank","href":"https://www.foundryspatial.com/"}},[_vm._v("Foundry Spatial "),_c('img',{staticStyle:{"margin":"-3px -3px -3px 2px","width":"15px"},attrs:{"src":__webpack_require__("x1YK")}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jtHw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k6pS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline primary white--text"},[_vm._t("header",[_vm._v("\n                "+_vm._s(_vm.numFeatures)+" features at these coordinates\n            ")],{numFeatures:_vm.numFeatures})],2),_vm._v(" "),_c('v-card-text',[_c('v-list',[_vm._l((_vm.features),function(feature,index){return [_c('v-list-tile',{key:feature.properties.id,attrs:{"avatar":"","ripple":""},on:{"click":function($event){_vm.select(feature)}}},[_c('v-list-tile-content',[_vm._t("listItem",[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(feature.properties.name)}})],{feature:feature})],2)],1),_vm._v(" "),(index + 1 < _vm.features.length)?_c('v-divider',{key:index}):_vm._e()]})],2)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.hide($event)}}},[_vm._v("Cancel")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kKz8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_mutations__ = __webpack_require__("cLT6");


var _mutations, _actions;




/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        // sidebar component visibility
        show: false,
        // sidebar context mode:
        // - 'live' = live list of (filtered) stations on the map
        // - 'station' = single station info
        // - 'watershed' = single watershed info
        // - 'licence' = single water licence info
        context: 'live'
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants_mutations__["A" /* SHOW_MAP_SIDEBAR */], function (state) {
        var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        state.show = show;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants_mutations__["w" /* SET_SIDEBAR_CONTEXT */], function (state, context) {
        state.context = context;
    }), _mutations),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], function (_ref, show) {
        var commit = _ref.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["A" /* SHOW_MAP_SIDEBAR */], show);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["w" /* SET_SIDEBAR_CONTEXT */], function (_ref2, context) {
        var commit = _ref2.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["w" /* SET_SIDEBAR_CONTEXT */], context);
    }), _actions)
});

/***/ }),

/***/ "kMCa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarStationGroundLevel_vue__ = __webpack_require__("kev0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cc0c8dd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarStationGroundLevel_vue__ = __webpack_require__("4qPv");
function injectStyle (ssrContext) {
  __webpack_require__("geBB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cc0c8dd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarStationGroundLevel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cc0c8dd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarStationGroundLevel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kNz+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scroll_sync__ = __webpack_require__("Am4t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scroll_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_scroll_sync__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            yCount: 15,
            busy: false
        };
    },

    components: {
        ScrollSync: __WEBPACK_IMPORTED_MODULE_1_vue_scroll_sync___default.a
    },
    computed: {
        paginatedData: function paginatedData() {
            if (this.data.length <= this.yCount) {
                return this.data;
            }
            return this.data.slice(0, this.yCount);
        },
        hasData: function hasData() {
            if (this.data.length > 0 && this.data[0].length > 0) {
                return true;
            }

            return false;
        }
    },
    updated: function updated() {
        this.resizeHeaderCells();
    },
    mounted: function mounted() {
        var _this = this;

        // resize header cells on window resize
        window.addEventListener('resize', this.resizeHeaderCells());

        // resize header cells after the table's initial render
        this.$nextTick(function () {
            _this.resizeHeaderCells();
        });
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.resizeHeaderCells());
    },

    methods: {
        loadMoreY: function loadMoreY() {
            this.yCount += 15;
        },
        cellStyle: function cellStyle(cell) {
            var styles = {};
            if (cell.color) {
                styles.backgroundColor = cell.color;
            }
            return styles;
        },
        resizeHeaderCells: function resizeHeaderCells() {
            if (!this.hasData) {
                return;
            }

            // reset anything already resized
            var resizedCells = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$el.querySelectorAll('.scrolling-table-resized'));
            resizedCells.forEach(function (el) {
                el.style.removeProperty('width');
                el.style.removeProperty('height');
                el.classList.remove('scrolling-table-resized');
            });

            var leftCol = this.$el.querySelector('.left-column');
            var tableRows = this.$el.querySelectorAll('.table tr');

            // resize header "columns"
            var firstTableRow = tableRows[0];
            var firstTableRowCells = firstTableRow.querySelectorAll('td');
            var headerRow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$el.querySelectorAll('.headers > .cell:not(.spacer)'));
            headerRow.forEach(function (td, i) {
                // resize left column header
                if (i === 0) {
                    var _colWidth = leftCol.offsetWidth;
                    td.style.width = _colWidth + 'px';
                    return;
                }

                var tableCell = firstTableRowCells[i - 1];
                var colWidth = tableCell.offsetWidth;
                var headerWidth = td.offsetWidth;
                // resize the column or the header cell, depending on which is wider
                if (colWidth > headerWidth) {
                    // add !importantt because ie gives incorrect prcedence to the stylesheet over the inline styles
                    td.classList.add('scrolling-table-resized');
                    td.style.width = colWidth + 'px';
                } else if (colWidth < headerWidth) {
                    // add !importantt because ie gives incorrect prcedence to the stylesheet over the inline styles
                    tableCell.classList.add('scrolling-table-resized');
                    tableCell.querySelector('.tabel-cell-inner').style.width = headerWidth + 'px';
                }
            });

            // resize left column "rows"
            var leftColCells = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(leftCol.querySelectorAll('.cell:not(.spacer)'));
            leftColCells.forEach(function (tr, i) {
                var tableRow = tableRows[i];
                var rowHeight = tableRow.offsetHeight;
                var leftCellHeight = tr.offsetHeight;
                // resize the row or left col cell depending on which is taller
                if (rowHeight > leftCellHeight) {
                    tr.classList.add('scrolling-table-resized');
                    tr.style.height = rowHeight + 'px';
                } else if (rowHeight < leftCellHeight) {
                    tableRow.classList.add('scrolling-table-resized');
                    tableRow.style.height = leftCellHeight + 'px';
                }
            });

            var topCorner = this.$el.querySelector('.top-corner');
            topCorner.classList.add('scrolling-table-resized');
            topCorner.style.width = leftColCells[0].offsetWidth + 'px';
            topCorner.style.height = headerRow[0].offsetHeight + 'px';
        }
    }
});

/***/ }),

/***/ "kev0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pluralize__ = __webpack_require__("DbJJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pluralize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pluralize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_checkQueryData__ = __webpack_require__("ieMF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_groundLevelData__ = __webpack_require__("djs4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_getStationMetadata__ = __webpack_require__("s6bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SidebarSparkline__ = __webpack_require__("XFj9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DownloadCsvButton__ = __webpack_require__("l2MX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// components



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'station-details-gw-level',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_checkQueryData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_groundLevelData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_getStationMetadata__["a" /* default */]],
    components: {
        SparkLine: __WEBPACK_IMPORTED_MODULE_5__components_SidebarSparkline__["a" /* default */],
        DownloadCsvButton: __WEBPACK_IMPORTED_MODULE_6__components_DownloadCsvButton__["a" /* default */]
    },
    computed: {
        stationId: function stationId() {
            return this.station.id;
        }
    },
    methods: {
        pluralize: function pluralize(term, num) {
            return __WEBPACK_IMPORTED_MODULE_0_pluralize___default()(term, num);
        },
        showChartModal: function showChartModal(tabName) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__constants_actions__["i" /* SET_CHART_MODAL_TAB */], tabName);
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__constants_actions__["y" /* SHOW_CHART_MODAL */], true);
        }
    }
});

/***/ }),

/***/ "kuBH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlowDurationCurve_vue__ = __webpack_require__("VAnR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f03b2a2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlowDurationCurve_vue__ = __webpack_require__("MFnw");
function injectStyle (ssrContext) {
  __webpack_require__("OTPV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlowDurationCurve_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f03b2a2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlowDurationCurve_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l2MX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadCsvButton_vue__ = __webpack_require__("oYoW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27deffa8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadCsvButton_vue__ = __webpack_require__("+/bs");
function injectStyle (ssrContext) {
  __webpack_require__("vHb6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadCsvButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27deffa8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadCsvButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l6B8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




/**
 * format the trimmed dataset for use in chart
 * @param {String} year
 * @param color
 * @param {Array} trimmedData
 * @returns {Object}
 */
var formatDataset = function formatDataset(year, color, trimmedData) {
    var dataset = {
        type: 'line',
        label: year,
        borderColor: color(year),
        backgroundColor: color(year),
        borderWidth: 2,
        fill: false,
        // steppedLine: 'before',
        pointRadius: 0,
        pointHitRadius: 1,
        data: trimmedData.map(function (d) {
            return {
                x: d.d,
                y: d.v
            };
        })
    };
    return dataset;
};

/**
 * trim the years data to the appropriate period
 * @param {Moment} periodStart
 * @param {Moment} periodEnd
 * @param {Array} dataYears
 * @return {Array}
 */
var trimArrayToPeriod = function trimArrayToPeriod(periodStart, periodEnd, dataYears) {
    var startIndex = dataYears.findIndex(function (e) {
        return e.d.isSame(periodStart);
    });
    var endIndex = dataYears.findIndex(function (e) {
        return e.d.isSame(periodEnd);
    });
    return dataYears.slice(startIndex, endIndex);
};

/**
 * get the period end, it is different if interval is month or day
 * @param {String} interval
 * @param {Moment} periodStart
 * @return {Moment}
 */
function getPeriodEnd(interval, periodStart) {
    if (interval === 'm') {
        return periodStart.clone().add(19, 'months');
    }
    return periodStart.clone().add(19, 'months').subtract(1, 'days');
}

/**
 * format 365-day yearly data into 18-month chart datasets
 * @param {Object} yearlyData
 * @param {Array} yearsSelected
 * @param {Function} formatterFunc
 * @param {String} interval
 * @param {Boolean} mss "true" if the datasets need to be split as per Manual Snow Surveys
 * @return {Array} formatted chart.js datasets
 */
/* harmony default export */ __webpack_exports__["a"] = (function (yearlyData, yearsSelected, formatterFunc, interval) {
    var mss = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    var formattedDatasets = [];
    var lastYear = __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, 'years').get('year');
    var color = __WEBPACK_IMPORTED_MODULE_1_d3__["t" /* scaleOrdinal */](__WEBPACK_IMPORTED_MODULE_1_d3__["v" /* schemeCategory10 */]);
    // add data that is both selected and downloaded
    var yearsToAdd = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(yearlyData).filter(function (e) {
        return yearsSelected.includes(parseInt(e, 10));
    });
    yearsToAdd.forEach(function (year) {
        // format data with date objects
        // the first of this month, last year
        var currentMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('MM');
        var periodStart = __WEBPACK_IMPORTED_MODULE_2_moment___default()(lastYear + '-' + currentMonth + '-01');

        // period start + 19 months, - 1 day (end of 18 months later)
        var periodEnd = getPeriodEnd(interval, periodStart);

        var singleYearData = yearlyData[year];
        var yearStart = __WEBPACK_IMPORTED_MODULE_2_moment___default()(lastYear + '-01-01');
        var formattedData = formatterFunc(singleYearData, yearStart);
        // trim the array to just this 18-month period
        var trimmedData = trimArrayToPeriod(periodStart, periodEnd, formattedData);

        if (interval === 'm') {
            // make the line graphs peaks and valleys fall in the "middle" of the month
            // because they are being overlaid on bar charts.
            // 15 technically isn't the exact middle but it's good enough.
            trimmedData.forEach(function (v) {
                v.d.add(15, 'days');
            });
        }

        if (mss) {
            // excise the contiguous dates for July 1 (61) to October 31 (183)
            formattedDatasets.push(formatDataset(year, color, trimmedData.splice(0, 61)));
            formattedDatasets.push(formatDataset(year, color, trimmedData.splice(183)));
        } else {
            // create chart.js dataset
            formattedDatasets.push(formatDataset(year, color, trimmedData));
        }
    });

    return formattedDatasets;
});

/***/ }),

/***/ "lD6Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ScrollingTable__ = __webpack_require__("92Dq");


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['query stationChemTable($id: Int!) {\n                getStation(id: $id) {\n                    chemistry {\n                        table\n                    }\n                }\n            }'], ['query stationChemTable($id: Int!) {\n                getStation(id: $id) {\n                    chemistry {\n                        table\n                    }\n                }\n            }']);

//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ScrollingTable: __WEBPACK_IMPORTED_MODULE_2__components_ScrollingTable__["a" /* default */]
    },
    computed: {
        stationId: function stationId() {
            var station = this.$store.state.map.selectedStation;
            if (!station) {
                return null;
            }
            return station.id;
        }
    },
    apollo: {
        tableData: {
            query: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject),
            variables: function variables() {
                return {
                    id: this.stationId
                };
            },
            update: function update(data) {
                var formatted = data.getStation.chemistry.table;
                return formatted;
            }
        }
    }
});

/***/ }),

/***/ "lIcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"annual-runoff-chart"},[_c('svg',{attrs:{"id":"flow-duration-annual-runoff","width":_vm.svgWidth,"height":_vm.svgHeight}},[_c('g',{staticClass:"chart",attrs:{"transform":("translate(" + (_vm.margin.left) + "," + (_vm.margin.top) + ")")}})]),_vm._v(" "),(_vm.tooltipVisible)?_c('chart-tooltip',{attrs:{"top":_vm.tooltipPosition[1],"left":_vm.tooltipPosition[0],"content":_vm.tooltipText}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lKjY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapContextMenu_vue__ = __webpack_require__("HHov");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6cc8b2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapContextMenu_vue__ = __webpack_require__("6bpK");
function injectStyle (ssrContext) {
  __webpack_require__("xDKa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapContextMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6cc8b2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapContextMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lKsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"800"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('v-card',{staticClass:"disclaimer-modal"},[_c('v-card-text',{staticClass:"body"},[_c('img',{staticClass:"mof-logo",attrs:{"src":"/static/bcf.svg","alt":"Ministry of Forests"}}),_vm._v(" "),_c('h2',{staticClass:"headline mb-3"},[_vm._v("Disclaimer")]),_vm._v(" "),_c('p',[_vm._v("\n                The BC Water Tool presents data from a variety of sources related to water resource management. This includes hydrology information derived from hydrological modeling, which contains inherent uncertainty, monitoring data which may contain errors or inaccuracies, and digital representations of water rights which may be inaccurate or incomplete.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n                The water supply information from hydrology models represents 30-year ‘normal’ or average conditions, and will generally be different from the hydrology measured or observed at any point in time. Model accuracy performance statistics are provided within the reports generated by the BC Water Tool. Users should be aware the predictions for small watersheds (generally smaller than 50 sq. km.) may be less accurate due to the lack of hydrometric data available for small watersheds.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n                The short term water use and water licence information for existing water rights and use approvals is derived from digital data contained in government databases, and may not represent fully the information contained in individual water use approval or water license documents. In all cases the legal documents should be relied upon where discrepancies exist.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n                Some of the monitoring data presented here have undergone a formal review and assessment process by the custodian prior to publishing, but others have not. Current year stream discharge values in particular should be considered as provisional.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n                Wherever possible, the custodian responsible for collecting and managing the data has been identified, and this custodian is the primary contact for any questions regarding the accuracy, QA methods, or any other issue related to data quality.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n                It is the responsibility of all persons who use this site to independently confirm the accuracy of the data, information, or results obtained through the use of this site, should it be necessary for the user’s purpose. Users requiring access to raw data for their own analysis should acquire such data from the relevant data custodian, to ensure that any revisions or changes made by the custodian are reflected in the data, and that any provisions, caveats, or notes accompanying the raw data can be provided for consideration.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n                No warranty of quality, accuracy, or completeness of any information, data or product from these web pages is made. No liability or blame for loss or damages incurred by any person or business entity based on the use of the site is accepted. It is provided 'AS IS' without warranty or condition of any nature. No guarantee of any kind is expressed or implied.\n            ")]),_vm._v(" "),_c('hr',{staticClass:"my-2"}),_vm._v(" "),_c('p',[_vm._v("\n                Proceeding beyond this Disclaimer will constitute your acceptance of the terms and conditions outlined above.\n            ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){_vm.disagree($event)}}},[_vm._v("Disagree")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.agree($event)}}},[_vm._v("Agree")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lg2u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mWem":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_stationsPage__ = __webpack_require__("geYf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_mapLegend__ = __webpack_require__("6Tn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ChartModalGwLevel__ = __webpack_require__("QU/y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MapSaveButton__ = __webpack_require__("e5y2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// mixins






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'GroundwaterLevelPage',
    components: {
        ChartModal: __WEBPACK_IMPORTED_MODULE_2__components_ChartModalGwLevel__["a" /* default */],
        MapSaveButton: __WEBPACK_IMPORTED_MODULE_3__components_MapSaveButton__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_stationsPage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_mapLegend__["a" /* default */]],
    data: function data() {
        return {
            name: 'ground water level',
            mapSourceUrl: this.$cfg.API_URL + '/stations/groundwater-level',
            stationType: 'GROUND_WATER_LEVEL',
            filters: ['network', 'status', 'yearMin', 'yearMax'],
            showMapSave: false
        };
    }
});

/***/ }),

/***/ "mZW9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-draw"},[_c('div',{staticClass:"mapboxgl-ctrl mapboxgl-ctrl-group map-draw-control",attrs:{"id":"map-draw-button"},on:{"click":_vm.togglePolygon}},[_c('v-tooltip',{attrs:{"right":""}},[_c('button',{attrs:{"slot":"activator","type":"button"},slot:"activator"},[_c('v-icon',{staticClass:"mbgl-color"},[_vm._v("crop_free")])],1),_vm._v(" "),_c('span',[_vm._v("Bulk Download")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mbVp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__turf_bbox_polygon__ = __webpack_require__("UzRZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_map__ = __webpack_require__("aiDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__turf_boolean_within__ = __webpack_require__("ZL0r");





/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_map__["a" /* default */]],
    methods: {
        /**
         * move the map to focus on the selected feature
         * @param  {Object} feature feature object with coords
         */
        revealFeature: function revealFeature(feature) {
            if (!this.map) {
                return;
            }

            var newPosition = {};

            // move the map if the feature is outside be viewport
            var bbox = this.$store.state.map.bbox;

            var _feature$coords = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(feature.coords, 2),
                lng = _feature$coords[0],
                lat = _feature$coords[1];

            var featureGeojson = {
                type: 'Feature',
                properties: {},
                geometry: {
                    type: 'Point',
                    coordinates: [lng, lat]
                }
            };
            var mapBounds = Object(__WEBPACK_IMPORTED_MODULE_1__turf_bbox_polygon__["a" /* default */])(bbox);
            // zoom in if the zoom is < 11
            var currentZoom = this.map.getZoom();
            if (currentZoom < 11 || !Object(__WEBPACK_IMPORTED_MODULE_3__turf_boolean_within__["a" /* default */])(featureGeojson, mapBounds)) {
                newPosition.center = feature.coords;
                newPosition.zoom = currentZoom < 11 ? 11 : currentZoom;
            }

            this.map.flyTo(newPosition);
        }
    }
});

/***/ }),

/***/ "mj8Y":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "el6m",
	"./af.js": "el6m",
	"./ar": "k/LX",
	"./ar-dz": "8sQJ",
	"./ar-dz.js": "8sQJ",
	"./ar-kw": "Ypiv",
	"./ar-kw.js": "Ypiv",
	"./ar-ly": "vFBa",
	"./ar-ly.js": "vFBa",
	"./ar-ma": "5srG",
	"./ar-ma.js": "5srG",
	"./ar-sa": "OWdl",
	"./ar-sa.js": "OWdl",
	"./ar-tn": "zbnz",
	"./ar-tn.js": "zbnz",
	"./ar.js": "k/LX",
	"./az": "+TbT",
	"./az.js": "+TbT",
	"./be": "I3+K",
	"./be.js": "I3+K",
	"./bg": "6pzG",
	"./bg.js": "6pzG",
	"./bm": "XaRw",
	"./bm.js": "XaRw",
	"./bn": "BSxz",
	"./bn.js": "BSxz",
	"./bo": "xZM4",
	"./bo.js": "xZM4",
	"./br": "z7xq",
	"./br.js": "z7xq",
	"./bs": "CRbE",
	"./bs.js": "CRbE",
	"./ca": "vtJn",
	"./ca.js": "vtJn",
	"./cs": "50M2",
	"./cs.js": "50M2",
	"./cv": "imKR",
	"./cv.js": "imKR",
	"./cy": "0GzN",
	"./cy.js": "0GzN",
	"./da": "w5+c",
	"./da.js": "w5+c",
	"./de": "EVTu",
	"./de-at": "nG3g",
	"./de-at.js": "nG3g",
	"./de-ch": "Yt6q",
	"./de-ch.js": "Yt6q",
	"./de.js": "EVTu",
	"./dv": "qtbI",
	"./dv.js": "qtbI",
	"./el": "5alt",
	"./el.js": "5alt",
	"./en-au": "z0Rx",
	"./en-au.js": "z0Rx",
	"./en-ca": "3NXy",
	"./en-ca.js": "3NXy",
	"./en-gb": "+etJ",
	"./en-gb.js": "+etJ",
	"./en-ie": "9aRM",
	"./en-ie.js": "9aRM",
	"./en-il": "FSWH",
	"./en-il.js": "FSWH",
	"./en-nz": "nuu6",
	"./en-nz.js": "nuu6",
	"./eo": "ScLw",
	"./eo.js": "ScLw",
	"./es": "dvvA",
	"./es-do": "yg1m",
	"./es-do.js": "yg1m",
	"./es-us": "iYIl",
	"./es-us.js": "iYIl",
	"./es.js": "dvvA",
	"./et": "0unr",
	"./et.js": "0unr",
	"./eu": "RwsK",
	"./eu.js": "RwsK",
	"./fa": "0MmL",
	"./fa.js": "0MmL",
	"./fi": "3jre",
	"./fi.js": "3jre",
	"./fo": "wY+L",
	"./fo.js": "wY+L",
	"./fr": "khqN",
	"./fr-ca": "bEN0",
	"./fr-ca.js": "bEN0",
	"./fr-ch": "S4fe",
	"./fr-ch.js": "S4fe",
	"./fr.js": "khqN",
	"./fy": "1XdY",
	"./fy.js": "1XdY",
	"./gd": "Q4Vj",
	"./gd.js": "Q4Vj",
	"./gl": "ZUnQ",
	"./gl.js": "ZUnQ",
	"./gom-latn": "4dEw",
	"./gom-latn.js": "4dEw",
	"./gu": "YpSa",
	"./gu.js": "YpSa",
	"./he": "9PWd",
	"./he.js": "9PWd",
	"./hi": "d8Wo",
	"./hi.js": "d8Wo",
	"./hr": "YkY+",
	"./hr.js": "YkY+",
	"./hu": "79Lb",
	"./hu.js": "79Lb",
	"./hy-am": "DMpe",
	"./hy-am.js": "DMpe",
	"./id": "Ibyo",
	"./id.js": "Ibyo",
	"./is": "L3mU",
	"./is.js": "L3mU",
	"./it": "9XIi",
	"./it.js": "9XIi",
	"./ja": "x5kd",
	"./ja.js": "x5kd",
	"./jv": "30df",
	"./jv.js": "30df",
	"./ka": "JI1o",
	"./ka.js": "JI1o",
	"./kk": "HJwE",
	"./kk.js": "HJwE",
	"./km": "OTi2",
	"./km.js": "OTi2",
	"./kn": "2230",
	"./kn.js": "2230",
	"./ko": "dDkv",
	"./ko.js": "dDkv",
	"./ky": "PHd1",
	"./ky.js": "PHd1",
	"./lb": "vxmX",
	"./lb.js": "vxmX",
	"./lo": "K877",
	"./lo.js": "K877",
	"./lt": "Zk7u",
	"./lt.js": "Zk7u",
	"./lv": "JOTR",
	"./lv.js": "JOTR",
	"./me": "Ex1I",
	"./me.js": "Ex1I",
	"./mi": "jjiy",
	"./mi.js": "jjiy",
	"./mk": "gWcD",
	"./mk.js": "gWcD",
	"./ml": "kBLj",
	"./ml.js": "kBLj",
	"./mn": "k+VG",
	"./mn.js": "k+VG",
	"./mr": "V2NI",
	"./mr.js": "V2NI",
	"./ms": "KQOe",
	"./ms-my": "POgm",
	"./ms-my.js": "POgm",
	"./ms.js": "KQOe",
	"./mt": "mxKv",
	"./mt.js": "mxKv",
	"./my": "ZAKQ",
	"./my.js": "ZAKQ",
	"./nb": "MQ71",
	"./nb.js": "MQ71",
	"./ne": "PefK",
	"./ne.js": "PefK",
	"./nl": "aSId",
	"./nl-be": "Fpiv",
	"./nl-be.js": "Fpiv",
	"./nl.js": "aSId",
	"./nn": "YpEG",
	"./nn.js": "YpEG",
	"./pa-in": "r+L2",
	"./pa-in.js": "r+L2",
	"./pl": "eXAp",
	"./pl.js": "eXAp",
	"./pt": "I4bD",
	"./pt-br": "iAmb",
	"./pt-br.js": "iAmb",
	"./pt.js": "I4bD",
	"./ro": "tXyB",
	"./ro.js": "tXyB",
	"./ru": "ngkl",
	"./ru.js": "ngkl",
	"./sd": "OWeY",
	"./sd.js": "OWeY",
	"./se": "+EdD",
	"./se.js": "+EdD",
	"./si": "gaPs",
	"./si.js": "gaPs",
	"./sk": "jUKU",
	"./sk.js": "jUKU",
	"./sl": "DQFe",
	"./sl.js": "DQFe",
	"./sq": "M7V7",
	"./sq.js": "M7V7",
	"./sr": "bzhX",
	"./sr-cyrl": "33c5",
	"./sr-cyrl.js": "33c5",
	"./sr.js": "bzhX",
	"./ss": "NejB",
	"./ss.js": "NejB",
	"./sv": "w+2E",
	"./sv.js": "w+2E",
	"./sw": "Dll1",
	"./sw.js": "Dll1",
	"./ta": "jbxT",
	"./ta.js": "jbxT",
	"./te": "jB/5",
	"./te.js": "jB/5",
	"./tet": "VbPC",
	"./tet.js": "VbPC",
	"./tg": "7sF4",
	"./tg.js": "7sF4",
	"./th": "nLNk",
	"./th.js": "nLNk",
	"./tl-ph": "mfkQ",
	"./tl-ph.js": "mfkQ",
	"./tlh": "jXJl",
	"./tlh.js": "jXJl",
	"./tr": "92cT",
	"./tr.js": "92cT",
	"./tzl": "5MIk",
	"./tzl.js": "5MIk",
	"./tzm": "0vIq",
	"./tzm-latn": "3+Cq",
	"./tzm-latn.js": "3+Cq",
	"./tzm.js": "0vIq",
	"./ug-cn": "ktU2",
	"./ug-cn.js": "ktU2",
	"./uk": "Hd7b",
	"./uk.js": "Hd7b",
	"./ur": "XtGu",
	"./ur.js": "XtGu",
	"./uz": "uRCu",
	"./uz-latn": "1AHx",
	"./uz-latn.js": "1AHx",
	"./uz.js": "uRCu",
	"./vi": "FB03",
	"./vi.js": "FB03",
	"./x-pseudo": "APXS",
	"./x-pseudo.js": "APXS",
	"./yo": "/1ch",
	"./yo.js": "/1ch",
	"./zh-cn": "yEKL",
	"./zh-cn.js": "yEKL",
	"./zh-hk": "sjvb",
	"./zh-hk.js": "sjvb",
	"./zh-tw": "f55z",
	"./zh-tw.js": "f55z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mj8Y";

/***/ }),

/***/ "mw/h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{staticClass:"mr-0",attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":_vm.toggle},slot:"activator"},[_c('v-badge',{attrs:{"value":_vm.numActiveFilters > 0,"right":"","color":"yellow darken-4","overlap":""}},[_c('v-icon',{attrs:{"slot":"badge","dark":""},slot:"badge"},[_vm._v("filter_list")]),_vm._v(" "),_c('v-icon',{attrs:{"large":""}},[_vm._v("more_vert")])],1)],1),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.tooltipText)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mydN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n8sP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nCzW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WatershedSidebar_vue__ = __webpack_require__("BJ4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d625906e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WatershedSidebar_vue__ = __webpack_require__("cOEg");
function injectStyle (ssrContext) {
  __webpack_require__("nnPQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d625906e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WatershedSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d625906e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WatershedSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nY6U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-wrap",class:_vm.classObj},[_c('mapbox-gl-map',{attrs:{"id":"map","accessToken":_vm.$cfg.mapboxgl.accessToken,"options":_vm.getMapOptions()},on:{"loaded":_vm.mapLoaded}}),_vm._v(" "),(_vm.$store.state.showChartModal)?_c('chart-modal'):_vm._e(),_vm._v(" "),_c('overlap-picker',{attrs:{"features":_vm.overlapFeatures},on:{"select":_vm.selectStation},scopedSlots:_vm._u([{key:"header",fn:function(slotScope){return [_vm._v("\n            "+_vm._s(slotScope.numFeatures)+" stations at these coordinates\n        ")]}},{key:"listItem",fn:function(slotScope){return [_c('v-list-tile-title',{domProps:{"textContent":_vm._s(slotScope.feature.properties.name)}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v("\n                "+_vm._s(slotScope.feature.properties.network)+"\n            ")])]}}]),model:{value:(_vm.showOverlapPicker),callback:function ($$v) {_vm.showOverlapPicker=$$v},expression:"showOverlapPicker"}}),_vm._v(" "),_c('style-switcher',{on:{"switchedStyle":_vm.addLayers},model:{value:(_vm.showStyleSwitcher),callback:function ($$v) {_vm.showStyleSwitcher=$$v},expression:"showStyleSwitcher"}}),_vm._v(" "),_c('map-save-button',{attrs:{"featuresUrl":_vm.mapSourceUrl},model:{value:(_vm.showMapSave),callback:function ($$v) {_vm.showMapSave=$$v},expression:"showMapSave"}},[_c('template',{attrs:{"slot":"features-headline"},slot:"features-headline"},[_vm._v("Download stations")])],2),_vm._v(" "),_c('map-legend',{attrs:{"items":_vm.getLegendLayers()},model:{value:(_vm.showMapLegend),callback:function ($$v) {_vm.showMapLegend=$$v},expression:"showMapLegend"}}),_vm._v(" "),_c('map-sidebar',{attrs:{"filters":_vm.filters}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nnPQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nsvp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Geoname_vue__ = __webpack_require__("VSUu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08894a5f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geoname_vue__ = __webpack_require__("9UE/");
function injectStyle (ssrContext) {
  __webpack_require__("zI30")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Geoname_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08894a5f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geoname_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nv2y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o5bc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gw-hydrograph-chart"},[_c('div',{staticClass:"yearly-data-select"},[_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"d-flex":"","sm3":""}},[_c('v-select',{attrs:{"width":"200","label":"Select","items":_vm.yearlyDataAvailable,"multiple":"","max-height":"400","hint":"Add yearly data","persistent-hint":""},model:{value:(_vm.yearlyDataDisplay),callback:function ($$v) {_vm.yearlyDataDisplay=$$v},expression:"yearlyDataDisplay"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":"","d-flex":"","justify-center":"","align-content-end":""}},[_c('v-btn',{attrs:{"outline":""},on:{"click":_vm.downloadChart}},[_c('v-icon',[_vm._v("file_download")]),_vm._v(" Download PNG")],1)],1)],1)],1),_vm._v(" "),_c('a',{ref:"downloadUrl",staticStyle:{"display":"none"},attrs:{"href":"#"}}),_vm._v(" "),_c('div',{staticClass:"chart-wrap"},[_c('v-btn',{staticClass:"zoom-btn",attrs:{"icon":""},on:{"click":_vm.resetZoom}},[_c('v-icon',[_vm._v("zoom_out")])],1),_vm._v(" "),_c('canvas',{attrs:{"id":_vm.chartId}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oJTU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"streamflow-seven-day-flow-chart"},[_c('div',{staticClass:"yearly-data-select"},[_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"d-flex":"","sm3":""}},[_c('v-select',{attrs:{"width":"200","label":"Select","items":_vm.yearlyDataAvailable,"multiple":"","max-height":"400","hint":"Add yearly data","persistent-hint":""},model:{value:(_vm.yearlyDataDisplay),callback:function ($$v) {_vm.yearlyDataDisplay=$$v},expression:"yearlyDataDisplay"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":"","d-flex":"","justify-center":"","align-content-end":""}},[_c('v-btn',{attrs:{"outline":""},on:{"click":_vm.downloadChart}},[_c('v-icon',[_vm._v("file_download")]),_vm._v(" Download PNG")],1)],1)],1)],1),_vm._v(" "),_c('a',{ref:"downloadUrl",staticStyle:{"display":"none"},attrs:{"href":"#"}}),_vm._v(" "),_c('div',{staticClass:"chart-wrap"},[_c('v-btn',{staticClass:"zoom-btn",attrs:{"icon":""},on:{"click":_vm.resetZoom}},[_c('v-icon',[_vm._v("zoom_out")])],1),_vm._v(" "),_c('canvas',{attrs:{"id":_vm.chartId}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oK1k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_mutations__ = __webpack_require__("cLT6");


var _mutations, _actions;

/**
 * vuex module for loading/restoring map state after the map/page are done loading
 * set the variables here and then switch to a new page, and the page can selectively set state
 * think of it kind of like a queue; the page will check any relevant variables here and process them as needed
 */




/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        mapCenter: null, // { lat, lng }
        mapZoom: null, // Number
        mapFilterSettings: null, // Object
        selectFeature: null // { id, type, coords, ... }
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants_mutations__["i" /* SET_LOADSTATE_MAP_CENTER */], function (state) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        state.mapCenter = value;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants_mutations__["k" /* SET_LOADSTATE_MAP_ZOOM */], function (state) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        state.mapZoom = value;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants_mutations__["j" /* SET_LOADSTATE_MAP_FILTER_SETTINGS */], function (state) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        state.mapFilterSettings = value;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants_mutations__["l" /* SET_LOADSTATE_SELECTED_FEATURE */], function (state) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        state.selectFeature = value;
    }), _mutations),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["e" /* RESET_LOADSTATE_ITEMS */], function (_ref) {
        var commit = _ref.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["i" /* SET_LOADSTATE_MAP_CENTER */], null);
        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["k" /* SET_LOADSTATE_MAP_ZOOM */], null);
        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["j" /* SET_LOADSTATE_MAP_FILTER_SETTINGS */], null);
        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["l" /* SET_LOADSTATE_SELECTED_FEATURE */], null);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["m" /* SET_LOADSTATE_MAP_CENTER */], function (_ref2) {
        var commit = _ref2.commit;
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["i" /* SET_LOADSTATE_MAP_CENTER */], value);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["o" /* SET_LOADSTATE_MAP_ZOOM */], function (_ref3) {
        var commit = _ref3.commit;
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["k" /* SET_LOADSTATE_MAP_ZOOM */], value);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["n" /* SET_LOADSTATE_MAP_FILTER_SETTINGS */], function (_ref4) {
        var commit = _ref4.commit;
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["j" /* SET_LOADSTATE_MAP_FILTER_SETTINGS */], value);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["p" /* SET_LOADSTATE_SELECTED_FEATURE */], function (_ref5) {
        var commit = _ref5.commit;
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["l" /* SET_LOADSTATE_SELECTED_FEATURE */], value);
    }), _actions)
});

/***/ }),

/***/ "oT8a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oYoW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_file_download__ = __webpack_require__("3UNf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_actions__ = __webpack_require__("UOq2");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        stationId: {
            default: '00'
        },
        redistribute: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    methods: {
        // download transferred csv data in the browser
        downloadCsv: function downloadCsv() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, file;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(_this.$cfg.API_URL + '/stations/' + _this.stationId + '.csv', {
                                    responseType: 'blob'
                                });

                            case 3:
                                _ref = _context.sent;
                                file = _ref.data;

                                __WEBPACK_IMPORTED_MODULE_3_js_file_download___default()(file, 'station-data-' + _this.stationId + '.csv');
                                _context.next = 11;
                                break;

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context['catch'](0);

                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__constants_actions__["D" /* TRIGGER_TOAST */], 'This station\'s data is not authorized for redistribution');

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[0, 8]]);
            }))();
        }
    }
});

/***/ }),

/***/ "odbt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_yearlyChart__ = __webpack_require__("tMAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_formatHistoricalDailyData__ = __webpack_require__("/SS+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_formatHistoricalDailyDateData__ = __webpack_require__("r0h7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_exportChart__ = __webpack_require__("h326");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_resetChart__ = __webpack_require__("AstN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_climateData__ = __webpack_require__("epYP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_ie11ChartResize__ = __webpack_require__("4+uC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chartData_climateSnowWaterEquivChart__ = __webpack_require__("VVRy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_yearlyChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_formatHistoricalDailyData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_formatHistoricalDailyDateData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_exportChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_resetChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_climateData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_ie11ChartResize__["a" /* default */]],
    data: function data() {
        return {
            chart: null,
            chartId: 'canvas-snow-water-equiv',
            dataType: 'snow_water_equivalent'
        };
    },

    computed: {
        chartData: function chartData() {
            return this.queryData.snow_water_equivalent;
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.chart.destroy();
    },
    mounted: function mounted() {
        if (this.chartData) {
            this.updateChart();
        }
    },

    methods: {
        /**
         * create datasets and chart context object
         * @return {Object} chart.js context object
         */
        formatDatasets: function formatDatasets() {
            var _chartData$datasets;

            var historicalData = this.formatHistoricalData(this.chartData.historical, function (date, e) {
                var formatted = {
                    d: date,
                    a: e.a,
                    p10: e.p10,
                    p25: e.p25,
                    p75: e.p75,
                    p90: e.p90
                };
                return formatted;
            });
            var currentData = this.formatCurrentData(this.chartData.current);
            var chartDates = historicalData.map(function (d) {
                return d.d;
            });

            var chartData = Object(__WEBPACK_IMPORTED_MODULE_8__chartData_climateSnowWaterEquivChart__["b" /* data */])(chartDates, currentData, historicalData);

            var yearlyOverlayDatasets = this.formatYearlyData(this.formatHistoricalDateData);
            (_chartData$datasets = chartData.datasets).unshift.apply(_chartData$datasets, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(yearlyOverlayDatasets));
            return chartData;
        },

        /**
         * set up the chart and do the initial render
         */
        renderChart: function renderChart() {
            var chartData = this.formatDatasets();

            this.chart = new __WEBPACK_IMPORTED_MODULE_9_chart_js___default.a(this.chartId, Object(__WEBPACK_IMPORTED_MODULE_8__chartData_climateSnowWaterEquivChart__["a" /* container */])(chartData));
        },

        /**
         * update the datasets and re-render the chart
         */
        updateChart: function updateChart() {
            // do the initial render if the chart isn't defined yet
            if (this.chart === null) {
                this.renderChart();
                return;
            }
            this.chart.data = this.formatDatasets();
            this.chart.update({
                duration: 0
            });
        },

        /**
         * format current snow water equivalent data with date objects
         * @param  {Array} currentData SWE data with string dates
         * @return {Array}             SWE data with moment.js dates
         */
        formatCurrentData: function formatCurrentData(currentData) {
            var dataWithDates = currentData.map(function (d) {
                var date = __WEBPACK_IMPORTED_MODULE_10_moment___default()(d.d);
                return {
                    d: date,
                    v: d.v
                };
            });

            return dataWithDates;
        }
    },
    watch: {
        /**
         * update the chart when the data changes
         */
        chartData: function chartData(val) {
            this.yearlyData = {};
            this.yearlyDataDisplay = [];
            if (val) {
                this.updateChart();
            }
        },
        updateData: function updateData(val) {
            if (val) {
                this.updateChart();
                this.updateData = false;
            }
        }
    }
});

/***/ }),

/***/ "pACh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pNUS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisclaimerModal_vue__ = __webpack_require__("2FRe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6de84b4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisclaimerModal_vue__ = __webpack_require__("lKsx");
function injectStyle (ssrContext) {
  __webpack_require__("QzKR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisclaimerModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6de84b4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisclaimerModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pRLy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthlyMeanFlowTable_vue__ = __webpack_require__("8bU7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_392ba220_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyMeanFlowTable_vue__ = __webpack_require__("jHET");
function injectStyle (ssrContext) {
  __webpack_require__("SWHv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthlyMeanFlowTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_392ba220_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyMeanFlowTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pVK1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pc19":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pfUN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_map__ = __webpack_require__("aiDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__functions_sortByKey__ = __webpack_require__("HvOn");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'map-filters',
    mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_map__["a" /* default */]],
    props: {
        filters: Array
    },
    data: function data() {
        return {
            yearMin: {},
            yearMax: {},
            yearOptions: [],

            status: [],
            statusOptions: [],

            analyses: [],
            analysesOptions: [],

            area: [],
            areaOptions: [],

            network: [],
            networkOptions: []
        };
    },

    // load options and set values
    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
            var map;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.mapPromise;

                        case 2:
                            map = _context.sent;


                            // Load current filters when stations layer is initialized
                            map.on('style.load', function () {
                                var waiting = function waiting() {
                                    if (map.getLayer('stations-points') === undefined) {
                                        setTimeout(waiting, 25);
                                    } else {
                                        _this.setFormValues();
                                    }
                                };
                                waiting();
                            });
                            _this.initialize();

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },

    computed: {
        analysesCheckbox: {
            get: function get() {
                return this.analyses.length !== 0;
            },
            set: function set() {
                if (this.analyses.length === this.analysesDefault().length) {
                    this.clearFilter('analyses');
                } else {
                    this.resetFilter('analyses');
                }
            }
        },
        networkCheckbox: {
            get: function get() {
                return this.network.length !== 0;
            },
            set: function set() {
                if (this.network.length === this.networkDefault().length) {
                    this.clearFilter('network');
                } else {
                    this.resetFilter('network');
                }
            }
        },
        areaCheckbox: {
            get: function get() {
                return this.area.length !== 0;
            },
            set: function set() {
                if (this.area.length === this.areaDefault().length) {
                    this.clearFilter('area');
                } else {
                    this.resetFilter('area');
                }
            }
        },
        // array of loaded filter names
        loadedFilters: function loadedFilters() {
            return this.$store.state.loadedFilters;
        },

        // options and ranges for filter dropdowns
        filterOptions: function filterOptions() {
            return this.$store.state.filterOptions;
        },

        // currently-set filters
        savedSettings: function savedSettings() {
            return this.$store.state.filterSettings;
        }
    },
    methods: {
        // used for the close button beside the card title.
        hideSidebar: function hideSidebar() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], false);
        },

        /**
         * reset filters to their default settings
         */
        reset: function reset() {
            // reset locally
            if (this.filterLoaded('yearMin')) {
                this.yearMin = this.yearDefault();
            }
            if (this.filterLoaded('yearMax')) {
                this.yearMax = this.yearDefault();
            }
            if (this.filterLoaded('analyses')) {
                this.analyses = this.analysesDefault();
            }
            if (this.filterLoaded('area')) {
                this.area = this.areaDefault();
            }
            if (this.filterLoaded('status')) {
                this.status = this.statusDefault();
            }
            if (this.filterLoaded('network')) {
                this.network = this.networkDefault();
            }
            // update vuex
            this.updateStore();
        },
        resetFilter: function resetFilter(filter) {
            this[filter] = this[filter + 'Default']();
        },
        clearFilter: function clearFilter(filter) {
            this[filter] = [];
        },

        /**
         * handle any special cases and update vuex
         * @param  {String}  name          filter name
         * @param  {Object|Array}  val     new filter value
         * @param  {Boolean} [update=true] whether to update vuex
         */
        filterChanged: function filterChanged(name, val) {
            var update = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            if (update) {
                this.updateStore();
            }
        },

        /**
         * adjust year filters to preserve min-max range
         * @param  {String} name filter name
         * @param  {Object} val  filter value
         */
        yearChanged: function yearChanged(name, val) {
            // if the new value breaks the year range
            if (this.yearMin.value && this.yearMax.value // not null
            && this.yearMin.value > this.yearMax.value) {
                // adjust the other control
                if (name === 'yearMin') {
                    this.yearMax = val;
                    this.filterChanged('yearMax', val, false);
                } else {
                    this.yearMin = val;
                    this.filterChanged('yearMin', val, false);
                }
            }
            this.filterChanged(name, val);
        },

        /**
         * persist an object of filter settings to vuex
         * the map page itself will handle the actual filtering
         */
        updateStore: function updateStore() {
            var currentSettings = {};
            // only add if the filter isn't set to its default
            // @TODO: a testDefault method (can use to display if a filter is "set" or not)
            if (this.filters.indexOf('yearMin') !== -1 && this.yearMin.value !== this.yearDefault().value) {
                currentSettings.yearMin = this.yearMin;
            }
            if (this.filters.indexOf('yearMax') !== -1 && this.yearMax.value !== this.yearDefault().value) {
                currentSettings.yearMax = this.yearMax;
            }
            if (this.filters.indexOf('analyses') !== -1 && this.analyses.length !== this.analysesDefault().length) {
                currentSettings.analyses = this.analyses;
            }
            if (this.filters.indexOf('area') !== -1 && this.area.length !== this.areaDefault().length) {
                currentSettings.area = this.area;
            }
            if (this.filters.indexOf('status') !== -1 && this.status.length !== this.statusDefault().length) {
                currentSettings.status = this.status;
            }
            if (this.filters.indexOf('network') !== -1 && this.network.length !== this.networkDefault().length) {
                currentSettings.network = this.network;
            }
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__constants_actions__["k" /* SET_FILTER_SETTINGS */], currentSettings);
        },

        /**
         * (re-)initialize form fields
         */
        initialize: function initialize() {
            this.setOptions();
            this.setFormValues();
        },

        /**
         * populate form fields with filter options
         */
        setOptions: function setOptions() {
            // cheap deep clone filterOptions from vuex
            // so it can be sorted
            var options = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.filterOptions));
            var sortLabels = Object(__WEBPACK_IMPORTED_MODULE_7__functions_sortByKey__["a" /* default */])('label');
            // sort all option values alphabetically by label
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(options).forEach(function (option) {
                var _option = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(option, 2),
                    key = _option[0],
                    val = _option[1];

                // don't sort certain options


                if (key === 'area' || key === 'min_year' || key === 'max_year') return;

                // sort array members
                options[key] = val.sort(sortLabels);
            });

            // set year range
            if (options.min_year && options.max_year) {
                var min = options.min_year.value;
                var max = options.max_year.value;
                var yearOptions = [this.yearDefault()];
                for (var i = min; i <= max; i += 1) {
                    yearOptions.push({ value: i, label: '' + i });
                }
                this.yearOptions = yearOptions;
            }

            // set status options
            if (options.analyses) {
                this.analysesOptions = options.analyses;
            }

            if (options.area) {
                this.areaOptions = options.area;
            }

            // set status options
            if (options.ty) {
                this.statusOptions = options.ty;
            }

            // set network options
            if (options.net) {
                this.networkOptions = options.net;
            }
        },

        /**
         * set form feld values to current/default settings
         */
        setFormValues: function setFormValues() {
            if (this.filterLoaded('yearMin')) {
                this.yearMin = this.getFilterValue('yearMin') || this.yearDefault();
            }
            if (this.filterLoaded('yearMax')) {
                this.yearMax = this.getFilterValue('yearMax') || this.yearDefault();
            }
            if (this.filterLoaded('status')) {
                this.status = this.getFilterValue('status') || this.statusDefault();
            }
            if (this.filterLoaded('area')) {
                this.area = this.getFilterValue('area') || this.areaDefault();
            }
            if (this.filterLoaded('analyses')) {
                this.analyses = this.getFilterValue('analyses') || this.analysesDefault();
            }
            if (this.filterLoaded('network')) {
                this.network = this.getFilterValue('network') || this.networkDefault();
            }
        },

        /**
         * return saved filter values from vuex
         * @param  {String} name         filter name
         * @return {Object|Array|null}   filter value, or null if not set in vuex
         */
        getFilterValue: function getFilterValue(name) {
            if (this.savedSettings[name]) {
                return this.savedSettings[name];
            }
            return null;
        },

        /**
         * returns true if the filter is loaded on the current page
         * @param  {String} name filter name
         * @return {Boolean}     true if loaded in vuex
         */
        filterLoaded: function filterLoaded(name) {
            return this.loadedFilters.includes(name);
        },

        // default filter values
        analysesDefault: function analysesDefault() {
            return this.filterOptions.analyses.map(function (e) {
                return e.value;
            });
        },
        statusDefault: function statusDefault() {
            return this.filterOptions.ty.map(function (e) {
                return e.value;
            });
        },
        areaDefault: function areaDefault() {
            return this.filterOptions.area.map(function (e) {
                return e.value;
            });
        },
        networkDefault: function networkDefault() {
            return this.filterOptions.net.map(function (e) {
                return e.value;
            });
        },
        yearDefault: function yearDefault() {
            return { value: null, label: 'Any' };
        }
    },
    watch: {
        network: function network() {
            this.filterChanged('type', 'network');
        },
        status: function status() {
            this.filterChanged('type', 'status');
        },
        analyses: function analyses() {
            this.filterChanged('type', 'analyses');
        },
        area: function area() {
            this.filterChanged('type', 'area');
        },

        // re-initialize if the list of loaded filters changes
        loadedFilters: function loadedFilters() {
            this.initialize();
        },

        // re-initialize if the filter options changes
        filterOptions: function filterOptions() {
            this.initialize();
        }
    }
});

/***/ }),

/***/ "pmr1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actions__ = __webpack_require__("UOq2");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'toast-wrapper',
    computed: {
        show: {
            get: function get() {
                return this.$store.state.toast.show;
            },
            set: function set(val) {
                this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__constants_actions__["C" /* SHOW_TOAST */], val);
            }
        },
        text: function text() {
            return this.$store.state.toast.text;
        }
    }
});

/***/ }),

/***/ "priH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q8xZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qKdb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qO0w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions_appColors__ = __webpack_require__("QW0U");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        color: {
            default: String(__WEBPACK_IMPORTED_MODULE_0__functions_appColors__["s" /* navIcon */]),
            type: String
        }
    }
});

/***/ }),

/***/ "qgrT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_crossfilter2__ = __webpack_require__("JowF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_crossfilter2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_crossfilter2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reductio__ = __webpack_require__("7Q+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reductio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_reductio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__apollo_apollo__ = __webpack_require__("YQr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_charts_FDMonthlyFlowStats__ = __webpack_require__("6ntq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_charts_FDAnnualRunoff__ = __webpack_require__("RWxs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_charts_FlowDurationCurve__ = __webpack_require__("kuBH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_charts_FDDatePicker__ = __webpack_require__("+CHo");





var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['query stationStreamflow($id: Int!) {\n                        getStation(id: $id) {\n                            flow_duration_tool\n                        }\n                    }'], ['query stationStreamflow($id: Int!) {\n                        getStation(id: $id) {\n                            flow_duration_tool\n                        }\n                    }']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        MonthlyFlow: __WEBPACK_IMPORTED_MODULE_10__components_charts_FDMonthlyFlowStats__["a" /* default */],
        AnnualRunoff: __WEBPACK_IMPORTED_MODULE_11__components_charts_FDAnnualRunoff__["a" /* default */],
        FlowDurationCurve: __WEBPACK_IMPORTED_MODULE_12__components_charts_FlowDurationCurve__["a" /* default */],
        FilterDatePicker: __WEBPACK_IMPORTED_MODULE_13__components_charts_FDDatePicker__["a" /* default */]
    },
    data: function data() {
        return {
            queryDone: false,
            // data from the API
            flowDurationData: null,
            // crossfilter object
            cf: null,
            // dimensions
            valuesDimension: null,
            monthsDimension: null,
            monthsFilter: null,
            yearsDimension: null,
            yearsFilter: null,
            // groups
            monthsGroup: null,
            yearsByTotalGroup: null,
            // chart data
            yearData: [],
            yearDataAll: [],
            monthData: [],
            monthDataAll: [],
            curveData: [],
            curveDataAll: []
        };
    },

    computed: {
        station: function station() {
            return this.$store.state.map.selectedStation;
        },
        hasData: function hasData() {
            var data = this.flowDurationData;
            return this.queryDone && data && data.length > 0;
        },

        // min and max years for the date picker component
        dateRange: function dateRange() {
            var min = __WEBPACK_IMPORTED_MODULE_8_d3__["o" /* min */](this.yearDataAll, function (d) {
                return d.key;
            });
            var max = __WEBPACK_IMPORTED_MODULE_8_d3__["l" /* max */](this.yearDataAll, function (d) {
                return d.key;
            });
            return {
                min: min,
                max: max
            };
        }
    },
    // re-initialize on re-mount
    mounted: function mounted() {
        this.initialize();
    },

    methods: {
        /**
         * get flow duration data from the API
         */
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, data, dataWithDates;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.queryDone = false;

                                if (_this.station) {
                                    _context.next = 3;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 3:

                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__constants_actions__["b" /* ADD_LOADING */], 'load flow duration data');
                                _context.prev = 4;
                                _context.next = 7;
                                return __WEBPACK_IMPORTED_MODULE_6__apollo_apollo__["a" /* apolloClient */].query({
                                    query: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject),
                                    variables: {
                                        id: _this.station.id,
                                        type: 1
                                    }
                                });

                            case 7:
                                _ref = _context.sent;
                                data = _ref.data;


                                // populate variables
                                dataWithDates = data.getStation.flow_duration_tool.map(function (e) {
                                    var date = new Date(e.d);
                                    return {
                                        d: date,
                                        v: e.v
                                    };
                                });

                                _this.flowDurationData = dataWithDates;
                                _this.queryDone = true;
                                _context.next = 17;
                                break;

                            case 14:
                                _context.prev = 14;
                                _context.t0 = _context['catch'](4);

                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__constants_actions__["D" /* TRIGGER_TOAST */], 'Error loading flow duration data');

                            case 17:
                                _context.prev = 17;

                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__constants_actions__["d" /* REMOVE_LOADING */], 'load flow duration data');
                                return _context.finish(17);

                            case 20:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[4, 14, 17, 20]]);
            }))();
        },

        // initialize crossfilter on new data
        initialize: function initialize() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var monthReducer;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this2.getData();

                            case 2:
                                if (_this2.flowDurationData) {
                                    _context2.next = 4;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 4:
                                // initialize crossfilter and define dimensions
                                _this2.cf = __WEBPACK_IMPORTED_MODULE_4_crossfilter2___default()(_this2.flowDurationData);
                                // fire a callback when filters change
                                _this2.cf.onChange(_this2.cfChanged);
                                // define dimensions
                                _this2.valuesDimension = _this2.cf.dimension(function (d) {
                                    return d.v;
                                });
                                _this2.monthsDimension = _this2.cf.dimension(function (d) {
                                    return d.d.getMonth() + 1;
                                });
                                _this2.yearsDimension = _this2.cf.dimension(function (d) {
                                    return d.d.getFullYear();
                                });

                                // group by annual total
                                _this2.yearsByTotalGroup = _this2.yearsDimension.group().reduceSum(function (d) {
                                    return d.v;
                                });
                                // group by month
                                _this2.monthsGroup = _this2.monthsDimension.group();

                                // monthly min, max, median, 75%, 25%
                                monthReducer = __WEBPACK_IMPORTED_MODULE_5_reductio___default()().valueList(function (d) {
                                    return d.v;
                                }).min(true).max(true).median(true).count(true);

                                // set the month group's reducer to use reductio

                                monthReducer(_this2.monthsGroup);

                                // initialize local data
                                _this2.setLocalData();
                                // store the initial, unfiltered data
                                _this2.yearDataAll = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.yearsByTotalGroup.all()));
                                _this2.monthDataAll = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.monthsGroup.all()));
                                // all dimension values, sorted and not yet filtered
                                _this2.curveDataAll = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.valuesDimension.top(Infinity)));

                            case 17:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },

        /**
         * callback for crossfilter change events
         * @param  {String} evType crossfilter event type
         */
        cfChanged: function cfChanged() {
            // update vm as needed with the changed (filtered) datasets
            this.setLocalData();
            // update filter props passed to chart components
            this.monthsFilter = this.monthsDimension.currentFilter() || null;
            this.yearsFilter = this.yearsDimension.currentFilter() || null;

            // @TODO: whatever's needed for the flow duration chart
        },

        /**
         * update local data with current group values
         */
        setLocalData: function setLocalData() {
            this.yearData = this.yearsByTotalGroup.all();
            this.monthData = this.monthsGroup.all();
            // all dimension values, sorted and filtered
            this.curveData = this.valuesDimension.top(Infinity);
        },

        /**
         * set filter on years dimension
         * pass null to clear filter
         * @param  {Array|null} years params for dimension.filter method
         */
        applyYearFilter: function applyYearFilter(years) {
            this.yearsDimension.filter(years);
        },

        /**
         * set filter on months dimension
         * pass null to clear filter
         * @param  {Array|null} months params for dimension.filter method
         */
        applyMonthFilter: function applyMonthFilter(months) {
            this.monthsDimension.filter(months);
        },

        /**
         * reset all filters to null
         */
        resetFilters: function resetFilters() {
            this.applyYearFilter(null);
            this.applyMonthFilter(null);
        }
    }
});

/***/ }),

/***/ "r0h7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        /**
         * format the historical data
         * @param {Array} data365Days
         * @param {Moment} yearStart
         * @return {Array} list of formatted data
         */
        formatHistoricalDateData: function formatHistoricalDateData(data365Days, yearStart) {
            return data365Days.concat(data365Days, data365Days).map(function (d, i) {
                var date = yearStart.clone().add(i, 'days');
                return {
                    d: date,
                    v: d.v
                };
            });
        }
    }
});

/***/ }),

/***/ "r1oa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VStep_vue__ = __webpack_require__("68bA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_253a96e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VStep_vue__ = __webpack_require__("NHGE");
function injectStyle (ssrContext) {
  __webpack_require__("3j7W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-253a96e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_253a96e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rcZh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "retR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apollo_apollo__ = __webpack_require__("YQr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_actions__ = __webpack_require__("UOq2");





var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['query expandShortUrl($key: String!) {\n                    getUrlShortener(key: $key)\n                }'], ['query expandShortUrl($key: String!) {\n                    getUrlShortener(key: $key)\n                }']);

//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var urlPath, _ref, data, urlData;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            // the short url key is the pathname without the leading "/"
                            // ex: "saved/surface-water-quality-jeJmTp"
                            urlPath = window.location.pathname.replace('/', '');
                            _context.prev = 1;
                            _context.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_5__apollo_apollo__["a" /* apolloClient */].query({
                                query: __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject),
                                variables: { key: urlPath }
                            });

                        case 4:
                            _ref = _context.sent;
                            data = _ref.data;
                            urlData = data.getUrlShortener;

                            // if the query is successful, but no saved url is found

                            if (!(urlData === null)) {
                                _context.next = 9;
                                break;
                            }

                            throw new Error('Error expanding saved URL');

                        case 9:

                            // set map zoom, if specified
                            if (urlData.mapZoom) {
                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["o" /* SET_LOADSTATE_MAP_ZOOM */], urlData.mapZoom);
                            }

                            // map center
                            if (urlData.mapCenter) {
                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["m" /* SET_LOADSTATE_MAP_CENTER */], urlData.mapCenter);
                            }

                            // filter settings
                            if (urlData.filterSettings && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(urlData.filterSettings).length) {
                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["n" /* SET_LOADSTATE_MAP_FILTER_SETTINGS */], urlData.filterSettings);
                            }

                            // redirect to page
                            _this.$router.push(urlData.pageRoute);
                            _context.next = 18;
                            break;

                        case 15:
                            _context.prev = 15;
                            _context.t0 = _context['catch'](1);

                            // if there was an error decoding the short url, redirect to home
                            _this.$router.push('/');

                        case 18:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[1, 15]]);
        }))();
    }
});

/***/ }),

/***/ "rgFZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/**
 * callback for chart.js tooltip title
 * returns the date in MMMM D format
 * @param  {Array} tooltipItem tooltip data
 * @return {String}             formatted date
 */
/* harmony default export */ __webpack_exports__["a"] = (function (tooltipItem) {
  var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(tooltipItem[0].xLabel, 'MMM D, YYYY');
  var display = date.format('MMMM D');
  return display;
});

/***/ }),

/***/ "ruar":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-chart-modal-wrap"},[_c('v-dialog',{attrs:{"max-width":"750"},model:{value:(_vm.enabled),callback:function ($$v) {_vm.enabled=$$v},expression:"enabled"}},[_c('v-card',{staticClass:"single-chart-modal"},[_c('v-card-title',{staticClass:"headline",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('v-card-text',[(_vm.chartDatasets)?_c('single-chart',{attrs:{"chartData":_vm.chartDatasets}}):_vm._e(),_vm._v(" "),(!_vm.chartDatasets)?_c('div',{staticClass:"loading"},[_c('p',[_vm._v("Loading chart data...")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.close()}}},[_vm._v("Close")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s6bu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apollo_apollo__ = __webpack_require__("YQr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__);




var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['query stationMetadata($id: Int!) {\n                        getStation(id: $id) {\n                            redistribute\n                        }\n                    }'], ['query stationMetadata($id: Int!) {\n                        getStation(id: $id) {\n                            redistribute\n                        }\n                    }']);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            dataRedistirbute: false
        };
    },

    // query on mount
    mounted: function mounted() {
        this.getStationMetadata();
    },

    methods: {
        // get station metadata:
        // - redistribute flag
        getStationMetadata: function getStationMetadata() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this.station) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__constants_actions__["b" /* ADD_LOADING */], 'load station sidebar metadata');
                                _context.prev = 3;
                                _context.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_4__apollo_apollo__["a" /* apolloClient */].query({
                                    query: __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default()(_templateObject),
                                    variables: { id: _this.station.id }
                                });

                            case 6:
                                _ref = _context.sent;
                                data = _ref.data;

                                _this.dataRedistirbute = data.getStation.redistribute;
                                _context.next = 14;
                                break;

                            case 11:
                                _context.prev = 11;
                                _context.t0 = _context['catch'](3);

                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__constants_actions__["D" /* TRIGGER_TOAST */], 'Error retrieving station data');

                            case 14:
                                _context.prev = 14;

                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__constants_actions__["d" /* REMOVE_LOADING */], 'load station sidebar metadata');
                                return _context.finish(14);

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[3, 11, 14, 17]]);
            }))();
        }
    },
    watch: {
        // query when the station changes
        station: function station() {
            this.getStationMetadata();
        }
    }
});

/***/ }),

/***/ "sP/z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = waterLayer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);

// map of style urls to the first waterbody layer id
// use this to re-order user layers beneath lakes/streams, etc.
var waterLayers = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
waterLayers.set('mapbox://styles/mapbox/basic-v9', 'waterway');
waterLayers.set('mapbox://styles/mapbox/bright-v9', 'waterway');
waterLayers.set('mapbox://styles/mapbox/light-v9', 'waterway-river-canal');
waterLayers.set('mapbox://styles/mapbox/dark-v9', 'waterway-river-canal');
waterLayers.set('mapbox://styles/mapbox/satellite-v9', null);

/**
 * get the first waterbody layer for a given mapbox style
 * @param  {String} styleUrl mapbox style url
 * @return {String|null}     map layer id, or null
 */
function waterLayer(styleUrl) {
  return waterLayers.get(styleUrl);
}

/***/ }),

/***/ "sh5l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pluralize__ = __webpack_require__("DbJJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pluralize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pluralize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_D3SparklineWrapper__ = __webpack_require__("8WYj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_surfaceQualityData__ = __webpack_require__("eTdZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_getStationMetadata__ = __webpack_require__("s6bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SingleChartModal__ = __webpack_require__("vOnF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DownloadCsvButton__ = __webpack_require__("l2MX");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'station-details-surface-quality',
    components: {
        SparkLine: __WEBPACK_IMPORTED_MODULE_4__components_D3SparklineWrapper__["a" /* default */],
        SingleChartModal: __WEBPACK_IMPORTED_MODULE_7__components_SingleChartModal__["a" /* default */],
        DownloadCsvButton: __WEBPACK_IMPORTED_MODULE_8__components_DownloadCsvButton__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_surfaceQualityData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_getStationMetadata__["a" /* default */]],
    mounted: function mounted() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.getData();

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    data: function data() {
        return {
            allChartData: null,
            numVisibleSparklines: 5,
            chartDetails: null
        };
    },

    computed: {
        stationId: function stationId() {
            return this.station.id;
        },
        visibleSparklines: function visibleSparklines() {
            return this.sparklineData.slice(0, this.numVisibleSparklines);
        }
    },
    methods: {
        addCharts: function addCharts() {
            this.numVisibleSparklines += 5;
        },
        pluralize: function pluralize(term, num) {
            return __WEBPACK_IMPORTED_MODULE_2_pluralize___default()(term, num);
        },
        showChartModal: function showChartModal(tabName) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__constants_actions__["i" /* SET_CHART_MODAL_TAB */], tabName);
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__constants_actions__["y" /* SHOW_CHART_MODAL */], true);
        },

        /**
         * display a modal window showing a single chart
         * @param  {Object} chart data object with name & data keys
         */
        showSingleChart: function showSingleChart(chart) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var paramId, title, units;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                paramId = chart.paramId, title = chart.title, units = chart.units;

                                _this2.chartDetails = {
                                    stationId: _this2.stationId,
                                    paramId: paramId,
                                    title: title,
                                    units: units
                                };
                                _this2.showSingleChartModal = true;

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    },
    watch: {
        station: function station() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this3.numVisibleSparklines = 5;
                                _context3.next = 3;
                                return _this3.getData();

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        }
    }
});

/***/ }),

/***/ "supx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_StreamflowSevenDayChart__ = __webpack_require__("d0sm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_StreamflowStageChart__ = __webpack_require__("XXI4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_FlowDurationTool__ = __webpack_require__("Gn66");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_charts_MonthlyMeanFlowTable__ = __webpack_require__("pRLy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_charts_FlowMetricsTable__ = __webpack_require__("KW/8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_checkQueryData__ = __webpack_require__("ieMF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_streamflowData__ = __webpack_require__("Nt91");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'chart-modal',
    components: {
        SevenDayFlowChart: __WEBPACK_IMPORTED_MODULE_1__components_charts_StreamflowSevenDayChart__["a" /* default */],
        MonthlyMeanFlowTable: __WEBPACK_IMPORTED_MODULE_4__components_charts_MonthlyMeanFlowTable__["a" /* default */],
        StageChart: __WEBPACK_IMPORTED_MODULE_2__components_charts_StreamflowStageChart__["a" /* default */],
        FlowDurationTool: __WEBPACK_IMPORTED_MODULE_3__components_charts_FlowDurationTool__["a" /* default */],
        FlowMetricsTable: __WEBPACK_IMPORTED_MODULE_5__components_charts_FlowMetricsTable__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_checkQueryData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_streamflowData__["a" /* default */]],
    computed: {
        show: function show() {
            return this.$store.state.showChartModal;
        },

        activeTab: {
            get: function get() {
                return this.$store.state.chartModalActiveTab;
            },
            set: function set(val) {
                this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__constants_actions__["i" /* SET_CHART_MODAL_TAB */], val);
            }
        },
        station: function station() {
            return this.$store.state.map.selectedStation;
        },
        stationData: function stationData() {
            return this.queryData;
        },
        stationName: function stationName() {
            if (this.stationData) {
                return this.stationData.name;
            }
            return '';
        },
        stationId: function stationId() {
            if (this.station) {
                return this.station.id;
            }
            return '';
        }
    },
    methods: {
        hide: function hide() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__constants_actions__["y" /* SHOW_CHART_MODAL */], false);
        }
    }
});

/***/ }),

/***/ "sw+o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t37k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tMAo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions_formatYearlyData__ = __webpack_require__("l6B8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__apollo_apollo__ = __webpack_require__("YQr3");






var _templateObject = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default()(['query stationYearlyData($id: Int!, $year: Int!) {\n                    getStation(id: $id) {\n                        ', '(year: $year) {\n                            yearly\n                        }\n                    }\n                }'], ['query stationYearlyData($id: Int!, $year: Int!) {\n                    getStation(id: $id) {\n                        ', '(year: $year) {\n                            yearly\n                        }\n                    }\n                }']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_taggedTemplateLiteral___default()(['query stationYearlyData($id: Int!) {\n                    getStation(id: $id) {\n                        historical_', '_years\n                    }\n                }'], ['query stationYearlyData($id: Int!) {\n                    getStation(id: $id) {\n                        historical_', '_years\n                    }\n                }']);






/* harmony default export */ __webpack_exports__["a"] = ({
    mounted: function mounted() {
        if (this.stationId === 0) return;
        this.getYearlyDataAvailable();
    },
    data: function data() {
        return {
            /*
             * d for day
             * m for month
             */
            chartInterval: 'd',
            yearlyDataDisplay: [],
            yearlyDataAvailable: [],
            yearlyData: {},
            updateData: false
        };
    },

    methods: {
        /**
         * format 365-day yearly data into 18-month chart datasets
         * @param {Function} formatDateDataFunc function to format date data
         * @param {Boolean} mss "true" if this is a Manual Snow Survey dataset, default false
         * @return {Array} formatted chart.js datasets
         */
        formatYearlyData: function formatYearlyData(formatDateDataFunc) {
            var mss = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return Object(__WEBPACK_IMPORTED_MODULE_5__functions_formatYearlyData__["a" /* default */])(this.yearlyData, this.yearlyDataDisplay, formatDateDataFunc, this.chartInterval, mss);
        },

        /**
         * reset the yearly data
         */
        resetYearlyData: function resetYearlyData() {
            this.yearlyDataDisplay = [];
            this.yearlyDataAvailable = [];
            this.yearlyData = {};
        },

        /**
         * query the API for precipitation data for one year
         * @param  {String}  year data year
         */
        getYearlyData: function getYearlyData(year) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
                var loadingKey, _ref, data;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                loadingKey = 'get yearly data ' + year;

                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["b" /* ADD_LOADING */], loadingKey);
                                _context.prev = 2;
                                _context.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_8__apollo_apollo__["a" /* apolloClient */].query({
                                    query: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject, _this.dataType),
                                    variables: {
                                        year: year,
                                        id: _this.stationId
                                    }
                                });

                            case 5:
                                _ref = _context.sent;
                                data = _ref.data;

                                // store data in this component
                                _this.yearlyData[year] = data.getStation[_this.dataType].yearly;
                                _context.next = 13;
                                break;

                            case 10:
                                _context.prev = 10;
                                _context.t0 = _context['catch'](2);

                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["D" /* TRIGGER_TOAST */], 'Error retrieving yearly station data');

                            case 13:
                                _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["d" /* REMOVE_LOADING */], loadingKey);

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[2, 10]]);
            }))();
        },

        /**
         * run the needed queries for yearly data overlays
         */
        addYearlyData: function addYearlyData() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var haveData, needData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, y;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                // check which yearly data values are needed
                                haveData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.yearlyData);
                                needData = _this2.yearlyDataDisplay.filter(function (e) {
                                    return !haveData.includes(e);
                                });

                                // @TODO: use some async/await-friendly version of forEach?
                                /* eslint-disable */

                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context2.prev = 5;
                                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(needData);

                            case 7:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context2.next = 14;
                                    break;
                                }

                                y = _step.value;
                                _context2.next = 11;
                                return _this2.getYearlyData(y);

                            case 11:
                                _iteratorNormalCompletion = true;
                                _context2.next = 7;
                                break;

                            case 14:
                                _context2.next = 20;
                                break;

                            case 16:
                                _context2.prev = 16;
                                _context2.t0 = _context2['catch'](5);
                                _didIteratorError = true;
                                _iteratorError = _context2.t0;

                            case 20:
                                _context2.prev = 20;
                                _context2.prev = 21;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 23:
                                _context2.prev = 23;

                                if (!_didIteratorError) {
                                    _context2.next = 26;
                                    break;
                                }

                                throw _iteratorError;

                            case 26:
                                return _context2.finish(23);

                            case 27:
                                return _context2.finish(20);

                            case 28:
                                /* eslint-enable */

                                _this2.updateData = true;

                            case 29:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[5, 16, 20, 28], [21,, 23, 27]]);
            }))();
        },
        getYearlyDataAvailable: function getYearlyDataAvailable() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var loadingKey, _ref2, data;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                loadingKey = 'get yearly data available';

                                _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["b" /* ADD_LOADING */], loadingKey);
                                _context3.prev = 2;
                                _context3.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_8__apollo_apollo__["a" /* apolloClient */].query({
                                    query: __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject2, _this3.dataType),
                                    variables: {
                                        id: _this3.stationId
                                    }
                                });

                            case 5:
                                _ref2 = _context3.sent;
                                data = _ref2.data;

                                // store data in this component
                                _this3.yearlyDataAvailable = data.getStation['historical_' + _this3.dataType + '_years'];
                                _context3.next = 13;
                                break;

                            case 10:
                                _context3.prev = 10;
                                _context3.t0 = _context3['catch'](2);

                                _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["D" /* TRIGGER_TOAST */], 'Error retrieving yearly station data');

                            case 13:
                                _context3.prev = 13;

                                _this3.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["d" /* REMOVE_LOADING */], loadingKey);
                                return _context3.finish(13);

                            case 16:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3, [[2, 10, 13, 16]]);
            }))();
        }
    },
    computed: {
        /**
         * get the station id from VueX
         * @return {Number}
         */
        stationId: function stationId() {
            var station = this.$store.state.map.selectedStation;
            if (station === null) {
                return 0;
            }
            return station.id;
        }
    },
    watch: {
        /**
         * add yearly data when years are selected
         */
        yearlyDataDisplay: function yearlyDataDisplay() {
            this.addYearlyData();
        },

        /**
         * add list of historical yearly station data on station change
         * @param {Number} stationId
         */
        stationId: function stationId(_stationId) {
            if (_stationId === 0) return;
            this.getYearlyDataAvailable();
        }
    }
});

/***/ }),

/***/ "tNUJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-wrap",class:_vm.classObj},[_c('mapbox-gl-map',{attrs:{"id":"map","accessToken":_vm.$cfg.mapboxgl.accessToken,"options":_vm.getMapOptions()},on:{"loaded":_vm.mapLoaded}}),_vm._v(" "),_c('chart-modal'),_vm._v(" "),_c('overlap-picker',{attrs:{"features":_vm.overlapFeatures},on:{"select":_vm.selectStation},scopedSlots:_vm._u([{key:"header",fn:function(slotScope){return [_vm._v("\n            "+_vm._s(slotScope.numFeatures)+" stations at these coordinates\n        ")]}},{key:"listItem",fn:function(slotScope){return [_c('v-list-tile-title',{domProps:{"textContent":_vm._s(slotScope.feature.properties.name)}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v("\n                "+_vm._s(slotScope.feature.properties.network)+"\n            ")])]}}]),model:{value:(_vm.showOverlapPicker),callback:function ($$v) {_vm.showOverlapPicker=$$v},expression:"showOverlapPicker"}}),_vm._v(" "),_c('style-switcher',{on:{"switchedStyle":_vm.addLayers},model:{value:(_vm.showStyleSwitcher),callback:function ($$v) {_vm.showStyleSwitcher=$$v},expression:"showStyleSwitcher"}}),_vm._v(" "),_c('map-save-button',{attrs:{"featuresUrl":_vm.mapSourceUrl},model:{value:(_vm.showMapSave),callback:function ($$v) {_vm.showMapSave=$$v},expression:"showMapSave"}},[_c('template',{attrs:{"slot":"features-headline"},slot:"features-headline"},[_vm._v("Download stations")])],2),_vm._v(" "),_c('map-legend',{attrs:{"items":_vm.getLegendLayers()},model:{value:(_vm.showMapLegend),callback:function ($$v) {_vm.showMapLegend=$$v},expression:"showMapLegend"}}),_vm._v(" "),_c('map-sidebar',{attrs:{"filters":_vm.filters}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "thqP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverlapPicker_vue__ = __webpack_require__("BbJx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_777fe3ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverlapPicker_vue__ = __webpack_require__("k6pS");
function injectStyle (ssrContext) {
  __webpack_require__("4rqJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverlapPicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_777fe3ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverlapPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tuZ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"24px","height":"24px","viewBox":"0 0 24 24","enable-background":"new 0 0 24 24","xml:space":"preserve"}},[_c('path',{attrs:{"fill":_vm.color,"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12,1.999c-5.521,0-10,4.48-10,10C2,17.52,6.479,22,12,22\n    c5.52,0,10-4.48,10-10.001C22,6.479,17.52,1.999,12,1.999z M15.938,15.779c-0.297,0.392-0.758,0.74-1.385,1.045\n    c-0.627,0.306-1.418,0.459-2.375,0.459c-1.217,0-2.211-0.379-2.98-1.135c-0.77-0.757-1.155-1.739-1.155-2.947v-2.078\n    c0-1.203,0.37-2.184,1.11-2.943c0.741-0.759,1.695-1.138,2.861-1.138c1.213,0,2.141,0.295,2.785,0.885s0.975,1.366,0.988,2.328\n    l-0.014,0.041h-1.881c-0.035-0.529-0.205-0.947-0.506-1.254c-0.3-0.308-0.74-0.461-1.318-0.461c-0.611,0-1.104,0.236-1.477,0.707\n    s-0.561,1.078-0.561,1.82v2.09c0,0.756,0.193,1.369,0.581,1.841s0.909,0.706,1.565,0.706c0.465,0,0.838-0.047,1.121-0.143\n    c0.281-0.096,0.496-0.213,0.643-0.354v-1.84h-1.764v-1.381h3.76V15.779z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tx64":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "txPp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GwQuality_vue__ = __webpack_require__("A4gD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_976f829c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GwQuality_vue__ = __webpack_require__("tuZ6");
function injectStyle (ssrContext) {
  __webpack_require__("VeNL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GwQuality_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_976f829c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GwQuality_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u0MU":
/***/ (function(module, exports) {

module.exports = {"name":"crossfilter2","version":"1.4.6","description":"Fast multidimensional filtering for coordinated views.","license":"Apache-2.0","keywords":["analytics","visualization","crossfilter"],"author":{"name":"Mike Bostock","url":"http://bost.ocks.org/mike"},"contributors":[{"name":"Jason Davies","url":"http://www.jasondavies.com/"}],"maintainers":[{"name":"Gordon Woodhull","url":"https://github.com/gordonwoodhull"},{"name":"Tanner Linsley","url":"https://github.com/tannerlinsley"},{"name":"Ethan Jewett","url":"https://github.com/esjewett"}],"homepage":"https://crossfilter.github.io/crossfilter/","main":"./index.js","types":"./index.d.ts","unpkg":"./crossfilter.min.js","repository":{"type":"git","url":"http://github.com/crossfilter/crossfilter.git"},"dependencies":{"lodash.result":"^4.4.0"},"devDependencies":{"browserify":"^13.0.0","d3":"3.5","eslint":"2.10.2","package-json-versionify":"1.0.2","semver":"^5.3.0","sinon":"^4.0.2","uglify-js":"2.4.0","vows":"0.7.0"},"scripts":{"benchmark":"node test/benchmark.js","build":"browserify index.js -t package-json-versionify --standalone crossfilter -o crossfilter.js && uglifyjs --compress --mangle --screw-ie8 crossfilter.js -o crossfilter.min.js","clean":"rm -f crossfilter.js crossfilter.min.js","test":"./node_modules/.bin/vows --verbose && eslint src/"},"files":["src","index.js","index.d.ts","crossfilter.js","crossfilter.min.js"],"eslintConfig":{"env":{"browser":true,"node":true},"globals":{"Uint8Array":true,"Uint16Array":true,"Uint32Array":true},"extends":"eslint:recommended"}}

/***/ }),

/***/ "u6mf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Climate_vue__ = __webpack_require__("8H5j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e52286b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Climate_vue__ = __webpack_require__("6qpg");
function injectStyle (ssrContext) {
  __webpack_require__("dr3q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Climate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e52286b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Climate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uAMi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartModalGwQuality_vue__ = __webpack_require__("hZKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ba953b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartModalGwQuality_vue__ = __webpack_require__("2VR6");
function injectStyle (ssrContext) {
  __webpack_require__("pACh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ba953b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartModalGwQuality_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ba953b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartModalGwQuality_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uIz3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-chart"},[_c('canvas',{staticClass:"chart",attrs:{"id":_vm.id,"height":"350","width":"600"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uXQQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_ChartTooltip__ = __webpack_require__("4jZd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_sciNotationFmt__ = __webpack_require__("XMAy");

//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ChartTooltip: __WEBPACK_IMPORTED_MODULE_3__components_charts_ChartTooltip__["a" /* default */]
    },
    props: {
        // filtered data from crossfilter group.all()
        data: {
            type: Array,
            required: true
        },
        // all (unfiltered) data (for preserving scales/ranges)
        dataAll: {
            type: Array,
            required: true
        },
        // dimension filters from crossfilter dimension.currentFilter()
        dimensionFilter: {
            required: true
        }
    },
    data: function data() {
        return {
            // @TEMP: make these into props
            svgHeight: (window.innerHeight - 320) / 2,
            svgWidth: window.innerWidth / 3.34 * 2,
            svg: null,
            g: null,
            margin: {
                top: 35,
                bottom: 35,
                left: 40,
                right: 50
            },
            height: 225,
            width: 225,
            xScaleTime: null,
            yScaleLog: null,
            barHeight: 4,
            axisLeft: null,
            brush: null,
            initialized: false,
            boxPaddingX: 10, // px padding on either side of each box
            // tooltip props
            tooltipPosition: [0, 0],
            tooltipVisible: false,
            tooltipText: []
        };
    },

    computed: {
        chartData: function chartData() {
            return this.formatData(this.data);
        },
        chartDataAll: function chartDataAll() {
            return this.formatData(this.dataAll);
        }
    },
    mounted: function mounted() {
        this.initializeSvg();
    },

    methods: {
        /**
         * format data into a structure with all the values needed for the box plot
         * @param  {Array} input array of objects (from crossfilter group.all)
         * @return {Array}       array of objects with values for box & whisker elements
         */
        formatData: function formatData(input) {
            var output = input.map(function (e) {
                // add date object
                var date = new Date(2014, e.key - 1, 1);
                // add percentiles
                var valueList = e.value.valueList;
                var p75 = __WEBPACK_IMPORTED_MODULE_1_d3__["q" /* quantile */](valueList, 0.75) || 0;
                var p25 = __WEBPACK_IMPORTED_MODULE_1_d3__["q" /* quantile */](valueList, 0.25) || 0;
                return {
                    key: e.key,
                    count: e.value.count,
                    max: e.value.max || 0,
                    median: e.value.median || 0,
                    min: e.value.min || 0,
                    p25: p25,
                    p75: p75,
                    date: date
                };
            });

            return output;
        },

        /**
         * initialize svg chart element and define variables
         */
        initializeSvg: function initializeSvg() {
            // initialize chart & vars
            this.svg = __WEBPACK_IMPORTED_MODULE_1_d3__["w" /* select */]('#flow-duration-monthly-flow');
            this.g = this.svg.select('g.chart');
            // chart (not element) size
            this.width = +this.svg.attr('width') - this.margin.left - this.margin.right;
            this.height = +this.svg.attr('height') - this.margin.top - this.margin.bottom;
            // initialize scales
            this.xScaleTime = __WEBPACK_IMPORTED_MODULE_1_d3__["u" /* scaleTime */]().rangeRound([0, this.width]);
            this.yScaleLog = __WEBPACK_IMPORTED_MODULE_1_d3__["s" /* scaleLog */]().rangeRound([this.height, 0]).clamp(true);
            // transition for bar size and axis
            this.transition = __WEBPACK_IMPORTED_MODULE_1_d3__["C" /* transition */]().duration(500);
            // set x-scale input domain (12 months)
            this.xScaleTime.domain([
            // 2014 - any non-leap year
            new Date(2014, 0, 1), new Date(2014, 11, 31)]);

            // adjust scales: update x-scale input domain
            var xMax = __WEBPACK_IMPORTED_MODULE_1_d3__["l" /* max */](this.chartDataAll, function (d) {
                return d.max;
            });
            this.yScaleLog.domain([0.001,
            // use dataAll, don't change domain
            __WEBPACK_IMPORTED_MODULE_1_d3__["l" /* max */]([0.001, xMax])]).nice();

            // bottom axis
            this.g.append('g').attr('class', 'axis axis--x').attr('transform', 'translate(0,' + this.height + ')').call(__WEBPACK_IMPORTED_MODULE_1_d3__["a" /* axisBottom */](this.xScaleTime).tickFormat(__WEBPACK_IMPORTED_MODULE_1_d3__["y" /* timeFormat */]('%B'))).selectAll('.tick text').call(this.moveAxisLabel);
            // left axis
            this.axisLeft = __WEBPACK_IMPORTED_MODULE_1_d3__["b" /* axisLeft */](this.yScaleLog).ticks(3).tickFormat(__WEBPACK_IMPORTED_MODULE_4__functions_sciNotationFmt__["a" /* default */]);
            this.g.append('g').attr('class', 'axis axis--y').attr('transform', 'translate(-2,0)');

            // add brush
            this.brush = __WEBPACK_IMPORTED_MODULE_1_d3__["e" /* brushX */]().extent([[0, 0], [this.width, this.height]]).on('end', this.brushEnded);

            // define & update bars
            this.updateChart();

            // axis label
            this.g.append('text').attr('class', 'axis-label').attr('transform', 'translate(3,3) rotate(-90)').attr('y', 6).attr('dy', '0.71em').attr('text-anchor', 'end').text('Monthly Flow (m³/s)');

            // add selection brush
            this.g.append('g').attr('class', 'brush monthly-flow').call(this.brush);

            // track mouse events on the chart area
            this.g.on('mousemove', this.mouseMove);
            this.g.on('mouseout', this.mouseOut);

            this.initialized = true;
        },

        /**
         * center a time axis label between ticks
         * @param  {[type]}  text [description]
         * @return {Boolean}      [description]
         */
        moveAxisLabel: function moveAxisLabel(text) {
            var _this = this;

            text.attr('x', function (date) {
                var thisDate = date;
                var nextDate = __WEBPACK_IMPORTED_MODULE_1_d3__["z" /* timeMonth */].offset(date, 1);
                var d0 = _this.xScaleTime(thisDate);
                var d1 = _this.xScaleTime(nextDate);
                var width = d1 - d0;
                return width / 2;
            });
        },

        /**
         * update chart bars & axis when data changes
         */
        updateChart: function updateChart() {
            var _this2 = this;

            // update x-axis
            this.g.select('.axis--y').transition(this.transition).call(this.axisLeft);

            // d3 data join to create column groups
            var column = this.g.selectAll('.column').data(this.chartData);

            var boxWidth = this.width / 12 - this.boxPaddingX * 2;

            // add group elements
            var gCols = column.enter().append('g').attr('class', 'column').attr('transform', function (d) {
                var x = _this2.xScaleTime(d.date) + _this2.boxPaddingX;
                return 'translate(' + x + ',0)';
            });

            // add center line
            gCols.append('line').attr('class', 'whisker center-line').attr('x1', boxWidth / 2).attr('x2', boxWidth / 2);

            // add whiskers showing min/max
            gCols.append('line').attr('class', 'min-max min').attr('x1', 0).attr('x2', boxWidth);
            gCols.append('line').attr('class', 'min-max max').attr('x1', 0).attr('x2', boxWidth);

            // add innerquartile box
            gCols.append('rect').attr('class', 'box').attr('width', boxWidth);

            // add median line
            gCols.append('line').attr('class', 'median').attr('x1', 0).attr('x2', boxWidth);

            // data join on whiskers and boxes
            var minLine = this.g.selectAll('.min-max.min').data(this.chartData);
            var maxLine = this.g.selectAll('.min-max.max').data(this.chartData);
            var centerLine = this.g.selectAll('.whisker.center-line').data(this.chartData);
            var box = this.g.selectAll('.box').data(this.chartData);
            var median = this.g.selectAll('.median').data(this.chartData);

            // update boxes
            box.transition(this.transition).attr('y', function (d) {
                return _this2.yScaleLog(d.p75);
            }).attr('height', function (d) {
                var p75 = _this2.yScaleLog(d.p75);
                var p25 = _this2.yScaleLog(d.p25);
                return p25 - p75;
            });

            // update whiskers / center lines
            minLine.transition(this.transition).attr('y1', function (d) {
                return _this2.yScaleLog(d.min);
            }).attr('y2', function (d) {
                return _this2.yScaleLog(d.min);
            });
            maxLine.transition(this.transition).attr('y1', function (d) {
                return _this2.yScaleLog(d.max);
            }).attr('y2', function (d) {
                return _this2.yScaleLog(d.max);
            });
            centerLine.transition(this.transition).attr('y1', function (d) {
                return _this2.yScaleLog(d.max);
            }).attr('y2', function (d) {
                return _this2.yScaleLog(d.min);
            });

            // update medians
            median.transition(this.transition).attr('y1', function (d) {
                return _this2.yScaleLog(d.median);
            }).attr('y2', function (d) {
                return _this2.yScaleLog(d.median);
            });
        },

        /**
         * callback for d3 brush end selection events
         * calculates the month range of the selection
         */
        brushEnded: function brushEnded() {
            if (!__WEBPACK_IMPORTED_MODULE_1_d3__["i" /* event */].sourceEvent) return; // Only transition after input.
            // clear filters for empty selection
            var s = __WEBPACK_IMPORTED_MODULE_1_d3__["i" /* event */].selection;
            if (!s) {
                this.clearFilters();
                return;
            }

            // date values
            var d0 = s.map(this.xScaleTime.invert);
            // rounded to the nearest month
            var d1 = d0.map(__WEBPACK_IMPORTED_MODULE_1_d3__["z" /* timeMonth */].round);

            // if empty when rounded, use floor & ceil instead
            if (d1[0] >= d1[1]) {
                d1[0] = __WEBPACK_IMPORTED_MODULE_1_d3__["z" /* timeMonth */].floor(d0[0]);
                d1[1] = __WEBPACK_IMPORTED_MODULE_1_d3__["z" /* timeMonth */].offset(d1[0]);
            }

            __WEBPACK_IMPORTED_MODULE_1_d3__["w" /* select */]('.brush.monthly-flow').transition(this.transition).call(__WEBPACK_IMPORTED_MODULE_1_d3__["i" /* event */].target.move, d1.map(this.xScaleTime));

            this.updateFilters(d1);
        },

        /**
         * emit an event with a new filter range
         * @param  {Array} dates array with min and max years
         */
        updateFilters: function updateFilters(dates) {
            var months = dates.map(function (m) {
                return +__WEBPACK_IMPORTED_MODULE_1_d3__["y" /* timeFormat */]('%m')(m);
            });
            // crossfilter is just using number 1-12,
            // so "next january" is just month "13"
            if (months[1] === 1) {
                months[1] = 13;
            }
            this.$emit('updateFilters', months);
        },

        /**
         * emit null to clear dimension filters
         */
        clearFilters: function clearFilters() {
            this.$emit('updateFilters', null);
        },

        /**
         * move brush to reflect changed filters
         * pass null to clear brush
         * @param  {Array|null} months params for group.filter method
         */
        setBrush: function setBrush(selection) {
            var _this3 = this;

            // clear brush on null (no transition)
            if (selection === null) {
                __WEBPACK_IMPORTED_MODULE_1_d3__["w" /* select */]('.brush.monthly-flow').call(this.brush.move, null);
                return;
            }
            // convert month integer to pixel values
            var selectionRange = selection.map(function (m) {
                // adjust month for js Date constructor (0-11)
                // 12 will automatically be next january
                var date = new Date(2014, m - 1, 1);
                return _this3.xScaleTime(date);
            });
            // move brush
            __WEBPACK_IMPORTED_MODULE_1_d3__["w" /* select */]('.brush.monthly-flow').transition(this.transition).call(this.brush.move, selectionRange);
        },

        /**
         * update tooltip when the mouse moves
         */
        mouseMove: function mouseMove() {
            var _d3$mouse = __WEBPACK_IMPORTED_MODULE_1_d3__["p" /* mouse */](this.g.node()),
                _d3$mouse2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_d3$mouse, 2),
                gX = _d3$mouse2[0],
                gY = _d3$mouse2[1];
            // hide on mouseout


            if (gX < 0 || gX > this.width || gY < 0 || gY > this.height) {
                this.mouseOut();
                return;
            }

            // position relative to the root flow duration tool element
            this.tooltipPosition = __WEBPACK_IMPORTED_MODULE_1_d3__["p" /* mouse */](this.$parent.$el);
            var date = this.xScaleTime.invert(gX);
            var month = __WEBPACK_IMPORTED_MODULE_1_d3__["z" /* timeMonth */].floor(date);
            var monthString = __WEBPACK_IMPORTED_MODULE_1_d3__["y" /* timeFormat */]('%B')(month);
            var monthNum = +__WEBPACK_IMPORTED_MODULE_1_d3__["y" /* timeFormat */]('%m')(month);

            var monthData = this.chartData.find(function (d) {
                return d.key === monthNum;
            });
            if (!monthData) {
                this.mouseOut();
                return;
            }

            var min = monthData.min,
                max = monthData.max,
                median = monthData.median,
                p25 = monthData.p25,
                p75 = monthData.p75;

            min = __WEBPACK_IMPORTED_MODULE_2_numeral___default()(min).format('0,0.[00]');
            max = __WEBPACK_IMPORTED_MODULE_2_numeral___default()(max).format('0,0.[00]');
            median = __WEBPACK_IMPORTED_MODULE_2_numeral___default()(median).format('0,0.[00]');
            p25 = __WEBPACK_IMPORTED_MODULE_2_numeral___default()(p25).format('0,0.[00]');
            p75 = __WEBPACK_IMPORTED_MODULE_2_numeral___default()(p75).format('0,0.[00]');
            this.tooltipText = [{ text: monthString, class: 'headline' }, { text: 'Discharge (m³/s)', class: 'subheading' }, { label: 'Max', value: max, class: 'black white--text' }, { label: '75th %ile', value: p75, class: 'orange' }, { label: 'Median', value: median, class: 'black white--text' }, { label: '25th %ile', value: p25, class: 'orange' }, { label: 'Min', value: min, class: 'black white--text' }];
            this.tooltipVisible = true;
        },

        /**
         * hide the tooltip on mouseout
         */
        mouseOut: function mouseOut() {
            this.tooltipVisible = false;
        }
    },
    watch: {
        // update chart when data changes
        data: {
            handler: function handler() {
                this.updateChart();
            },

            deep: true
        },
        // update brush selection when cf filter changes externally
        dimensionFilter: function dimensionFilter(selection) {
            this.setBrush(selection);
        }
    }
});

/***/ }),

/***/ "uehw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StationGroundLevelTable_vue__ = __webpack_require__("OAsj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7180abba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StationGroundLevelTable_vue__ = __webpack_require__("hN7P");
function injectStyle (ssrContext) {
  __webpack_require__("Desb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StationGroundLevelTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7180abba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StationGroundLevelTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v1v/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vHb6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vOnF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleChartModal_vue__ = __webpack_require__("Vo26");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ad8e9e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleChartModal_vue__ = __webpack_require__("ruar");
function injectStyle (ssrContext) {
  __webpack_require__("6Ba5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ad8e9e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleChartModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ad8e9e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleChartModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vPEI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/**
 * Store map zoom and center to localstorage
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        /**
         * save map position to localStorage
         */
        saveMapPosition: function saveMapPosition() {
            var namespace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'bcwt';

            var centerKey = 'mapPositionCenter:' + namespace;
            var zoomKey = 'mapPositionzoom:' + namespace;
            var map = this.map;
            var center = map.getCenter();
            var zoom = map.getZoom();
            localStorage.setItem(centerKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(center));
            localStorage.setItem(zoomKey, zoom);
        },

        /**
         * return saved map position from local storage, if available
         * otherwise, return some defaults
         * @return {Object} object with map center and zoom
         */
        loadMapPosition: function loadMapPosition() {
            var namespace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'bcwt';

            var centerKey = 'mapPositionCenter:' + namespace;
            var zoomKey = 'mapPositionzoom:' + namespace;
            var center = localStorage.getItem(centerKey);
            center = JSON.parse(center);
            var zoom = localStorage.getItem(zoomKey);

            return {
                center: center,
                zoom: zoom
            };
        }
    }
});

/***/ }),

/***/ "va/E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_stationsPage__ = __webpack_require__("geYf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_mapLegend__ = __webpack_require__("6Tn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ChartModalSwQuality__ = __webpack_require__("/63i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MapSaveButton__ = __webpack_require__("e5y2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SurfaceWaterQuality',
    components: {
        ChartModal: __WEBPACK_IMPORTED_MODULE_2__components_ChartModalSwQuality__["a" /* default */],
        MapSaveButton: __WEBPACK_IMPORTED_MODULE_3__components_MapSaveButton__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_stationsPage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_mapLegend__["a" /* default */]],
    data: function data() {
        return {
            name: 'surface water quality',
            mapSourceUrl: this.$cfg.API_URL + '/stations/surface-water-quality',
            stationType: 'SURFACE_WATER_QUALITY',
            filters: ['network', 'analyses', 'yearMin', 'yearMax'],
            showMapSave: false
        };
    }
});

/***/ }),

/***/ "vm4e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-bar"},[_c('v-text-field',{staticClass:"search-input",attrs:{"light":"","solo":"","clearable":"","prepend-icon":"search","placeholder":"Search"},on:{"input":function($event){_vm.startLoading(); _vm.onInput()}},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.searching),expression:"searching"}],staticClass:"ma-0 searching-indicator",attrs:{"indeterminate":true,"height":"4","color":"accent"}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showResults),expression:"showResults"}],staticClass:"results white primary--text elevation-4"},[_c('v-list',{attrs:{"two-line":"","light":""}},[(_vm.coordsQuery)?_c('div',[_c('v-subheader',{staticClass:"grey--text text-x-darken-2"},[_vm._v("Latitude, Longitude")]),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.goToCoordinates(_vm.coords)}}},[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"orange white--text"},[_vm._v("location_searching")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                        "+_vm._s(_vm._f("numFormat")(_vm.coords.lat,'0.00000'))+",\n                        "+_vm._s(_vm._f("numFormat")(_vm.coords.lng,'0.00000'))+"\n                    ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Go to coordinates")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-subheader',{staticClass:"grey--text text-x-darken-2"},[_vm._v("Search results")]),_vm._v(" "),(_vm.results.length === 0)?_c('v-list-tile',[_c('v-list-tile-content',[(!_vm.searching)?_c('v-list-tile-title',[_c('em',[_vm._v("No results found")])]):_vm._e(),_vm._v(" "),(_vm.searching)?_c('v-list-tile-title',[_c('em',[_vm._v("Searching...")])]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_vm._l((_vm.results),function(result){return _c('div',{key:result._id},[_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.selectResult(result)}}},[(result.type === 'wfis')?_c('v-list-tile-avatar',[_c('icon-watershed')],1):_vm._e(),_vm._v(" "),(result.type === 'wfis')?_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(result._source.wfi))])],1):_vm._e(),_vm._v(" "),(result.type === 'licences')?_c('v-list-tile-avatar',[_c('icon-watershed')],1):_vm._e(),_vm._v(" "),(result.type === 'licences')?_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(result._source.licence_no))])],1):_vm._e(),_vm._v(" "),(result.type === 'geonames')?_c('v-list-tile-avatar',[_c('icon-geoname')],1):_vm._e(),_vm._v(" "),(result.type === 'geonames')?_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(result._source.geoname))])],1):_vm._e(),_vm._v(" "),(result.type === 'groundwater level')?_c('v-list-tile-avatar',[_c('icon-gw-level')],1):_vm._e(),_vm._v(" "),(result.type === 'groundwater level')?_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(result._source.station_name))])],1):_vm._e(),_vm._v(" "),(result.type === 'climate')?_c('v-list-tile-avatar',[_c('icon-climate')],1):_vm._e(),_vm._v(" "),(result.type === 'climate')?_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(result._source.station_name))])],1):_vm._e(),_vm._v(" "),(result.type === 'streamflow monitoring')?_c('v-list-tile-avatar',[_c('icon-streamflow')],1):_vm._e(),_vm._v(" "),(result.type === 'streamflow monitoring')?_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(result._source.station_name))])],1):_vm._e(),_vm._v(" "),(result.type === 'surface water quality')?_c('v-list-tile-avatar',[_c('icon-sw-quality')],1):_vm._e(),_vm._v(" "),(result.type === 'surface water quality')?_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(result._source.station_name))])],1):_vm._e(),_vm._v(" "),(result.type === 'groundwater quality')?_c('v-list-tile-avatar',[_c('icon-gw-quality')],1):_vm._e(),_vm._v(" "),(result.type === 'groundwater quality')?_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(result._source.station_name))])],1):_vm._e()],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}})],1)})],2)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vmV/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_mutations__ = __webpack_require__("cLT6");




/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        // navigation component visibility
        show: false
    },
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__constants_mutations__["B" /* SHOW_NAV_DRAWER */], function (state) {
        var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        state.show = show;
    }),
    actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__constants_actions__["B" /* SHOW_NAV_DRAWER */], function (_ref, show) {
        var commit = _ref.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants_mutations__["B" /* SHOW_NAV_DRAWER */], show);
    })
});

/***/ }),

/***/ "vqYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return container; });
/* unused harmony export data */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__ = __webpack_require__("oPhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_appColors__ = __webpack_require__("QW0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_chartTooltipDate__ = __webpack_require__("rgFZ");






var container = function container(data) {
    return {
        type: 'line',
        plugins: [__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default.a],
        data: data,
        options: {
            animation: {
                duration: 0
            },
            hover: {
                animationDuration: 0
            },
            elements: {
                line: {
                    tension: 0 // disables bezier curves
                }
            },
            responsiveAnimationDuration: 0,
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
                mode: 'index',
                intersect: false,
                position: 'nearest',
                callbacks: {
                    label: function label(tooltipItem, d) {
                        var label = d.datasets[tooltipItem.datasetIndex].label || '';
                        var value = __WEBPACK_IMPORTED_MODULE_0_numeral___default()(tooltipItem.yLabel).format('0,0.[00]');
                        return label + ': ' + value + ' m\xB3/s';
                    },

                    title: __WEBPACK_IMPORTED_MODULE_4__functions_chartTooltipDate__["a" /* default */]
                }
            },
            annotation: {
                events: [],
                annotations: [{
                    drawTime: 'afterDatasetsDraw',
                    id: 'vline',
                    type: 'line',
                    mode: 'vertical',
                    scaleID: 'x-axis-0',
                    value: __WEBPACK_IMPORTED_MODULE_1_moment___default()(),
                    borderColor: 'black',
                    borderWidth: 3,
                    label: {
                        backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["A" /* todayMarker */],
                        content: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('LL'),
                        enabled: true
                    }
                }]
            },
            pan: {
                enabled: true,
                mode: 'y',
                speed: 10,
                threshold: 10
            },
            zoom: {
                enabled: true,
                mode: 'y',
                limits: {
                    max: 100,
                    min: 1
                }
            },
            scales: {
                xAxes: [{
                    type: 'time',
                    distribution: 'linear',
                    time: {
                        tooltipFormat: 'MMM DD, YYYY',
                        unit: 'month'
                    }
                }],
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'Seven Day Flow (m³/s)'
                    }
                }],
                // disable animations
                animation: false
            }
        }
    };
};

var data = function data(labels, currentData, historicalData) {
    return {
        labels: labels,
        datasets: [{
            type: 'line',
            label: 'Current',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["d" /* currentBorder */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["d" /* currentBorder */],
            borderWidth: 2,
            fill: false,
            pointRadius: 0,
            pointHitRadius: 1,
            // steppedLine: 'before',
            data: currentData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.v
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 50th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["h" /* historicalMedian */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["h" /* historicalMedian */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p50
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 75th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            borderWidth: 2,
            fill: '+1',
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p75
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical 25th %ile',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["e" /* historical1 */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.p25
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical Max',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            borderWidth: 2,
            fill: '+1',
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.max
                };
                return valObj;
            })
        }, {
            type: 'line',
            label: 'Historical Min',
            borderColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            backgroundColor: __WEBPACK_IMPORTED_MODULE_3__functions_appColors__["f" /* historical2 */],
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            pointHitRadius: 1,
            data: historicalData.map(function (d) {
                var valObj = {
                    x: d.d,
                    y: d.min
                };
                return valObj;
            })
        }]
    };
};

/***/ }),

/***/ "wVEN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actions__ = __webpack_require__("UOq2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'alerts',
    data: function data() {
        return {};
    },

    computed: {
        alerts: function alerts() {
            return this.$store.state.alerts;
        }
    },
    methods: {
        /**
         * remove dismissed alerts from the array in vuex
         * @param  {String} alertId alert id
         */
        dismissed: function dismissed(alertId) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__constants_actions__["c" /* REMOVE_ALERT */], alertId);
        }
    }
});

/***/ }),

/***/ "waD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__turf_helpers__ = __webpack_require__("cK3Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ChartModalGwQuality__ = __webpack_require__("uAMi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MapSaveButton__ = __webpack_require__("e5y2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_stationsPage__ = __webpack_require__("geYf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_mapLegend__ = __webpack_require__("6Tn/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// mixins



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'GroundwaterQuality',
    components: {
        ChartModal: __WEBPACK_IMPORTED_MODULE_1__components_ChartModalGwQuality__["a" /* default */],
        MapSaveButton: __WEBPACK_IMPORTED_MODULE_2__components_MapSaveButton__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_stationsPage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_mapLegend__["a" /* default */]],
    data: function data() {
        return {
            name: 'ground water quality',
            mapSourceUrl: this.$cfg.API_URL + '/stations/groundwater-quality',
            stationType: 'GROUND_WATER_QUALITY',
            filters: ['network', 'analyses', 'yearMin', 'yearMax'],
            showMapSave: false
        };
    },

    computed: {
        // "Not Available" monitoring stations
        notAvailable: function notAvailable() {
            var data = this.stationData.filter(function (_ref) {
                var properties = _ref.properties;

                var type = properties.type === 'Not Available';
                return type;
            });
            return Object(__WEBPACK_IMPORTED_MODULE_0__turf_helpers__["a" /* featureCollection */])(data);
        }
    }
});

/***/ }),

/***/ "wdo+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wnug":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OverlapPicker__ = __webpack_require__("thqP");


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        OverlapPicker: __WEBPACK_IMPORTED_MODULE_0__components_OverlapPicker__["a" /* default */]
    },
    data: function data() {
        return {
            overlapFeatures: [],
            showOverlapPicker: false
        };
    }
});

/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_mutations__ = __webpack_require__("cLT6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_modules_MapModule__ = __webpack_require__("DUX4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_SidebarModule__ = __webpack_require__("kKz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_ToastModule__ = __webpack_require__("D0on");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_modules_LoadStateModule__ = __webpack_require__("oK1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_modules_NavDrawerModule__ = __webpack_require__("vmV/");


var _mutations, _actions;






// vuex modules





// install Vuex
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* eslint-disable no-param-reassign */
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
    modules: {
        map: __WEBPACK_IMPORTED_MODULE_5__store_modules_MapModule__["a" /* default */],
        sidebar: __WEBPACK_IMPORTED_MODULE_6__store_modules_SidebarModule__["a" /* default */],
        navdrawer: __WEBPACK_IMPORTED_MODULE_9__store_modules_NavDrawerModule__["a" /* default */],
        toast: __WEBPACK_IMPORTED_MODULE_7__store_modules_ToastModule__["a" /* default */],
        loadState: __WEBPACK_IMPORTED_MODULE_8__store_modules_LoadStateModule__["a" /* default */]
    },
    state: {
        // promise resolved when the full-screen map is loaded
        // or set to null when no map is present on the page
        mapPromise: null,
        // alert objects with text, [color], [icon]
        alerts: [],
        // array of things that are loading
        loading: [],
        // display the chart modal
        showChartModal: false,
        chartModalActiveTab: '',

        // disable watershed clicks in order to select polygon
        selectingPolygon: false,

        // @TEMP temporary spot to store station data
        selectedStationData: null,
        selectedTableData: null,

        // @TEMP temporary spot to store filter stuff
        // names of the filters to be used on this page
        loadedFilters: [],
        // all possible options and extrema for the various filters
        filterOptions: {},
        // current filter settings
        filterSettings: {}
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__constants_mutations__["q" /* SET_POLYGON_SELECTING */], function (state, selectingPolygon) {
        state.selectingPolygon = selectingPolygon;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__constants_mutations__["t" /* SET_SELECTED_STATION_DATA */], function (state, data) {
        state.selectedStationData = data;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__constants_mutations__["u" /* SET_SELECTED_TABLE_DATA */], function (state, data) {
        state.selectedTableData = data;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__constants_mutations__["o" /* SET_MAP_PROMISE */], function (state, mapPromise) {
        state.mapPromise = mapPromise;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__constants_mutations__["a" /* ADD_ALERT */], function (state, alertObj) {
        // use timestamp to add a unique id
        var timestamp = Date.now();
        alertObj.id = 'alert-' + timestamp;
        state.alerts.push(alertObj);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__constants_mutations__["c" /* REMOVE_ALERT */], function (state, alertId) {
        state.alerts = state.alerts.filter(function (alert) {
            return alert.id !== alertId;
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__constants_mutations__["b" /* ADD_LOADING */], function (state, activityName) {
        state.loading.push(activityName);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__constants_mutations__["d" /* REMOVE_LOADING */], function (state, activityName) {
        state.loading = state.loading.filter(function (i) {
            return i !== activityName;
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__constants_mutations__["y" /* SHOW_CHART_MODAL */], function (state) {
        var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        state.showChartModal = show;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__constants_mutations__["e" /* SET_CHART_MODAL_TAB */], function (state, tabName) {
        state.chartModalActiveTab = tabName;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__constants_mutations__["h" /* SET_LOADED_FILTERS */], function (state, filters) {
        state.loadedFilters = filters;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__constants_mutations__["f" /* SET_FILTER_OPTIONS */], function (state, options) {
        state.filterOptions = options;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__constants_mutations__["g" /* SET_FILTER_SETTINGS */], function (state, settings) {
        state.filterSettings = settings;
    }), _mutations),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants_actions__["u" /* SET_SELECTED_STATION_DATA */], function (_ref, data) {
        var commit = _ref.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__constants_mutations__["t" /* SET_SELECTED_STATION_DATA */], data);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants_actions__["v" /* SET_SELECTED_TABLE_DATA */], function (_ref2, data) {
        var commit = _ref2.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__constants_mutations__["u" /* SET_SELECTED_TABLE_DATA */], data);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants_actions__["s" /* SET_MAP_PROMISE */], function (_ref3, mapPromise) {
        var commit = _ref3.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__constants_mutations__["o" /* SET_MAP_PROMISE */], mapPromise);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants_actions__["a" /* ADD_ALERT */], function (_ref4, alertObj) {
        var commit = _ref4.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__constants_mutations__["a" /* ADD_ALERT */], alertObj);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants_actions__["c" /* REMOVE_ALERT */], function (_ref5, alertId) {
        var commit = _ref5.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__constants_mutations__["c" /* REMOVE_ALERT */], alertId);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants_actions__["b" /* ADD_LOADING */], function (_ref6, activityName) {
        var commit = _ref6.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__constants_mutations__["b" /* ADD_LOADING */], activityName);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants_actions__["d" /* REMOVE_LOADING */], function (_ref7, activityName) {
        var commit = _ref7.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__constants_mutations__["d" /* REMOVE_LOADING */], activityName);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants_actions__["y" /* SHOW_CHART_MODAL */], function (_ref8) {
        var commit = _ref8.commit;
        var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        commit(__WEBPACK_IMPORTED_MODULE_4__constants_mutations__["y" /* SHOW_CHART_MODAL */], show);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants_actions__["i" /* SET_CHART_MODAL_TAB */], function (_ref9, tabName) {
        var commit = _ref9.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__constants_mutations__["e" /* SET_CHART_MODAL_TAB */], tabName);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants_actions__["l" /* SET_LOADED_FILTERS */], function (_ref10, filters) {
        var commit = _ref10.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__constants_mutations__["h" /* SET_LOADED_FILTERS */], filters);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants_actions__["j" /* SET_FILTER_OPTIONS */], function (_ref11, options) {
        var commit = _ref11.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__constants_mutations__["f" /* SET_FILTER_OPTIONS */], options);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants_actions__["k" /* SET_FILTER_SETTINGS */], function (_ref12, settings) {
        var commit = _ref12.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__constants_mutations__["g" /* SET_FILTER_SETTINGS */], settings);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants_actions__["E" /* UNLOAD_FILTERS */], function (_ref13) {
        var commit = _ref13.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__constants_mutations__["h" /* SET_LOADED_FILTERS */], []);
        commit(__WEBPACK_IMPORTED_MODULE_4__constants_mutations__["f" /* SET_FILTER_OPTIONS */], {});
        commit(__WEBPACK_IMPORTED_MODULE_4__constants_mutations__["g" /* SET_FILTER_SETTINGS */], {});
    }), _actions)
}));

/***/ }),

/***/ "x1Cl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StationsPageSidebar_vue__ = __webpack_require__("xgLC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a30d3f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StationsPageSidebar_vue__ = __webpack_require__("fLr5");
function injectStyle (ssrContext) {
  __webpack_require__("1j2J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a30d3f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StationsPageSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a30d3f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StationsPageSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x1YK":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTQiIGhlaWdodD0iOTQiIHZpZXdCb3g9IjAgMCA5NCA5NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+Zm91bmRyeUxvZ288L3RpdGxlPjxnIGZpbGw9IiNFMjYwMjkiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHBhdGggZD0iTTQ2LjY3NSA4Ni44OTdjLTIyLjE4MyAwLTQwLjIzLTE4LjA0Ny00MC4yMy00MC4yMzEgMC0yMi4xOCAxOC4wNDctNDAuMjI0IDQwLjIzLTQwLjIyNCAyMi4xODIgMCA0MC4yMjkgMTguMDQ0IDQwLjIyOSA0MC4yMjQgMCAyMi4xODQtMTguMDQ3IDQwLjIzMS00MC4yMjkgNDAuMjMxem0wLTg2Ljg5N0MyMC45MzkgMCAwIDIwLjkzNCAwIDQ2LjY2NmMwIDI1LjczOCAyMC45MzkgNDYuNjc2IDQ2LjY3NSA0Ni42NzYgMjUuNzM0IDAgNDYuNjcxLTIwLjkzOCA0Ni42NzEtNDYuNjc2QzkzLjM0NiAyMC45MzQgNzIuNDA5IDAgNDYuNjc1IDB6Ii8+PHBhdGggZD0iTTU4LjA5NSAzOS43MjlMNDYuNTc0IDI4LjIwN2MtMS4zNTMgMS4zNTYtNC4wOTMgNC4wOTQtNi42OCA2LjY4MmwtNC44NDEgNC44NGExNi4yNzUgMTYuMjc1IDAgMCAwLTMuODU5IDYuMTMzYy0yLjAwMSA1LjcyNC0uNzE0IDEyLjMzOSAzLjg1OSAxNi45MTJhMTYuMTc0IDE2LjE3NCAwIDAgMCA0LjUzNyAzLjE4MWMuMDk5LjA0Ny4yMDMuMDkuMzA0LjEzNy4zNjcuMTY2Ljc0LjMyNCAxLjExNy40NTdhOS40IDkuNCAwIDAgMS0uODEtLjU5NGMtLjEwMy0uMDg0LS4yMDQtLjE3Ny0uMzA3LS4yNjMtLjE1OC0uMTQxLS4zMS0uMjgtLjQ2LS40MjgtMy45NC0zLjk0NS0zLjk0LTEwLjMzNiAwLTE0LjI3Ny4xMzktLjE0MS4yOTYtLjI5NS40Ni0uNDYxIDEuODUtMS44NTIgNS4zNDYtNS4zNDggNi42OC02LjY4Mi41NzEuNTY2IDEuMjY1IDEuMjYgMi4wMTggMi4wMThhMzUwNS4zMyAzNTA1LjMzIDAgMCAxIDUuMTIxIDUuMTI1YzMuOTQxIDMuOTQxIDMuOTQxIDEwLjMzMiAwIDE0LjI3N2E5LjY3NyA5LjY3NyAwIDAgMS0xLjU3NSAxLjI4NSAxNi4xMjUgMTYuMTI1IDAgMCAwIDUuOTU3LTMuNzc1YzYuMzY0LTYuMzY0IDYuMzY0LTE2LjY4MiAwLTIzLjA0NSIvPjxwYXRoIGQ9Ik0zMS43NjIgMzguNjU2bDEuMyAxLjI5NyA2LjI5MS02LjMyMi0xLjMxMi0xLjMwOGguMDAxYy0yLjQ4NS0yLjQ4NS00Ljk0My00Ljk0Ni02LjY4MS02LjY4Mi0yLjM0OCAyLjM0Ny04LjgzNiA4LjgzOC0xMS41MiAxMS41MjMtNi4zNjQgNi4zNi02LjM2NCAxNi42OCAwIDIzLjA0M2ExNi4yMDYgMTYuMjA2IDAgMCAwIDUuOTU3IDMuNzc4IDEwIDEwIDAgMCAxLTEuNTc0LTEuMjg5Yy0zLjk0My0zLjk0Mi0zLjc1Ny0xMi4yOTEuMTgzLTE2LjIzMy45MTEtLjkxMSA0LjkwMS01LjIyOCA3LjM1NS03LjgwN003My41MDQgMzcuMTY0Yy0yLjY4MS0yLjY4NS05LjE3NS05LjE3Ni0xMS41MjQtMTEuNTIzLTEuNzM0IDEuNzM2LTQuMTk1IDQuMTk3LTYuNjc2IDYuNjgyaC4wMDFsLTEuMzEzIDEuMzA4IDYuMjkxIDYuMzIyIDEuMy0xLjI5NmMyLjQ1MyAyLjU3OCA2LjQ0MSA2Ljg5NSA3LjM1MiA3LjgwNiAzLjk0NiAzLjk0MiA0LjEzMiAxMi4yOTEuMTg3IDE2LjIzMy0uNDg3LjQ5LTEuMDE4LjkxOC0xLjU3MSAxLjI4OWExNi4yNDkgMTYuMjQ5IDAgMCAwIDUuOTUzLTMuNzc4YzYuMzY1LTYuMzYzIDYuMzY1LTE2LjY4MyAwLTIzLjA0MyIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ "x2qp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = licenceType;
/* unused harmony export licenceTermLength */
/* harmony export (immutable) */ __webpack_exports__["b"] = licenceTermType;
/* harmony export (immutable) */ __webpack_exports__["a"] = brandingOrganization;
/**
* lookups for licence field values
*/

/**
 * convert GW/SW abbreviations to words for display
 * returns the original string if there's no match
 * @param  {String} type uppercase abbreviation from the database
 * @return {String}      expanded string for display
 */
function licenceType(type) {
    if (type === 'SW') {
        return 'Surface Water';
    } else if (type === 'GW') {
        return 'Groundwater';
    }
    return type;
}

/**
 * convert long/short abbreviations to words for display
 * returns the original string if there's no match
 * @param  {String} term lowercase abbreviation from the database
 * @return {String}      expanded string for display
 */
function licenceTermLength(term) {
    if (term === 'long') {
        return 'Long-term';
    } else if (term === 'short') {
        return 'Short-term';
    }
    return term;
}

/**
 * convert long/short abbreviations to words for display
 * returns the original string if there's no match
 * @param  {String} term lowercase abbreviation from the database
 * @return {String}      expanded string for display
 */
function licenceTermType(term) {
    if (term === 'long') {
        return 'Water Licence';
    } else if (term === 'short') {
        return 'Use Approval';
    }
    return term;
}

/**
 * format branding organization for display
 * shortens input to an acronym
 * @param  {String} org full branding organization value from the database
 * @return {String}     abbreviated value for display
 */
function brandingOrganization(org) {
    var display = org;
    if (typeof org === 'string') {
        display = org.replace(/[^A-Z]/g, '');
    }

    return display;
}

/***/ }),

/***/ "xDKa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xIt0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StationsPageFilters_vue__ = __webpack_require__("pfUN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_613a71b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StationsPageFilters_vue__ = __webpack_require__("hr07");
function injectStyle (ssrContext) {
  __webpack_require__("N6HB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StationsPageFilters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_613a71b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StationsPageFilters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Alerts__ = __webpack_require__("MGb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Toast__ = __webpack_require__("hNqL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SidebarToggle__ = __webpack_require__("/5hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Search__ = __webpack_require__("/KFX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_map__ = __webpack_require__("aiDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions_appColors__ = __webpack_require__("QW0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_Watershed__ = __webpack_require__("IkOK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_Streamflow__ = __webpack_require__("AEt0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_icons_SwQuality__ = __webpack_require__("cu9N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_icons_GwQuality__ = __webpack_require__("txPp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_icons_GwLevel__ = __webpack_require__("Qxw7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_icons_Climate__ = __webpack_require__("u6mf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ReportInterstitial__ = __webpack_require__("8q94");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_DisclaimerModal__ = __webpack_require__("pNUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Tour__ = __webpack_require__("d1zR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants_actions__ = __webpack_require__("UOq2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_map__["a" /* default */]],
    components: {
        AlertsContainer: __WEBPACK_IMPORTED_MODULE_0__components_Alerts__["a" /* default */],
        ToastContainer: __WEBPACK_IMPORTED_MODULE_1__components_Toast__["a" /* default */],
        SidebarToggle: __WEBPACK_IMPORTED_MODULE_2__components_SidebarToggle__["a" /* default */],
        SearchBar: __WEBPACK_IMPORTED_MODULE_3__components_Search__["a" /* default */],
        ReportInterstitial: __WEBPACK_IMPORTED_MODULE_12__components_ReportInterstitial__["a" /* default */],
        DisclaimerModal: __WEBPACK_IMPORTED_MODULE_13__components_DisclaimerModal__["a" /* default */],
        Tour: __WEBPACK_IMPORTED_MODULE_14__components_Tour__["a" /* default */]
    },
    data: function data() {
        return {
            items: [{ iconComponent: __WEBPACK_IMPORTED_MODULE_6__components_icons_Watershed__["a" /* default */], title: 'Watershed Reporting', to: '/watershed' }, { iconComponent: __WEBPACK_IMPORTED_MODULE_7__components_icons_Streamflow__["a" /* default */], title: 'Streamflow & Water Levels', to: '/streamflow' }, { iconComponent: __WEBPACK_IMPORTED_MODULE_8__components_icons_SwQuality__["a" /* default */], title: 'Surface Water Quality', to: '/surface-water-quality' }, { iconComponent: __WEBPACK_IMPORTED_MODULE_9__components_icons_GwQuality__["a" /* default */], title: 'Groundwater Quality', to: '/groundwater-quality' }, { iconComponent: __WEBPACK_IMPORTED_MODULE_10__components_icons_GwLevel__["a" /* default */], title: 'Groundwater Level', to: '/groundwater-level' }, { iconComponent: __WEBPACK_IMPORTED_MODULE_11__components_icons_Climate__["a" /* default */], title: 'Climate', to: '/climate' }],
            showDisclaimer: true,
            showTour: localStorage.getItem('ShowTour') !== 'false'
        };
    },

    methods: {
        toggle: function toggle() {
            this.expandDrawer = !this.expandDrawer;
        },
        iconColor: function iconColor(navItem) {
            if (navItem.to === this.$route.path) {
                return __WEBPACK_IMPORTED_MODULE_5__functions_appColors__["t" /* navIconActive */];
            }
            return __WEBPACK_IMPORTED_MODULE_5__functions_appColors__["s" /* navIcon */];
        }
    },
    computed: {
        routeName: function routeName() {
            return this.$route.meta.pageId || 'no-page-id';
        },

        expandDrawer: {
            get: function get() {
                return this.$store.state.navdrawer.show;
            },
            set: function set(val) {
                this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_15__constants_actions__["B" /* SHOW_NAV_DRAWER */], val);
            }
        },
        // returns true if the route is a full-screen map page
        mapRoute: function mapRoute() {
            return ['watershed', 'streamflow', 'climate', 'groundwaterlevel', 'groundwaterquality', 'surfacewaterquality'].includes(this.routeName);
        },
        loading: function loading() {
            return this.$store.state.loading.length;
        },
        mapSourceLoaded: function mapSourceLoaded() {
            return this.$store.state.map.sourceDataLoaded;
        },
        routeHeader: function routeHeader() {
            return this.$route.meta.toolHeader || 'BC Water Tool';
        }
    },
    watch: {
        // shrink nav on route change
        $route: function $route() {
            this.expandDrawer = false;
        }
    }
});

/***/ }),

/***/ "xRYM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xScb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        top: {
            type: Number,
            required: true
        },
        left: {
            type: Number,
            required: true
        },
        content: {
            type: Array,
            default: []
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        styles: function styles() {
            return {
                top: this.top + "px",
                left: this.left + "px"
            };
        }
    }
});

/***/ }),

/***/ "xWn7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pluralize__ = __webpack_require__("DbJJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pluralize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pluralize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_checkQueryData__ = __webpack_require__("ieMF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_climateData__ = __webpack_require__("epYP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_getStationMetadata__ = __webpack_require__("s6bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SidebarSparkline__ = __webpack_require__("XFj9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DownloadCsvButton__ = __webpack_require__("l2MX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// components



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'station-details-climate',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_checkQueryData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_climateData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_getStationMetadata__["a" /* default */]],
    components: {
        SparkLine: __WEBPACK_IMPORTED_MODULE_5__components_SidebarSparkline__["a" /* default */],
        DownloadCsvButton: __WEBPACK_IMPORTED_MODULE_6__components_DownloadCsvButton__["a" /* default */]
    },
    computed: {
        stationId: function stationId() {
            return this.station.id;
        }
    },
    methods: {
        pluralize: function pluralize(term, num) {
            return __WEBPACK_IMPORTED_MODULE_0_pluralize___default()(term, num);
        },
        showChartModal: function showChartModal(tabName) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__constants_actions__["i" /* SET_CHART_MODAL_TAB */], tabName);
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__constants_actions__["y" /* SHOW_CHART_MODAL */], true);
        }
    }
});

/***/ }),

/***/ "xg4G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_yearlyChart__ = __webpack_require__("tMAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_formatHistoricalDailyData__ = __webpack_require__("/SS+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_formatHistoricalDailyDateData__ = __webpack_require__("r0h7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_exportChart__ = __webpack_require__("h326");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_resetChart__ = __webpack_require__("AstN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_streamflowData__ = __webpack_require__("Nt91");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_ie11ChartResize__ = __webpack_require__("4+uC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__chartData_streamflowStage__ = __webpack_require__("RwPU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_chart_js__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_yearlyChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_formatHistoricalDailyData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_formatHistoricalDailyDateData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_exportChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_resetChart__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_streamflowData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_ie11ChartResize__["a" /* default */]],
    data: function data() {
        return {
            chart: null,
            chartId: 'canvas-stage',
            dataType: 'stage',
            chartInterval: 'd'
        };
    },

    computed: {
        chartData: function chartData() {
            if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.queryData).length > 0) {
                return this.queryData.stage;
            }
            return null;
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.chart.destroy();
    },
    mounted: function mounted() {
        // Set chart interval to month
        if (this.chartData) {
            this.updateChart();
        }
    },

    methods: {
        /**
         * create datasets and chart context object
         * @return {Object} chart.js context object
         */
        formatDatasets: function formatDatasets() {
            var _chartData$datasets;

            var chartData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.queryData.formatted_stage_chart_data));

            var yearlyOverlayDatasets = this.formatYearlyData(this.formatHistoricalDateData);
            (_chartData$datasets = chartData.datasets).unshift.apply(_chartData$datasets, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(yearlyOverlayDatasets));
            return chartData;
        },

        /**
         * set up the chart and do the initial render
         */
        renderChart: function renderChart() {
            var chartData = this.formatDatasets();

            this.chart = new __WEBPACK_IMPORTED_MODULE_11_chart_js___default.a(this.chartId, Object(__WEBPACK_IMPORTED_MODULE_10__chartData_streamflowStage__["a" /* container */])(chartData));
        },

        /**
         * update the datasets and re-render the chart
         */
        updateChart: function updateChart() {
            // do the initial render if the chart isn't defined yet
            if (this.chart === null) {
                this.renderChart();
                return;
            }
            this.chart.data = this.formatDatasets();
            this.chart.update({
                duration: 0
            });
        }
    },
    watch: {
        chartData: function chartData(val) {
            this.yearlyData = {};
            this.yearlyDataDisplay = [];
            if (val) {
                this.updateChart();
            }
        },
        updateData: function updateData(val) {
            if (val) {
                this.updateChart();
                this.updateData = false;
            }
        }
    }
});

/***/ }),

/***/ "xgLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StationsPageFilters__ = __webpack_require__("xIt0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SidebarStation__ = __webpack_require__("ZjrC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_actions__ = __webpack_require__("UOq2");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'map-sidebar',
    components: {
        MapFilters: __WEBPACK_IMPORTED_MODULE_1__components_StationsPageFilters__["a" /* default */],
        StationDetails: __WEBPACK_IMPORTED_MODULE_2__components_SidebarStation__["a" /* default */]
    },
    props: {
        filters: Array
    },
    data: function data() {
        return {
            showFilters: false
        };
    },

    computed: {
        show: {
            get: function get() {
                return this.$store.state.sidebar.show;
            },
            set: function set(val) {
                this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], val);
            }
        },
        context: function context() {
            return this.$store.state.sidebar.context;
        },
        classObj: function classObj() {
            return [this.show ? 'showing' : 'hidden'];
        },
        stations: function stations() {
            return [];
        },

        // if filters are loaded into vuex and the filter options query is done
        filtersLoaded: function filtersLoaded() {
            var filters = this.$store.state.loadedFilters.length > 0;
            var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.filterOptions).length > 0;
            return filters && options;
        }
    },
    methods: {
        /**
         * scroll the sidebar to the top and show the filters component
         */
        revealFilters: function revealFilters() {
            // scroll to reveal the filters panel
            var el = document.getElementById('filters-panel');
            el.scrollIntoView();
            this.showFilters = true;
        },

        /**
         * set sidebar context to live results list
         */
        showLiveList: function showLiveList() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__constants_actions__["w" /* SET_SIDEBAR_CONTEXT */], 'live');
        }
    }
});

/***/ }),

/***/ "xnE8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xyEH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"watershed-details"},[_c('h3',{staticClass:"headline watershed-name primary--text",domProps:{"textContent":_vm._s(_vm.name)}}),_vm._v(" "),(!_vm.queryDone)?_c('div',{staticClass:"loading"},[_c('p',[_vm._v("Loading watershed data...")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.watershedId && _vm.queryDone),expression:"watershedId && queryDone"}],staticClass:"watershed"},[_c('p',{staticClass:"body-2 mb-1 network-info"},[_vm._v("\n            WFI: "+_vm._s(_vm.watershedId)+"\n        ")]),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_vm._l((_vm.properties),function(ref){
var title = ref.title;
var value = ref.value;
return (value)?_c('div',{staticClass:"properties-item mb-3"},[_c('h4',{staticClass:"subheading field-title grey--text",domProps:{"textContent":_vm._s(title)}}),_vm._v(" "),_c('div',{staticClass:"body-1 field-value",domProps:{"textContent":_vm._s(value)}})]):_vm._e()}),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_c('h4',{staticClass:"subheading field-title grey--text"},[_vm._v("Watershed PDF Report")]),_vm._v(" "),_c('v-btn',{staticClass:"my-3",attrs:{"block":"","large":"","color":"primary"},on:{"click":_vm.generateReport}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("library_add")]),_vm._v("\n            Add to My Reports\n        ")],1),_vm._v(" "),_c('v-btn',{staticClass:"my-3",attrs:{"color":"info","block":"","large":""},on:{"click":_vm.downloadGeoJSON}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("cloud_download")]),_vm._v("\n            Download GeoJSON\n        ")],1),_vm._v(" "),_c('v-btn',{attrs:{"block":""},on:{"click":_vm.clearSelection}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-cancel")]),_vm._v("\n            Clear selection\n        ")],1)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yHZv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actions__ = __webpack_require__("UOq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pluralize__ = __webpack_require__("DbJJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pluralize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pluralize__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sidebar-toggle',
    computed: {
        show: {
            get: function get() {
                return this.$store.state.sidebar.show;
            },
            set: function set(val) {
                this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__constants_actions__["A" /* SHOW_MAP_SIDEBAR */], val);
            }
        },
        tooltipText: function tooltipText() {
            var tooltip = '';
            var numFilters = this.numActiveFilters;

            if (this.show) {
                tooltip += 'Hide side panel';
            } else {
                tooltip += 'Show side panel';
            }

            if (numFilters > 0) {
                tooltip += ' <br>(' + numFilters + ' ' + __WEBPACK_IMPORTED_MODULE_2_pluralize___default()('filters', numFilters) + ' active)';
            }

            return tooltip;
        },

        // number of filters a non-default value set
        numActiveFilters: function numActiveFilters() {
            var activeFilters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.filterSettings);
            return activeFilters.length;
        }
    },
    methods: {
        /**
         * show/hide the sidebar
         */
        toggle: function toggle() {
            this.show = !this.show;
        }
    }
});

/***/ }),

/***/ "yJFt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_d3SparklineValueDots__ = __webpack_require__("b8W6");
//
//
//
//
//
//
//
//


// import tooltipMixin from '@/mixins/tooltip';


/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [
    // tooltipMixin,
    __WEBPACK_IMPORTED_MODULE_1__mixins_d3SparklineValueDots__["a" /* default */]],
    props: {
        chartData: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            // layout elements
            wrapper: null, // svg wrapper div (same size/position)
            svgEl: null,
            // dimensions of the chart, not the svg
            chartWidth: 400,
            chartHeight: 200,
            margin: {
                top: 5,
                right: 6,
                bottom: 5,
                left: 6
            },
            gChart: null,

            // scales
            xScaleTime: null,
            yScaleLinear: null
        };
    },

    // define date ranges and initialize chart
    mounted: function mounted() {
        this.wrapper = this.$el;
        this.svgEl = this.$el.querySelector('svg');
        this.svg = __WEBPACK_IMPORTED_MODULE_0_d3__["w" /* select */](this.svgEl);

        this.init();
    },

    methods: {
        init: function init() {
            var _this = this;

            // define chart margins/dimensions
            this.chartWidth = this.wrapper.clientWidth - this.margin.left - this.margin.right;
            this.chartHeight = this.wrapper.clientHeight - this.margin.top - this.margin.bottom;

            var data = this.chartData;

            var dateMin = __WEBPACK_IMPORTED_MODULE_0_d3__["o" /* min */](data, function (d) {
                return d.d;
            });
            var dateMax = __WEBPACK_IMPORTED_MODULE_0_d3__["l" /* max */](data, function (d) {
                return d.d;
            });
            // const valMin = d3.min(data, d => d.v);
            var valMin = 0;
            var valMax = __WEBPACK_IMPORTED_MODULE_0_d3__["l" /* max */](data, function (d) {
                return d.v;
            });

            // x scale
            this.xScaleTime = __WEBPACK_IMPORTED_MODULE_0_d3__["u" /* scaleTime */]().rangeRound([0, this.chartWidth]).domain([dateMin, dateMax]);

            this.yScaleLinear = __WEBPACK_IMPORTED_MODULE_0_d3__["r" /* scaleLinear */]().rangeRound([this.chartHeight, 0]).domain([valMin, valMax]).nice();

            var line = __WEBPACK_IMPORTED_MODULE_0_d3__["k" /* line */]().defined(function (d) {
                return d.v;
            }).x(function (d) {
                return _this.xScaleTime(d.d);
            }).y(function (d) {
                return _this.yScaleLinear(d.v);
            }).curve(__WEBPACK_IMPORTED_MODULE_0_d3__["h" /* curveMonotoneX */]);

            // chart container group
            this.gChart = this.svg.append('g').attr('class', 'chart-elements').attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')');

            // add chart sparkline path
            this.gChart.append('path').datum(data).attr('class', 'line').attr('d', line);

            // add dot at the end
            this.addCurrentDot();

            // add
            // this.addValueDots();

            // add tooltip listeners
            // this.addTooltipListeners();
        }
    }
});

/***/ }),

/***/ "yjwP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_appColors__ = __webpack_require__("QW0U");


/**
 * functions and helpers for querying and working with watershed data
 */



/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        /**
         * add map source and layer for the watershed polygon
         * the layer will update as the source data is changed
         */
        addWatershedLayer: function addWatershedLayer(layerAbove) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var map;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.mapPromise;

                            case 2:
                                map = _context.sent;


                                // start with an empty source
                                map.addSource('watershed-polygon', {
                                    type: 'geojson',
                                    data: null
                                });

                                map.addLayer({
                                    id: 'watershed-polygon',
                                    type: 'fill',
                                    source: 'watershed-polygon',
                                    paint: {
                                        'fill-color': String(__WEBPACK_IMPORTED_MODULE_2__functions_appColors__["D" /* watershedPolygon */]),
                                        'fill-opacity': 0.5
                                    }
                                });

                                // move the layer below layerAbove, if specified
                                if (layerAbove) {
                                    map.moveLayer('watershed-polygon', layerAbove);
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        /**
         * get the query search distance from the map zoom level
         * @param  {[type]} zoom [description]
         * @return {[type]}      [description]
         */
        getSearchDistance: function getSearchDistance(zoom) {
            var searchDistance = 5000;
            var intZoom = Math.floor(zoom);
            // check zoom level within the range below
            if (intZoom > 13) {
                intZoom = 13;
            } else if (intZoom < 7) {
                intZoom = 7;
            }
            // Set the search distance based on the zoom level
            switch (intZoom) {
                case 7:
                    searchDistance = 5000;
                    break;
                case 8:
                    searchDistance = 1000;
                    break;
                case 9:
                    searchDistance = 750;
                    break;
                case 10:
                    searchDistance = 500;
                    break;
                case 11:
                    searchDistance = 200;
                    break;
                case 12:
                    searchDistance = 150;
                    break;
                case 13:
                    searchDistance = 100;
                    break;
                default:
                    searchDistance = 5000;
                    break;
            }
            return searchDistance;
        },

        /**
         * clear the watershed polygon
         * by setting the source data to an empty feature
         * note that this doesn't remove the source or the layer
         */
        clearWatershedPolygon: function clearWatershedPolygon() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var map, source;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this2.mapPromise;

                            case 2:
                                map = _context2.sent;
                                source = map.getSource('watershed-polygon');

                                source.setData({
                                    type: 'Point',
                                    coordinates: []
                                });

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    }
});

/***/ }),

/***/ "z5wY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zAgp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrolling-table"},[(!_vm.hasData)?_c('div',{staticClass:"no-data grey lighten-2 grey--text"},[_c('span',[_vm._v("No data available")])]):_vm._e(),_vm._v(" "),(_vm.hasData)?_c('div',{staticClass:"header-wrap"},[_c('div',{staticClass:"cell header-cell top-corner"},[_vm._v("\n            "+_vm._s(_vm.data[0][0].text)+"\n        ")]),_vm._v(" "),_c('scroll-sync',{staticClass:"headers",attrs:{"horizontal":""}},[_vm._l((_vm.paginatedData[0]),function(th){return _c('div',{key:th.text,staticClass:"cell header-cell",domProps:{"textContent":_vm._s(th.text)}})}),_c('div',{staticClass:"spacer cell header-cell"},[_vm._v(" ")])],2)],1):_vm._e(),_vm._v(" "),(_vm.hasData)?_c('div',{staticClass:"scrolling-table-wrap"},[_c('scroll-sync',{staticClass:"left-column",attrs:{"vertical":"","horizontal":""}},[_vm._l((_vm.paginatedData),function(row, i){return (i > 0)?_c('div',{key:row[0].text,staticClass:"cell"},[_vm._v("\n                "+_vm._s(row[0].text)+"\n            ")]):_vm._e()}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.data.length > _vm.yCount),expression:"data.length > yCount"}],staticStyle:{"margin-top":"36px"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"spacer cell"},[_vm._v(" ")])],2),_vm._v(" "),_c('scroll-sync',{staticClass:"scroll-wrap main"},[_c('table',{staticClass:"table"},_vm._l((_vm.paginatedData),function(row, rowIndex){return (rowIndex > 0)?_c('tr',_vm._l((row),function(td, tdIndex){return (tdIndex > 0)?_c('td',{staticClass:"cell",style:(_vm.cellStyle(td))},[_c('div',{staticClass:"tabel-cell-inner",domProps:{"innerHTML":_vm._s((td.text || td.text === 0) ? td.text : '&nbsp;')}})]):_vm._e()})):_vm._e()}))])],1):_vm._e(),_vm._v(" "),(_vm.data.length > _vm.yCount)?_c('v-btn',{staticStyle:{"margin-left":"170px"},on:{"click":_vm.loadMoreY}},[_vm._v("Load More")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zI30":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.8b40ed4c7a75b4879589.js